// This file is auto-generated by @hey-api/openapi-ts

export const $DevicesStateCountsDto = {
  type: "object",
  properties: {
    counts: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            type: "number",
          },
        ],
      },
    },
    total: {
      type: "number",
    },
  },
  required: ["counts", "total"],
} as const;

export const $QueryDeviceState = {
  type: "string",
  enum: ["deploying", "ready", "disconnected", "disabled", "down", "all"],
} as const;

export const $DeviceOrderEnum = {
  type: "string",
  enum: ["state", "site", "name", "lastPing", "localIp", "id"],
} as const;

export const $DeviceOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/DeviceOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListDeviceSummariesDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    state: {
      type: "array",
      items: {
        $ref: "#/components/schemas/QueryDeviceState",
      },
    },
    excludeClusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    excludeSiteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      description:
        "Sorting by one or more fields, each with an optional direction.",
      type: "array",
      items: {
        $ref: "#/components/schemas/DeviceOrderEnumSortOption",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    videoState: {
      type: "array",
      items: {
        type: "string",
        enum: ["Unknown", "Disabled", "Disconnected", "Down", "OK", "All"],
      },
      description: "Filter by one or more video states",
    },
    id: {
      type: "number",
      minimum: 1,
    },
    name: {
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    os: {
      type: "string",
    },
    cpu: {
      type: "string",
    },
    modelName: {
      type: "string",
    },
    localIp: {
      type: "string",
    },
    lastPing: {
      format: "date-time",
      type: "string",
    },
    clusterId: {
      type: "number",
    },
    siteId: {
      type: "number",
    },
    configLocked: {
      type: "boolean",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $PaginatedResponseWithCountDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
    },
    count: {
      type: "number",
    },
    countIsEstimate: {
      type: "boolean",
    },
    lastPage: {
      type: "number",
    },
    perPage: {
      type: "number",
    },
    total: {
      type: "number",
    },
    totalIsEstimate: {
      type: "boolean",
    },
    limit: {
      type: "number",
    },
    page: {
      type: "number",
    },
  },
  required: ["results", "total", "limit", "page"],
} as const;

export const $DeviceSummaryClusterDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "name"],
} as const;

export const $DeviceSummarySiteDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "name"],
} as const;

export const $DeviceSummaryModelDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "name"],
} as const;

export const $DeviceSummaryModelExtendedDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "pending",
        "cancelled",
        "installing",
        "failed",
        "running",
        "stopped",
      ],
      type: "string",
    },
    role: {
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
  },
  required: ["state", "role", "updatedAt", "id", "name"],
} as const;

export const $Tag = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    isLocked: {
      type: "boolean",
    },
  },
  required: ["name"],
} as const;

export const $DeviceSummaryDto = {
  type: "object",
  properties: {
    state: {
      enum: ["deploying", "ready", "disconnected", "disabled", "down"],
      type: "string",
    },
    cameraState: {
      enum: ["Unknown", "Disabled", "Disconnected", "Down", "OK"],
      type: "string",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    lastPing: {
      format: "date-time",
      type: "string",
    },
    localIp: {
      type: "string",
    },
    token: {
      type: "string",
    },
    configLocked: {
      type: "boolean",
    },
    cluster: {
      $ref: "#/components/schemas/DeviceSummaryClusterDto",
    },
    site: {
      $ref: "#/components/schemas/DeviceSummarySiteDto",
    },
    characteristics: {
      type: "object",
      properties: {
        os: {
          type: "string",
        },
      },
      required: ["os"],
    },
    deployedModel: {
      $ref: "#/components/schemas/DeviceSummaryModelDto",
    },
    deployedModels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DeviceSummaryModelExtendedDto",
      },
    },
    numberOfSamples: {
      format: "int64",
      type: "integer",
    },
    sampleBufferStatus: {
      type: "object",
    },
    videoBufferStatus: {
      type: "object",
    },
    servicesStatus: {
      type: "object",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    alertsEnabled: {
      type: "boolean",
    },
  },
  required: [
    "state",
    "cameraState",
    "id",
    "name",
    "agentVersion",
    "lastPing",
    "localIp",
    "token",
    "configLocked",
    "cluster",
    "site",
    "characteristics",
    "deployedModel",
    "deployedModels",
    "numberOfSamples",
    "sampleBufferStatus",
    "videoBufferStatus",
    "servicesStatus",
    "tags",
    "alertsEnabled",
  ],
} as const;

export const $ExportDeviceSummariesDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    state: {
      type: "array",
      items: {
        $ref: "#/components/schemas/QueryDeviceState",
      },
    },
    excludeClusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    excludeSiteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    videoState: {
      type: "array",
      items: {
        type: "string",
        enum: ["Unknown", "Disabled", "Disconnected", "Down", "OK", "All"],
      },
      description: "Filter by one or more video states",
    },
    maxRows: {
      type: "number",
      minimum: 1,
      description:
        "Backend-only row cap override. Not exposed in the UI; omit to use the default.",
    },
    name: {
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    os: {
      type: "string",
    },
    cpu: {
      type: "string",
    },
    modelName: {
      type: "string",
    },
    localIp: {
      type: "string",
    },
    lastPing: {
      format: "date-time",
      type: "string",
    },
    clusterId: {
      type: "number",
    },
    siteId: {
      type: "number",
    },
    configLocked: {
      type: "boolean",
    },
  },
} as const;

export const $DownloadDeviceSummariesRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/ExportDeviceSummariesDto",
    },
  },
  required: ["query"],
} as const;

export const $LoggedStreamableFile = {
  type: "object",
  properties: {},
} as const;

export const $PaginatedResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
    },
    total: {
      type: "number",
    },
    totalIsEstimate: {
      type: "boolean",
    },
    limit: {
      type: "number",
    },
    page: {
      type: "number",
    },
  },
  required: ["results", "total", "limit", "page"],
} as const;

export const $MinimalEntityDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["name", "id"],
} as const;

export const $ListMinimalDeviceDto = {
  type: "object",
  properties: {
    state: {
      enum: ["deploying", "ready", "disconnected", "disabled", "down"],
      type: "string",
    },
    name: {
      type: "string",
    },
    clusterId: {
      type: "number",
    },
    siteId: {
      type: "number",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $EntityIdDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
  },
  required: ["id"],
} as const;

export const $CreateDeviceDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
  required: ["name"],
} as const;

export const $BulkDevicesQueryDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    state: {
      type: "array",
      items: {
        $ref: "#/components/schemas/QueryDeviceState",
      },
    },
    excludeClusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    excludeSiteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    videoState: {
      type: "array",
      items: {
        type: "string",
        enum: ["Unknown", "Disabled", "Disconnected", "Down", "OK", "All"],
      },
      description: "Filter by one or more video states",
    },
    name: {
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    os: {
      type: "string",
    },
    cpu: {
      type: "string",
    },
    modelName: {
      type: "string",
    },
    localIp: {
      type: "string",
    },
    lastPing: {
      format: "date-time",
      type: "string",
    },
    clusterId: {
      type: "number",
    },
    siteId: {
      type: "number",
    },
    configLocked: {
      type: "boolean",
    },
  },
} as const;

export const $UpdateDevicesActivationTimeDto = {
  type: "object",
  properties: {
    activationTime: {
      format: "date-time",
      type: "string",
    },
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
  },
  required: ["activationTime", "query"],
} as const;

export const $UpdateDevicesTagsDto = {
  type: "object",
  properties: {
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $UpdateDeviceTaggingsBulkDto = {
  type: "object",
  properties: {
    assignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    unAssignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    all: {
      type: "boolean",
    },
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $ScheduleJobScheduleDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
  },
  required: ["name"],
} as const;

export const $DevicesModelDeploymentBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    modelId: {
      type: "number",
      minimum: 1,
    },
    role: {
      enum: [
        "predictor",
        "nonScanDetector",
        "objectDetector",
        "similarityFilter",
      ],
      type: "string",
    },
  },
  required: ["query", "modelId"],
} as const;

export const $DevicesConfigLockBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    configLocked: {
      type: "boolean",
    },
  },
  required: ["query", "configLocked"],
} as const;

export const $DevicesServiceVersionDeploymentBulkDto = {
  type: "object",
  properties: {
    serviceName: {
      enum: [
        "edgify-non-scan-detector",
        "edgify-worker",
        "edgify-on-screen-app",
        "edgify-zebra-adapter",
        "edgify-agent",
        "edgify-model",
      ],
      type: "string",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    version: {
      type: "string",
    },
    type: {
      type: "string",
    },
  },
  required: ["serviceName", "query", "version"],
} as const;

export const $DeployServiceVersionDto = {
  type: "object",
  properties: {
    serviceName: {
      enum: [
        "edgify-non-scan-detector",
        "edgify-worker",
        "edgify-on-screen-app",
        "edgify-zebra-adapter",
        "edgify-agent",
        "edgify-model",
      ],
      type: "string",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    version: {
      type: "string",
    },
    type: {
      type: "string",
    },
  },
  required: ["serviceName", "version"],
} as const;

export const $AgentModeEnum = {
  type: "string",
  enum: ["silent", "active"],
  description:
    "Agent Mode - in silent mode, alerts are not sent to the client, and predictions are not returned",
} as const;

export const $ConfigAgentTlsDto = {
  type: "object",
  properties: {
    generate_ca: {
      type: "boolean",
      description:
        "Auto-generate a self-signed CA and server certificate on startup",
    },
    server_key: {
      oneOf: [
        {
          type: "string",
          description: "Absolute file path on the device",
        },
        {
          type: "object",
          description: "Write content to path and store path in config",
          properties: {
            path: {
              type: "string",
            },
            content: {
              type: "string",
            },
          },
          required: ["path", "content"],
        },
      ],
      description: "Server private key file path",
    },
    server_cert: {
      oneOf: [
        {
          type: "string",
          description: "Absolute file path on the device",
        },
        {
          type: "object",
          description: "Write content to path and store path in config",
          properties: {
            path: {
              type: "string",
            },
            content: {
              type: "string",
            },
          },
          required: ["path", "content"],
        },
      ],
      description: "Server certificate file path",
    },
  },
  required: ["generate_ca"],
} as const;

export const $ConfigAgentDto = {
  type: "object",
  properties: {
    version: {
      type: "string",
      description:
        "The agent version - actually hard-coded during the build (using a build command parameter)",
    },
    web_grpc_enable: {
      type: "boolean",
      description:
        "Enable gRPC-Web server (used to communicate with JS clients such as setup-ui and data collector)",
    },
    web_grpc_port: {
      type: "number",
      description: "The port used for gGRPC-Web",
    },
    max_msg_size: {
      type: "number",
      description:
        "The max msg size of a gRPC msg (depends on the number of images in data stream)",
    },
    grpc_port: {
      type: "number",
      description: "The gRPC port",
      minimum: 0,
    },
    web_server_port: {
      type: "number",
      description:
        "The port for the web server used for displaying the docs, the samples, the setup-ui, and the data-collector",
      minimum: 0,
    },
    reverse_proxy_server_port: {
      type: "number",
      description:
        "The port for the gRPC reverse proxy (=REST interface), or 0 for disabled",
      minimum: 0,
    },
    http_port: {
      type: "number",
      description: "The port for the http rest, or 0 for disabled",
      minimum: 0,
    },
    https_port: {
      type: "number",
      description: "The port for the https rest, or 0 for disabled",
      minimum: 0,
    },
    grpc_ping_period: {
      type: "number",
      description: "Ping period to the cluster server in seconds",
      minimum: 0,
    },
    cluster_server_ping_period: {
      type: "number",
      description: "'Ping period to the cluster server in seconds',",
      minimum: 0,
    },
    network_mode: {
      type: "string",
      description:
        "The network mode for the worker and collaborator containers",
    },
    static_files_directory: {
      type: "string",
      description:
        "the root directory used to serving docs (under /docs/*), samples (/samples/*), setup-ui (/*), and data-collector (/data-collector/*) via HTTP",
    },
    rest_only: {
      type: "boolean",
      description: "disable GRPC, enable only REST",
    },
    client_app_ping_period: {
      type: "number",
      description: "Ping period to the client app in seconds, 0 for disabled",
      minimum: 0,
    },
    mode: {
      description:
        "Agent Mode - in silent mode, alerts are not sent to the client, and predictions are not returned",
      allOf: [
        {
          $ref: "#/components/schemas/AgentModeEnum",
        },
      ],
    },
    external_path: {
      type: "string",
      description:
        "when running a service container (training, non-scan..) use this folder for mapping to container, overridden by container_name",
    },
    container_name: {
      type: "string",
      description:
        "when agent is running inside of a docker container - specify the agent's container name here, used for mapping folders to service containers (training, non-scan..)",
    },
    allow_remote_access: {
      type: "boolean",
      description:
        "When false, public APIs listen on 127.0.0.1 (requests from localhost only) instead of 0.0.0.0, unless network_mode is bridge. Default is true (accessible from any network interface).",
    },
    max_auth_retries: {
      type: "number",
      minimum: 0,
      description:
        "Maximum number of failed authentication attempts allowed per IP address before blocking. Default is 5. Set to 0 to disable blocking.",
    },
    auth_retry_window_sec: {
      type: "number",
      minimum: 0,
      description:
        "Time window in seconds for counting failed authentication attempts. Failed attempts outside this window are not counted. Default is 300 seconds (5 minutes).",
    },
    auth_block_duration_sec: {
      type: "number",
      minimum: 0,
      description:
        "Duration in seconds to block an IP address after exceeding max authentication retries. Default is 3600 seconds (1 hour).",
    },
    show_swagger: {
      type: "boolean",
      description: "Serve the agent swagger UI",
    },
    show_agent_ui: {
      type: "boolean",
      description: "Serve the agent UI (setup-ui / data-collector)",
    },
    tls: {
      $ref: "#/components/schemas/ConfigAgentTlsDto",
    },
    repository_url: {
      type: "string",
    },
    start_session_on_capture: {
      type: "boolean",
    },
  },
  required: [
    "version",
    "max_msg_size",
    "grpc_port",
    "https_port",
    "network_mode",
    "static_files_directory",
  ],
} as const;

export const $ConfigApiDto = {
  type: "object",
  properties: {
    backend_url: {
      type: "string",
      description: "The edgify backend's root URL",
    },
    base_url: {
      type: "string",
    },
    token: {
      type: "string",
      description:
        "The device's token, generated on the control panel or via automatic device registration",
    },
    account_token: {
      type: "string",
      description:
        "The account's token, used for automatic device registration (can't be left empty if token is also empty)",
    },
    timeout: {
      type: "number",
      description: "Timeout, in seconds, for app-server requests",
    },
    download_url: {
      type: "string",
      description: "Root URL for downloading component installers",
    },
    download_timeout: {
      type: "number",
      description:
        "Timeout, in seconds, for app-server download requests (model downloads)",
    },
    upload_timeout: {
      type: "number",
      description: "Timeout, in seconds, for uploading logs to the backend",
      minimum: 0,
    },
    max_video_upload_speed_mbps: {
      type: "number",
      description: "Video upload speed limit, in Mbps, 0 for no limit",
      minimum: 0,
    },
    proxy: {
      type: "string",
      description:
        "URL of a proxy server for communicating with the app-server (both HTTP and websockets)",
    },
    websocket_endpoint: {
      type: "string",
      description:
        "The address for communicating with the appserver via websockets.",
    },
    websocket_protocol: {
      type: "string",
      description: "wss (secure websockets) or ws (non-secure)",
    },
    websocket_path: {
      type: "string",
      description: "The URL path for starting a websocket connection",
    },
    websocket_reconnect_period: {
      type: "number",
      description: "time, in seconds, between reconnection attempts",
    },
    websocket_ping_period: {
      type: "number",
      description:
        "time, in seconds, between empty ping messages sent to the app-server in order to keep the channel open",
    },
    restart_on_disconnect_backoff_multiplier: {
      type: "number",
      description: `To overcome agent-to-backend disconnections, we may have to resort to restarting the agent. This is done after a minimal period
     of disconnection, which is defined by this value. If the restart doesn't fix the connection, subsequent restarts will occur 
     according to the exponential-backoff formula: backoff-minutes(i) = min(backoff_multiplier * 2^i, max_backoff)`,
    },
    restart_on_disconnect_max_backoff: {
      type: "number",
      description:
        "The maximal backoff for restarting the agent on disconnections - see above",
    },
    skip_ssl_verify: {
      type: "boolean",
      description: "",
    },
    remote_proxy: {
      type: "string",
      description:
        "URL of a proxy server for communicating with different agents",
    },
    clock_sync_period: {
      type: "number",
      description: "interval in seconds to sync clock with backend",
    },
    clock_sync_threshold_seconds: {
      type: "number",
      description:
        "min threshold time difference with backend that requires time adjustment, -1 will clear time adjustment",
    },
    agent_download_timeout: {
      type: "number",
    },
    remote_timeout: {
      type: "number",
    },
  },
  required: [
    "backend_url",
    "timeout",
    "proxy",
    "websocket_reconnect_period",
    "websocket_ping_period",
    "skip_ssl_verify",
    "remote_proxy",
    "clock_sync_period",
    "clock_sync_threshold_seconds",
    "remote_timeout",
  ],
} as const;

export const $ConfigAnalyticsDto = {
  type: "object",
  properties: {
    update_period: {
      type: "number",
      minimum: 0,
      description:
        "Time, in seconds, between /predictions and /ground_truths POST requests  - or 0, to disable updates (v1.17+)",
    },
    containers_size: {
      type: "number",
      minimum: 0,
      description:
        "Max number of items (predictions / ground-truths) to buffer in memory - or 0 to disable the buffer (v1.17+)",
    },
    max_items_per_notification: {
      type: "number",
      minimum: 1,
      description:
        "Max number of items (predictions / ground-truths) per notification - Min 1",
    },
  },
  required: ["update_period", "containers_size", "max_items_per_notification"],
} as const;

export const $VideoStreamCameraTypeEnum = {
  type: "string",
  enum: ["", "usb", "external", "zebra"],
  description:
    'camera type: "" - usb, or external when external_camera_source is set; zebra - the zebra adapter camera (source composed from the ZebraAdapter config)',
} as const;

export const $VideoStreamCaptureModeEnum = {
  type: "string",
  enum: ["", "on-demand", "streaming"],
  description: "capture mode",
} as const;

export const $VideoStreamEncoding = {
  type: "string",
  enum: ["", "raw", "jpeg", "h264", "h265", "bayer", "mjpeg"],
  description:
    'video stream encoding "" | "raw" | "jpeg" | "h264" | "h265" | "mjpeg" - "" - empty is auto - (raw for webcam, dynamic decoding for rtsp)',
} as const;

export const $VideoStreamFormatEnum = {
  type: "string",
  enum: [
    "",
    "A444_16LE",
    "A444_16BE",
    "AYUV64",
    "RGBA64_LE",
    "ARGB64",
    "ARGB64_LE",
    "BGRA64_LE",
    "ABGR64_LE",
    "RGBA64_BE",
    "ARGB64_BE",
    "BGRA64_BE",
    "ABGR64_BE",
    "A422_16LE",
    "A422_16BE",
    "A420_16LE",
    "A420_16BE",
    "A444_12LE",
    "GBRA_12LE",
    "A444_12BE",
    "GBRA_12BE",
    "Y412_LE",
    "Y412_BE",
    "A422_12LE",
    "A422_12BE",
    "A420_12LE",
    "A420_12BE",
    "A444_10LE",
    "GBRA_10LE",
    "A444_10BE",
    "GBRA_10BE",
    "A422_10LE",
    "A422_10BE",
    "A420_10LE",
    "A420_10BE",
    "BGR10A2_LE",
    "RGB10A2_LE",
    "Y410",
    "A444",
    "GBRA",
    "AYUV",
    "VUYA",
    "RGBA",
    "RBGA",
    "ARGB",
    "BGRA",
    "ABGR",
    "A422",
    "A420",
    "AV12",
    "Y444_16LE",
    "GBR_16LE",
    "Y444_16BE",
    "GBR_16BE",
    "v216",
    "P016_LE",
    "P016_BE",
    "Y444_12LE",
    "GBR_12LE",
    "Y444_12BE",
    "GBR_12BE",
    "I422_12LE",
    "I422_12BE",
    "Y212_LE",
    "Y212_BE",
    "I420_12LE",
    "I420_12BE",
    "P012_LE",
    "P012_BE",
    "Y444_10LE",
    "GBR_10LE",
    "Y444_10BE",
    "GBR_10BE",
    "r210",
    "I422_10LE",
    "I422_10BE",
    "NV16_10LE32",
    "Y210",
    "UYVP",
    "v210",
    "I420_10LE",
    "I420_10BE",
    "P010_10LE",
    "NV12_10LE40",
    "NV12_10LE32",
    "P010_10BE",
    "MT2110R",
    "MT2110T",
    "NV12_10BE_8L128",
    "NV12_10LE40_4L4",
    "Y444",
    "BGRP",
    "GBR",
    "RGBP",
    "NV24",
    "v308",
    "IYU2",
    "RGBx",
    "xRGB",
    "BGRx",
    "xBGR",
    "RGB",
    "BGR",
    "Y42B",
    "NV16",
    "NV61",
    "YUY2",
    "YVYU",
    "UYVY",
    "VYUY",
    "I420",
    "YV12",
    "NV12",
    "NV21",
    "NV12_16L32S",
    "NV12_32L32",
    "NV12_4L4",
    "NV12_64Z32",
    "NV12_8L128",
    "Y41B",
    "IYU1",
    "YUV9",
    "YVU9",
    "BGR16",
    "RGB16",
    "BGR15",
    "RGB15",
    "RGB8P",
    "GRAY16_LE",
    "GRAY16_BE",
    "GRAY10_LE32",
    "GRAY",
  ],
  description:
    "video stream format - when using raw encoding and need to pick camera color format",
} as const;

export const $OnOffEnum = {
  type: "string",
  enum: ["", "on", "off"],
  description:
    'enable/disable auto focus, "" does not apply, "on" enable, "off" disable',
} as const;

export const $VideoStreamTypeEnum = {
  type: "string",
  enum: ["", "opencv", "gstreamer"],
  description: "switch backend for video capture",
} as const;

export const $VideoStreamHardwareEnum = {
  type: "string",
  enum: [
    "",
    "cpu",
    "vaapi",
    "va",
    "qsv",
    "nvcodec",
    "nvv4l2",
    "mediafoundation",
    "d3d11",
    "d3d12",
    "vulkan",
    "opengl",
    "v4l2",
    "vpu",
    "imx",
  ],
  description: "choose hardware acceleration, defaults to cpu",
} as const;

export const $StreamingType = {
  type: "string",
  enum: ["", "udp", "shm", "d3d11", "d3d12", "cuda"],
  description:
    'streaming method - udp - network / shm - shared memory, "" - empty will default to udp',
} as const;

export const $StreamingEncoding = {
  type: "string",
  enum: ["", "raw", "jpeg", "h264", "h265"],
  description:
    'streaming encoding "" | "raw" | "jpeg" | "h264" | "h265" - specifying this will attempt input stream reuse if no processing, otherwise encoding is required - "" - empty will auto select encoding based on streaming type and input video encoding - shm will prefer raw, udp will prefer no processing (ie using original encoded video), if processing is required (ie cropping) will prefer jpeg',
} as const;

export const $StreamingConfig = {
  type: "object",
  properties: {
    type: {
      description:
        'streaming method - udp - network / shm - shared memory, "" - empty will default to udp',
      allOf: [
        {
          $ref: "#/components/schemas/StreamingType",
        },
      ],
    },
    encoding: {
      description:
        'streaming encoding "" | "raw" | "jpeg" | "h264" | "h265" - specifying this will attempt input stream reuse if no processing, otherwise encoding is required - "" - empty will auto select encoding based on streaming type and input video encoding - shm will prefer raw, udp will prefer no processing (ie using original encoded video), if processing is required (ie cropping) will prefer jpeg',
      allOf: [
        {
          $ref: "#/components/schemas/StreamingEncoding",
        },
      ],
    },
    host: {
      type: "string",
      description: "The receiver process host name",
    },
    port: {
      type: "number",
      description: "The receiver process port",
    },
    shm: {
      type: "string",
      description:
        "path for shared memory file descriptor creation, alternative to network streaming",
    },
    frame_rate: {
      description:
        "streaming framerate, empty or 0 will retain same framerate as source",
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    hardware: {
      description: "choose hardware acceleration, defaults to cpu",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamHardwareEnum",
        },
      ],
    },
    convert_hardware: {
      description:
        "choose hardware acceleration for format conversion, defaults to cpu",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamHardwareEnum",
        },
      ],
    },
    bitrate: {
      type: "number",
      description: "Streaming bitrate in bits/sec",
      format: "integer",
      minimum: 0,
    },
    enabled: {
      type: "boolean",
    },
  },
  required: ["host", "port", "enabled"],
} as const;

export const $ROIPredictorDto = {
  type: "object",
  properties: {
    x1: {
      type: "number",
      minimum: 0,
      format: "integer",
      description:
        "the x coordinate of the top-left corner of the region of interest",
    },
    y1: {
      type: "number",
      minimum: 0,
      format: "integer",
      description:
        "the y coordinate of the top-left corner of the region of interest",
    },
    x2: {
      type: "number",
      minimum: 0,
      format: "integer",
      description:
        "the x coordinate of the bottom-right corner of the region of interest",
    },
    y2: {
      type: "number",
      minimum: 0,
      format: "integer",
      description:
        "the y coordinate of the bottom-right corner of the region of interest",
    },
    disable_on_capture_triggers: {
      description:
        "List of capture triggers that should disable ROI predictor cropping",
      type: "array",
      items: {
        type: "string",
      },
    },
    enabled: {
      type: "boolean",
    },
  },
  required: ["x1", "y1", "x2", "y2", "disable_on_capture_triggers", "enabled"],
} as const;

export const $VideoStreamSourcePluginEnum = {
  type: "string",
  enum: [
    "",
    "v4l2src",
    "ksvideosrc",
    "tcamsrc",
    "mfvideosrc",
    "directshow",
    "dshowvideosrc",
    "uvc",
    "v4l2",
    "winks",
    "mediafoundation",
    "souphttpsrc",
    "http",
    "https",
  ],
  description: "choose source plugin, used for different camera interfaces",
} as const;

export const $ConfigVideoStreamDto = {
  type: "object",
  properties: {
    enabled: {
      type: "boolean",
      description: "Enable the video device",
    },
    device_name: {
      type: "string",
      description:
        "Device name used to identify the video device. Will attempt to use device matching this name.",
    },
    device_id: {
      type: "number",
      minimum: 0,
      description:
        "On laptops, 0 is the built-in camera. USB cameras come after in arbitrary order.",
    },
    external_camera_source: {
      type: "string",
      description:
        "A URL, file, or GStreamer pipeline used to capture pictures instead of the device defined by device_id. Used for an IP camera in RTSP protocol",
    },
    camera_type: {
      description:
        'camera type: "" - usb, or external when external_camera_source is set; zebra - the zebra adapter camera (source composed from the ZebraAdapter config)',
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamCameraTypeEnum",
        },
      ],
    },
    auth: {
      type: "boolean",
      description: "send auth headers to client (https only, bearer <TOKEN>)",
    },
    capture_mode: {
      description: "capture mode",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamCaptureModeEnum",
        },
      ],
    },
    encoding: {
      description:
        'video stream encoding "" | "raw" | "jpeg" | "h264" | "h265" | "mjpeg" - "" - empty is auto - (raw for webcam, dynamic decoding for rtsp)',
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamEncoding",
        },
      ],
    },
    format: {
      description:
        "video stream format - when using raw encoding and need to pick camera color format",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamFormatEnum",
        },
      ],
    },
    frame_width: {
      type: "number",
      minimum: 0,
      description: "Frame width",
    },
    frame_height: {
      type: "number",
      minimum: 0,
      description: "Frame height",
    },
    frame_rate: {
      minimum: 0,
      description: "Video device’s FPS",
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    crop_enable: {
      type: "boolean",
      description:
        "Should we crop the images according to the top-left, bottom-right coordinates given below",
    },
    crop_x1: {
      type: "number",
      minimum: 0,
      description: "Crop rectangle’s left X coordinate (or 0 if disabled)",
    },
    crop_y1: {
      type: "number",
      minimum: 0,
      description: "Crop rectangle’s top Y coordinate (or 0 if disabled)",
    },
    crop_x2: {
      type: "number",
      minimum: 0,
      description: "Crop rectangle’s right X coordinate (or 0 if disabled)",
    },
    crop_y2: {
      type: "number",
      minimum: 0,
      description: "Crop rectangle’s bottom Y coordinate (or 0 if disabled)",
    },
    image_delay_milliseconds: {
      type: "number",
      minimum: 0,
      description:
        "Delay before capturing the image (for cases the IP camera’s video stream is delayed)",
    },
    reconnect_on_black_screen: {
      type: "boolean",
      description:
        "Detect black images on capture, and try to reconnect the camera if one happens",
    },
    focus_absolute: {
      type: "number",
      description:
        "set absolute focus on camera, auto focus should be off, -1 does not apply",
    },
    auto_focus: {
      description:
        'enable/disable auto focus, "" does not apply, "on" enable, "off" disable',
      allOf: [
        {
          $ref: "#/components/schemas/OnOffEnum",
        },
      ],
    },
    auto_exposure: {
      description:
        'enable/disable auto exposure, "" does not apply, "on" enable, "off" disable',
      allOf: [
        {
          $ref: "#/components/schemas/OnOffEnum",
        },
      ],
    },
    auto_white_balance: {
      description:
        'enable/disable auto white balance, "" does not apply, "on" enable, "off" disable',
      allOf: [
        {
          $ref: "#/components/schemas/OnOffEnum",
        },
      ],
    },
    exposure: {
      type: "number",
      description:
        "Controls the camera exposure level. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    brightness: {
      type: "number",
      description:
        "Adjusts the overall image brightness. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    contrast: {
      type: "number",
      description:
        "Controls the image contrast between light and dark areas. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    saturation: {
      type: "number",
      description:
        "Affects the intensity of colors in the image. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    sharpness: {
      type: "number",
      description:
        "Controls the image sharpness or crispness. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    hue: {
      type: "number",
      description:
        "Adjusts the overall image color hue. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    gamma: {
      type: "number",
      description:
        "Corrects the image brightness based on lighting conditions. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    gain: {
      type: "number",
      description:
        "Amplifies the camera signal for low-light conditions. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    backlight_compensation: {
      type: "number",
      description:
        "Compensates for uneven backlight in the scene. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    iso_speed: {
      type: "number",
      description:
        "Sets the camera ISO speed, which affects image sensitivity. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    white_balance_temperature: {
      type: "number",
      description:
        "Sets the white balance based on a specific color temperature value. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    zoom: {
      type: "number",
      description:
        "Controls the camera zoom level. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    iris: {
      type: "number",
      description:
        "Controls the camera iris level, affecting aperture size. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    pan: {
      type: "number",
      description:
        "Controls the horizontal camera orientation. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    tilt: {
      type: "number",
      description:
        "Controls the vertical camera orientation. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    roll: {
      type: "number",
      description:
        "Controls the camera roll rotation. Keep empty to use the default value. Not supported by all cameras.",
      format: "float",
    },
    enable_mjpeg: {
      type: "boolean",
      description:
        "enable mjpeg when capturing video from camera (should allow higher frame rates, based on camera)",
    },
    type: {
      description: "switch backend for video capture",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamTypeEnum",
        },
      ],
    },
    pipeline: {
      type: "string",
      description: "GStreamer pipeline for video capture, supports templates",
      example:
        "videotestsrc ! video/x-raw,width=$FRAME_WIDTH,height=$FRAME_HEIGHT,framerate=$FRAME_RATE/1 ! $END",
    },
    hardware: {
      description: "choose hardware acceleration, defaults to cpu",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamHardwareEnum",
        },
      ],
    },
    convert_hardware: {
      description:
        "choose hardware acceleration for format conversion, defaults to cpu",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamHardwareEnum",
        },
      ],
    },
    convert_format: {
      type: "string",
      description:
        'gstreamer raw format a hardware conversion writes on the way to BGR - "BGRx", "BGRA", "RGBA", "NV12"; empty is BGRx',
      example: "BGRx",
    },
    camera_controls: {
      type: "object",
      description:
        "Key/value of controls to set on camera, currently only works on linux, possible key/values depend on camera",
    },
    min_frame_rate_threshold: {
      type: "number",
      description: "Minimal framerate threshold - 0 will be auto, -1 disabled",
      format: "integer",
    },
    adapt_frame_rate: {
      type: "number",
      description:
        "Adapt frame rate early before streaming/recording, 0 to disable",
      format: "integer",
      minimum: 0,
    },
    adapt_width: {
      type: "number",
      description:
        "Adapt frame width early before streaming/recording, 0 to disable",
      format: "integer",
      minimum: 0,
    },
    adapt_height: {
      type: "number",
      description:
        "Adapt frame height early before streaming/recording, 0 to disable",
      format: "integer",
      minimum: 0,
    },
    capture_timeout: {
      type: "number",
      description: "Timeout in seconds for capture operations, 0 to disable",
      format: "integer",
      minimum: 0,
    },
    rtsp_protocols: {
      type: "string",
      description:
        "RTSP protocol(s) to use for RTSP streams (for allowed values see gstreamer's rtspsrc protocols property)",
    },
    streaming: {
      description: "Streaming video to an external process",
      allOf: [
        {
          $ref: "#/components/schemas/StreamingConfig",
        },
      ],
    },
    roi_predictor: {
      description:
        "ROI used for predictor, affects capture / capture-and-predict calls",
      allOf: [
        {
          $ref: "#/components/schemas/ROIPredictorDto",
        },
      ],
    },
    source_plugin: {
      description: "choose source plugin, used for different camera interfaces",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamSourcePluginEnum",
        },
      ],
    },
    rotation_enabled: {
      type: "boolean",
      description: "Enable video rotation",
    },
    rotation_offset: {
      type: "number",
      description: "Video rotation offset in degrees (0, 90, 180, 270)",
      enum: [0, 90, 180, 270],
    },
    frames_to_grab: {
      type: "number",
      description: "Number of frames to grab from camera buffer",
    },
    use_read_instead_of_grab: {
      type: "boolean",
      description: "Use read instead of grab for camera capture",
    },
    number_of_samples_to_save: {
      type: "number",
      description: "Number of samples to save",
    },
  },
  required: [
    "enabled",
    "device_id",
    "external_camera_source",
    "capture_mode",
    "frame_width",
    "frame_height",
    "frame_rate",
    "crop_enable",
    "crop_x1",
    "crop_y1",
    "crop_x2",
    "crop_y2",
    "image_delay_milliseconds",
    "reconnect_on_black_screen",
  ],
} as const;

export const $ConfigDatabaseDto = {
  type: "object",
  properties: {
    Path: {
      type: "string",
      description: "path to the database file",
    },
    path: {
      type: "string",
      description: "path to the database file",
    },
    optimize_period_minutes: {
      type: "number",
      description: "Database optimization period in minutes",
      minimum: 0,
    },
  },
} as const;

export const $TlsMinVersionEnum = {
  type: "string",
  enum: ["", "1.0", "1.1", "1.2", "1.3"],
  description: "Minimum TLS version",
} as const;

export const $ConfigDataManagerTlsDto = {
  type: "object",
  properties: {
    insecure_skip_verify: {
      type: "boolean",
      description: "Skip server certificate verification",
    },
    min_version: {
      description: "Minimum TLS version",
      allOf: [
        {
          $ref: "#/components/schemas/TlsMinVersionEnum",
        },
      ],
    },
    ca_cert: {
      oneOf: [
        {
          type: "string",
          description: "Absolute file path on the device",
        },
        {
          type: "object",
          description: "Write content to path and store path in config",
          properties: {
            path: {
              type: "string",
            },
            content: {
              type: "string",
            },
          },
          required: ["path", "content"],
        },
      ],
      description: "CA certificate",
    },
  },
  required: ["insecure_skip_verify", "min_version"],
} as const;

export const $ConfigDataManagerDto = {
  type: "object",
  properties: {
    path: {
      type: "string",
      description: 'path to the images folder (the samples "buffer")',
    },
    size: {
      type: "number",
      description: "The size of the samples buffer (in bytes)",
      minimum: 0,
    },
    training_buffer_percentage: {
      type: "number",
      description:
        "What percent of the buffer to use for storing new samples arriving during training",
      minimum: 0,
    },
    store_only_during_recording: {
      type: "boolean",
      description: "Store samples only when recording?",
    },
    backend_update_period: {
      type: "number",
      description:
        "Seconds between data buffer analytics (/device_data_stream) updates",
      minimum: 0,
    },
    remote_sync_period: {
      type: "number",
      description:
        "Seconds between data buffer syncing samples with cluster collaborator, 0 - manually sync samples to edgibox",
      minimum: 0,
    },
    remote_sync_delay_between_samples: {
      type: "number",
      description:
        "The delay, in seconds, between each sample sent to the collaborator",
      minimum: 0,
    },
    minimum_samples_per_label: {
      type: "number",
      description: "Minimum number of samples required per label, 0 to disable",
      minimum: 0,
    },
    auto_upload: {
      type: "boolean",
      description: "Upload samples to the cluster automatically",
    },
    auto_upload_delete: {
      type: "boolean",
      description: "Delete samples from the device once auto uploaded",
    },
    tls: {
      $ref: "#/components/schemas/ConfigDataManagerTlsDto",
    },
  },
  required: [
    "path",
    "size",
    "training_buffer_percentage",
    "backend_update_period",
  ],
} as const;

export const $ModelHardwareEnum = {
  type: "string",
  enum: [
    "",
    "cpu",
    "openvino",
    "openvino-cpu",
    "openvino-gpu",
    "openvino-fp16",
    "openvino-fp32",
    "cuda",
  ],
  description: "hardware accel for classifier filtering model",
} as const;

export const $TpuInferenceServerConfig = {
  type: "object",
  properties: {
    port: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "The server's port",
    },
    host: {
      type: "string",
      description: "The server's host name",
    },
    image: {
      type: "string",
      description: "The server's docker image.",
    },
    enabled: {
      type: "boolean",
      description: "enable",
    },
  },
  required: ["port", "host", "image", "enabled"],
} as const;

export const $ConfigPredictorDto = {
  type: "object",
  properties: {
    default_model_path: {
      type: "string",
      description:
        "path to the default model file (.onnx) - the model will be deployed when no model is deployed",
    },
    default_model_config_path: {
      type: "string",
      description: "path to the default model config file (.yml)",
    },
    default_model_id: {
      type: "number",
      minimum: 0,
      description:
        "default model id - or 0 to avoid installing a default model",
    },
    filtering_model_path: {
      type: "string",
      description: "path to the filtering model file (.onnx)",
    },
    filtering_model_config_path: {
      type: "string",
      description: "path to the filtering model config file (.yml)",
    },
    filtering_model_id: {
      type: "number",
      minimum: 0,
      description: "filtering model id",
    },
    filtering_model_hardware: {
      description: "hardware accel for classifier filtering model",
      allOf: [
        {
          $ref: "#/components/schemas/ModelHardwareEnum",
        },
      ],
    },
    certainty_enabled: {
      type: "boolean",
      description: "send is_certain for auto-buy",
    },
    top1_high_certainty_threshold: {
      type: "number",
      description:
        "Minimal score for is_certain in a case 1 label is returned - or -1 to derive this automatically",
      format: "float",
    },
    min_confidence_per_prediction: {
      type: "number",
      description:
        "Minimal score to include a label in the prediction or -1 to derive this automatically",
      format: "float",
    },
    min_confidence_sum: {
      type: "number",
      description:
        "Minimal sum of scores of all returned labels (otherwise unknown) or -1 to derive this automatically",
      format: "float",
    },
    number_of_classes_to_show: {
      type: "number",
      description:
        "Maximum number of predicted classes to show in the results - or 0 to derive this automatically",
    },
    lookup_table_path: {
      type: "string",
      description: "path to the lookup table that converts from SKU to name",
    },
    retry_items: {
      description: "array of classes that trigger a prediction retry",
      type: "array",
      items: {
        type: "string",
      },
    },
    retry_period: {
      type: "number",
      minimum: 0,
      description:
        "milliseconds from the first prediction, during which prediction should be retried until the predicted result is no longer part of the retry_items",
    },
    ignore_family: {
      type: "boolean",
      description:
        "should predictor ignore family field when making prediction",
    },
    default_family: {
      type: "string",
      description:
        "assign default family when predictions are done without family",
    },
    return_match_strength: {
      type: "boolean",
      description: "Return the match strength on PUT sample requests",
    },
    match_alert_threshold: {
      type: "number",
      format: "float",
    },
    match_alert_threshold_unknown: {
      type: "number",
      format: "float",
    },
    tpu_inference_server: {
      description: "TPU Inference Service (used for tflite models only)",
      allOf: [
        {
          $ref: "#/components/schemas/TpuInferenceServerConfig",
        },
      ],
    },
    hardware: {
      description: "hardware accel for classifier model",
      allOf: [
        {
          $ref: "#/components/schemas/ModelHardwareEnum",
        },
      ],
    },
    match_alert_unknowns: {
      type: "boolean",
    },
    match_enable_unknown: {
      type: "boolean",
    },
  },
  required: [
    "default_model_path",
    "default_model_config_path",
    "default_model_id",
    "filtering_model_path",
    "filtering_model_config_path",
    "filtering_model_id",
    "certainty_enabled",
    "top1_high_certainty_threshold",
    "min_confidence_per_prediction",
    "min_confidence_sum",
    "number_of_classes_to_show",
    "retry_items",
    "retry_period",
    "ignore_family",
    "default_family",
    "match_alert_threshold",
    "match_alert_threshold_unknown",
    "tpu_inference_server",
    "match_alert_unknowns",
    "match_enable_unknown",
  ],
} as const;

export const $RegionOfInterestDto = {
  type: "object",
  properties: {
    x1: {
      type: "number",
      minimum: 0,
      format: "integer",
      description:
        "the x coordinate of the top-left corner of the region of interest",
    },
    y1: {
      type: "number",
      minimum: 0,
      format: "integer",
      description:
        "the y coordinate of the top-left corner of the region of interest",
    },
    x2: {
      type: "number",
      minimum: 0,
      format: "integer",
      description:
        "the x coordinate of the bottom-right corner of the region of interest",
    },
    y2: {
      type: "number",
      minimum: 0,
      format: "integer",
      description:
        "the y coordinate of the bottom-right corner of the region of interest",
    },
  },
  required: ["x1", "y1", "x2", "y2"],
} as const;

export const $GpuTypeEnum = {
  type: "string",
  enum: ["disabled", "nvidia", "intel"],
  description: "Which GPU to enable in the service docker",
} as const;

export const $VideoRecordingHardwareEnum = {
  type: "string",
  enum: [
    "",
    "cpu",
    "vaapi",
    "va",
    "qsv",
    "nvcodec",
    "nvv4l2",
    "mediafoundation",
    "d3d11",
    "d3d12",
    "vulkan",
    "opengl",
    "v4l2",
    "vpu",
    "imx",
  ],
  description: "hardware acceleration in non scan detector",
} as const;

export const $NonScanDetectorServiceConfig = {
  type: "object",
  properties: {
    port: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "The server's port",
    },
    host: {
      type: "string",
      description: "The server's host name",
    },
    image: {
      type: "string",
      description: "The server's docker image.",
    },
    managed: {
      type: "boolean",
      description:
        "Should the agent manage the external non-scan detector process?",
    },
    agent_host: {
      type: "string",
      description:
        "The host name by which the non-scan detector accesses the agent",
    },
    streaming_type: {
      description:
        'streaming method - udp - network / shm - shared memory, "" - empty will default to udp',
      allOf: [
        {
          $ref: "#/components/schemas/StreamingType",
        },
      ],
    },
    streaming_encoding: {
      description:
        'streaming encoding "" | "raw" | "jpeg" | "h264" | "h265" - specifiying this will attempt input stream reuse if no processing, otherwise encoding is required - "" - empty will auto select encoding based on streaming type and input video encoding - shm will prefer raw, udp will prefer no processing (ie using original encoded video), if processing is required (ie cropping) will prefer jpeg',
      allOf: [
        {
          $ref: "#/components/schemas/StreamingEncoding",
        },
      ],
    },
    streaming_port: {
      type: "number",
      description:
        "The port used by the non-scan-detector to receive the video stream from the agent",
      format: "integer",
    },
    streaming_shm: {
      type: "string",
      description:
        "path for shared memory file descriptor creation, alternative to network streaming",
    },
    streaming_frame_rate: {
      description:
        "The frame rate used by the non-scan-detector to receive the video stream from the agent",
      format: "integer",
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    streaming_hardware: {
      description: "choose hardware acceleration, defaults to cpu",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamHardwareEnum",
        },
      ],
    },
    streaming_convert_hardware: {
      description:
        "choose hardware acceleration for format conversion, defaults to cpu",
      allOf: [
        {
          $ref: "#/components/schemas/VideoStreamHardwareEnum",
        },
      ],
    },
    network_mode: {
      type: "string",
      description:
        "The network mode used by the non-scan-detector (leave empty to determine automatically by the mode used for running the agent)",
    },
    timeout: {
      type: "number",
      description: "Timeout for accessing the non-scan detector",
      format: "integer",
    },
    init_timeout: {
      type: "number",
      description: "Timeout for initializing the non-scan detector",
      format: "integer",
    },
    shutdown_timeout: {
      type: "number",
      description: "Timeout for shutting down the non-scan detector",
      format: "integer",
    },
    gpu_enabled: {
      type: "boolean",
      description: "Enable GPU in the server docker",
    },
    gpu_type: {
      description: "Which GPU to enable in the service docker",
      allOf: [
        {
          $ref: "#/components/schemas/GpuTypeEnum",
        },
      ],
    },
    gstreamer_hardware: {
      description: "hardware acceleration in non scan detector",
      allOf: [
        {
          $ref: "#/components/schemas/VideoRecordingHardwareEnum",
        },
      ],
    },
    cpus: {
      type: "number",
      description:
        "How much of the available CPU resources the container can use",
      format: "float",
      minimum: 0,
    },
    privileged: {
      type: "boolean",
      description: "run the service in docker's privileged mode",
    },
    streaming_bitrate: {
      type: "number",
      description: "video stream bitrate, 0 - encoder default",
      format: "integer",
    },
    constant_streaming: {
      type: "boolean",
      description: "stream to the non-scan detector constantly",
    },
    auto_pull: {
      description:
        'pull the service docker image when the agent starts it: false/""/off - never, true/once/first/on - when the image is missing, always - on every boot',
      oneOf: [
        {
          type: "boolean",
        },
        {
          type: "string",
          enum: ["", "off", "once", "always", "first", "on"],
        },
      ],
    },
    container_hostname_postfix: {
      type: "boolean",
      description: "add a postfix to the service container hostname",
    },
    state_transition_timeout: {
      type: "number",
      description:
        "state transition timeout in seconds, -1 - auto (non-scan detector default)",
      minimum: -1,
      format: "integer",
    },
    cpu_shares: {
      type: "number",
      description:
        "relative CPU weight of the container (docker cpu-shares), 0 - docker default",
      format: "integer",
      minimum: 0,
    },
    path: {
      type: "string",
      description: "service executable folder / path",
    },
    pipeline: {
      type: "string",
      description: "video stream gstreamer pipeline override",
    },
  },
  required: [
    "port",
    "host",
    "image",
    "managed",
    "agent_host",
    "streaming_port",
    "streaming_frame_rate",
    "network_mode",
    "timeout",
    "gpu_enabled",
    "gpu_type",
    "gstreamer_hardware",
    "cpus",
    "privileged",
  ],
} as const;

export const $ConfigNonScanRulesDto = {
  type: "object",
  properties: {
    scale_iou_threshold: {
      type: "number",
      format: "float",
    },
    checkout_iou_threshold: {
      type: "number",
      format: "float",
    },
    gt_frame_tolerance: {
      type: "number",
      format: "integer",
    },
  },
  required: [
    "scale_iou_threshold",
    "checkout_iou_threshold",
    "gt_frame_tolerance",
  ],
} as const;

export const $NonScanTrackerTypeEnum = {
  type: "string",
  enum: ["", "sort"],
  description: "algorithm for non scan tracker",
} as const;

export const $ConfigNonScanTrackerDto = {
  type: "object",
  properties: {
    min_updates_use_prediction: {
      type: "number",
      format: "integer",
    },
    max_predicts_without_update: {
      type: "number",
      format: "integer",
    },
    iou_threshold: {
      type: "number",
      format: "float",
    },
    confidence_threshold: {
      type: "number",
      format: "float",
    },
    tracker_type: {
      description: "algorithm for non scan tracker",
      allOf: [
        {
          $ref: "#/components/schemas/NonScanTrackerTypeEnum",
        },
      ],
    },
  },
  required: [
    "min_updates_use_prediction",
    "max_predicts_without_update",
    "iou_threshold",
    "confidence_threshold",
  ],
} as const;

export const $ConfigNonScanSimilarityFilterDto = {
  type: "object",
  properties: {
    similarity_threshold: {
      type: "number",
      format: "float",
    },
    gt_detection_min_confidence: {
      type: "number",
      format: "float",
    },
    gt_detection_min_iou: {
      type: "number",
      format: "float",
    },
    hardware: {
      description: "hardware accel for similarity filter",
      allOf: [
        {
          $ref: "#/components/schemas/ModelHardwareEnum",
        },
      ],
    },
    enable: {
      type: "boolean",
    },
  },
  required: [
    "similarity_threshold",
    "gt_detection_min_confidence",
    "gt_detection_min_iou",
  ],
} as const;

export const $NonScanPrecisionLevelEnum = {
  type: "string",
  enum: ["", "strict", "normal", "soft"],
  description: "Precision level for non scan detector",
} as const;

export const $NonScanInferenceHardwareEnum = {
  type: "string",
  enum: [
    "",
    "CPU",
    "NPU",
    "GPU",
    "GPU.0",
    "GPU.1",
    "CUDA",
    "CUDA.0",
    "CUDA.1",
    "TPU",
  ],
  description: "Inference hardware used by the non scan detector",
} as const;

export const $HeadBlurringShapeEnum = {
  type: "string",
  enum: ["octagon7", "rectangle"],
  description: "The shape used for masking the detected heads",
} as const;

export const $NonScanAlertDroppedFramesConfigDto = {
  type: "object",
  properties: {
    dropped_frames_percentage: {
      type: "number",
      format: "float",
      description:
        "Percentage of FPS drop to trigger alert (e.g., 20 for 20% drop)",
    },
    num_events_in_session: {
      type: "number",
      format: "integer",
      description:
        "Number of FPS drop events required in a session to trigger alert",
    },
    sliding_window_duration: {
      type: "number",
      format: "float",
      description: "Sliding window duration in seconds for FPS drop detection",
    },
  },
} as const;

export const $ConfigNonScanDetectorDto = {
  type: "object",
  properties: {
    enabled: {
      type: "boolean",
      description: "enable non-scan detector",
    },
    send_images: {
      type: "boolean",
      description: "send alert images",
    },
    send_clip: {
      type: "boolean",
      description: "send alert clip",
    },
    region_of_interest_a: {
      description: "Region Of Interest A",
      allOf: [
        {
          $ref: "#/components/schemas/RegionOfInterestDto",
        },
      ],
    },
    roi_scale: {
      description: "Region Of Interest of scale",
      allOf: [
        {
          $ref: "#/components/schemas/RegionOfInterestDto",
        },
      ],
    },
    region_of_interest_b: {
      description: "Region Of Interest B",
      allOf: [
        {
          $ref: "#/components/schemas/RegionOfInterestDto",
        },
      ],
    },
    roi_checkout: {
      description: "Region Of Interest of checkout",
      allOf: [
        {
          $ref: "#/components/schemas/RegionOfInterestDto",
        },
      ],
    },
    sample_images_per_second: {
      type: "number",
      minimum: 1,
      format: "integer",
      description: "how many sample images to store per second",
    },
    frame_rate: {
      description: "Non-scan frame rate",
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    return_skip_frames: {
      type: "number",
      description:
        "Non-scan on screen app frame skip - increase to reduce memory consumption",
    },
    save_return_frames: {
      type: "boolean",
      description: "should non scan save frames for on-screen app",
    },
    hardware: {
      description: "hardware accel for non scan object detector model",
      allOf: [
        {
          $ref: "#/components/schemas/ModelHardwareEnum",
        },
      ],
    },
    store_fps: {
      type: "number",
      minimum: 1,
      format: "integer",
      description:
        "How many frames to store per second when there is a non-scan",
    },
    onnx_execution_provider: {
      type: "string",
      description: "onnx execution provider",
    },
    onnx_device_type: {
      type: "string",
      description: "onnx device type",
    },
    onnx_precision: {
      type: "string",
      description: "onnx precision",
    },
    onnx_runtime_path: {
      type: "string",
      description: "onnx runtime path",
    },
    frames_skip: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "how many frames to skip",
    },
    polling_frequency: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "polling frequency",
    },
    output_frame_width: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "output frame width",
    },
    output_frame_height: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "output frame height",
    },
    get_motions_on_gt: {
      type: "boolean",
      description: "get motions on gt only",
    },
    video_source: {
      type: "string",
      description: "video source",
    },
    server: {
      description: "Non-scan detector server config",
      allOf: [
        {
          $ref: "#/components/schemas/NonScanDetectorServiceConfig",
        },
      ],
    },
    service: {
      description: "Non-scan detector service config",
      allOf: [
        {
          $ref: "#/components/schemas/NonScanDetectorServiceConfig",
        },
      ],
    },
    rules: {
      description: "Non-scan rules",
      allOf: [
        {
          $ref: "#/components/schemas/ConfigNonScanRulesDto",
        },
      ],
    },
    tracker: {
      description: "Non-scan tracker",
      allOf: [
        {
          $ref: "#/components/schemas/ConfigNonScanTrackerDto",
        },
      ],
    },
    similarity_filter: {
      description: "Non-scan similarity filter",
      allOf: [
        {
          $ref: "#/components/schemas/ConfigNonScanSimilarityFilterDto",
        },
      ],
    },
    precision_level: {
      description: "Precision level for non scan detector",
      allOf: [
        {
          $ref: "#/components/schemas/NonScanPrecisionLevelEnum",
        },
      ],
    },
    num_frames_in_alert: {
      type: "number",
      description: "Number of frames in alert",
    },
    alert_width: {
      type: "number",
      description: "Width of the alert image",
    },
    alert_height: {
      type: "number",
      description: "Height of the alert image",
    },
    inference_hardware: {
      description: "Inference hardware used by the non scan detector",
      allOf: [
        {
          $ref: "#/components/schemas/NonScanInferenceHardwareEnum",
        },
      ],
    },
    tpu_mode: {
      type: "string",
      description: "TPU mode for non-scan detector (std or max)",
      enum: ["std", "max"],
    },
    log_debug: {
      type: "boolean",
      description: "Print debug-level logs",
    },
    log_trace: {
      type: "boolean",
      description:
        "Print trace-level logs (finer than log_debug, overrides it). Non-scan detector 0.5.3+",
    },
    visualize: {
      type: "boolean",
      description:
        "For each session, save a video with object detection bounding boxes for debugging purposes",
    },
    visualize_folder: {
      type: "string",
      description: "The folder in which to save the visualized videos",
    },
    enable_left_in_cart: {
      type: "boolean",
      description: "Enable left-in-cart detection",
    },
    detect_cart_loss_timeout_seconds: {
      type: "number",
      format: "integer",
      description: "Timeout in seconds for detect-cart-loss API call",
    },
    left_in_cart_timeout_seconds: {
      type: "number",
      format: "integer",
      description: "Timeout in seconds for detect-cart-loss API call",
    },
    silence_before_intervention: {
      type: "boolean",
      description: "Silence alerts before intervention",
    },
    left_in_cart_mode: {
      type: "string",
      description: "Left-in-cart detection mode (silent or active)",
      enum: ["silent", "active"],
    },
    left_in_cart_on_end_session: {
      type: "boolean",
      description:
        "Left-in-cart on end session call (if integration is not implemented)",
    },
    enable_head_blurring: {
      type: "boolean",
      description:
        "Enable head blurring (faces are blurred in recorded videos and data samples)",
    },
    head_blurring_shape: {
      description: "The shape used for masking the detected heads",
      allOf: [
        {
          $ref: "#/components/schemas/HeadBlurringShapeEnum",
        },
      ],
    },
    auto_blur: {
      type: "boolean",
      description:
        "Automatically trigger the head-blurring job on session stop",
    },
    head_blur_timeout_seconds: {
      type: "number",
      minimum: 1,
      format: "integer",
      description: "Timeout in seconds for a head-blurring API call",
    },
    head_blur_on_get_sample: {
      type: "boolean",
      description:
        "Attempt to blur heads on sample requests, instead of rejecting a sample that is not blurred yet",
    },
    sleep_between_frames: {
      type: "boolean",
      description: "Sleep between frames to reduce CPU usage",
    },
    buffer_size: {
      type: "number",
      format: "integer",
      minimum: 0,
      description: "Buffer size for non-scan detector",
    },
    max_latency_sec: {
      type: "number",
      format: "float",
      description:
        "Maximum latency in seconds for non-scan detector processing",
    },
    work_dir: {
      type: "string",
      description: "Working directory for non-scan detector",
    },
    dropped_frames_alert: {
      description: "FPS drop alert configuration",
      allOf: [
        {
          $ref: "#/components/schemas/NonScanAlertDroppedFramesConfigDto",
        },
      ],
    },
  },
  required: ["enabled", "server", "service"],
} as const;

export const $ProtocolEnum = {
  type: "string",
  enum: ["", "http", "https"],
  description: "protocol to use for the service",
} as const;

export const $OnScreenAppLogLevelEnum = {
  type: "string",
  enum: ["", "debug", "info", "warn", "error"],
  description: "on-screen-app log level",
} as const;

export const $ExternalServiceAgentConfigDto = {
  type: "object",
  properties: {
    host: {
      type: "string",
      description: "agent host for external service to connect to",
    },
    port: {
      type: "number",
      description: "agent port for external service to connect to",
    },
    https: {
      type: "boolean",
      description: "use https for agent connection",
    },
    skip_ssl_verify: {
      type: "boolean",
      description: "skip ssl verification for agent connection",
    },
  },
  required: ["host", "port", "https", "skip_ssl_verify"],
} as const;

export const $ConfigOnScreenAppDto = {
  type: "object",
  properties: {
    port: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "The server's port",
    },
    host: {
      type: "string",
      description: "The server's host name",
    },
    image: {
      type: "string",
      description: "The server's docker image.",
    },
    network_mode: {
      type: "string",
      description: "service docker network mode",
    },
    protocol: {
      description: "protocol to use for the service",
      allOf: [
        {
          $ref: "#/components/schemas/ProtocolEnum",
        },
      ],
    },
    privileged: {
      type: "boolean",
      description: "service docker privileged flag",
    },
    path: {
      type: "string",
      description: "service executable folder / path",
    },
    env_image_override: {
      type: "string",
      description: "service docker image override",
    },
    init_timeout: {
      type: "number",
      format: "integer",
      minimum: 0,
      description:
        "timeout in seconds for service to respond after service startup",
    },
    timeout: {
      type: "number",
      format: "integer",
      minimum: 0,
      description:
        "timeout in seconds for service to respond to requests from agent",
    },
    logs_folder: {
      type: "string",
      description: "folder to store logs of service running in docker",
    },
    auto_pull: {
      description:
        'pull the service docker image when the agent starts it: false/""/off - never, true/once/first/on - when the image is missing, always - on every boot',
      oneOf: [
        {
          type: "boolean",
        },
        {
          type: "string",
          enum: ["", "off", "once", "always", "first", "on"],
        },
      ],
    },
    show_powered_by_edgify: {
      type: "boolean",
      description: "on-screen-app show powered by edgify trademark or not",
    },
    close_on_scan: {
      type: "boolean",
      description:
        "on-screen-app ignore unhandled alert if user continues to next item",
    },
    merge_event_types: {
      type: "boolean",
      description:
        "on-screen-app combine alert-non-scan and alert-non-match alert message display",
    },
    show_help: {
      type: "boolean",
      description: "on-screen-app show help page",
    },
    dev_tools: {
      type: "boolean",
      description: "on-screen-app run with dev tools",
    },
    max_request_size: {
      type: "string",
      description: "on-screen-app max json request size",
    },
    log_level: {
      description: "on-screen-app log level",
      allOf: [
        {
          $ref: "#/components/schemas/OnScreenAppLogLevelEnum",
        },
      ],
    },
    shared_path: {
      type: "string",
      description:
        "on-screen-app docker config.json stroage (and any additional future files for on-screen-app)",
    },
    show_predictions: {
      type: "boolean",
      description: "Show predictions in on-screen app",
    },
    report_samples: {
      type: "boolean",
      description: "Report sample updates to on-screen app",
    },
    report_predictions: {
      type: "boolean",
      description: "Report predictions to on-screen app",
    },
    agent: {
      description: "Agent connection configuration for on-screen-app",
      allOf: [
        {
          $ref: "#/components/schemas/ExternalServiceAgentConfigDto",
        },
      ],
    },
    theme: {
      type: "string",
    },
    enabled: {
      type: "boolean",
    },
  },
  required: [
    "port",
    "host",
    "image",
    "network_mode",
    "protocol",
    "privileged",
    "path",
    "init_timeout",
    "timeout",
    "logs_folder",
    "show_powered_by_edgify",
    "close_on_scan",
    "merge_event_types",
    "show_help",
    "dev_tools",
    "log_level",
    "shared_path",
    "theme",
    "enabled",
  ],
} as const;

export const $ZebraAdapterLogLevelEnum = {
  type: "string",
  enum: ["", "trace", "debug", "info", "warn", "error", "critical", "off"],
  description: "zebra adapter log level",
} as const;

export const $ZebraAdapterImageFromEnum = {
  type: "string",
  enum: ["", "zebra", "agent"],
  description: "image source for agent (zebra or agent)",
} as const;

export const $ZebraAdapterAgentConfigDto = {
  type: "object",
  properties: {
    host: {
      type: "string",
      description: "agent host for external service to connect to",
    },
    port: {
      type: "number",
      description: "agent port for external service to connect to",
    },
    https: {
      type: "boolean",
      description: "use https for agent connection",
    },
    skip_ssl_verify: {
      type: "boolean",
      description: "skip ssl verification for agent connection",
    },
    enabled: {
      type: "boolean",
      description: "enable agent for zebra adapter",
    },
    image_from: {
      description: "image source for agent (zebra or agent)",
      allOf: [
        {
          $ref: "#/components/schemas/ZebraAdapterImageFromEnum",
        },
      ],
    },
  },
  required: [
    "host",
    "port",
    "https",
    "skip_ssl_verify",
    "enabled",
    "image_from",
  ],
} as const;

export const $ConfigZebraAdapterDto = {
  type: "object",
  properties: {
    port: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "The server's port",
    },
    host: {
      type: "string",
      description: "The server's host name",
    },
    image: {
      type: "string",
      description: "The server's docker image.",
    },
    network_mode: {
      type: "string",
      description: "service docker network mode",
    },
    protocol: {
      description: "protocol to use for the service",
      allOf: [
        {
          $ref: "#/components/schemas/ProtocolEnum",
        },
      ],
    },
    privileged: {
      type: "boolean",
      description: "service docker privileged flag",
    },
    path: {
      type: "string",
      description: "service executable folder / path",
    },
    env_image_override: {
      type: "string",
      description: "service docker image override",
    },
    init_timeout: {
      type: "number",
      format: "integer",
      minimum: 0,
      description:
        "timeout in seconds for service to respond after service startup",
    },
    timeout: {
      type: "number",
      format: "integer",
      minimum: 0,
      description:
        "timeout in seconds for service to respond to requests from agent",
    },
    logs_folder: {
      type: "string",
      description: "folder to store logs of service running in docker",
    },
    auto_pull: {
      description:
        'pull the service docker image when the agent starts it: false/""/off - never, true/once/first/on - when the image is missing, always - on every boot',
      oneOf: [
        {
          type: "boolean",
        },
        {
          type: "string",
          enum: ["", "off", "once", "always", "first", "on"],
        },
      ],
    },
    shared_path: {
      type: "string",
      description: "shared path for zebra adapter",
    },
    log_level: {
      description: "zebra adapter log level",
      allOf: [
        {
          $ref: "#/components/schemas/ZebraAdapterLogLevelEnum",
        },
      ],
    },
    light_on_capture: {
      type: "boolean",
      description: "turn on light on capture",
    },
    rootless: {
      type: "boolean",
      description:
        "rootless docker: use the device mirrors from mirror_folder instead of the host devices",
    },
    mirror_folder: {
      type: "string",
      description:
        'folder of device mirrors (videoX, bus_usb_Y_Z), "" -> /data/docker/dev, "-"/"none" -> disabled',
    },
    barcode_agent: {
      description: "barcode agent configuration",
      allOf: [
        {
          $ref: "#/components/schemas/ZebraAdapterAgentConfigDto",
        },
      ],
    },
    produce_agent: {
      description: "produce agent configuration",
      allOf: [
        {
          $ref: "#/components/schemas/ZebraAdapterAgentConfigDto",
        },
      ],
    },
    enabled: {
      type: "boolean",
    },
  },
  required: [
    "port",
    "host",
    "image",
    "network_mode",
    "protocol",
    "privileged",
    "path",
    "init_timeout",
    "timeout",
    "logs_folder",
    "shared_path",
    "log_level",
    "light_on_capture",
    "barcode_agent",
    "produce_agent",
    "enabled",
  ],
} as const;

export const $PredictionModelConfig = {
  type: "object",
  properties: {
    path: {
      type: "string",
      description: "path",
    },
    config_path: {
      type: "string",
      description: "config_path",
    },
    id: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "id",
    },
    top1_high_certainty_threshold: {
      type: "number",
      description:
        "Minimal score for is_certain in a case 1 label is returned - or -1 to derive this automatically",
      format: "float",
    },
    min_confidence_per_prediction: {
      type: "number",
      description:
        "Minimal score to include a label in the prediction or -1 to derive this automatically",
      format: "float",
    },
    min_confidence_sum: {
      type: "number",
      description:
        "Minimal sum of scores of all returned labels (otherwise unknown) or -1 to derive this automatically",
      format: "float",
    },
    number_of_classes_to_show: {
      type: "number",
      format: "integer",
      description:
        "Maximum number of predicted classes to show in the results - or 0 to derive this automatically",
    },
  },
  required: [
    "path",
    "config_path",
    "id",
    "top1_high_certainty_threshold",
    "min_confidence_per_prediction",
    "min_confidence_sum",
    "number_of_classes_to_show",
  ],
} as const;

export const $ModelConfigDto = {
  type: "object",
  properties: {
    path: {
      type: "string",
      description: "path",
    },
    config_path: {
      type: "string",
      description: "config_path",
    },
    id: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "id",
    },
  },
  required: ["path", "config_path", "id"],
} as const;

export const $OldRegionOfInterestDto = {
  type: "object",
  properties: {
    left: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "left",
    },
    top: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "top",
    },
    width: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "width",
    },
    height: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "height",
    },
  },
  required: ["left", "top", "width", "height"],
} as const;

export const $ConfigMotionDetectorDto = {
  type: "object",
  properties: {
    enabled: {
      type: "boolean",
      description: "enable motion detector",
    },
    default_model: {
      description: "PredictionModelConfig",
      allOf: [
        {
          $ref: "#/components/schemas/PredictionModelConfig",
        },
      ],
    },
    filtering_model: {
      description: "ModelConfigDto",
      allOf: [
        {
          $ref: "#/components/schemas/ModelConfigDto",
        },
      ],
    },
    region_of_interest: {
      description: "RegionOfInterest",
      allOf: [
        {
          $ref: "#/components/schemas/OldRegionOfInterestDto",
        },
      ],
    },
    filtering_model_threshold: {
      type: "number",
      format: "float",
      description: "filtering_model_threshold",
    },
    filtering_model_threshold_gt: {
      type: "number",
      format: "float",
      description: "filtering_model_threshold_gt",
    },
    target_frame_rate: {
      type: "number",
      minimum: 0,
      description:
        "frame rate for motion detection (should be lower or equal to the video frame rate)",
      format: "integer",
    },
    sensitivity_threshold_percent: {
      type: "number",
      minimum: 0,
      maximum: 100,
      format: "integer",
      description: "sensitivity threshold",
    },
    pixel_threshold: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "pixel_threshold",
    },
    static_duration_ms: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "static_duration_ms",
    },
    initial_noise_duration_ms: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "initial_noise_duration_ms",
    },
    after_last_gt_duration_ms: {
      type: "number",
      minimum: 0,
      format: "integer",
      description: "after_last_gt_duration_ms",
    },
    sample_images_per_second: {
      type: "number",
      minimum: 1,
      format: "integer",
      description: "how many sample images to store per second",
    },
  },
  required: [
    "enabled",
    "default_model",
    "filtering_model",
    "region_of_interest",
    "filtering_model_threshold",
    "filtering_model_threshold_gt",
    "target_frame_rate",
    "sensitivity_threshold_percent",
    "pixel_threshold",
    "static_duration_ms",
    "initial_noise_duration_ms",
    "after_last_gt_duration_ms",
    "sample_images_per_second",
  ],
} as const;

export const $ConfigDeviceManagerDto = {
  type: "object",
  properties: {
    local_ip: {
      type: "string",
      description:
        "IP of this device, or “auto” if it should be determined automatically",
    },
    state_update_period: {
      type: "number",
      description:
        "Seconds between sending STATUS_UPDATE websocket messages to the app-server",
    },
    resources_update_period: {
      type: "number",
      description:
        "Seconds between sending UPDATE_RESOURCES websocket messages to the app-server",
    },
    worker_shared_folder: {
      type: "string",
      description:
        "Folder to share files (e.g. training config YAML) with the worker docker",
    },
    models_folder: {
      type: "string",
      description: "Folder to store deployed model files",
    },
    registry_access_token: {
      type: "string",
      description: "OAUTH2 token for accessing the docker registry",
    },
  },
  required: [
    "local_ip",
    "state_update_period",
    "resources_update_period",
    "worker_shared_folder",
    "models_folder",
  ],
} as const;

export const $ResourceAlertsConfigDto = {
  type: "object",
  properties: {
    threshold_percentage: {
      type: "number",
      minimum: 0,
      maximum: 100,
      description: "Threshold percentage for triggering an alert, 0 to disable",
    },
    alert_after_seconds: {
      type: "number",
      minimum: 0,
      description: "Alert after this many seconds above the threshold",
    },
    resolve_after_seconds: {
      type: "number",
      minimum: 0,
      description: "Resolve after this many seconds below the threshold",
    },
  },
  required: [
    "threshold_percentage",
    "alert_after_seconds",
    "resolve_after_seconds",
  ],
} as const;

export const $ServiceResourceAlertsConfigDto = {
  type: "object",
  properties: {
    memory_alerts: {
      $ref: "#/components/schemas/ResourceAlertsConfigDto",
    },
    cpu_alerts: {
      $ref: "#/components/schemas/ResourceAlertsConfigDto",
    },
  },
  required: ["memory_alerts", "cpu_alerts"],
} as const;

export const $ConfigResourceMonitoringDto = {
  type: "object",
  properties: {
    enabled: {
      type: "boolean",
      description: "Enable resource monitoring and threshold based alerts",
    },
    monitoring_interval_milliseconds: {
      type: "number",
      minimum: 1,
      description: "Monitoring interval in milliseconds",
    },
    device_alerts: {
      $ref: "#/components/schemas/ServiceResourceAlertsConfigDto",
    },
    agent_alerts: {
      $ref: "#/components/schemas/ServiceResourceAlertsConfigDto",
    },
    non_scan_detector_alerts: {
      $ref: "#/components/schemas/ServiceResourceAlertsConfigDto",
    },
  },
  required: [
    "enabled",
    "monitoring_interval_milliseconds",
    "device_alerts",
    "agent_alerts",
    "non_scan_detector_alerts",
  ],
} as const;

export const $ConfigLoggerDto = {
  type: "object",
  properties: {
    log_level: {
      type: "number",
      minimum: -1,
      maximum: 5,
      description:
        "Log level: -1- trace, 0- debug, 1- info, 2-warn, 3-error, 4-fatal, 5-panic",
    },
    console_logging_enabled: {
      type: "boolean",
      description: "Write logs to console",
    },
    file_logging_enabled: {
      type: "boolean",
      description: "Write logs to files",
    },
    directory: {
      type: "string",
      description:
        "path to rolling logs directory    (can be empty if file logging is disabled)",
    },
    filename: {
      type: "string",
      description:
        "base name of the rolling logs file     (can be empty if file logging is disabled)",
    },
    max_file_size: {
      type: "number",
      minimum: 0,
      description:
        "the max size in MB of the each log file     (can be 0 if file logging is disabled)",
    },
    max_backups: {
      type: "number",
      description:
        "the max number of log files to keep - or 0 to avoid deleting backups",
    },
    max_age: {
      type: "number",
      minimum: 0,
      description:
        "the max age in days to keep a logfile     (can be 0 if file logging is disabled)",
    },
    emitted_log_level: {
      type: "number",
      minimum: -1,
      maximum: 5,
      description:
        "the minimum log level to send to the backend. -1 value disables sending entirely. ",
    },
    reemit_timeout_seconds: {
      type: "number",
      description: "Timeout in seconds for re-emitting recurring logs",
      minimum: 0,
    },
  },
  required: [
    "log_level",
    "console_logging_enabled",
    "file_logging_enabled",
    "directory",
    "filename",
    "max_file_size",
    "max_backups",
    "max_age",
  ],
} as const;

export const $ConfigTrainingDto = {
  type: "object",
  properties: {
    worker_gpu_enabled: {
      type: "boolean",
      description: "Enable GPU in worker docker",
    },
  },
  required: ["worker_gpu_enabled"],
} as const;

export const $VideoRecordingEncodingEnum = {
  type: "string",
  enum: [
    "",
    "h264",
    "h265",
    "jpeg",
    "mjpeg",
    "jpg",
    "mjpg",
    "vp8",
    "vp9",
    "mpeg4",
    "raw",
    "ffv1",
  ],
  description: "encoding format for video",
} as const;

export const $VideoRecordingTypeEnum = {
  type: "string",
  enum: ["", "opencv", "gstreamer"],
  description: "switch backend for video encoding",
} as const;

export const $VideoRecordingCleanStrategyEnum = {
  type: "string",
  enum: ["", "fifo", "off"],
  description:
    'cleaning behaviour for video recordings once capacity is reached, "" | "fifo" - delete oldest videos once capacity is reached, "off" - will stop recording / not allow uploads when capacity is reached',
} as const;

export const $VideoRecordingContainerEnum = {
  type: "string",
  enum: ["", "mp4", "mkv", "webm"],
  description:
    "video recording ext - mp4,mkv,webm - leaving this empty will decide preffered based on encoding",
} as const;

export const $ConfigVideoRecordingDto = {
  type: "object",
  properties: {
    enabled: {
      type: "boolean",
      description: "enable/disable video recording of sessions",
    },
    folder: {
      type: "string",
      description: "folder for storing video recordings",
    },
    max_folder_size: {
      type: "number",
      minimum: 0,
      description:
        "max folder size in MiB, after which videos will not be stored",
    },
    max_video_inactivity_seconds: {
      type: "number",
      description:
        "duration since last client action, after which session should stop (fail safe for StopCostumerSession no called)",
    },
    post_session_recording_seconds: {
      type: "number",
      description: "additional duration to record after session ends",
    },
    encoding: {
      description: "encoding format for video",
      allOf: [
        {
          $ref: "#/components/schemas/VideoRecordingEncodingEnum",
        },
      ],
    },
    type: {
      description: "switch backend for video encoding",
      allOf: [
        {
          $ref: "#/components/schemas/VideoRecordingTypeEnum",
        },
      ],
    },
    hardware: {
      description: "choose hardware acceleration, defaults to cpu",
      allOf: [
        {
          $ref: "#/components/schemas/VideoRecordingHardwareEnum",
        },
      ],
    },
    convert_hardware: {
      description:
        "choose hardware acceleration for format conversion, defaults to cpu",
      allOf: [
        {
          $ref: "#/components/schemas/VideoRecordingHardwareEnum",
        },
      ],
    },
    convert_format: {
      type: "string",
      description: `the format the cpu turns the frames into for a hardware encoder's converter - "BGRx", "BGRA", "RGBA", "NV12"; empty is BGRx`,
      example: "BGRx",
    },
    frame_rate: {
      description:
        "framerate for video recording, -1 will use VideoSource.frame_rate",
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    pipeline: {
      type: "string",
      description: "GStreamer pipeline for video recording, supports templates",
      example:
        '$START ! x264enc tune=zerolatency ! matroskamux ! filesink location="$LOCATION"',
    },
    bitrate: {
      type: "number",
      description: "video encoding bitrate in bits/sec",
    },
    auto_upload: {
      type: "boolean",
      description: "auto upload video to designated cluster | backend",
    },
    clean_strategy: {
      description:
        'cleaning behaviour for video recordings once capacity is reached, "" | "fifo" - delete oldest videos once capacity is reached, "off" - will stop recording / not allow uploads when capacity is reached',
      allOf: [
        {
          $ref: "#/components/schemas/VideoRecordingCleanStrategyEnum",
        },
      ],
    },
    recorded_sessions_percentage: {
      type: "number",
      description: "The percentage of sessions to record",
      minimum: 0,
      maximum: 100,
    },
    container: {
      description:
        "video recording ext - mp4,mkv,webm - leaving this empty will decide preffered based on encoding",
      allOf: [
        {
          $ref: "#/components/schemas/VideoRecordingContainerEnum",
        },
      ],
    },
    non_scan_recording: {
      type: "boolean",
      description:
        "record video using non scan detecotr (if non scan detector is enabled)",
    },
    keep_videos_with_labels: {
      description:
        "List of labels/patterns for which videos should be kept regardless of recorded_sessions_percentage",
      type: "array",
      items: {
        type: "string",
      },
    },
    keep_videos_with_non_match: {
      type: "boolean",
      description: "Keep videos when there is a non-match alert",
    },
  },
  required: [
    "enabled",
    "folder",
    "max_folder_size",
    "max_video_inactivity_seconds",
  ],
} as const;

export const $IssueQueueInsertionPolicy = {
  type: "string",
  enum: ["LIFO", "FIFO"],
  description: "Insertion policy for issues in the queue",
} as const;

export const $IssuePublishProtocol = {
  type: "string",
  enum: ["", "mqtt"],
  description: "The protocol used for publishing",
} as const;

export const $QoS = {
  type: "number",
  enum: [0, 1, 2],
  description: "MQTT QoS",
} as const;

export const $PublishThumbnailsConfigDto = {
  type: "object",
  properties: {
    width: {
      type: "number",
      description: "Width of thumbnail in pixels",
    },
    height: {
      type: "number",
      description: "Height of thumbnail in pixels",
    },
  },
  required: ["width", "height"],
} as const;

export const $ConfigIssuesPublishDto = {
  type: "object",
  properties: {
    enabled: {
      type: "boolean",
      description:
        "Enable / disable publishing of issues when added to the queue",
    },
    protocol: {
      description: "The protocol used for publishing",
      allOf: [
        {
          $ref: "#/components/schemas/IssuePublishProtocol",
        },
      ],
    },
    url: {
      type: "string",
      description:
        "URL to publish to (broker, server, etc - depending on the protocol)",
    },
    topic: {
      type: "string",
      description: "Topic to publish to",
    },
    username: {
      type: "string",
      description: "Broker / server authentication user name",
    },
    password: {
      type: "string",
      description: "Broker / server authentication password",
    },
    reconnect_period: {
      type: "number",
      description: "Reconnect period in seconds",
    },
    qos: {
      description: "MQTT QoS",
      allOf: [
        {
          $ref: "#/components/schemas/QoS",
        },
      ],
    },
    payload: {
      type: "object",
      description:
        "Key/value pairs of fields to publish along with any issue - can be nested. Key names should be in snake_case instead of camelCase, and will be converted automatically",
    },
    thumbnails: {
      description: "Thumbnails configuration",
      allOf: [
        {
          $ref: "#/components/schemas/PublishThumbnailsConfigDto",
        },
      ],
    },
  },
  required: [
    "enabled",
    "protocol",
    "url",
    "topic",
    "username",
    "password",
    "reconnect_period",
    "qos",
  ],
} as const;

export const $ConfigIssuesQueueDto = {
  type: "object",
  properties: {
    in_session_only: {
      type: "boolean",
      description:
        "If true, add issues to the queue only in a session (between StartCustomerSession and StopCustomerSession), otherwise - always",
    },
    insertion_policy: {
      description: "Insertion policy for issues in the queue",
      allOf: [
        {
          $ref: "#/components/schemas/IssueQueueInsertionPolicy",
        },
      ],
    },
    add_match_alerts: {
      type: "boolean",
      description: `If true, add "ticketSwitch" alerts in case of a mismatch between the sample's label and the prediction`,
    },
    publish: {
      description:
        "Optional configuration for publishing issues added to the queue",
      allOf: [
        {
          $ref: "#/components/schemas/ConfigIssuesPublishDto",
        },
      ],
    },
  },
  required: ["in_session_only", "insertion_policy", "add_match_alerts"],
} as const;

export const $ConfigPublishDto = {
  type: "object",
  properties: {
    in_session_only: {
      type: "boolean",
      description:
        "If true, add issues to the queue only in a session (between StartCustomerSession and StopCustomerSession), otherwise - always",
    },
    add_match_alerts: {
      type: "boolean",
      description: `If true, add "ticketSwitch" alerts in case of a mismatch between the sample's label and the prediction`,
    },
    thumbnails: {
      description: "Thumbnails configuration",
      allOf: [
        {
          $ref: "#/components/schemas/PublishThumbnailsConfigDto",
        },
      ],
    },
    alert_left_in_cart: {
      type: "boolean",
      description: "If true, send webhook alerts for left-in-cart detections",
    },
    send_predictions: {
      type: "boolean",
      description:
        "If true, send the prediction event on every capture - the predict webhook and the PREDICTION_RESPONSE MQTT message. Alerts are unaffected. Default is false",
    },
    send_samples: {
      type: "boolean",
      description:
        "If true, send the sample webhook when a sample is stored. Applies to every publisher, while Webhooks.report_samples turns the same event off for the webhooks target alone. Default is true",
    },
  },
  required: ["in_session_only", "add_match_alerts"],
} as const;

export const $ConfigWebhooksDto = {
  type: "object",
  properties: {
    enabled: {
      type: "boolean",
      description: "enable webhooks",
    },
    url: {
      type: "string",
      description: "webhooks base url",
    },
    auth: {
      type: "boolean",
      description: "Enable authentication for webhooks",
    },
    timeout: {
      type: "number",
      description: "Timeout in seconds for webhook requests",
      minimum: 0,
    },
    report_samples: {
      type: "boolean",
      description: "Report sample updates via webhooks",
    },
    report_predictions: {
      type: "boolean",
      description: "Report predictions via webhooks",
    },
  },
  required: ["enabled", "url"],
} as const;

export const $ConfigMqttTlsDto = {
  type: "object",
  properties: {
    ca_cert: {
      oneOf: [
        {
          type: "string",
          description: "Absolute file path on the device",
        },
        {
          type: "object",
          description: "Write content to path and store path in config",
          properties: {
            path: {
              type: "string",
            },
            content: {
              type: "string",
            },
          },
          required: ["path", "content"],
        },
      ],
      description: "CA certificate",
    },
    client_cert: {
      oneOf: [
        {
          type: "string",
          description: "Absolute file path on the device",
        },
        {
          type: "object",
          description: "Write content to path and store path in config",
          properties: {
            path: {
              type: "string",
            },
            content: {
              type: "string",
            },
          },
          required: ["path", "content"],
        },
      ],
      description: "Client certificate for mTLS",
    },
    client_key: {
      oneOf: [
        {
          type: "string",
          description: "Absolute file path on the device",
        },
        {
          type: "object",
          description: "Write content to path and store path in config",
          properties: {
            path: {
              type: "string",
            },
            content: {
              type: "string",
            },
          },
          required: ["path", "content"],
        },
      ],
      description: "Client private key for mTLS",
    },
    insecure_skip_verify: {
      type: "boolean",
      description:
        "Skip server certificate verification (insecure, testing only)",
    },
    server_name: {
      type: "string",
      description: "SNI server name override",
    },
    min_version: {
      description: "Minimum TLS version",
      allOf: [
        {
          $ref: "#/components/schemas/TlsMinVersionEnum",
        },
      ],
    },
  },
  required: ["insecure_skip_verify", "min_version"],
} as const;

export const $ConfigMqttDto = {
  type: "object",
  properties: {
    enabled: {
      type: "boolean",
      description: "Enable MQTT",
    },
    url: {
      type: "string",
      description: "MQTT Broker URL",
    },
    publish_topic: {
      type: "string",
      description: "Publish topic",
    },
    left_in_cart_publish_topic: {
      type: "string",
      description:
        "Dedicated topic for left-in-cart responses, empty disables publishing them",
    },
    subscribe_topic: {
      type: "string",
      description: "Subscribe topic",
    },
    username: {
      type: "string",
      description: "MQTT username",
    },
    password: {
      type: "string",
      description: "MQTT password",
    },
    reconnect_period: {
      type: "number",
      description: "Reconnect period",
    },
    qos: {
      description: "MQTT QoS",
      allOf: [
        {
          $ref: "#/components/schemas/QoS",
        },
      ],
    },
    payload: {
      type: "object",
      description:
        "Key/value pairs of fields to publish along with any issue - can be nested. Key names should be in snake_case instead of camelCase, and will be converted automatically",
    },
    publish_retries: {
      type: "number",
      minimum: 0,
      description: "Publish retries",
    },
    tls: {
      $ref: "#/components/schemas/ConfigMqttTlsDto",
    },
  },
  required: [
    "enabled",
    "url",
    "publish_topic",
    "subscribe_topic",
    "username",
    "password",
    "reconnect_period",
    "qos",
    "publish_retries",
  ],
} as const;

export const $PartialDeviceConfigDto = {
  type: "object",
  properties: {
    Agent: {
      $ref: "#/components/schemas/ConfigAgentDto",
    },
    Api: {
      $ref: "#/components/schemas/ConfigApiDto",
    },
    Analytics: {
      $ref: "#/components/schemas/ConfigAnalyticsDto",
    },
    VideoStream: {
      $ref: "#/components/schemas/ConfigVideoStreamDto",
    },
    Database: {
      $ref: "#/components/schemas/ConfigDatabaseDto",
    },
    DataManager: {
      $ref: "#/components/schemas/ConfigDataManagerDto",
    },
    Predictor: {
      $ref: "#/components/schemas/ConfigPredictorDto",
    },
    NonScanDetector: {
      $ref: "#/components/schemas/ConfigNonScanDetectorDto",
    },
    OnScreenApp: {
      $ref: "#/components/schemas/ConfigOnScreenAppDto",
    },
    ZebraAdapter: {
      $ref: "#/components/schemas/ConfigZebraAdapterDto",
    },
    MotionDetector: {
      $ref: "#/components/schemas/ConfigMotionDetectorDto",
    },
    DeviceManager: {
      $ref: "#/components/schemas/ConfigDeviceManagerDto",
    },
    ResourceMonitoring: {
      $ref: "#/components/schemas/ConfigResourceMonitoringDto",
    },
    Logger: {
      $ref: "#/components/schemas/ConfigLoggerDto",
    },
    Training: {
      $ref: "#/components/schemas/ConfigTrainingDto",
    },
    VideoRecording: {
      $ref: "#/components/schemas/ConfigVideoRecordingDto",
    },
    IssuesQueue: {
      $ref: "#/components/schemas/ConfigIssuesQueueDto",
    },
    Publish: {
      $ref: "#/components/schemas/ConfigPublishDto",
    },
    Webhooks: {
      $ref: "#/components/schemas/ConfigWebhooksDto",
    },
    Mqtt: {
      $ref: "#/components/schemas/ConfigMqttDto",
    },
  },
} as const;

export const $DevicesConfigDeploymentBulkDto = {
  type: "object",
  properties: {
    deviceConfig: {
      $ref: "#/components/schemas/PartialDeviceConfigDto",
    },
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    isPartial: {
      type: "boolean",
    },
    originalDeviceId: {
      type: "number",
      minimum: 1,
    },
    dontCleanDangerousConfigParams: {
      type: "boolean",
    },
  },
  required: ["deviceConfig", "query", "isPartial"],
} as const;

export const $DeviceConfigDangerousFields = {
  type: "string",
  enum: [
    "NonScanDetector.roi_checkout",
    "NonScanDetector.roi_scale",
    "VideoStream.roi_predictor",
    "VideoStream.crop_enable",
    "VideoStream.crop_x1",
    "VideoStream.crop_x2",
    "VideoStream.crop_y1",
    "VideoStream.crop_y2",
  ],
  description: "The dangerous config fields - use with caution",
} as const;

export const $DangerousConfigDto = {
  type: "object",
  properties: {
    fields: {
      description: "The dangerous config fields - use with caution",
      allOf: [
        {
          $ref: "#/components/schemas/DeviceConfigDangerousFields",
        },
      ],
    },
  },
  required: ["fields"],
} as const;

export const $DevicesRestartBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    restartAgent: {
      type: "boolean",
      default: true,
    },
    restartNS: {
      type: "boolean",
      default: false,
      description: "Accepted for future NS restart support",
    },
    restartJobs: {
      type: "boolean",
      default: false,
      description: "Accepted for future jobs restart support",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
  },
  required: ["query"],
} as const;

export const $CancelConfigDeploymentDto = {
  type: "object",
  properties: {
    deploymentId: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["deploymentId"],
} as const;

export const $ServiceVersionDto = {
  type: "object",
  properties: {
    types: {
      type: "array",
      items: {
        type: "string",
      },
    },
    version: {
      type: "string",
    },
    isDeployed: {
      type: "boolean",
    },
    isLatest: {
      type: "boolean",
    },
    type: {
      type: "string",
    },
  },
  required: ["version", "isDeployed", "isLatest"],
} as const;

export const $DeviceUploadPreviewRowDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    cluster: {
      type: "string",
    },
    site: {
      type: "string",
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        type: "string",
      },
    },
    status: {
      enum: ["new", "existing", "error"],
      type: "string",
    },
    warnings: {
      description: "Warning messages (e.g. cluster/site not found)",
      type: "array",
      items: {
        type: "string",
      },
    },
    error: {
      type: "string",
      description: "Error message when status is error",
    },
  },
  required: ["name", "tags", "status", "warnings"],
} as const;

export const $DeviceUploadResponseDto = {
  type: "object",
  properties: {
    dryRun: {
      type: "boolean",
      description:
        "Whether this response is from a dry run (preview) or an actual apply",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DeviceUploadPreviewRowDto",
      },
    },
    totalNew: {
      type: "number",
    },
    totalExisting: {
      type: "number",
    },
    totalErrors: {
      type: "number",
    },
    fatalError: {
      type: "string",
      description:
        "Fatal error that prevents the entire upload from proceeding",
    },
  },
  required: ["dryRun", "results", "totalNew", "totalExisting", "totalErrors"],
} as const;

export const $UploadDevicesFileDto = {
  type: "object",
  properties: {
    file: {
      type: "string",
      format: "binary",
    },
    dryRun: {
      type: "boolean",
      description:
        "If true, validate and return preview without applying changes",
      default: false,
    },
  },
  required: ["file", "dryRun"],
} as const;

export const $LabelsDistributionDto = {
  type: "object",
  properties: {
    labels: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            type: "number",
          },
        ],
      },
    },
    total: {
      type: "number",
    },
  },
  required: ["labels", "total"],
} as const;

export const $DeviceDetailsClusterDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    architecture: {
      type: "string",
    },
    serverDeviceId: {
      type: "number",
    },
  },
  required: ["id", "name", "architecture", "serverDeviceId"],
} as const;

export const $DeviceDetailsSiteDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "name"],
} as const;

export const $DeviceDetailsCharacteristicDto = {
  type: "object",
  properties: {
    cpu: {
      type: "string",
    },
    gpu: {
      type: "string",
    },
    ram: {
      type: "string",
    },
    disk: {
      type: "string",
    },
    os: {
      type: "string",
    },
    platform: {
      type: "string",
    },
    platformFamily: {
      type: "string",
    },
    platformVersion: {
      type: "string",
    },
    kernelArch: {
      type: "string",
    },
    kernelVersion: {
      type: "string",
    },
  },
  required: ["cpu", "gpu", "ram", "disk"],
} as const;

export const $DeviceDetailsDataStreamDto = {
  type: "object",
  properties: {
    capacity: {
      format: "int64",
      type: "integer",
    },
    usedSpace: {
      format: "int64",
      type: "integer",
    },
    labelsDistribution: {
      $ref: "#/components/schemas/LabelsDistributionDto",
    },
  },
  required: ["capacity", "usedSpace"],
} as const;

export const $DeviceDetailsDeployedModelDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    role: {
      type: "string",
    },
    type: {
      type: "string",
    },
  },
  required: ["id", "name", "updatedAt", "role", "type"],
} as const;

export const $DeviceDetailsDto = {
  type: "object",
  properties: {
    state: {
      enum: ["deploying", "ready", "disconnected", "disabled", "down"],
      type: "string",
    },
    cameraState: {
      enum: ["Unknown", "Disabled", "Disconnected", "Down", "OK"],
      type: "string",
    },
    clientAppMode: {
      nullable: true,
      enum: ["active", "silent"],
      type: "string",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
      nullable: true,
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    ip: {
      type: "string",
      nullable: true,
    },
    localIp: {
      type: "string",
      nullable: true,
    },
    clusterId: {
      type: "number",
      nullable: true,
    },
    lastPing: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    port: {
      type: "string",
      nullable: true,
    },
    agentVersion: {
      type: "string",
      nullable: true,
    },
    webGrpcPort: {
      type: "string",
      nullable: true,
    },
    webServerPort: {
      type: "string",
      nullable: true,
    },
    httpPort: {
      type: "string",
      nullable: true,
    },
    httpsPort: {
      type: "string",
      nullable: true,
    },
    calibrated: {
      type: "boolean",
      nullable: true,
    },
    calibrationSampleId: {
      type: "string",
      nullable: true,
    },
    cluster: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/DeviceDetailsClusterDto",
        },
      ],
    },
    site: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/DeviceDetailsSiteDto",
        },
      ],
    },
    characteristics: {
      $ref: "#/components/schemas/DeviceDetailsCharacteristicDto",
    },
    dataStream: {
      $ref: "#/components/schemas/DeviceDetailsDataStreamDto",
    },
    deployedModel: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/DeviceDetailsDeployedModelDto",
        },
      ],
    },
    modelDeployments: {
      nullable: true,
      type: "array",
      items: {
        $ref: "#/components/schemas/DeviceDetailsDeployedModelDto",
      },
    },
    serviceDeployments: {
      type: "object",
      additionalProperties: {
        type: "array",
        items: true,
      },
    },
    lastPredictionTime: {
      format: "date-time",
      type: "string",
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
    firstConnectedAt: {
      format: "date-time",
      type: "string",
    },
    connectedSince: {
      format: "date-time",
      type: "string",
    },
    agentDeploymentTime: {
      format: "date-time",
      type: "string",
    },
    configLocked: {
      type: "boolean",
    },
    lastCameraPing: {
      format: "date-time",
      type: "string",
    },
    sampleBufferStatus: {
      type: "object",
    },
    videoBufferStatus: {
      type: "object",
    },
    servicesStatus: {
      type: "object",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    alertsEnabled: {
      type: "boolean",
    },
  },
  required: [
    "state",
    "cameraState",
    "id",
    "name",
    "description",
    "createdAt",
    "updatedAt",
    "ip",
    "localIp",
    "clusterId",
    "lastPing",
    "port",
    "agentVersion",
    "webGrpcPort",
    "webServerPort",
    "httpPort",
    "httpsPort",
    "calibrated",
    "calibrationSampleId",
    "cluster",
    "site",
    "characteristics",
    "dataStream",
    "deployedModel",
    "modelDeployments",
    "serviceDeployments",
    "lastPredictionTime",
    "activationTime",
    "firstConnectedAt",
    "connectedSince",
    "agentDeploymentTime",
    "configLocked",
    "lastCameraPing",
    "sampleBufferStatus",
    "videoBufferStatus",
    "servicesStatus",
    "tags",
    "alertsEnabled",
  ],
} as const;

export const $UpdateDeviceDto = {
  type: "object",
  properties: {
    state: {
      enum: ["deploying", "ready", "disconnected", "disabled", "down"],
      type: "string",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    configLocked: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
} as const;

export const $DeviceEventsOrderEnum = {
  type: "string",
  enum: ["createdAt", "addedAt", "name"],
} as const;

export const $DeviceEventsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/DeviceEventsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListDeviceEventsDto = {
  type: "object",
  properties: {
    logLevel: {
      type: "array",
      items: {
        type: "string",
      },
    },
    timeField: {
      enum: ["createdAt", "addedAt"],
      type: "string",
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DeviceEventsOrderEnumSortOption",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
    fromDate: {
      format: "date-time",
      type: "string",
    },
    toDate: {
      format: "date-time",
      type: "string",
    },
    text: {
      type: "string",
    },
  },
  required: ["limit", "page"],
} as const;

export const $DeviceEventDto = {
  type: "object",
  properties: {
    uuid: {
      type: "string",
      format: "uuid",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    addedAt: {
      format: "date-time",
      type: "string",
    },
    data: {
      type: "object",
    },
    device: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    logMessage: {
      type: "string",
    },
    logLevel: {
      type: "string",
    },
    errorMessage: {
      type: "string",
    },
  },
  required: [
    "uuid",
    "createdAt",
    "addedAt",
    "logMessage",
    "logLevel",
    "errorMessage",
  ],
} as const;

export const $DeviceConfigDto = {
  type: "object",
  properties: {
    Agent: {
      $ref: "#/components/schemas/ConfigAgentDto",
    },
    Api: {
      $ref: "#/components/schemas/ConfigApiDto",
    },
    Analytics: {
      $ref: "#/components/schemas/ConfigAnalyticsDto",
    },
    VideoStream: {
      $ref: "#/components/schemas/ConfigVideoStreamDto",
    },
    Database: {
      $ref: "#/components/schemas/ConfigDatabaseDto",
    },
    DataManager: {
      $ref: "#/components/schemas/ConfigDataManagerDto",
    },
    Predictor: {
      $ref: "#/components/schemas/ConfigPredictorDto",
    },
    NonScanDetector: {
      $ref: "#/components/schemas/ConfigNonScanDetectorDto",
    },
    OnScreenApp: {
      $ref: "#/components/schemas/ConfigOnScreenAppDto",
    },
    ZebraAdapter: {
      $ref: "#/components/schemas/ConfigZebraAdapterDto",
    },
    MotionDetector: {
      $ref: "#/components/schemas/ConfigMotionDetectorDto",
    },
    DeviceManager: {
      $ref: "#/components/schemas/ConfigDeviceManagerDto",
    },
    ResourceMonitoring: {
      $ref: "#/components/schemas/ConfigResourceMonitoringDto",
    },
    Logger: {
      $ref: "#/components/schemas/ConfigLoggerDto",
    },
    Training: {
      $ref: "#/components/schemas/ConfigTrainingDto",
    },
    VideoRecording: {
      $ref: "#/components/schemas/ConfigVideoRecordingDto",
    },
    IssuesQueue: {
      $ref: "#/components/schemas/ConfigIssuesQueueDto",
    },
    Publish: {
      $ref: "#/components/schemas/ConfigPublishDto",
    },
    Webhooks: {
      $ref: "#/components/schemas/ConfigWebhooksDto",
    },
    Mqtt: {
      $ref: "#/components/schemas/ConfigMqttDto",
    },
  },
  required: [
    "Agent",
    "Api",
    "Analytics",
    "VideoStream",
    "Database",
    "DataManager",
    "Predictor",
    "NonScanDetector",
    "OnScreenApp",
    "ZebraAdapter",
    "MotionDetector",
    "DeviceManager",
    "Logger",
    "Training",
    "VideoRecording",
    "IssuesQueue",
    "Publish",
    "Webhooks",
    "Mqtt",
  ],
} as const;

export const $RevertConfigDto = {
  type: "object",
  properties: {
    configDeploymentId: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["configDeploymentId"],
} as const;

export const $PasswordDto = {
  type: "object",
  properties: {
    password: {
      type: "string",
    },
  },
} as const;

export const $GetSamplesQueryRequestDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "array",
      items: {
        type: "string",
      },
    },
    groupId: {
      type: "array",
      items: {
        type: "string",
      },
    },
    deviceId: {
      type: "array",
      items: {
        type: "number",
      },
    },
    label: {
      type: "array",
      items: {
        type: "string",
      },
    },
    labelTrigger: {
      type: "array",
      items: {
        type: "string",
      },
    },
    captureTrigger: {
      type: "array",
      items: {
        type: "string",
      },
    },
    family: {
      type: "array",
      items: {
        type: "string",
      },
    },
    category: {
      type: "array",
      items: {
        type: "string",
      },
    },
    imgSource: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetType: {
      type: "array",
      items: {
        type: "string",
      },
    },
    dataType: {
      type: "array",
      items: {
        type: "string",
      },
    },
    opened: {
      type: "boolean",
    },
    pendingRemoteAction: {
      type: "string",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    timeField: {
      type: "string",
    },
    page: {
      type: "number",
    },
    limit: {
      type: "number",
    },
    orderBy: {
      type: "string",
    },
    direction: {
      type: "string",
    },
    uploadedBackend: {
      type: "boolean",
    },
    uploadedCluster: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    headsFound: {
      type: "boolean",
    },
  },
} as const;

export const $DeviceSampleDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "string",
    },
    groupId: {
      type: "string",
    },
    label: {
      type: "string",
    },
    size: {
      type: "number",
    },
    opened: {
      type: "boolean",
    },
    pendingRemoteAction: {
      type: "string",
    },
    datasetType: {
      type: "string",
    },
    imgSource: {
      type: "string",
    },
    labelTrigger: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    deviceId: {
      type: "number",
    },
    family: {
      type: "string",
    },
    category: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    capturedAt: {
      format: "date-time",
      type: "string",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    addedAt: {
      format: "date-time",
      type: "string",
    },
    matchStrength: {
      type: "string",
    },
    barcode: {
      type: "string",
    },
    price: {
      type: "string",
    },
    weight: {
      type: "string",
    },
    name: {
      type: "string",
    },
    dataType: {
      type: "string",
    },
    uploadedCluster: {
      type: "boolean",
    },
    uploadedBackend: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    headsFound: {
      type: "boolean",
    },
  },
  required: [
    "sampleId",
    "groupId",
    "label",
    "size",
    "opened",
    "datasetType",
    "imgSource",
    "labelTrigger",
    "captureTrigger",
    "deviceId",
    "family",
    "category",
    "sessionId",
    "createdAt",
  ],
} as const;

export const $GetSamplesQueryResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DeviceSampleDto",
      },
    },
    total: {
      type: "number",
    },
    perPage: {
      type: "number",
    },
    page: {
      type: "number",
    },
    lastPage: {
      type: "number",
    },
  },
  required: ["results", "total", "perPage", "page", "lastPage"],
} as const;

export const $DataStreamDto = {
  type: "object",
  properties: {
    labels_distribution: {
      type: "object",
      properties: {
        opened: {
          type: "object",
          additionalProperties: {
            type: "number",
          },
        },
        closed: {
          type: "object",
          additionalProperties: {
            type: "number",
          },
        },
      },
      required: ["opened", "closed"],
    },
    used_space: {
      type: "number",
    },
    number_of_samples: {
      type: "number",
    },
  },
  required: ["labels_distribution", "used_space", "number_of_samples"],
} as const;

export const $StartRecordingResponseDto = {
  type: "object",
  properties: {
    start_time: {
      format: "date-time",
      type: "string",
    },
    end_time: {
      format: "date-time",
      type: "string",
    },
    session_id: {
      type: "string",
    },
    path: {
      type: "string",
    },
    size: {
      type: "number",
    },
    codec: {
      type: "string",
    },
    width: {
      type: "number",
    },
    height: {
      type: "number",
    },
    fps: {
      type: "number",
    },
  },
  required: [
    "start_time",
    "end_time",
    "session_id",
    "path",
    "size",
    "codec",
    "width",
    "height",
    "fps",
  ],
} as const;

export const $StopRecordingRequestDto = {
  type: "object",
  properties: {
    report: {
      type: "boolean",
    },
  },
} as const;

export const $VideoFileDto = {
  type: "object",
  properties: {
    start_time: {
      format: "date-time",
      type: "string",
    },
    end_time: {
      format: "date-time",
      type: "string",
    },
    session_id: {
      type: "string",
    },
    path: {
      type: "string",
    },
    size: {
      type: "number",
    },
    codec: {
      type: "string",
    },
    width: {
      type: "number",
    },
    height: {
      type: "number",
    },
    fps: {
      type: "number",
    },
  },
  required: [
    "start_time",
    "end_time",
    "session_id",
    "path",
    "size",
    "codec",
    "width",
    "height",
    "fps",
  ],
} as const;

export const $VideoFrameDto = {
  type: "object",
  properties: {
    image: {
      type: "string",
    },
    frame: {
      type: "number",
    },
    time: {
      type: "number",
    },
  },
  required: ["image", "frame", "time"],
} as const;

export const $VideoReportDto = {
  type: "object",
  properties: {
    frames: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VideoFrameDto",
      },
    },
    total_frame_count: {
      type: "number",
    },
    duration: {
      type: "number",
    },
  },
  required: ["frames", "total_frame_count", "duration"],
} as const;

export const $StopRecordingResponseDto = {
  type: "object",
  properties: {
    recording: {
      $ref: "#/components/schemas/VideoFileDto",
    },
    report: {
      $ref: "#/components/schemas/VideoReportDto",
    },
    error: {
      type: "string",
    },
  },
} as const;

export const $VideoUploadTargetEnum = {
  type: "string",
  enum: ["backend", "cluster"],
  description: "",
} as const;

export const $GetSessionsRequestDto = {
  type: "object",
  properties: {
    sessionId: {
      type: "array",
      items: {
        type: "string",
      },
    },
    deviceId: {
      type: "array",
      items: {
        type: "number",
      },
    },
    uploadedBackend: {
      type: "boolean",
    },
    uploadedCluster: {
      type: "boolean",
    },
    shouldUpload: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    timeField: {
      type: "string",
    },
    page: {
      type: "number",
    },
    limit: {
      type: "number",
    },
    order: {
      type: "string",
    },
    direction: {
      type: "string",
    },
  },
} as const;

export const $StartVideoUploadRequestDto = {
  type: "object",
  properties: {
    target: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    query: {
      $ref: "#/components/schemas/GetSessionsRequestDto",
    },
    delete: {
      type: "boolean",
    },
    force: {
      type: "boolean",
    },
    timeout: {
      type: "number",
    },
    maxUploadSpeed: {
      type: "number",
    },
    name: {
      type: "string",
    },
    onlyHeadBlurred: {
      type: "boolean",
      description:
        "Upload only already-blurred videos - forces query.head_blurred=true. Added ^1.58.0 || ^2.34.0",
    },
    waitForBlur: {
      type: "boolean",
      description:
        "Blur a session before uploading it when it is not blurred yet; a blur failure fails the session. Added ^1.58.0 || ^2.34.0",
    },
  },
} as const;

export const $StartUploadResponseDto = {
  type: "object",
  properties: {
    id: {
      type: "string",
    },
    name: {
      type: "string",
    },
  },
} as const;

export const $NameRequestDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
  },
} as const;

export const $MultipartProgressDto = {
  type: "object",
  properties: {
    operation: {
      description: `Which operation this is about. Missing on agents that predate the split - such a report is
always an upload, and carries only the upload fields. Use \`isBlurProgress\`/\`progressOperation\`
rather than reading this directly.`,
      enum: ["upload", "blur"],
      type: "string",
    },
    totalBytes: {
      type: "number",
      description:
        "Upload-only, set when `operation` is `upload` (or missing).",
    },
    doneBytes: {
      type: "number",
    },
    remainingBytes: {
      type: "number",
    },
    currentRateBytesPerSecond: {
      type: "number",
    },
    averageRateBytesPerSecond: {
      type: "number",
    },
    videoSize: {
      type: "number",
      description:
        "Size of the video being blurred - what an estimate is built from before the detector reports one.",
    },
    videoSeconds: {
      type: "number",
    },
    currentFrame: {
      type: "number",
    },
    sourceTotalFrames: {
      type: "number",
    },
    totalFrames: {
      type: "number",
    },
    totalFramesWithHeads: {
      type: "number",
    },
    totalProcessingSec: {
      type: "number",
    },
    status: {
      type: "string",
      description: "Agent-side status string; empty before anything started.",
    },
    sessionId: {
      type: "string",
    },
    filename: {
      type: "string",
    },
    running: {
      type: "boolean",
    },
    percent: {
      type: "number",
      description:
        "0..1 of the item - bytes written for an upload, frames read for a blur. 0 until it can place itself.",
    },
    remainingSeconds: {
      type: "number",
    },
    durationMs: {
      type: "number",
    },
    startTime: {
      format: "date-time",
      type: "string",
    },
    endTime: {
      format: "date-time",
      type: "string",
    },
    lastError: {
      type: "string",
    },
  },
} as const;

export const $VideoUploadProgressDto = {
  type: "object",
  properties: {
    id: {
      type: "string",
      description:
        "UUID, unique per run. Available on agent ^1.57.0 || ^2.33.0",
    },
    name: {
      type: "string",
      description:
        "Optional label; multiple runs can share a name. Available on agent ^1.57.0 || ^2.33.0",
    },
    latest: {
      type: "boolean",
      description:
        "True if this is the most recent run for the given name. Available on agent ^1.57.0 || ^2.33.0",
    },
    startTime: {
      type: "string",
      description:
        "ISO date string when upload started. Available on agent ^1.57.0 || ^2.33.0",
    },
    endTime: {
      type: "string",
      description:
        "ISO date string when upload ended; omitted if still running. Available on agent ^1.57.0 || ^2.33.0",
    },
    args: {
      type: "object",
      description:
        "Original request args passed to StartVideoUpload. Available on agent ^1.57.0 || ^2.33.0",
    },
    running: {
      type: "boolean",
    },
    total: {
      type: "number",
    },
    remaining: {
      type: "number",
    },
    done: {
      type: "number",
    },
    progress: {
      $ref: "#/components/schemas/MultipartProgressDto",
    },
    lastError: {
      type: "object",
    },
    error: {
      type: "object",
    },
    failures: {
      type: "number",
    },
    skipped: {
      type: "number",
    },
  },
  required: ["running", "total", "remaining", "done"],
} as const;

export const $StartSamplesUploadRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/GetSamplesQueryRequestDto",
    },
    name: {
      type: "string",
    },
    target: {
      type: "string",
      description: "Upload destination. Added ^1.57.0 || ^2.33.0",
      enum: ["cluster", "backend"],
    },
    delete: {
      type: "boolean",
      description: "Delete sample after upload. Added ^1.57.0 || ^2.33.0",
    },
    force: {
      type: "boolean",
      description:
        "Re-upload even if already uploaded. Added ^1.57.0 || ^2.33.0",
    },
    maxUploadSpeed: {
      type: "number",
      description:
        "Max upload speed override, 0 = infinite. Added ^1.57.0 || ^2.33.0",
    },
    timeout: {
      type: "number",
      description:
        "Request timeout override ms, 0 = infinite. Added ^1.57.0 || ^2.33.0",
    },
    onlyHeadBlurred: {
      type: "boolean",
      description:
        "Upload only already-blurred samples - forces query.head_blurred=true. Added ^1.58.0 || ^2.34.0",
    },
    waitForBlur: {
      type: "boolean",
      description:
        "Blur a sample before uploading it when it is not blurred yet; a blur failure fails the sample. Added ^1.58.0 || ^2.34.0",
    },
  },
} as const;

export const $SampleUploadProgressDto = {
  type: "object",
  properties: {
    id: {
      type: "string",
      description:
        "UUID, unique per run. Available on agent ^1.57.0 || ^2.33.0",
    },
    name: {
      type: "string",
      description:
        "Optional label; multiple runs can share a name. Available on agent ^1.57.0 || ^2.33.0",
    },
    latest: {
      type: "boolean",
      description:
        "True if this is the most recent run for the given name. Available on agent ^1.57.0 || ^2.33.0",
    },
    startTime: {
      type: "string",
      description:
        "ISO date string when upload started. Available on agent ^1.57.0 || ^2.33.0",
    },
    endTime: {
      type: "string",
      description:
        "ISO date string when upload ended; omitted if still running. Available on agent ^1.57.0 || ^2.33.0",
    },
    args: {
      description:
        "Original request args passed to StartSamplesUpload. Available on agent ^1.57.0 || ^2.33.0",
      allOf: [
        {
          $ref: "#/components/schemas/StartSamplesUploadRequestDto",
        },
      ],
    },
    running: {
      type: "boolean",
    },
    total: {
      type: "number",
    },
    remaining: {
      type: "number",
    },
    done: {
      type: "number",
    },
    lastError: {
      type: "object",
    },
    error: {
      type: "object",
    },
    failures: {
      type: "number",
    },
    skipped: {
      type: "number",
    },
    progress: {
      $ref: "#/components/schemas/MultipartProgressDto",
    },
  },
  required: ["running", "total", "remaining", "done"],
} as const;

export const $ListSamplesUploadsResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleUploadProgressDto",
      },
    },
    page: {
      type: "number",
    },
    perPage: {
      type: "number",
    },
    total: {
      type: "number",
    },
    lastPage: {
      type: "number",
    },
  },
  required: ["results"],
} as const;

export const $ListVideoUploadsResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VideoUploadProgressDto",
      },
    },
    page: {
      type: "number",
    },
    perPage: {
      type: "number",
    },
    total: {
      type: "number",
    },
    lastPage: {
      type: "number",
    },
  },
  required: ["results"],
} as const;

export const $StartHeadBlurVideosRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/GetSessionsRequestDto",
    },
    name: {
      type: "string",
      description:
        'Optional job name; multiple runs may share a name. Omit → agent uses "default".',
    },
    force: {
      type: "boolean",
      description: "re-blur even if the session is already marked headBlurred",
    },
  },
} as const;

export const $HeadBlurVideosArgsDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/GetSessionsRequestDto",
    },
    name: {
      type: "string",
    },
    force: {
      type: "boolean",
    },
    context: {
      type: "object",
      additionalProperties: true,
    },
  },
} as const;

export const $BlurProgressDto = {
  type: "object",
  properties: {
    operation: {
      description: `Which operation this is about. Missing on agents that predate the split - such a report is
always an upload, and carries only the upload fields. Use \`isBlurProgress\`/\`progressOperation\`
rather than reading this directly.`,
      enum: ["upload", "blur"],
      type: "string",
    },
    videoSize: {
      type: "number",
      description:
        "Size of the video being blurred - what an estimate is built from before the detector reports one.",
    },
    videoSeconds: {
      type: "number",
    },
    currentFrame: {
      type: "number",
    },
    sourceTotalFrames: {
      type: "number",
    },
    totalFrames: {
      type: "number",
    },
    totalFramesWithHeads: {
      type: "number",
    },
    totalProcessingSec: {
      type: "number",
    },
    status: {
      type: "string",
      description: "Agent-side status string; empty before anything started.",
    },
    sessionId: {
      type: "string",
    },
    filename: {
      type: "string",
    },
    running: {
      type: "boolean",
    },
    percent: {
      type: "number",
      description:
        "0..1 of the item - bytes written for an upload, frames read for a blur. 0 until it can place itself.",
    },
    remainingSeconds: {
      type: "number",
    },
    durationMs: {
      type: "number",
    },
    startTime: {
      format: "date-time",
      type: "string",
    },
    endTime: {
      format: "date-time",
      type: "string",
    },
    lastError: {
      type: "string",
    },
  },
} as const;

export const $HeadBlurVideosStateDto = {
  type: "object",
  properties: {
    args: {
      $ref: "#/components/schemas/HeadBlurVideosArgsDto",
    },
    id: {
      type: "string",
      description: "UUID, unique per run",
    },
    name: {
      type: "string",
      description: "Optional label; multiple runs can share a name",
    },
    latest: {
      type: "boolean",
      description: "True if this is the most recent run for the given name",
    },
    startTime: {
      type: "string",
      description: "ISO date string when blurring started",
    },
    endTime: {
      type: "string",
      description:
        "ISO date string when blurring ended; omitted if still running",
    },
    running: {
      type: "boolean",
    },
    total: {
      type: "number",
    },
    remaining: {
      type: "number",
    },
    done: {
      type: "number",
    },
    lastError: {
      type: "object",
    },
    failures: {
      type: "number",
    },
    skipped: {
      type: "number",
    },
    progress: {
      $ref: "#/components/schemas/BlurProgressDto",
    },
  },
  required: ["running", "total", "remaining", "done"],
} as const;

export const $ListHeadBlurVideosResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/HeadBlurVideosStateDto",
      },
    },
    page: {
      type: "number",
    },
    perPage: {
      type: "number",
    },
    total: {
      type: "number",
    },
    lastPage: {
      type: "number",
    },
  },
  required: ["results"],
} as const;

export const $StartHeadBlurImagesRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/GetSamplesQueryRequestDto",
    },
    name: {
      type: "string",
      description:
        'Optional job name; multiple runs may share a name. Omit → agent uses "default".',
    },
    force: {
      type: "boolean",
      description: "re-blur even if the sample is already marked headBlurred",
    },
  },
} as const;

export const $HeadBlurImagesArgsDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/GetSamplesQueryRequestDto",
    },
    name: {
      type: "string",
    },
    force: {
      type: "boolean",
    },
    context: {
      type: "object",
      additionalProperties: true,
    },
  },
} as const;

export const $HeadBlurImagesStateDto = {
  type: "object",
  properties: {
    args: {
      $ref: "#/components/schemas/HeadBlurImagesArgsDto",
    },
    id: {
      type: "string",
      description: "UUID, unique per run",
    },
    name: {
      type: "string",
      description: "Optional label; multiple runs can share a name",
    },
    latest: {
      type: "boolean",
      description: "True if this is the most recent run for the given name",
    },
    startTime: {
      type: "string",
      description: "ISO date string when blurring started",
    },
    endTime: {
      type: "string",
      description:
        "ISO date string when blurring ended; omitted if still running",
    },
    running: {
      type: "boolean",
    },
    total: {
      type: "number",
    },
    remaining: {
      type: "number",
    },
    done: {
      type: "number",
    },
    lastError: {
      type: "object",
    },
    failures: {
      type: "number",
    },
    skipped: {
      type: "number",
    },
    progress: {
      $ref: "#/components/schemas/BlurProgressDto",
    },
  },
  required: ["running", "total", "remaining", "done"],
} as const;

export const $ListHeadBlurImagesResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/HeadBlurImagesStateDto",
      },
    },
    page: {
      type: "number",
    },
    perPage: {
      type: "number",
    },
    total: {
      type: "number",
    },
    lastPage: {
      type: "number",
    },
  },
  required: ["results"],
} as const;

export const $HeadBlurImageRequestDto = {
  type: "object",
  properties: {
    image: {
      type: "string",
      format: "base64",
      example: "/9j/4...",
    },
  },
  required: ["image"],
} as const;

export const $HeadBlurImageResponseDto = {
  type: "object",
  properties: {
    image: {
      type: "string",
      format: "base64",
    },
    headsFound: {
      type: "boolean",
      description: "omitted when the detector did not report on this image",
    },
    duration: {
      type: "number",
      description: "how long the blur call took, in milliseconds",
    },
  },
  required: ["image", "duration"],
} as const;

export const $GetThumbnailRequestDto = {
  type: "object",
  properties: {
    width: {
      type: "number",
    },
    height: {
      type: "number",
    },
    expand: {
      type: "boolean",
    },
  },
} as const;

export const $CaptureRequestDto = {
  type: "object",
  properties: {
    thumbnail: {
      $ref: "#/components/schemas/GetThumbnailRequestDto",
    },
    crop: {
      type: "boolean",
    },
  },
} as const;

export const $BboxDto = {
  type: "object",
  properties: {
    x1: {
      type: "number",
    },
    y1: {
      type: "number",
    },
    x2: {
      type: "number",
    },
    y2: {
      type: "number",
    },
  },
  required: ["x1", "y1", "x2", "y2"],
} as const;

export const $PredictionOption = {
  type: "object",
  properties: {
    label: {
      type: "string",
    },
    certainty: {
      type: "number",
    },
    originalLabel: {
      type: "string",
    },
    bbox: {
      $ref: "#/components/schemas/BboxDto",
    },
  },
  required: ["label", "certainty", "originalLabel"],
} as const;

export const $CaptureAndPredictResponseDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "string",
    },
    duration: {
      type: "number",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    capturedAt: {
      format: "date-time",
      type: "string",
    },
    modelId: {
      type: "number",
    },
    certain: {
      type: "boolean",
    },
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PredictionOption",
      },
    },
    image: {
      type: "string",
    },
  },
  required: [
    "sampleId",
    "duration",
    "predictedAt",
    "capturedAt",
    "modelId",
    "certain",
    "predictions",
    "image",
  ],
} as const;

export const $CaptureAndPredictRequestDto = {
  type: "object",
  properties: {
    role: {
      type: "string",
    },
    family: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    thumbnail: {
      $ref: "#/components/schemas/GetThumbnailRequestDto",
    },
    crop: {
      type: "boolean",
    },
  },
} as const;

export const $PredictionOptionTranslated = {
  type: "object",
  properties: {
    englishName: {
      type: "string",
    },
    label: {
      type: "string",
    },
    certainty: {
      type: "number",
    },
    originalLabel: {
      type: "string",
    },
    bbox: {
      $ref: "#/components/schemas/BboxDto",
    },
  },
  required: ["label", "certainty", "originalLabel"],
} as const;

export const $CaptureAndPredictResponseTranslatedDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "string",
    },
    duration: {
      type: "number",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    capturedAt: {
      format: "date-time",
      type: "string",
    },
    modelId: {
      type: "number",
    },
    certain: {
      type: "boolean",
    },
    image: {
      type: "string",
    },
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PredictionOptionTranslated",
      },
    },
  },
  required: [
    "sampleId",
    "duration",
    "predictedAt",
    "capturedAt",
    "modelId",
    "certain",
    "image",
    "predictions",
  ],
} as const;

export const $PredictResponseDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "string",
    },
    duration: {
      type: "number",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    modelId: {
      type: "number",
    },
    certain: {
      type: "boolean",
    },
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PredictionOption",
      },
    },
  },
  required: [
    "sampleId",
    "duration",
    "predictedAt",
    "modelId",
    "certain",
    "predictions",
  ],
} as const;

export const $PredictRequestDto = {
  type: "object",
  properties: {
    role: {
      type: "string",
    },
    family: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    image: {
      type: "string",
    },
  },
  required: ["image"],
} as const;

export const $PredictResponseTranslatedDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "string",
    },
    duration: {
      type: "number",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    modelId: {
      type: "number",
    },
    certain: {
      type: "boolean",
    },
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PredictionOptionTranslated",
      },
    },
  },
  required: [
    "sampleId",
    "duration",
    "predictedAt",
    "modelId",
    "certain",
    "predictions",
  ],
} as const;

export const $AddSampleRequestDto = {
  type: "object",
  properties: {
    label: {
      type: "string",
    },
    labelTrigger: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    family: {
      type: "string",
    },
    category: {
      type: "string",
    },
    groupId: {
      type: "string",
    },
    imgSource: {
      type: "string",
    },
    image: {
      type: "string",
    },
    deviceId: {
      type: "number",
    },
  },
  required: [
    "label",
    "labelTrigger",
    "captureTrigger",
    "family",
    "category",
    "groupId",
    "imgSource",
    "image",
    "deviceId",
  ],
} as const;

export const $Decimal2 = {
  type: "object",
  properties: {},
} as const;

export const $SaveSampleRequestDto = {
  type: "object",
  properties: {
    weight: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    sampleId: {
      type: "string",
    },
    label: {
      type: "string",
    },
    labelTrigger: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    family: {
      type: "string",
    },
    category: {
      type: "string",
    },
    groupId: {
      type: "string",
    },
    imgSource: {
      type: "string",
    },
    image: {
      type: "string",
    },
    deviceId: {
      type: "number",
    },
    barcode: {
      type: "string",
    },
    name: {
      type: "string",
    },
  },
  required: [
    "sampleId",
    "label",
    "labelTrigger",
    "family",
    "category",
    "groupId",
    "imgSource",
    "image",
    "deviceId",
  ],
} as const;

export const $SaveSampleResponseDto = {
  type: "object",
  properties: {
    matchStrength: {
      type: "string",
    },
  },
  required: ["matchStrength"],
} as const;

export const $DeviceSessionDto = {
  type: "object",
  properties: {
    sessionId: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    startTime: {
      format: "date-time",
      type: "string",
    },
    endTime: {
      format: "date-time",
      type: "string",
    },
    path: {
      type: "string",
    },
    size: {
      type: "number",
    },
    codec: {
      type: "string",
    },
    width: {
      type: "number",
    },
    height: {
      type: "number",
    },
    fps: {
      type: "number",
    },
    bitrate: {
      type: "number",
    },
    deviceId: {
      type: "number",
    },
    startCause: {
      type: "string",
    },
    stopCause: {
      type: "string",
    },
    uploadedBackend: {
      type: "boolean",
    },
    uploadedCluster: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    nonScanModelId: {
      type: "number",
    },
    predictorModelId: {
      type: "number",
    },
    nonScanPrecisionLevel: {
      type: "string",
    },
    agentAlertMode: {
      type: "string",
    },
    clientAppMode: {
      type: "string",
    },
  },
  required: ["sessionId", "createdAt", "updatedAt"],
} as const;

export const $GetSessionsResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DeviceSessionDto",
      },
    },
    total: {
      type: "number",
    },
    perPage: {
      type: "number",
    },
    page: {
      type: "number",
    },
    lastPage: {
      type: "number",
    },
  },
  required: ["results", "total", "perPage", "page", "lastPage"],
} as const;

export const $DeployAgentVersionRequestDto = {
  type: "object",
  properties: {
    version: {
      type: "string",
    },
  },
  required: ["version"],
} as const;

export const $PaginatedRequestDto = {
  type: "object",
  properties: {
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $AgentDeploymentDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "pending",
        "downloading",
        "installing",
        "error",
        "cancelled",
        "deployed",
        "removed",
      ],
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    error: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["state", "agentVersion", "createdAt", "updatedAt"],
} as const;

export const $ServiceDeploymentDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "pending",
        "downloading",
        "installing",
        "error",
        "cancelled",
        "deployed",
        "removed",
      ],
      type: "string",
    },
    serviceName: {
      type: "string",
    },
    version: {
      type: "string",
    },
    error: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    type: {
      type: "string",
    },
    runningStartTime: {
      format: "date-time",
      type: "string",
    },
    runningEndTime: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["state", "serviceName", "version", "createdAt", "updatedAt"],
} as const;

export const $DeviceConfigDeploymentDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    deviceConfig: {
      $ref: "#/components/schemas/PartialDeviceConfigDto",
    },
    isPartial: {
      type: "boolean",
    },
    state: {
      enum: [
        "applied",
        "partiallyApplied",
        "noChanges",
        "pending",
        "cancelled",
        "failed",
        "validating",
        "scheduled",
        "fromAgent",
      ],
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    notAppliedChanges: {
      $ref: "#/components/schemas/PartialDeviceConfigDto",
    },
    originalDeviceConfig: {
      $ref: "#/components/schemas/PartialDeviceConfigDto",
    },
    originalDeviceId: {
      type: "number",
    },
    deployedBy: {
      type: "string",
    },
  },
  required: [
    "id",
    "deviceConfig",
    "isPartial",
    "state",
    "createdAt",
    "updatedAt",
    "deployedBy",
  ],
} as const;

export const $ListDeviceConfigOrderEnum = {
  type: "string",
  enum: ["createdAt", "updatedAt"],
} as const;

export const $ListDeviceConfigOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ListDeviceConfigOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $DisableDeviceAlertsDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    suppressedUntil: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
  },
  required: ["deviceIds"],
} as const;

export const $EnableDeviceAlertsDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["deviceIds"],
} as const;

export const $DeviceAlertsStatusRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $DeviceAlertStatusItemDto = {
  type: "object",
  properties: {
    alertType: {
      enum: [
        "DeviceDown",
        "ServerDown",
        "CameraDown",
        "HighResourceUsage",
        "LookupTableDisabled",
        "DeployedModelFailure",
        "RegisterDisabledDeviceAttempt",
        "RegisterDuplicateDeviceAttempt",
        "TrainingFailed",
        "NonScanDetectorDown",
        "OnScreenAppDown",
        "ZebraAdapterDown",
        "AgentPortClash",
        "LockedSamplesAboveThreshold",
        "FailedToStoreSampleLackOfStorage",
        "BlackScreenImageDetected",
        "LocalStorageAlmostFull",
        "AgentDoesNotReachEdgibox",
        "VideoUploadError",
        "ImageUploadError",
        "PredictorDisabled",
        "NonScanDetectorRepeatedFpsDrops",
        "ModelBelowKpiThreshold",
        "TrainingWarnings",
        "LookupTableMismatch",
        "MetricThresholdBreach",
        "ServiceDown",
        "DataCompletenessBelowThreshold",
        "DeviceDownEscalated",
        "ServerDownEscalated",
        "CameraDownEscalated",
        "HighResourceUsageEscalated",
        "LookupTableDisabledEscalated",
        "DeployedModelFailureEscalated",
        "NonScanDetectorDownEscalated",
        "OnScreenAppDownEscalated",
        "ZebraAdapterDownEscalated",
        "AgentPortClashEscalated",
        "LockedSamplesAboveThresholdEscalated",
        "FailedToStoreSampleLackOfStorageEscalated",
        "BlackScreenImageDetectedEscalated",
        "LocalStorageAlmostFullEscalated",
        "AgentDoesNotReachEdgiboxEscalated",
        "VideoUploadErrorEscalated",
        "ImageUploadErrorEscalated",
        "PredictorDisabledEscalated",
        "NonScanDetectorRepeatedFpsDropsEscalated",
      ],
      type: "string",
    },
    disabledCount: {
      type: "number",
    },
    enabledCount: {
      type: "number",
    },
  },
  required: ["alertType", "disabledCount", "enabledCount"],
} as const;

export const $DeviceAlertsStatusDto = {
  type: "object",
  properties: {
    totalDevices: {
      type: "number",
    },
    alerts: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DeviceAlertStatusItemDto",
      },
    },
  },
  required: ["totalDevices", "alerts"],
} as const;

export const $DeviceAlertStateDto = {
  type: "object",
  properties: {
    alertType: {
      enum: [
        "DeviceDown",
        "ServerDown",
        "CameraDown",
        "HighResourceUsage",
        "LookupTableDisabled",
        "DeployedModelFailure",
        "RegisterDisabledDeviceAttempt",
        "RegisterDuplicateDeviceAttempt",
        "TrainingFailed",
        "NonScanDetectorDown",
        "OnScreenAppDown",
        "ZebraAdapterDown",
        "AgentPortClash",
        "LockedSamplesAboveThreshold",
        "FailedToStoreSampleLackOfStorage",
        "BlackScreenImageDetected",
        "LocalStorageAlmostFull",
        "AgentDoesNotReachEdgibox",
        "VideoUploadError",
        "ImageUploadError",
        "PredictorDisabled",
        "NonScanDetectorRepeatedFpsDrops",
        "ModelBelowKpiThreshold",
        "TrainingWarnings",
        "LookupTableMismatch",
        "MetricThresholdBreach",
        "ServiceDown",
        "DataCompletenessBelowThreshold",
        "DeviceDownEscalated",
        "ServerDownEscalated",
        "CameraDownEscalated",
        "HighResourceUsageEscalated",
        "LookupTableDisabledEscalated",
        "DeployedModelFailureEscalated",
        "NonScanDetectorDownEscalated",
        "OnScreenAppDownEscalated",
        "ZebraAdapterDownEscalated",
        "AgentPortClashEscalated",
        "LockedSamplesAboveThresholdEscalated",
        "FailedToStoreSampleLackOfStorageEscalated",
        "BlackScreenImageDetectedEscalated",
        "LocalStorageAlmostFullEscalated",
        "AgentDoesNotReachEdgiboxEscalated",
        "VideoUploadErrorEscalated",
        "ImageUploadErrorEscalated",
        "PredictorDisabledEscalated",
        "NonScanDetectorRepeatedFpsDropsEscalated",
      ],
      type: "string",
    },
    enabled: {
      type: "boolean",
    },
  },
  required: ["alertType", "enabled"],
} as const;

export const $SetDeviceAlertsDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    allAlerts: {
      type: "boolean",
    },
    alerts: {
      minItems: 1,
      type: "array",
      items: {
        $ref: "#/components/schemas/DeviceAlertStateDto",
      },
    },
    suppressedUntil: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
  },
  required: ["query"],
} as const;

export const $TestConnectionTlsDto = {
  type: "object",
  properties: {
    ca_cert: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "object",
          properties: {
            path: {
              type: "string",
            },
            content: {
              type: "string",
            },
          },
          required: ["path", "content"],
        },
      ],
    },
    client_cert: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "object",
          properties: {
            path: {
              type: "string",
            },
            content: {
              type: "string",
            },
          },
          required: ["path", "content"],
        },
      ],
    },
    client_key: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "object",
          properties: {
            path: {
              type: "string",
            },
            content: {
              type: "string",
            },
          },
          required: ["path", "content"],
        },
      ],
    },
    insecure_skip_verify: {
      type: "boolean",
    },
    server_name: {
      type: "string",
    },
    min_version: {
      type: "string",
    },
  },
  required: [
    "ca_cert",
    "client_cert",
    "client_key",
    "insecure_skip_verify",
    "server_name",
    "min_version",
  ],
} as const;

export const $TestConnectionRequestDto = {
  type: "object",
  properties: {
    url: {
      type: "string",
    },
    username: {
      type: "string",
    },
    password: {
      type: "string",
    },
    tls: {
      $ref: "#/components/schemas/TestConnectionTlsDto",
    },
    goal: {
      type: "string",
      description:
        'Target to test: "mqtt" or "cluster". Inferred from URL scheme when empty.',
    },
    timeout_ms: {
      type: "number",
      description: "Connect timeout in ms; uses default 10 s when 0",
    },
  },
  required: ["url", "username", "password"],
} as const;

export const $GetConfigFileResponseDto = {
  type: "object",
  properties: {
    content: {
      type: "string",
    },
  },
  required: ["content"],
} as const;

export const $SetConfigFileRequestDto = {
  type: "object",
  properties: {
    field: {
      enum: [
        "Mqtt.tls.ca_cert",
        "Mqtt.tls.client_cert",
        "Mqtt.tls.client_key",
        "DataManager.tls.ca_cert",
        "Agent.tls.server_cert",
        "Agent.tls.server_key",
      ],
      type: "string",
    },
    content: {
      type: "string",
      description:
        "File content; empty string deletes the file and clears the config field",
    },
  },
  required: ["field", "content"],
} as const;

export const $GetCertValidityResponseDto = {
  type: "object",
  properties: {
    field: {
      type: "string",
    },
    path: {
      type: "string",
    },
    subject: {
      type: "string",
    },
    issuer: {
      type: "string",
    },
    not_before: {
      type: "string",
    },
    not_after: {
      type: "string",
    },
    days_remaining: {
      type: "number",
    },
    is_expired: {
      type: "boolean",
    },
  },
  required: [
    "field",
    "path",
    "subject",
    "issuer",
    "not_before",
    "not_after",
    "days_remaining",
    "is_expired",
  ],
} as const;

export const $TagSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    isLocked: {
      type: "boolean",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt", "isLocked"],
} as const;

export const $TagOrderEnum = {
  type: "string",
  enum: ["createdAt", "name"],
} as const;

export const $TagOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/TagOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $CreateTagsDto = {
  type: "object",
  properties: {
    tags: {
      minItems: 1,
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["tags"],
} as const;

export const $AssignTagsDto = {
  type: "object",
  properties: {
    elementIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "object",
      },
    },
    tags: {
      minItems: 1,
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["elementIds", "tags"],
} as const;

export const $AssignTagsResponseDto = {
  type: "object",
  properties: {
    createdTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    foundElementsIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "object",
      },
    },
    missingElements: {
      type: "array",
      items: {
        type: "object",
      },
    },
  },
  required: ["foundElementsIds", "missingElements"],
} as const;

export const $UnassignTagsDto = {
  type: "object",
  properties: {
    all: {
      type: "boolean",
    },
    elementIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "object",
      },
    },
    tags: {
      minItems: 1,
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["elementIds", "tags"],
} as const;

export const $UnassignTagsResponseDto = {
  type: "object",
  properties: {
    foundElementsIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "object",
      },
    },
    missingElements: {
      type: "array",
      items: {
        type: "object",
      },
    },
  },
  required: ["foundElementsIds", "missingElements"],
} as const;

export const $TagDetailsDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    isLocked: {
      type: "boolean",
    },
    usedCount: {
      type: "number",
    },
    updatedBy: {
      type: "string",
    },
  },
  required: ["id", "name", "createdAt", "updatedAt"],
} as const;

export const $UpdateTagDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    isLocked: {
      type: "boolean",
    },
  },
} as const;

export const $ListPermissionsSummariesDto = {
  type: "object",
  properties: {
    module: {
      type: "array",
      items: {
        type: "string",
      },
    },
    search: {
      type: "string",
    },
    showBackend: {
      type: "boolean",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $PermissionsSummaryDto = {
  type: "object",
  properties: {
    module: {
      type: "string",
    },
    submodule: {
      type: "string",
    },
    action: {
      type: "string",
    },
    description: {
      type: "string",
    },
    viewer: {
      type: "boolean",
    },
    annotator: {
      type: "boolean",
    },
    tech: {
      type: "boolean",
    },
    owner: {
      type: "boolean",
    },
    mlops: {
      type: "boolean",
    },
    siteManager: {
      type: "boolean",
    },
    annotatorManager: {
      type: "boolean",
    },
    edgifyCandidate: {
      type: "boolean",
    },
  },
  required: [
    "module",
    "submodule",
    "action",
    "description",
    "viewer",
    "annotator",
    "tech",
    "owner",
    "mlops",
    "siteManager",
    "annotatorManager",
    "edgifyCandidate",
  ],
} as const;

export const $PermissionsDevicesDataDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "edit"],
} as const;

export const $PermissionsDevicesSettingsDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "edit"],
} as const;

export const $PermissionsDevicesVersionHistoryDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    deploy: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "deploy"],
} as const;

export const $PermissionsDevicesTagsDto = {
  type: "object",
  properties: {
    create: {
      type: "boolean",
      default: false,
    },
    update: {
      type: "boolean",
      default: false,
    },
    lock: {
      type: "boolean",
      default: false,
    },
    unassignLocked: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    merge: {
      type: "boolean",
      default: false,
    },
  },
  required: ["create", "update", "lock", "unassignLocked", "delete", "merge"],
} as const;

export const $PermissionsDevicesBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
    readDeployments: {
      type: "boolean",
      default: false,
    },
    readPassword: {
      type: "boolean",
      default: false,
    },
    readData: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "readMinimal",
    "readDetails",
    "readDeployments",
    "readPassword",
    "readData",
  ],
} as const;

export const $PermissionsDevicesDto = {
  type: "object",
  properties: {
    data: {
      $ref: "#/components/schemas/PermissionsDevicesDataDto",
    },
    settings: {
      $ref: "#/components/schemas/PermissionsDevicesSettingsDto",
    },
    versionHistory: {
      $ref: "#/components/schemas/PermissionsDevicesVersionHistoryDto",
    },
    tags: {
      $ref: "#/components/schemas/PermissionsDevicesTagsDto",
    },
    backend: {
      $ref: "#/components/schemas/PermissionsDevicesBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    diagnostics: {
      type: "boolean",
      default: false,
    },
    uploadLogs: {
      type: "boolean",
      default: false,
    },
    logs: {
      type: "boolean",
      default: false,
    },
    setupUI: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "data",
    "settings",
    "versionHistory",
    "tags",
    "backend",
    "view",
    "download",
    "create",
    "delete",
    "edit",
    "diagnostics",
    "uploadLogs",
    "logs",
    "setupUI",
  ],
} as const;

export const $PermissionsClustersTagsDto = {
  type: "object",
  properties: {
    create: {
      type: "boolean",
      default: false,
    },
    update: {
      type: "boolean",
      default: false,
    },
    lock: {
      type: "boolean",
      default: false,
    },
    unassignLocked: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    merge: {
      type: "boolean",
      default: false,
    },
  },
  required: ["create", "update", "lock", "unassignLocked", "delete", "merge"],
} as const;

export const $PermissionsClustersDevicesDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "edit"],
} as const;

export const $PermissionsClustersBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsClustersDto = {
  type: "object",
  properties: {
    tags: {
      $ref: "#/components/schemas/PermissionsClustersTagsDto",
    },
    devices: {
      $ref: "#/components/schemas/PermissionsClustersDevicesDto",
    },
    backend: {
      $ref: "#/components/schemas/PermissionsClustersBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "tags",
    "devices",
    "backend",
    "view",
    "download",
    "create",
    "delete",
    "edit",
  ],
} as const;

export const $PermissionsSitesTagsDto = {
  type: "object",
  properties: {
    create: {
      type: "boolean",
      default: false,
    },
    update: {
      type: "boolean",
      default: false,
    },
    lock: {
      type: "boolean",
      default: false,
    },
    unassignLocked: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    merge: {
      type: "boolean",
      default: false,
    },
  },
  required: ["create", "update", "lock", "unassignLocked", "delete", "merge"],
} as const;

export const $PermissionsSitesDevicesDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "edit"],
} as const;

export const $PermissionsSitesVersionHistoryDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    deploy: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "deploy"],
} as const;

export const $PermissionsSitesGroupsDto = {
  type: "object",
  properties: {
    list: {
      type: "boolean",
      default: false,
    },
    details: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    update: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    assignSites: {
      type: "boolean",
      default: false,
    },
    removeSites: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "list",
    "details",
    "create",
    "update",
    "delete",
    "assignSites",
    "removeSites",
  ],
} as const;

export const $PermissionsSitesBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDeployments: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDeployments", "readDetails"],
} as const;

export const $PermissionsSitesDto = {
  type: "object",
  properties: {
    tags: {
      $ref: "#/components/schemas/PermissionsSitesTagsDto",
    },
    devices: {
      $ref: "#/components/schemas/PermissionsSitesDevicesDto",
    },
    versionHistory: {
      $ref: "#/components/schemas/PermissionsSitesVersionHistoryDto",
    },
    groups: {
      $ref: "#/components/schemas/PermissionsSitesGroupsDto",
    },
    backend: {
      $ref: "#/components/schemas/PermissionsSitesBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "tags",
    "devices",
    "versionHistory",
    "groups",
    "backend",
    "view",
    "download",
    "create",
    "delete",
    "edit",
  ],
} as const;

export const $PermissionsSamplesTagsDto = {
  type: "object",
  properties: {
    create: {
      type: "boolean",
      default: false,
    },
    update: {
      type: "boolean",
      default: false,
    },
    lock: {
      type: "boolean",
      default: false,
    },
    unassignLocked: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    merge: {
      type: "boolean",
      default: false,
    },
  },
  required: ["create", "update", "lock", "unassignLocked", "delete", "merge"],
} as const;

export const $PermissionsSamplesBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
    readDeviceImages: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails", "readDeviceImages"],
} as const;

export const $PermissionsSamplesDto = {
  type: "object",
  properties: {
    tags: {
      $ref: "#/components/schemas/PermissionsSamplesTagsDto",
    },
    backend: {
      $ref: "#/components/schemas/PermissionsSamplesBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    blur: {
      type: "boolean",
      default: false,
    },
    viewTaggedBy: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "tags",
    "backend",
    "view",
    "delete",
    "edit",
    "blur",
    "viewTaggedBy",
  ],
} as const;

export const $PermissionsJsonDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view"],
} as const;

export const $PermissionsLabelDistributionBackendDto = {
  type: "object",
  properties: {
    read: {
      type: "boolean",
      default: false,
    },
  },
  required: ["read"],
} as const;

export const $PermissionsLabelDistributionDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsLabelDistributionBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view"],
} as const;

export const $PermissionsSessionsTagsDto = {
  type: "object",
  properties: {
    create: {
      type: "boolean",
      default: false,
    },
    update: {
      type: "boolean",
      default: false,
    },
    lock: {
      type: "boolean",
      default: false,
    },
    unassignLocked: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    merge: {
      type: "boolean",
      default: false,
    },
  },
  required: ["create", "update", "lock", "unassignLocked", "delete", "merge"],
} as const;

export const $PermissionsSessionsBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsSessionsVideoDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
    upload: {
      type: "boolean",
      default: false,
    },
    blur: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "download", "upload", "blur"],
} as const;

export const $PermissionsSessionsVisualizationDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    tracks: {
      type: "boolean",
      default: false,
    },
    debug: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "tracks", "debug"],
} as const;

export const $PermissionsSessionsDto = {
  type: "object",
  properties: {
    tags: {
      $ref: "#/components/schemas/PermissionsSessionsTagsDto",
    },
    backend: {
      $ref: "#/components/schemas/PermissionsSessionsBackendDto",
    },
    video: {
      $ref: "#/components/schemas/PermissionsSessionsVideoDto",
    },
    visualization: {
      $ref: "#/components/schemas/PermissionsSessionsVisualizationDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    viewAssignee: {
      type: "boolean",
      default: false,
    },
    updateAssignee: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "tags",
    "backend",
    "video",
    "visualization",
    "view",
    "delete",
    "viewAssignee",
    "updateAssignee",
  ],
} as const;

export const $PermissionsDatasetsBackendDto = {
  type: "object",
  properties: {
    readDetails: {
      type: "boolean",
      default: false,
    },
    readMinimal: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readDetails", "readMinimal"],
} as const;

export const $PermissionsDatasetsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsDatasetsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit"],
} as const;

export const $PermissionsCatalogTagsDto = {
  type: "object",
  properties: {
    create: {
      type: "boolean",
      default: false,
    },
    update: {
      type: "boolean",
      default: false,
    },
    lock: {
      type: "boolean",
      default: false,
    },
    unassignLocked: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    merge: {
      type: "boolean",
      default: false,
    },
  },
  required: ["create", "update", "lock", "unassignLocked", "delete", "merge"],
} as const;

export const $PermissionsCatalogBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsCatalogDto = {
  type: "object",
  properties: {
    tags: {
      $ref: "#/components/schemas/PermissionsCatalogTagsDto",
    },
    backend: {
      $ref: "#/components/schemas/PermissionsCatalogBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
  },
  required: ["tags", "backend", "view", "create", "delete", "edit", "download"],
} as const;

export const $PermissionsPendingBackendDto = {
  type: "object",
  properties: {
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readDetails"],
} as const;

export const $PermissionsPendingUploadsDto = {
  type: "object",
  properties: {
    cancelOwn: {
      type: "boolean",
      default: false,
    },
  },
  required: ["cancelOwn"],
} as const;

export const $PermissionsPendingDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsPendingBackendDto",
    },
    uploads: {
      $ref: "#/components/schemas/PermissionsPendingUploadsDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "uploads", "view"],
} as const;

export const $PermissionsTrainingsBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsTrainingsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsTrainingsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    createModel: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
    editDefaults: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "backend",
    "view",
    "create",
    "delete",
    "edit",
    "createModel",
    "execute",
    "editDefaults",
  ],
} as const;

export const $PermissionsJobsCameraCalibrationBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsCameraCalibrationDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsCameraCalibrationBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsDeleteSamplesBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsDeleteSamplesDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsDeleteSamplesBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsDeleteVideosBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsDeleteVideosDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsDeleteVideosBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsScheduledTrainingsBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsScheduledTrainingsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsScheduledTrainingsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsSyncGroundTruthsBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsSyncGroundTruthsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsSyncGroundTruthsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsUploadSamplesBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsUploadSamplesDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsUploadSamplesBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsUploadVideosBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsUploadVideosDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsUploadVideosBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsHeadBlurVideosBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsHeadBlurVideosDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsHeadBlurVideosBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsHeadBlurImagesBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsHeadBlurImagesDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsHeadBlurImagesBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsCapacityTaggingBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsCapacityTaggingDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsCapacityTaggingBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsRecoveryEstimatesBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsRecoveryEstimatesDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsRecoveryEstimatesBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsDeployComponentsBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsDeployComponentsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsDeployComponentsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsDeployModelsBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsDeployModelsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsDeployModelsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsServiceHealthChecksBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsServiceHealthChecksDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsServiceHealthChecksBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsWorkerJobsBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
    readToken: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails", "readToken"],
} as const;

export const $PermissionsJobsWorkerJobsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsWorkerJobsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsQueuesBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsJobsQueuesDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsJobsQueuesBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "execute"],
} as const;

export const $PermissionsJobsDto = {
  type: "object",
  properties: {
    cameraCalibration: {
      $ref: "#/components/schemas/PermissionsJobsCameraCalibrationDto",
    },
    deleteSamples: {
      $ref: "#/components/schemas/PermissionsJobsDeleteSamplesDto",
    },
    deleteVideos: {
      $ref: "#/components/schemas/PermissionsJobsDeleteVideosDto",
    },
    scheduledTrainings: {
      $ref: "#/components/schemas/PermissionsJobsScheduledTrainingsDto",
    },
    syncGroundTruths: {
      $ref: "#/components/schemas/PermissionsJobsSyncGroundTruthsDto",
    },
    uploadSamples: {
      $ref: "#/components/schemas/PermissionsJobsUploadSamplesDto",
    },
    uploadVideos: {
      $ref: "#/components/schemas/PermissionsJobsUploadVideosDto",
    },
    headBlurVideos: {
      $ref: "#/components/schemas/PermissionsJobsHeadBlurVideosDto",
    },
    headBlurImages: {
      $ref: "#/components/schemas/PermissionsJobsHeadBlurImagesDto",
    },
    capacityTagging: {
      $ref: "#/components/schemas/PermissionsJobsCapacityTaggingDto",
    },
    recoveryEstimates: {
      $ref: "#/components/schemas/PermissionsJobsRecoveryEstimatesDto",
    },
    deployComponents: {
      $ref: "#/components/schemas/PermissionsJobsDeployComponentsDto",
    },
    deployModels: {
      $ref: "#/components/schemas/PermissionsJobsDeployModelsDto",
    },
    serviceHealthChecks: {
      $ref: "#/components/schemas/PermissionsJobsServiceHealthChecksDto",
    },
    workerJobs: {
      $ref: "#/components/schemas/PermissionsJobsWorkerJobsDto",
    },
    queues: {
      $ref: "#/components/schemas/PermissionsJobsQueuesDto",
    },
  },
  required: [
    "cameraCalibration",
    "deleteSamples",
    "deleteVideos",
    "scheduledTrainings",
    "syncGroundTruths",
    "uploadSamples",
    "uploadVideos",
    "headBlurVideos",
    "headBlurImages",
    "capacityTagging",
    "recoveryEstimates",
    "deployComponents",
    "deployModels",
    "serviceHealthChecks",
    "workerJobs",
    "queues",
  ],
} as const;

export const $PermissionsModelsBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
    readDeployments: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails", "readDeployments"],
} as const;

export const $PermissionsModelsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsModelsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    deploy: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "backend",
    "view",
    "create",
    "delete",
    "edit",
    "deploy",
    "download",
  ],
} as const;

export const $PermissionsReportsSubscriptionBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsReportsSubscriptionCustomSubscriptionBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsReportsSubscriptionCustomSubscriptionDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsReportsSubscriptionCustomSubscriptionBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    approve: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "approve"],
} as const;

export const $PermissionsReportsSubscriptionDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsReportsSubscriptionBackendDto",
    },
    customSubscription: {
      $ref: "#/components/schemas/PermissionsReportsSubscriptionCustomSubscriptionDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    execute: {
      type: "boolean",
      default: false,
    },
    addAttachments: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "backend",
    "customSubscription",
    "view",
    "create",
    "delete",
    "edit",
    "execute",
    "addAttachments",
  ],
} as const;

export const $PermissionsReportsBackendDto = {
  type: "object",
  properties: {
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readDetails"],
} as const;

export const $PermissionsReportsDto = {
  type: "object",
  properties: {
    subscription: {
      $ref: "#/components/schemas/PermissionsReportsSubscriptionDto",
    },
    backend: {
      $ref: "#/components/schemas/PermissionsReportsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    editUrl: {
      type: "boolean",
      default: false,
    },
    editConfig: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "subscription",
    "backend",
    "view",
    "create",
    "delete",
    "edit",
    "editUrl",
    "editConfig",
  ],
} as const;

export const $PermissionsAccountsBackendDto = {
  type: "object",
  properties: {
    readDetails: {
      type: "boolean",
      default: false,
    },
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readAgentVersions: {
      type: "boolean",
      default: false,
    },
    readServiceVersions: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "readDetails",
    "readMinimal",
    "readAgentVersions",
    "readServiceVersions",
  ],
} as const;

export const $PermissionsAccountsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsAccountsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "edit"],
} as const;

export const $PermissionsUsersBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsUsersDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsUsersBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    invite: {
      type: "boolean",
      default: false,
    },
    assignSites: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "backend",
    "view",
    "download",
    "create",
    "delete",
    "edit",
    "invite",
    "assignSites",
  ],
} as const;

export const $PermissionsAlertsGlobalDto = {
  type: "object",
  properties: {
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: ["create", "delete", "edit"],
} as const;

export const $PermissionsAlertsEscalationDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "edit"],
} as const;

export const $PermissionsAlertsBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsAlertsDto = {
  type: "object",
  properties: {
    global: {
      $ref: "#/components/schemas/PermissionsAlertsGlobalDto",
    },
    escalation: {
      $ref: "#/components/schemas/PermissionsAlertsEscalationDto",
    },
    backend: {
      $ref: "#/components/schemas/PermissionsAlertsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    subscribe: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "global",
    "escalation",
    "backend",
    "view",
    "download",
    "create",
    "delete",
    "edit",
    "subscribe",
  ],
} as const;

export const $PermissionsLookupTableBackendDto = {
  type: "object",
  properties: {
    readMinimal: {
      type: "boolean",
      default: false,
    },
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readMinimal", "readDetails"],
} as const;

export const $PermissionsLookupTableDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsLookupTableBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "delete", "edit", "download"],
} as const;

export const $PermissionsPermissionsBackendDto = {
  type: "object",
  properties: {
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readDetails"],
} as const;

export const $PermissionsPermissionsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsPermissionsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "edit"],
} as const;

export const $PermissionsPredictionsBackendDto = {
  type: "object",
  properties: {
    readDetails: {
      type: "boolean",
      default: false,
    },
    readModelDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readDetails", "readModelDetails"],
} as const;

export const $PermissionsPredictionsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsPredictionsBackendDto",
    },
  },
  required: ["backend"],
} as const;

export const $PermissionsFeaturesSectionsDto = {
  type: "object",
  properties: {
    resources: {
      type: "boolean",
      default: false,
    },
    data: {
      type: "boolean",
      default: false,
    },
    jobs: {
      type: "boolean",
      default: false,
    },
    models: {
      type: "boolean",
      default: false,
    },
    reports: {
      type: "boolean",
      default: false,
    },
    settings: {
      type: "boolean",
      default: false,
    },
  },
  required: ["resources", "data", "jobs", "models", "reports", "settings"],
} as const;

export const $PermissionsFeaturesDto = {
  type: "object",
  properties: {
    sections: {
      $ref: "#/components/schemas/PermissionsFeaturesSectionsDto",
    },
    search: {
      type: "boolean",
      default: false,
    },
  },
  required: ["sections", "search"],
} as const;

export const $PermissionsSiteGroupsDto = {
  type: "object",
  properties: {
    list: {
      type: "boolean",
      default: false,
    },
    details: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    update: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    assignSites: {
      type: "boolean",
      default: false,
    },
    removeSites: {
      type: "boolean",
      default: false,
    },
    view: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
  },
  required: [
    "list",
    "details",
    "create",
    "update",
    "delete",
    "assignSites",
    "removeSites",
    "view",
    "edit",
  ],
} as const;

export const $PermissionsMcpDto = {
  type: "object",
  properties: {
    use: {
      type: "boolean",
      default: false,
    },
    advancedUse: {
      type: "boolean",
      default: false,
    },
    viewChatLog: {
      type: "boolean",
      default: false,
    },
  },
  required: ["use", "advancedUse", "viewChatLog"],
} as const;

export const $PermissionsNotificationsBackendDto = {
  type: "object",
  properties: {
    readDetails: {
      type: "boolean",
      default: false,
    },
  },
  required: ["readDetails"],
} as const;

export const $PermissionsNotificationsDto = {
  type: "object",
  properties: {
    backend: {
      $ref: "#/components/schemas/PermissionsNotificationsBackendDto",
    },
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
  },
  required: ["backend", "view", "create", "edit", "delete"],
} as const;

export const $PermissionsMetricAlertsDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    test: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "create", "edit", "delete", "test"],
} as const;

export const $PermissionsRegionsDto = {
  type: "object",
  properties: {
    view: {
      type: "boolean",
      default: false,
    },
    download: {
      type: "boolean",
      default: false,
    },
    create: {
      type: "boolean",
      default: false,
    },
    edit: {
      type: "boolean",
      default: false,
    },
    delete: {
      type: "boolean",
      default: false,
    },
    upload: {
      type: "boolean",
      default: false,
    },
  },
  required: ["view", "download", "create", "edit", "delete", "upload"],
} as const;

export const $PermissionsDto = {
  type: "object",
  properties: {
    devices: {
      $ref: "#/components/schemas/PermissionsDevicesDto",
    },
    clusters: {
      $ref: "#/components/schemas/PermissionsClustersDto",
    },
    sites: {
      $ref: "#/components/schemas/PermissionsSitesDto",
    },
    samples: {
      $ref: "#/components/schemas/PermissionsSamplesDto",
    },
    json: {
      $ref: "#/components/schemas/PermissionsJsonDto",
    },
    labelDistribution: {
      $ref: "#/components/schemas/PermissionsLabelDistributionDto",
    },
    sessions: {
      $ref: "#/components/schemas/PermissionsSessionsDto",
    },
    datasets: {
      $ref: "#/components/schemas/PermissionsDatasetsDto",
    },
    catalog: {
      $ref: "#/components/schemas/PermissionsCatalogDto",
    },
    pending: {
      $ref: "#/components/schemas/PermissionsPendingDto",
    },
    trainings: {
      $ref: "#/components/schemas/PermissionsTrainingsDto",
    },
    jobs: {
      $ref: "#/components/schemas/PermissionsJobsDto",
    },
    models: {
      $ref: "#/components/schemas/PermissionsModelsDto",
    },
    reports: {
      $ref: "#/components/schemas/PermissionsReportsDto",
    },
    accounts: {
      $ref: "#/components/schemas/PermissionsAccountsDto",
    },
    users: {
      $ref: "#/components/schemas/PermissionsUsersDto",
    },
    alerts: {
      $ref: "#/components/schemas/PermissionsAlertsDto",
    },
    lookupTable: {
      $ref: "#/components/schemas/PermissionsLookupTableDto",
    },
    permissions: {
      $ref: "#/components/schemas/PermissionsPermissionsDto",
    },
    predictions: {
      $ref: "#/components/schemas/PermissionsPredictionsDto",
    },
    features: {
      $ref: "#/components/schemas/PermissionsFeaturesDto",
    },
    siteGroups: {
      $ref: "#/components/schemas/PermissionsSiteGroupsDto",
    },
    mcp: {
      $ref: "#/components/schemas/PermissionsMcpDto",
    },
    notifications: {
      $ref: "#/components/schemas/PermissionsNotificationsDto",
    },
    metricAlerts: {
      $ref: "#/components/schemas/PermissionsMetricAlertsDto",
    },
    regions: {
      $ref: "#/components/schemas/PermissionsRegionsDto",
    },
  },
  required: [
    "devices",
    "clusters",
    "sites",
    "samples",
    "json",
    "labelDistribution",
    "sessions",
    "datasets",
    "catalog",
    "pending",
    "trainings",
    "jobs",
    "models",
    "reports",
    "accounts",
    "users",
    "alerts",
    "lookupTable",
    "permissions",
    "predictions",
    "features",
    "siteGroups",
    "mcp",
    "notifications",
    "metricAlerts",
    "regions",
  ],
} as const;

export const $CreateAccountDto = {
  type: "object",
  properties: {
    logoImage: {
      type: "string",
      format: "binary",
    },
    defaultClusterArchitecture: {
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
      nullable: true,
    },
    timezone: {
      type: "string",
      default: "UTC",
      example: "Asia/Jerusalem",
    },
    name: {
      type: "string",
    },
    companyName: {
      type: "string",
    },
  },
  required: ["name"],
} as const;

export const $ListMinimalDto = {
  type: "object",
  properties: {
    groupId: {
      type: "number",
    },
    accountId: {
      type: "number",
    },
    name: {
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $AccountOrderEnum = {
  type: "string",
  enum: ["name"],
} as const;

export const $AccountOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/AccountOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListAccountSummariesDto = {
  type: "object",
  properties: {
    accountIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    isActive: {
      type: "boolean",
      description: "Filter by active status. Defaults to true when omitted.",
    },
    sortBy: {
      description:
        "Sort by multiple fields and directions. Default direction for name is ascending.",
      type: "array",
      items: {
        $ref: "#/components/schemas/AccountOrderEnumSortOption",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $AccountSummaryClusterDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "name"],
} as const;

export const $AccountSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    isActive: {
      type: "boolean",
    },
    defaultClusterArchitecture: {
      nullable: true,
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
    },
    defaultCluster: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/AccountSummaryClusterDto",
        },
      ],
    },
    currency: {
      type: "string",
    },
    enableSiteSpecificPricing: {
      type: "boolean",
    },
  },
  required: [
    "id",
    "name",
    "isActive",
    "defaultClusterArchitecture",
    "defaultCluster",
    "currency",
    "enableSiteSpecificPricing",
  ],
} as const;

export const $OperationalHoursEntryResponseDto = {
  type: "object",
  properties: {
    dayOfWeek: {
      enum: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      type: "string",
    },
    startTime: {
      type: "string",
      example: "08:30",
      pattern: "^([01]\\d|2[0-3]):([0-5]\\d)$",
    },
    endTime: {
      type: "string",
      example: "17:45",
      pattern: "^([01]\\d|2[0-3]):([0-5]\\d)$",
    },
    enabled: {
      type: "boolean",
    },
  },
  required: ["dayOfWeek", "startTime", "endTime", "enabled"],
} as const;

export const $OperationalHoursResponseDto = {
  type: "object",
  properties: {
    schedule: {
      type: "array",
      items: {
        $ref: "#/components/schemas/OperationalHoursEntryResponseDto",
      },
    },
    isDefault: {
      type: "boolean",
      description:
        "Indicates the operational hours were inherited from a default source (site group or account level)",
    },
    enabled: {
      type: "boolean",
    },
    timezone: {
      type: "string",
    },
  },
  required: ["schedule", "enabled", "timezone"],
} as const;

export const $AccountDetailsDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    companyName: {
      type: "object",
      nullable: true,
    },
    logoImage: {
      type: "object",
      nullable: true,
    },
    isActive: {
      type: "object",
      nullable: true,
    },
    currency: {
      type: "object",
      nullable: true,
    },
    timezone: {
      type: "object",
      nullable: true,
    },
    status: {
      type: "object",
      nullable: true,
    },
    alertsEnabled: {
      type: "object",
      nullable: true,
    },
    defaultClusterArchitecture: {
      nullable: true,
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
    },
    defaultCluster: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/MinimalEntityDto",
        },
      ],
    },
    accountReportUrl: {
      type: "object",
      nullable: true,
    },
    showEnvReport: {
      type: "object",
      nullable: true,
    },
    showAccountReport: {
      type: "object",
      nullable: true,
    },
    maxAgentVersion: {
      type: "object",
      nullable: true,
    },
    enableSiteSpecificPricing: {
      type: "boolean",
    },
    autoSampleSessionsEnabled: {
      type: "boolean",
    },
    autoSampleSessionsPercentage: {
      type: "object",
      nullable: true,
    },
    nonScanDailyCapacityThreshold: {
      type: "object",
      nullable: true,
    },
    retentionMonths: {
      type: "number",
    },
    cameraTypeTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    defaultOperationalHours: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/OperationalHoursResponseDto",
        },
      ],
    },
    token: {
      type: "string",
    },
  },
  required: [
    "id",
    "name",
    "companyName",
    "logoImage",
    "isActive",
    "currency",
    "timezone",
    "status",
    "alertsEnabled",
    "defaultClusterArchitecture",
    "defaultCluster",
    "accountReportUrl",
    "showEnvReport",
    "showAccountReport",
    "maxAgentVersion",
    "enableSiteSpecificPricing",
    "autoSampleSessionsEnabled",
    "autoSampleSessionsPercentage",
    "nonScanDailyCapacityThreshold",
    "retentionMonths",
    "cameraTypeTagIds",
    "defaultOperationalHours",
    "token",
  ],
} as const;

export const $BulkAccountsQueryDto = {
  type: "object",
  properties: {
    accountIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    isActive: {
      type: "boolean",
      description: "Filter by active status. Defaults to true when omitted.",
    },
  },
} as const;

export const $UpdateAccountIsActiveBulkDto = {
  type: "object",
  properties: {
    isActive: {
      type: "boolean",
    },
    query: {
      $ref: "#/components/schemas/BulkAccountsQueryDto",
    },
  },
  required: ["isActive", "query"],
} as const;

export const $UpdateAccountDto = {
  type: "object",
  properties: {
    logoImage: {
      type: "string",
      format: "binary",
    },
    defaultClusterArchitecture: {
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
      nullable: true,
    },
    timezone: {
      type: "string",
      default: "UTC",
      example: "Asia/Jerusalem",
    },
    retentionMonths: {
      type: "number",
      default: 18,
      description:
        "Months of history kept for the partitioned high-volume tables",
    },
    cameraTypeTagIds: {
      description:
        "Device tags that name a camera model, most significant first. A session records the name of the first of these its device carries.",
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    companyName: {
      type: "string",
    },
    userId: {
      type: "number",
    },
    currency: {
      type: "string",
    },
    accountReportUrl: {
      type: "string",
    },
    showAccountReport: {
      type: "boolean",
    },
    showEnvReport: {
      type: "boolean",
    },
    status: {
      type: "string",
    },
    defaultClusterID: {
      type: "number",
      minimum: 1,
    },
    enableSiteSpecificPricing: {
      type: "boolean",
    },
    autoSampleSessionsEnabled: {
      type: "boolean",
    },
    autoSampleSessionsPercentage: {
      type: "number",
    },
    nonScanDailyCapacityThreshold: {
      type: "number",
    },
  },
} as const;

export const $CreateOperationalHoursEntryDto = {
  type: "object",
  properties: {
    dayOfWeek: {
      enum: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      type: "string",
    },
    startTime: {
      type: "string",
      example: "08:30",
      pattern: "^([01]\\d|2[0-3]):([0-5]\\d)$",
    },
    endTime: {
      type: "string",
      example: "17:45",
      pattern: "^([01]\\d|2[0-3]):([0-5]\\d)$",
    },
    enabled: {
      type: "boolean",
    },
  },
  required: ["dayOfWeek", "startTime", "endTime", "enabled"],
} as const;

export const $CreateOperationalHoursDto = {
  type: "object",
  properties: {
    schedule: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CreateOperationalHoursEntryDto",
      },
    },
    enabled: {
      type: "boolean",
    },
    timezone: {
      type: "string",
    },
  },
  required: ["schedule", "enabled", "timezone"],
} as const;

export const $AssignSitesDto = {
  type: "object",
  properties: {
    userId: {
      type: "number",
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["userId", "siteIds"],
} as const;

export const $TableSortOptionDto = {
  type: "object",
  properties: {
    field: {
      type: "string",
      minLength: 1,
      maxLength: 100,
      pattern: `^[^&<>"']+$`,
    },
    dir: {
      enum: ["asc", "desc"],
      type: "string",
    },
  },
  required: ["field", "dir"],
} as const;

export const $TableSettingsDto = {
  type: "object",
  properties: {
    visibleColumns: {
      description:
        'Column ids currently shown. Never empty -- an empty list is "unset", not "hide everything".',
      type: "array",
      items: {
        type: "string",
      },
    },
    columnOrder: {
      description:
        "Every column id the layout knew about, in display order; a column missing here is new to the layout.",
      type: "array",
      items: {
        type: "string",
      },
    },
    sort: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TableSortOptionDto",
      },
    },
    pageSize: {
      type: "number",
      minimum: 1,
      maximum: 1000,
    },
  },
} as const;

export const $TableSettingsEntryDto = {
  type: "object",
  properties: {
    key: {
      type: "string",
      description: "The table's `tableKey`, e.g. `data.sessions`.",
    },
    version: {
      type: "number",
      description:
        "Written by the server (TABLE_SETTINGS_VERSION); entries of any other version are not returned.",
    },
    value: {
      $ref: "#/components/schemas/TableSettingsDto",
    },
  },
  required: ["key", "version", "value"],
} as const;

export const $UserSettingsDto = {
  type: "object",
  properties: {
    tablesSettings: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TableSettingsEntryDto",
      },
    },
  },
} as const;

export const $UserDetailsDto = {
  type: "object",
  properties: {
    role: {
      type: "string",
      enum: [
        "Viewer",
        "Annotator",
        "Tech",
        "Owner",
        "MLOps",
        "SiteManager",
        "AnnotatorManager",
        "EdgifyCandidate",
        "SuperAdmin",
      ],
    },
    userSettings: {
      description:
        "The caller's own dashboard settings (ID-6897). Only GET /me fills this; the users list never carries other users' UI state.",
      allOf: [
        {
          $ref: "#/components/schemas/UserSettingsDto",
        },
      ],
    },
    defaultClusterArchitecture: {
      nullable: true,
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
    },
    associatedSites: {
      description: "Sites associated with the user",
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    defaultOperationalHours: {
      $ref: "#/components/schemas/OperationalHoursResponseDto",
    },
    id: {
      type: "number",
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    email: {
      type: "string",
      nullable: true,
    },
    company: {
      type: "string",
    },
    profileImg: {
      type: "string",
    },
    defaultAccount: {
      type: "number",
    },
    accountId: {
      type: "number",
    },
    accountName: {
      type: "string",
    },
    token: {
      type: "string",
    },
    isActive: {
      type: "boolean",
    },
    accountLogo: {
      type: "string",
    },
    timezone: {
      type: "string",
    },
    defaultClusterId: {
      type: "number",
    },
    defaultClusterName: {
      type: "string",
    },
    currency: {
      type: "string",
    },
    accountReportUrl: {
      type: "string",
    },
    envReportUrl: {
      type: "string",
    },
    showEnvReport: {
      type: "boolean",
    },
    showAccountReport: {
      type: "boolean",
    },
    referrer: {
      type: "string",
    },
    showRoleSwitcher: {
      type: "boolean",
    },
    accountStatus: {
      type: "string",
    },
    lastConnected: {
      format: "date-time",
      type: "string",
    },
    isDeleted: {
      type: "boolean",
    },
    environment: {
      type: "string",
    },
    enableSiteSpecificPricing: {
      type: "boolean",
    },
    autoSampleSessionsEnabled: {
      type: "boolean",
    },
    cameraTypeTagIds: {
      description:
        "Device tags that name a camera model, most significant first (ID-6991).",
      type: "array",
      items: {
        type: "number",
      },
    },
    bigQuerySqlCompanionEnabled: {
      type: "boolean",
    },
    autoSampleSessionsPercentage: {
      type: "number",
    },
    nonScanDailyCapacityThreshold: {
      type: "number",
    },
    retentionMonths: {
      type: "number",
    },
  },
  required: [
    "role",
    "id",
    "firstName",
    "lastName",
    "email",
    "company",
    "profileImg",
    "defaultAccount",
    "accountId",
    "accountName",
    "token",
    "isActive",
    "accountLogo",
    "lastConnected",
    "environment",
  ],
} as const;

export const $RelatedAccountDto = {
  type: "object",
  properties: {
    account: {
      $ref: "#/components/schemas/AccountSummaryDto",
    },
  },
  required: ["account"],
} as const;

export const $Role = {
  type: "string",
  enum: [
    "Viewer",
    "Annotator",
    "Tech",
    "Owner",
    "MLOps",
    "SiteManager",
    "AnnotatorManager",
    "EdgifyCandidate",
    "SuperAdmin",
  ],
} as const;

export const $UserDetails = {
  type: "object",
  properties: {
    associatedSites: {
      description: "Sites associated with the user",
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    id: {
      type: "number",
    },
    defaultAccount: {
      type: "number",
    },
    email: {
      type: "string",
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    profileImg: {
      type: "string",
    },
    company: {
      type: "string",
    },
    isSuperAdmin: {
      type: "boolean",
    },
    referrer: {
      type: "string",
    },
    lastConnected: {
      format: "date-time",
      type: "string",
    },
    isDeleted: {
      type: "boolean",
    },
  },
  required: [
    "id",
    "defaultAccount",
    "email",
    "firstName",
    "lastName",
    "profileImg",
    "company",
    "isSuperAdmin",
    "lastConnected",
  ],
} as const;

export const $AccountDetails = {
  type: "object",
  properties: {
    defaultClusterArchitecture: {
      nullable: true,
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
    },
    defaultOperationalHours: {
      $ref: "#/components/schemas/OperationalHoursResponseDto",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    logoImage: {
      type: "string",
    },
    timezone: {
      type: "string",
    },
    defaultClusterId: {
      type: "number",
    },
    defaultClusterName: {
      type: "string",
    },
    currency: {
      type: "string",
    },
    accountReportUrl: {
      type: "string",
    },
    showAccountReport: {
      type: "boolean",
    },
    showEnvReport: {
      type: "boolean",
    },
    status: {
      type: "string",
    },
    enableSiteSpecificPricing: {
      type: "boolean",
    },
    autoSampleSessionsEnabled: {
      type: "boolean",
    },
    cameraTypeTagIds: {
      description:
        "Device tags that name a camera model, most significant first (ID-6991).",
      type: "array",
      items: {
        type: "number",
      },
    },
    bigQuerySqlCompanionEnabled: {
      type: "boolean",
    },
    autoSampleSessionsPercentage: {
      type: "number",
    },
    nonScanDailyCapacityThreshold: {
      type: "number",
    },
    retentionMonths: {
      type: "number",
    },
  },
  required: ["id", "name", "createdAt", "logoImage"],
} as const;

export const $FullUserDetailsDto = {
  type: "object",
  properties: {
    role: {
      allOf: [
        {
          $ref: "#/components/schemas/Role",
        },
      ],
    },
    user: {
      $ref: "#/components/schemas/UserDetails",
    },
    account: {
      $ref: "#/components/schemas/AccountDetails",
    },
    isActive: {
      type: "boolean",
    },
  },
  required: ["role", "user", "account", "isActive"],
} as const;

export const $FloatingUserDetails = {
  type: "object",
  properties: {},
} as const;

export const $FloatingUserDetailsDto = {
  type: "object",
  properties: {
    user: {
      $ref: "#/components/schemas/FloatingUserDetails",
    },
  },
  required: ["user"],
} as const;

export const $CheckUserDto = {
  type: "object",
  properties: {
    role: {
      enum: [
        "Viewer",
        "Annotator",
        "Tech",
        "Owner",
        "MLOps",
        "SiteManager",
        "AnnotatorManager",
        "EdgifyCandidate",
        "SuperAdmin",
      ],
      type: "string",
    },
    email: {
      type: "string",
      format: "email",
    },
  },
  required: ["role", "email"],
} as const;

export const $CreateUserClientDto = {
  type: "object",
  properties: {
    email: {
      type: "string",
      format: "email",
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    company: {
      type: "string",
    },
    profileImg: {
      type: "string",
      format: "binary",
    },
    role: {
      enum: [
        "Viewer",
        "Annotator",
        "Tech",
        "Owner",
        "MLOps",
        "SiteManager",
        "AnnotatorManager",
        "EdgifyCandidate",
        "SuperAdmin",
      ],
      type: "string",
    },
    profileImgUrl: {
      type: "string",
    },
  },
  required: ["email", "firstName", "lastName", "company", "role"],
} as const;

export const $CreateUserResponseDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    failedRecipients: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "failedRecipients"],
} as const;

export const $UserOrderEnum = {
  type: "string",
  enum: ["firstName", "lastName", "company", "id", "role"],
} as const;

export const $UserOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/UserOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $UserQueryDto = {
  type: "object",
  properties: {
    userIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    roles: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "Viewer",
          "Annotator",
          "Tech",
          "Owner",
          "MLOps",
          "SiteManager",
          "AnnotatorManager",
          "EdgifyCandidate",
        ],
      },
    },
    excludeRoles: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "Viewer",
          "Annotator",
          "Tech",
          "Owner",
          "MLOps",
          "SiteManager",
          "AnnotatorManager",
          "EdgifyCandidate",
        ],
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/UserOrderEnumSortOption",
      },
    },
    id: {
      type: "number",
      maximum: 2147483647,
      minimum: 1,
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    company: {
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $UserMinimalDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
  },
  required: ["id", "firstName", "lastName"],
} as const;

export const $ExportUsersDto = {
  type: "object",
  properties: {
    roles: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "Viewer",
          "Annotator",
          "Tech",
          "Owner",
          "MLOps",
          "SiteManager",
          "AnnotatorManager",
          "EdgifyCandidate",
        ],
      },
    },
    excludeRoles: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "Viewer",
          "Annotator",
          "Tech",
          "Owner",
          "MLOps",
          "SiteManager",
          "AnnotatorManager",
          "EdgifyCandidate",
        ],
      },
    },
    maxRows: {
      type: "number",
      minimum: 1,
      description:
        "Backend-only row cap override. Not exposed in the UI; omit to use the default.",
    },
    id: {
      type: "number",
      maximum: 2147483647,
      minimum: 1,
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    company: {
      type: "string",
    },
  },
} as const;

export const $DownloadUsersRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/ExportUsersDto",
    },
  },
  required: ["query"],
} as const;

export const $RoleCreatePermissionDto = {
  type: "object",
  properties: {
    allowedRoles: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["allowedRoles"],
} as const;

export const $UpdateUserDto = {
  type: "object",
  properties: {
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    defaultAccount: {
      type: "number",
    },
    profileImg: {
      type: "string",
      format: "binary",
    },
    lastConnected: {
      format: "date-time",
      type: "string",
    },
  },
} as const;

export const $UpdateTableSettingsDto = {
  type: "object",
  properties: {
    visibleColumns: {
      type: "array",
      nullable: true,
      minLength: 1,
      uniqueItems: true,
      items: {
        type: "string",
        minLength: 1,
        maxLength: 100,
        pattern: `^[^&<>"']+$`,
      },
      maxItems: 200,
      description:
        "Column ids to show. null or [] clears the stored choice (the table falls back to its defaults).",
    },
    columnOrder: {
      type: "array",
      nullable: true,
      minLength: 1,
      uniqueItems: true,
      items: {
        type: "string",
        minLength: 1,
        maxLength: 100,
        pattern: `^[^&<>"']+$`,
      },
      maxItems: 200,
      description:
        "Every known column id in display order -- also the list a later-added column is checked against. null or [] clears the stored order.",
    },
    sort: {
      nullable: true,
      maxItems: 10,
      description: "null or [] clears the stored sort.",
      type: "array",
      items: {
        $ref: "#/components/schemas/TableSortOptionDto",
      },
    },
    pageSize: {
      type: "number",
      nullable: true,
      minimum: 1,
      maximum: 1000,
      description: "null clears the stored page size.",
    },
  },
} as const;

export const $AdminUpdateUserDto = {
  type: "object",
  properties: {
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    defaultAccount: {
      type: "number",
    },
    profileImg: {
      type: "string",
      format: "binary",
    },
    id: {
      type: "number",
    },
    email: {
      type: "string",
    },
    company: {
      type: "string",
    },
    role: {
      enum: [
        "Viewer",
        "Annotator",
        "Tech",
        "Owner",
        "MLOps",
        "SiteManager",
        "AnnotatorManager",
        "EdgifyCandidate",
      ],
      type: "string",
    },
    isActive: {
      type: "boolean",
    },
    lastConnected: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["id"],
} as const;

export const $BulkUsersQueryDto = {
  type: "object",
  properties: {
    userIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    roles: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "Viewer",
          "Annotator",
          "Tech",
          "Owner",
          "MLOps",
          "SiteManager",
          "AnnotatorManager",
          "EdgifyCandidate",
        ],
      },
    },
    excludeRoles: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "Viewer",
          "Annotator",
          "Tech",
          "Owner",
          "MLOps",
          "SiteManager",
          "AnnotatorManager",
          "EdgifyCandidate",
        ],
      },
    },
    id: {
      type: "number",
      maximum: 2147483647,
      minimum: 1,
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    company: {
      type: "string",
    },
  },
} as const;

export const $DeleteUsersBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkUsersQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $InviteUsersDto = {
  type: "object",
  properties: {
    mailingList: {
      minItems: 1,
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    reportId: {
      type: "number",
    },
    filters: {
      type: "string",
    },
  },
  required: ["mailingList", "reportId", "filters"],
} as const;

export const $EmailSendOutcomeDto = {
  type: "object",
  properties: {
    failedRecipients: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["failedRecipients"],
} as const;

export const $GeneratePdfDto = {
  type: "object",
  properties: {
    urlParameters: {
      type: "string",
    },
  },
  required: ["urlParameters"],
} as const;

export const $ReportUserDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
  },
  required: ["id", "firstName", "lastName"],
} as const;

export const $ReportDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    url: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    user: {
      $ref: "#/components/schemas/ReportUserDto",
    },
    isEnvReport: {
      type: "boolean",
    },
    isEnabled: {
      type: "boolean",
    },
    showCustomReportSubscription: {
      type: "boolean",
    },
    filters: {
      type: "object",
      additionalProperties: true,
    },
  },
  required: [
    "id",
    "name",
    "url",
    "createdAt",
    "user",
    "isEnvReport",
    "isEnabled",
    "showCustomReportSubscription",
  ],
} as const;

export const $ReportsOrderEnum = {
  type: "string",
  enum: ["name", "createdAt"],
} as const;

export const $ReportsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ReportsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ValueColumnDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    displayName: {
      type: "string",
    },
    title: {
      type: "string",
    },
    index: {
      type: "number",
    },
  },
  required: ["name", "displayName", "title", "index"],
} as const;

export const $MetabaseQuestion = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    title: {
      type: "string",
    },
    id: {
      type: "number",
    },
    dashcardId: {
      type: "number",
    },
    type: {
      type: "string",
    },
    valueColumn: {
      $ref: "#/components/schemas/ValueColumnDto",
    },
  },
  required: ["name", "id", "dashcardId", "type"],
} as const;

export const $EmailReportsJobDataDto = {
  type: "object",
  properties: {
    mailingList: {
      minItems: 1,
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    internalMailingList: {
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    approvers: {
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    reportUrl: {
      type: "string",
    },
    reportName: {
      type: "string",
    },
    reportId: {
      type: "number",
    },
    addAttachments: {
      type: "boolean",
    },
    fileType: {
      type: "string",
    },
    selectedQuestions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetabaseQuestion",
      },
    },
    customReportQuestions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetabaseQuestion",
      },
    },
    summaryTable: {
      $ref: "#/components/schemas/MetabaseQuestion",
    },
    summaryText: {
      type: "string",
    },
    subject: {
      type: "string",
    },
    isCustomReport: {
      type: "boolean",
    },
  },
  required: ["mailingList", "reportUrl", "reportName"],
} as const;

export const $ReportSubscriptionDto = {
  type: "object",
  properties: {
    subscriptionId: {
      type: "number",
    },
    subscriptionName: {
      type: "string",
    },
    jobId: {
      type: "number",
    },
    cron: {
      type: "string",
    },
    data: {
      $ref: "#/components/schemas/EmailReportsJobDataDto",
    },
    timezone: {
      type: "string",
    },
    isPending: {
      type: "boolean",
    },
    lastSent: {
      format: "date-time",
      type: "string",
    },
    latestData: {
      type: "object",
    },
  },
  required: [
    "subscriptionId",
    "subscriptionName",
    "jobId",
    "cron",
    "data",
    "timezone",
    "isPending",
    "lastSent",
  ],
} as const;

export const $DetailedReportDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    url: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    user: {
      $ref: "#/components/schemas/ReportUserDto",
    },
    isEnvReport: {
      type: "boolean",
    },
    isEnabled: {
      type: "boolean",
    },
    showCustomReportSubscription: {
      type: "boolean",
    },
    filters: {
      type: "object",
      additionalProperties: true,
    },
    signedUrl: {
      type: "string",
    },
    subscriptions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ReportSubscriptionDto",
      },
    },
  },
  required: [
    "id",
    "name",
    "url",
    "createdAt",
    "user",
    "isEnvReport",
    "isEnabled",
    "showCustomReportSubscription",
    "signedUrl",
    "subscriptions",
  ],
} as const;

export const $UpdateReportDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    isEnabled: {
      type: "boolean",
    },
    showCustomReportSubscription: {
      type: "boolean",
    },
  },
} as const;

export const $UpdateReportConfigDto = {
  type: "object",
  properties: {
    filters: {
      type: "object",
      additionalProperties: true,
    },
  },
} as const;

export const $UpdateReportUrlDto = {
  type: "object",
  properties: {
    url: {
      type: "string",
    },
  },
  required: ["url"],
} as const;

export const $CreateReportDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    url: {
      type: "string",
    },
  },
  required: ["name", "url"],
} as const;

export const $TestEmailDto = {
  type: "object",
  properties: {
    mailingList: {
      minItems: 1,
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    filters: {
      type: "string",
    },
    reportName: {
      type: "string",
    },
    reportId: {
      type: "number",
    },
    addAttachments: {
      type: "boolean",
    },
    fileType: {
      type: "string",
    },
    selectedQuestions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetabaseQuestion",
      },
    },
    internalMailingList: {
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    approvers: {
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    customReportQuestions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetabaseQuestion",
      },
    },
    summaryTable: {
      $ref: "#/components/schemas/MetabaseQuestion",
    },
    summaryText: {
      type: "string",
    },
    isCustomReport: {
      type: "boolean",
    },
  },
  required: ["mailingList", "filters", "reportName", "reportId"],
} as const;

export const $ContactUsDto = {
  type: "object",
  properties: {
    userName: {
      type: "string",
    },
    userEmail: {
      type: "string",
    },
    account: {
      type: "string",
    },
    subject: {
      type: "string",
    },
    additionalInput: {
      type: "string",
    },
  },
  required: ["userName", "account", "subject", "additionalInput"],
} as const;

export const $MetabaseFilter = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "string",
    },
    slug: {
      type: "string",
    },
    type: {
      type: "string",
    },
  },
  required: ["name", "id", "slug", "type"],
} as const;

export const $DashboardMetadataResponseDto = {
  type: "object",
  properties: {
    questions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetabaseQuestion",
      },
    },
    filters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetabaseFilter",
      },
    },
  },
  required: ["questions", "filters"],
} as const;

export const $BulkSitesQueryDto = {
  type: "object",
  properties: {
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    groupId: {
      type: "number",
    },
    excludeGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    name: {
      type: "string",
    },
  },
} as const;

export const $ClusterSummariesOrderEnum = {
  type: "string",
  enum: ["name", "lastPing"],
} as const;

export const $ClusterSummariesOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ClusterSummariesOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $BulkClustersQueryDto = {
  type: "object",
  properties: {
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ClusterSummariesOrderEnumSortOption",
      },
    },
    name: {
      type: "string",
    },
  },
} as const;

export const $ScheduleModelDeploymentsJobDataDto = {
  type: "object",
  properties: {
    devicesQuery: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    sitesQuery: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    clustersQuery: {
      $ref: "#/components/schemas/BulkClustersQueryDto",
    },
    includeCollaboratorDevices: {
      type: "boolean",
      description: `Whether a cluster whose architecture leaves its in-site collaborator out of a model deployment
should deploy to it anyway. That is hybrid only: centralized clusters run the model on the
collaborator and always target it, distributed clusters target every device.

Absent means false, so a hybrid cluster deploys to its workers alone, as it does when a device
joins it. Devices named explicitly through \`devicesQuery\`, and site deployments, are unaffected.

The choice is recorded on each cluster's ClusterModelDeployment row, so a device that joins the
cluster later is deployed to on the same rule - see @common/cluster-utils/cluster-model-targets.`,
      default: false,
    },
    modelId: {
      type: "number",
    },
    role: {
      type: "string",
      enum: [
        "predictor",
        "nonScanDetector",
        "objectDetector",
        "similarityFilter",
      ],
    },
  },
  required: ["modelId"],
} as const;

export const $ScheduleModelDeploymentsScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ScheduleModelDeploymentsJobDataDto",
    },
  },
  required: ["name", "data"],
} as const;

export const $ScheduleModelDeploymentsScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ScheduleModelDeploymentsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $ScheduledJobOrderEnum = {
  type: "string",
  enum: ["createdAt", "name"],
} as const;

export const $ScheduledJobOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ScheduledJobOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListScheduledJobsDto = {
  type: "object",
  properties: {
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ScheduledJobOrderEnumSortOption",
      },
    },
    name: {
      type: "string",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $ScheduleModelDeploymentsScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ScheduleModelDeploymentsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $ScheduleModelDeploymentsUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ScheduleModelDeploymentsJobDataDto",
    },
  },
} as const;

export const $BulkScheduledJobsQueryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    scheduledJobIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $DeleteScheduledJobsBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkScheduledJobsQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $DeployComponentsDeviceStateEnum = {
  type: "string",
  enum: ["running", "done", "failed"],
  description: "",
} as const;

export const $ErrorDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    message: {
      type: "string",
    },
  },
  required: ["message"],
} as const;

export const $DeployComponentsDeviceResultDto = {
  type: "object",
  properties: {
    state: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/DeployComponentsDeviceStateEnum",
        },
      ],
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    updateTime: {
      type: "string",
      format: "date-time",
    },
    name: {
      type: "string",
    },
    failed: {
      type: "boolean",
    },
    done: {
      type: "boolean",
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
  },
} as const;

export const $DeployComponentsJobDetailsDto = {
  type: "object",
  properties: {
    devices: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            $ref: "#/components/schemas/DeployComponentsDeviceResultDto",
          },
        ],
      },
    },
    total: {
      type: "number",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
  },
  required: ["devices"],
} as const;

export const $ScheduleModelDeploymentsJobDeviceStateDto = {
  type: "string",
  enum: ["running", "done", "failed"],
} as const;

export const $ScheduleModelDeploymentsJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/ScheduleModelDeploymentsJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $ScheduleModelDeploymentsJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/ScheduleModelDeploymentsJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $ScheduleModelDeploymentsJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/ScheduleModelDeploymentsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/ScheduleModelDeploymentsJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $StoppedScheduledDto = {
  type: "object",
  properties: {
    unscheduledBullRepeatableKey: {
      type: "boolean",
    },
    unscheduledBullStopRepeatableKey: {
      type: "boolean",
    },
    unscheduledBullJob: {
      type: "boolean",
    },
    unscheduledBullStopJob: {
      type: "boolean",
    },
  },
} as const;

export const $ScheduleModelDeploymentsDataWithNameDto = {
  type: "object",
  properties: {
    devicesQuery: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    sitesQuery: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    clustersQuery: {
      $ref: "#/components/schemas/BulkClustersQueryDto",
    },
    includeCollaboratorDevices: {
      type: "boolean",
      description: `Whether a cluster whose architecture leaves its in-site collaborator out of a model deployment
should deploy to it anyway. That is hybrid only: centralized clusters run the model on the
collaborator and always target it, distributed clusters target every device.

Absent means false, so a hybrid cluster deploys to its workers alone, as it does when a device
joins it. Devices named explicitly through \`devicesQuery\`, and site deployments, are unaffected.

The choice is recorded on each cluster's ClusterModelDeployment row, so a device that joins the
cluster later is deployed to on the same rule - see @common/cluster-utils/cluster-model-targets.`,
      default: false,
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    modelId: {
      type: "number",
    },
    role: {
      enum: [
        "predictor",
        "nonScanDetector",
        "objectDetector",
        "similarityFilter",
      ],
      type: "string",
    },
  },
  required: ["modelId"],
} as const;

export const $NumberConditionEnum = {
  type: "string",
  enum: [
    "gte",
    ">=",
    "lte",
    "<=",
    "gt",
    ">",
    "lt",
    "<",
    "eq",
    "==",
    "not",
    "!=",
  ],
} as const;

export const $NumberConditionDto = {
  type: "object",
  properties: {
    condition: {
      allOf: [
        {
          $ref: "#/components/schemas/NumberConditionEnum",
        },
      ],
    },
    value: {
      type: "number",
    },
  },
  required: ["condition", "value"],
} as const;

export const $JobOrderEnum = {
  type: "string",
  enum: ["createdAt", "name", "state", "progress", "done"],
} as const;

export const $JobOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/JobOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListJobsDto = {
  type: "object",
  properties: {
    state: {
      type: "string",
      items: {
        type: "string",
        enum: [
          "done",
          "failed",
          "pending",
          "cancelled",
          "running",
          "cancelling",
          "suspended",
          "aborted",
        ],
      },
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    total: {
      description:
        "Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.",
      type: "array",
      items: {
        $ref: "#/components/schemas/NumberConditionDto",
      },
    },
    done: {
      description: "Filters on how many items the job actually completed.",
      type: "array",
      items: {
        $ref: "#/components/schemas/NumberConditionDto",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/JobOrderEnumSortOption",
      },
    },
    name: {
      type: "string",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $ScheduleModelDeploymentsJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/ScheduleModelDeploymentsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $BulkJobsQueryDto = {
  type: "object",
  properties: {
    state: {
      type: "string",
      items: {
        type: "string",
        enum: [
          "done",
          "failed",
          "pending",
          "cancelled",
          "running",
          "cancelling",
          "suspended",
          "aborted",
        ],
      },
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    total: {
      description:
        "Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.",
      type: "array",
      items: {
        $ref: "#/components/schemas/NumberConditionDto",
      },
    },
    done: {
      description: "Filters on how many items the job actually completed.",
      type: "array",
      items: {
        $ref: "#/components/schemas/NumberConditionDto",
      },
    },
    name: {
      type: "string",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    jobIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $DeleteJobsBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkJobsQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $ScheduleModelDeploymentsUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $DeployComponentsJobDataDto = {
  type: "object",
  properties: {
    devicesQuery: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    sitesQuery: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    clustersQuery: {
      $ref: "#/components/schemas/BulkClustersQueryDto",
    },
    component: {
      type: "string",
    },
    version: {
      type: "string",
    },
    type: {
      type: "string",
    },
  },
  required: ["component", "version"],
} as const;

export const $DeployComponentsScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeployComponentsJobDataDto",
    },
  },
  required: ["name", "data"],
} as const;

export const $DeployComponentsScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeployComponentsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $DeployComponentsScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeployComponentsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $DeployComponentsUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeployComponentsJobDataDto",
    },
  },
} as const;

export const $DeployComponentsJobDeviceStateDto = {
  type: "string",
  enum: ["running", "done", "failed"],
} as const;

export const $DeployComponentsJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/DeployComponentsJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $DeployComponentsJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/DeployComponentsJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $DeployComponentsJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/DeployComponentsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/DeployComponentsJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $DeployComponentsDataWithNameDto = {
  type: "object",
  properties: {
    devicesQuery: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    sitesQuery: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    clustersQuery: {
      $ref: "#/components/schemas/BulkClustersQueryDto",
    },
    component: {
      type: "string",
    },
    version: {
      type: "string",
    },
    type: {
      type: "string",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
  required: ["component", "version"],
} as const;

export const $DeployComponentsJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/DeployComponentsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $DeployComponentsUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $ScheduleConfigDeploymentsJobDataDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    cleanDeviceConfig: {
      type: "object",
    },
    isPartial: {
      type: "boolean",
    },
    originalDeviceId: {
      type: "number",
    },
    userId: {
      type: "number",
    },
    devicesQuery: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    sitesQuery: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    clustersQuery: {
      $ref: "#/components/schemas/BulkClustersQueryDto",
    },
  },
  required: ["cleanDeviceConfig", "isPartial"],
} as const;

export const $ScheduleConfigDeploymentsScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ScheduleConfigDeploymentsJobDataDto",
    },
  },
  required: ["name", "data"],
} as const;

export const $ScheduleConfigDeploymentsScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ScheduleConfigDeploymentsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $ScheduleConfigDeploymentsScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ScheduleConfigDeploymentsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $ScheduleConfigDeploymentsUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ScheduleConfigDeploymentsJobDataDto",
    },
  },
} as const;

export const $ScheduleConfigDeploymentsJobDeviceStateDto = {
  type: "string",
  enum: ["running", "done", "failed"],
} as const;

export const $ScheduleConfigDeploymentsJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/ScheduleConfigDeploymentsJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $ScheduleConfigDeploymentsJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/ScheduleConfigDeploymentsJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $ScheduleConfigDeploymentsJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/ScheduleConfigDeploymentsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/ScheduleConfigDeploymentsJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $ScheduleConfigDeploymentsDataWithNameDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    cleanDeviceConfig: {
      type: "object",
    },
    isPartial: {
      type: "boolean",
    },
    originalDeviceId: {
      type: "number",
    },
    userId: {
      type: "number",
    },
    devicesQuery: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    sitesQuery: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    clustersQuery: {
      $ref: "#/components/schemas/BulkClustersQueryDto",
    },
  },
  required: ["cleanDeviceConfig", "isPartial"],
} as const;

export const $ScheduleConfigDeploymentsJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/ScheduleConfigDeploymentsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $ScheduleConfigDeploymentsUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $DeviceRestartJobDataDto = {
  type: "object",
  properties: {
    devicesQuery: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    restartAgent: {
      type: "boolean",
      default: true,
    },
    restartNS: {
      type: "boolean",
      default: false,
      description: "Reserved for future NS restart support",
    },
    restartJobs: {
      type: "boolean",
      default: false,
      description: "Reserved for future jobs restart support",
    },
  },
  required: ["devicesQuery"],
} as const;

export const $DeviceRestartScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeviceRestartJobDataDto",
    },
  },
  required: ["name", "data"],
} as const;

export const $DeviceRestartScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeviceRestartJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $DeviceRestartScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeviceRestartJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $DeviceRestartUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeviceRestartJobDataDto",
    },
  },
} as const;

export const $DeviceRestartJobDeviceStateDto = {
  type: "string",
  enum: ["running", "done", "failed"],
} as const;

export const $DeviceRestartJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/DeviceRestartJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $DeviceRestartJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/DeviceRestartJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $DeviceRestartJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/DeviceRestartJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/DeviceRestartJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $DeviceRestartDataWithNameDto = {
  type: "object",
  properties: {
    devicesQuery: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
    restartAgent: {
      type: "boolean",
      default: true,
    },
    restartNS: {
      type: "boolean",
      default: false,
      description: "Reserved for future NS restart support",
    },
    restartJobs: {
      type: "boolean",
      default: false,
      description: "Reserved for future jobs restart support",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
  required: ["devicesQuery"],
} as const;

export const $DeviceRestartJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeployComponentsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/DeviceRestartJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $DeviceRestartUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $LoginDto = {
  type: "object",
  properties: {
    destination: {
      type: "string",
      format: "email",
    },
    context: {
      type: "string",
    },
  },
  required: ["destination"],
} as const;

export const $LoginResponseDto = {
  type: "object",
  properties: {
    redirectUrl: {
      type: "string",
    },
  },
} as const;

export const $AccountSwitchDto = {
  type: "object",
  properties: {
    accountId: {
      type: "number",
    },
  },
  required: ["accountId"],
} as const;

export const $TransactionResultEnum = {
  type: "string",
  enum: [
    "Top1_Correct",
    "Top2_Correct",
    "Top3_Correct",
    "Top4_Correct",
    "Top5_Correct",
    "Unknown",
    "Out_Of_Scope",
    "Non_Scan",
    "Mistake",
  ],
} as const;

export const $ListSamplesCountDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    sampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    region: {
      type: "string",
      deprecated: true,
      description:
        "Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.",
    },
    regionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this region (active regions only).",
    },
    subRegionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this sub-region (active, under an active region).",
    },
    uxSource: {
      type: "string",
      description: "UX source filter (case-insensitive exact match)",
    },
    deviceIp: {
      type: "string",
      description:
        "Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)",
    },
    timeField: {
      enum: ["createdAt", "addedAt"],
      type: "string",
    },
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    modelIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    result: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionResultEnum",
      },
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    predictions: {
      type: "array",
      items: {
        type: "string",
      },
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    taggedByIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    dataType: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetId: {
      type: "number",
    },
    fromDate: {
      format: "date-time",
      type: "string",
    },
    toDate: {
      format: "date-time",
      type: "string",
    },
    onlyWithPrediction: {
      type: "boolean",
    },
    showNonScans: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    headsFound: {
      type: "boolean",
    },
    family: {
      type: "string",
    },
    fuzzy: {
      type: "boolean",
    },
    matchStrength: {
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    showOnlyWithImages: {
      type: "boolean",
    },
  },
} as const;

export const $UxSourceDto = {
  type: "object",
  properties: {
    uxSource: {
      type: "string",
    },
  },
  required: ["uxSource"],
} as const;

export const $SamplesOrderEnum = {
  type: "string",
  enum: ["createdAt", "addedAt", "label", "family"],
} as const;

export const $SamplesOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/SamplesOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListSamplesDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    sampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    region: {
      type: "string",
      deprecated: true,
      description:
        "Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.",
    },
    regionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this region (active regions only).",
    },
    subRegionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this sub-region (active, under an active region).",
    },
    uxSource: {
      type: "string",
      description: "UX source filter (case-insensitive exact match)",
    },
    deviceIp: {
      type: "string",
      description:
        "Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)",
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SamplesOrderEnumSortOption",
      },
    },
    timeField: {
      enum: ["createdAt", "addedAt"],
      type: "string",
    },
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    modelIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    result: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionResultEnum",
      },
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    predictions: {
      type: "array",
      items: {
        type: "string",
      },
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    taggedByIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    dataType: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetId: {
      type: "number",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
    fromDate: {
      format: "date-time",
      type: "string",
    },
    toDate: {
      format: "date-time",
      type: "string",
    },
    onlyWithPrediction: {
      type: "boolean",
    },
    showNonScans: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    headsFound: {
      type: "boolean",
    },
    family: {
      type: "string",
    },
    fuzzy: {
      type: "boolean",
    },
    matchStrength: {
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    showOnlyWithImages: {
      type: "boolean",
    },
  },
  required: ["limit", "page"],
} as const;

export const $DeviceWithActivation = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["name", "id", "activationTime"],
} as const;

export const $PartialDevice = {
  type: "object",
  properties: {
    state: {
      enum: ["deploying", "ready", "disconnected", "disabled", "down"],
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["state", "agentVersion", "name", "id"],
} as const;

export const $PredictionEntryDto = {
  type: "object",
  properties: {
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    label: {
      type: "string",
    },
    certainty: {
      type: "number",
    },
    englishName: {
      type: "string",
    },
  },
  required: ["label", "certainty"],
} as const;

export const $GroundTruthPredictionDto = {
  type: "object",
  properties: {
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PredictionEntryDto",
      },
    },
    device: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    model: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    loss: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    editedLoss: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    id: {
      type: "number",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    capturedAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    captureDuration: {
      type: "number",
    },
    captureTrigger: {
      type: "string",
    },
    certain: {
      type: "boolean",
    },
    family: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    interactionStartTime: {
      format: "date-time",
      type: "string",
    },
    transactionDuration: {
      type: "number",
    },
    isActive: {
      type: "boolean",
    },
    result: {
      type: "string",
    },
    certainty: {
      type: "number",
    },
    inModel: {
      type: "boolean",
    },
    modelGroup: {
      type: "string",
    },
    modelFamily: {
      type: "string",
    },
  },
  required: [
    "predictions",
    "id",
    "createdAt",
    "predictedAt",
    "capturedAt",
    "updatedAt",
    "captureTrigger",
    "certain",
    "sessionId",
  ],
} as const;

export const $SampleTagDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    count: {
      type: "number",
    },
    referencedSampleUuid: {
      type: "string",
      format: "uuid",
    },
    isLocked: {
      type: "boolean",
    },
  },
  required: ["name", "id"],
} as const;

export const $SampleSummaryDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    addedAt: {
      format: "date-time",
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    device: {
      $ref: "#/components/schemas/DeviceWithActivation",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    site: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    storageDevice: {
      $ref: "#/components/schemas/PartialDevice",
    },
    totalPrice: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    weight: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    calculatedTotalPrice: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/GroundTruthPredictionDto",
      },
    },
    id: {
      type: "number",
    },
    uuid: {
      type: "string",
    },
    groupId: {
      type: "string",
    },
    label: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    editedLabel: {
      type: "string",
    },
    editedLabelEnglishName: {
      type: "string",
    },
    comment: {
      type: "string",
    },
    family: {
      type: "string",
    },
    editedFamily: {
      type: "string",
    },
    category: {
      type: "string",
    },
    labelTrigger: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    imgSource: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    matchStrength: {
      type: "string",
    },
    storagePath: {
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagDto",
      },
    },
    taggedByName: {
      type: "string",
    },
    taggedById: {
      type: "number",
    },
    barcode: {
      type: "string",
    },
    count: {
      type: "number",
    },
    dataType: {
      type: "string",
    },
    data: {
      type: "object",
    },
    headBlurred: {
      type: "boolean",
      description: "true when the sample image had heads blurred on the device",
    },
    headsFound: {
      type: "boolean",
      description:
        "whether heads were found in the sample image, null when not evaluated",
    },
  },
  required: [
    "state",
    "addedAt",
    "createdAt",
    "updatedAt",
    "id",
    "uuid",
    "groupId",
    "label",
    "family",
    "headBlurred",
  ],
} as const;

export const $UpdateSampleLossDto = {
  type: "object",
  properties: {
    editedLoss: {
      nullable: true,
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
  },
} as const;

export const $RefreshLossDto = {
  type: "object",
  properties: {
    sampleIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
  },
  required: ["sampleIds"],
} as const;

export const $SampleWithImageDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    addedAt: {
      format: "date-time",
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    device: {
      $ref: "#/components/schemas/DeviceWithActivation",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    site: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    storageDevice: {
      $ref: "#/components/schemas/PartialDevice",
    },
    totalPrice: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    weight: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    calculatedTotalPrice: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/GroundTruthPredictionDto",
      },
    },
    id: {
      type: "number",
    },
    uuid: {
      type: "string",
    },
    groupId: {
      type: "string",
    },
    label: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    editedLabel: {
      type: "string",
    },
    editedLabelEnglishName: {
      type: "string",
    },
    comment: {
      type: "string",
    },
    family: {
      type: "string",
    },
    editedFamily: {
      type: "string",
    },
    category: {
      type: "string",
    },
    labelTrigger: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    imgSource: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    matchStrength: {
      type: "string",
    },
    storagePath: {
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagDto",
      },
    },
    taggedByName: {
      type: "string",
    },
    taggedById: {
      type: "number",
    },
    barcode: {
      type: "string",
    },
    count: {
      type: "number",
    },
    dataType: {
      type: "string",
    },
    data: {
      type: "object",
    },
    headBlurred: {
      type: "boolean",
      description: "true when the sample image had heads blurred on the device",
    },
    headsFound: {
      type: "boolean",
      description:
        "whether heads were found in the sample image, null when not evaluated",
    },
    image: {
      type: "object",
      properties: {
        data: {
          type: "string",
        },
        error: {
          $ref: "#/components/schemas/ErrorDto",
        },
      },
      required: [],
    },
    sessionVideoLink: {
      type: "string",
    },
    videoStartTime: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "state",
    "addedAt",
    "createdAt",
    "updatedAt",
    "id",
    "uuid",
    "groupId",
    "label",
    "family",
    "headBlurred",
  ],
} as const;

export const $SampleDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    addedAt: {
      format: "date-time",
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    device: {
      $ref: "#/components/schemas/DeviceWithActivation",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    site: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    storageDevice: {
      $ref: "#/components/schemas/PartialDevice",
    },
    totalPrice: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    weight: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    calculatedTotalPrice: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/GroundTruthPredictionDto",
      },
    },
    id: {
      type: "number",
    },
    uuid: {
      type: "string",
    },
    groupId: {
      type: "string",
    },
    label: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    editedLabel: {
      type: "string",
    },
    editedLabelEnglishName: {
      type: "string",
    },
    comment: {
      type: "string",
    },
    family: {
      type: "string",
    },
    editedFamily: {
      type: "string",
    },
    category: {
      type: "string",
    },
    labelTrigger: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    imgSource: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    matchStrength: {
      type: "string",
    },
    storagePath: {
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagDto",
      },
    },
    taggedByName: {
      type: "string",
    },
    taggedById: {
      type: "number",
    },
    barcode: {
      type: "string",
    },
    count: {
      type: "number",
    },
    dataType: {
      type: "string",
    },
    data: {
      type: "object",
    },
    headBlurred: {
      type: "boolean",
      description: "true when the sample image had heads blurred on the device",
    },
    headsFound: {
      type: "boolean",
      description:
        "whether heads were found in the sample image, null when not evaluated",
    },
    sessionVideoLink: {
      type: "string",
    },
    videoStartTime: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "state",
    "addedAt",
    "createdAt",
    "updatedAt",
    "id",
    "uuid",
    "groupId",
    "label",
    "family",
    "headBlurred",
  ],
} as const;

export const $UpdateSamplesBulkParamsDto = {
  type: "object",
  properties: {
    editedLabel: {
      type: "string",
      nullable: true,
    },
    editedFamily: {
      type: "string",
      nullable: true,
    },
    valueToUpdate: {
      enum: ["label", "family"],
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
  required: ["valueToUpdate"],
} as const;

export const $BulkSamplesQueryDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    sampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    region: {
      type: "string",
      deprecated: true,
      description:
        "Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.",
    },
    regionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this region (active regions only).",
    },
    subRegionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this sub-region (active, under an active region).",
    },
    uxSource: {
      type: "string",
      description: "UX source filter (case-insensitive exact match)",
    },
    deviceIp: {
      type: "string",
      description:
        "Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)",
    },
    timeField: {
      enum: ["createdAt", "addedAt"],
      type: "string",
    },
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    modelIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    result: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionResultEnum",
      },
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    predictions: {
      type: "array",
      items: {
        type: "string",
      },
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    taggedByIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    dataType: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetId: {
      type: "number",
    },
    fromDate: {
      format: "date-time",
      type: "string",
    },
    toDate: {
      format: "date-time",
      type: "string",
    },
    onlyWithPrediction: {
      type: "boolean",
    },
    showNonScans: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    headsFound: {
      type: "boolean",
    },
    family: {
      type: "string",
    },
    fuzzy: {
      type: "boolean",
    },
    matchStrength: {
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    showOnlyWithImages: {
      type: "boolean",
    },
  },
} as const;

export const $UpdateSamplesBulkDto = {
  type: "object",
  properties: {
    params: {
      $ref: "#/components/schemas/UpdateSamplesBulkParamsDto",
    },
    query: {
      $ref: "#/components/schemas/BulkSamplesQueryDto",
    },
  },
  required: ["params", "query"],
} as const;

export const $UpdateSampleMetadataDto = {
  type: "object",
  properties: {
    comment: {
      type: "string",
      nullable: true,
    },
  },
} as const;

export const $UpdateSamplesMetadataBulkBodyDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkSamplesQueryDto",
    },
    params: {
      $ref: "#/components/schemas/UpdateSampleMetadataDto",
    },
  },
  required: ["query", "params"],
} as const;

export const $UpdateSamplesTaggingBulkDto = {
  type: "object",
  properties: {
    assignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    unAssignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    all: {
      type: "boolean",
    },
    query: {
      $ref: "#/components/schemas/BulkSamplesQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $UpdateSampleDto = {
  type: "object",
  properties: {
    editedLabel: {
      type: "string",
      nullable: true,
    },
    editedFamily: {
      type: "string",
      nullable: true,
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
} as const;

export const $UploadSamplesBulkQueryDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    sampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    region: {
      type: "string",
      deprecated: true,
      description:
        "Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.",
    },
    regionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this region (active regions only).",
    },
    subRegionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this sub-region (active, under an active region).",
    },
    uxSource: {
      type: "string",
      description: "UX source filter (case-insensitive exact match)",
    },
    deviceIp: {
      type: "string",
      description:
        "Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)",
    },
    timeField: {
      enum: ["createdAt", "addedAt"],
      type: "string",
    },
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    modelIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    result: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionResultEnum",
      },
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    predictions: {
      type: "array",
      items: {
        type: "string",
      },
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    taggedByIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    dataType: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetId: {
      type: "number",
    },
    deleteAfterUpload: {
      type: "boolean",
      description: "delete the sample off the device once uploaded to storage",
    },
    fromDate: {
      format: "date-time",
      type: "string",
    },
    toDate: {
      format: "date-time",
      type: "string",
    },
    onlyWithPrediction: {
      type: "boolean",
    },
    showNonScans: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    headsFound: {
      type: "boolean",
    },
    family: {
      type: "string",
    },
    fuzzy: {
      type: "boolean",
    },
    matchStrength: {
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    showOnlyWithImages: {
      type: "boolean",
    },
  },
} as const;

export const $UploadOperationCreatedDto = {
  type: "object",
  properties: {
    operationId: {
      type: "number",
    },
  },
  required: ["operationId"],
} as const;

export const $ListPredictionsCountDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    modelIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    timeField: {
      enum: ["createdAt", "predictedAt"],
      type: "string",
    },
    result: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionResultEnum",
      },
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    label: {
      type: "string",
    },
    prediction: {
      type: "string",
    },
    fuzzy: {
      type: "boolean",
    },
  },
} as const;

export const $PredictionsOrderEnum = {
  type: "string",
  enum: ["createdAt", "predictedAt"],
} as const;

export const $PredictionsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/PredictionsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListPredictionsDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    modelIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PredictionsOrderEnumSortOption",
      },
    },
    timeField: {
      enum: ["createdAt", "predictedAt"],
      type: "string",
    },
    result: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionResultEnum",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    label: {
      type: "string",
    },
    prediction: {
      type: "string",
    },
    fuzzy: {
      type: "boolean",
    },
  },
  required: ["limit", "page"],
} as const;

export const $PredictionGroundTruthDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    addedAt: {
      format: "date-time",
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    device: {
      $ref: "#/components/schemas/DeviceWithActivation",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    site: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    storageDevice: {
      $ref: "#/components/schemas/PartialDevice",
    },
    totalPrice: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    weight: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    loss: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    editedLoss: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    id: {
      type: "number",
    },
    groupId: {
      type: "string",
    },
    label: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    editedLabel: {
      type: "string",
    },
    editedLabelEnglishName: {
      type: "string",
    },
    comment: {
      type: "string",
    },
    family: {
      type: "string",
    },
    editedFamily: {
      type: "string",
    },
    category: {
      type: "string",
    },
    labelTrigger: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    imgSource: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    matchStrength: {
      type: "string",
    },
    storagePath: {
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagDto",
      },
    },
    taggedByName: {
      type: "string",
    },
    taggedById: {
      type: "number",
    },
    barcode: {
      type: "string",
    },
    count: {
      type: "number",
    },
    dataType: {
      type: "string",
    },
    data: {
      type: "object",
    },
    headBlurred: {
      type: "boolean",
      description: "true when the sample image had heads blurred on the device",
    },
    headsFound: {
      type: "boolean",
      description:
        "whether heads were found in the sample image, null when not evaluated",
    },
    transactionDuration: {
      type: "number",
    },
    isActive: {
      type: "boolean",
    },
    result: {
      type: "string",
    },
    certainty: {
      type: "number",
    },
    inModel: {
      type: "boolean",
    },
    modelGroup: {
      type: "string",
    },
    modelFamily: {
      type: "string",
    },
  },
  required: [
    "state",
    "addedAt",
    "createdAt",
    "updatedAt",
    "id",
    "groupId",
    "label",
    "family",
    "headBlurred",
  ],
} as const;

export const $PredictionDto = {
  type: "object",
  properties: {
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PredictionEntryDto",
      },
    },
    device: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    model: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    groundTruth: {
      $ref: "#/components/schemas/PredictionGroundTruthDto",
    },
    id: {
      type: "number",
    },
    uuid: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    capturedAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    captureDuration: {
      type: "number",
    },
    captureTrigger: {
      type: "string",
    },
    certain: {
      type: "boolean",
    },
    family: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    interactionStartTime: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "predictions",
    "id",
    "uuid",
    "createdAt",
    "predictedAt",
    "capturedAt",
    "updatedAt",
    "captureTrigger",
    "certain",
    "sessionId",
  ],
} as const;

export const $ListModelPredictionsCountDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    timeField: {
      enum: ["createdAt", "predictedAt"],
      type: "string",
    },
    result: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionResultEnum",
      },
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    label: {
      type: "string",
    },
    prediction: {
      type: "string",
    },
    fuzzy: {
      type: "boolean",
    },
  },
} as const;

export const $ListModelPredictionsDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PredictionsOrderEnumSortOption",
      },
    },
    timeField: {
      enum: ["createdAt", "predictedAt"],
      type: "string",
    },
    result: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionResultEnum",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    label: {
      type: "string",
    },
    prediction: {
      type: "string",
    },
    fuzzy: {
      type: "boolean",
    },
  },
  required: ["limit", "page"],
} as const;

export const $ListSessionsCountDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storage: {
      enum: ["any", "backend", "cluster", "edge", "device", "recorded", "none"],
      type: "string",
    },
    timeField: {
      enum: ["createdAt", "session"],
      type: "string",
    },
    sessionIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionsTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    assigneeIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    assigneeMatch: {
      enum: ["any", "none"],
      type: "string",
    },
    alertType: {
      type: "array",
      items: {
        type: "string",
        enum: ["non-scan", "non-match", "left-in-cart"],
      },
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetId: {
      type: "number",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    onlyNonScans: {
      type: "boolean",
    },
    onlyStored: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    assistantId: {
      type: "string",
    },
    shopperId: {
      type: "string",
    },
  },
} as const;

export const $ListSessionsAlertsOrderEnum = {
  type: "string",
  enum: ["createdAt", "session", "size"],
} as const;

export const $ListSessionsAlertsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ListSessionsAlertsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListSessionsAlertsDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storage: {
      enum: ["any", "backend", "cluster", "edge", "device", "recorded", "none"],
      type: "string",
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ListSessionsAlertsOrderEnumSortOption",
      },
    },
    timeField: {
      enum: ["createdAt", "session"],
      type: "string",
    },
    sessionIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionsTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    onlyNonScans: {
      type: "boolean",
    },
    onlyStored: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    assistantId: {
      type: "string",
    },
    shopperId: {
      type: "string",
    },
  },
  required: ["limit", "page"],
} as const;

export const $SessionsAlertsSummaryDto = {
  type: "object",
  properties: {
    devices: {
      type: "number",
      description:
        "Number of active devices in the specified sites during the time period",
    },
    totalAlerts: {
      type: "number",
      description: "Total number of alert events across all filtered sessions",
    },
    pendingAlerts: {
      type: "number",
      description: "Number of alert events that have not been tagged yet",
    },
    reviewedAlerts: {
      type: "number",
      description: "Number of alert events that have been tagged",
    },
  },
  required: ["devices", "totalAlerts", "pendingAlerts", "reviewedAlerts"],
} as const;

export const $ListSessionsAlertsResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
    },
    summary: {
      description: "Summary statistics for the entire filtered dataset",
      allOf: [
        {
          $ref: "#/components/schemas/SessionsAlertsSummaryDto",
        },
      ],
    },
    count: {
      type: "number",
    },
    countIsEstimate: {
      type: "boolean",
    },
    lastPage: {
      type: "number",
    },
    perPage: {
      type: "number",
    },
    total: {
      type: "number",
    },
    totalIsEstimate: {
      type: "boolean",
    },
    limit: {
      type: "number",
    },
    page: {
      type: "number",
    },
  },
  required: ["results", "summary", "total", "limit", "page"],
} as const;

export const $SampleTagReferencedDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    count: {
      type: "number",
    },
    referencedSampleUuid: {
      type: "string",
      format: "uuid",
    },
    isLocked: {
      type: "boolean",
    },
    referenced: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id"],
} as const;

export const $TransactionPredictionDto = {
  type: "object",
  properties: {
    predictions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PredictionEntryDto",
      },
    },
    device: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    model: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    capturedAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    captureDuration: {
      type: "number",
    },
    captureTrigger: {
      type: "string",
    },
    certain: {
      type: "boolean",
    },
    family: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    interactionStartTime: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "predictions",
    "id",
    "createdAt",
    "predictedAt",
    "capturedAt",
    "updatedAt",
    "captureTrigger",
    "certain",
    "sessionId",
  ],
} as const;

export const $TransactionGroundTruthDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    addedAt: {
      format: "date-time",
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    device: {
      $ref: "#/components/schemas/DeviceWithActivation",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    site: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    storageDevice: {
      $ref: "#/components/schemas/PartialDevice",
    },
    totalPrice: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    weight: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    id: {
      type: "number",
    },
    groupId: {
      type: "string",
    },
    label: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    editedLabel: {
      type: "string",
    },
    editedLabelEnglishName: {
      type: "string",
    },
    comment: {
      type: "string",
    },
    family: {
      type: "string",
    },
    editedFamily: {
      type: "string",
    },
    category: {
      type: "string",
    },
    labelTrigger: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    imgSource: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    matchStrength: {
      type: "string",
    },
    storagePath: {
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagDto",
      },
    },
    taggedByName: {
      type: "string",
    },
    taggedById: {
      type: "number",
    },
    barcode: {
      type: "string",
    },
    count: {
      type: "number",
    },
    dataType: {
      type: "string",
    },
    data: {
      type: "object",
    },
    headBlurred: {
      type: "boolean",
      description: "true when the sample image had heads blurred on the device",
    },
    headsFound: {
      type: "boolean",
      description:
        "whether heads were found in the sample image, null when not evaluated",
    },
  },
  required: [
    "state",
    "addedAt",
    "createdAt",
    "updatedAt",
    "id",
    "groupId",
    "label",
    "family",
    "headBlurred",
  ],
} as const;

export const $TransactionDto = {
  type: "object",
  properties: {
    loss: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    editedLoss: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    prediction: {
      $ref: "#/components/schemas/TransactionPredictionDto",
    },
    groundTruth: {
      $ref: "#/components/schemas/TransactionGroundTruthDto",
    },
    id: {
      type: "number",
    },
    uuid: {
      type: "string",
    },
    groupId: {
      type: "string",
      format: "uuid",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    addedAt: {
      format: "date-time",
      type: "string",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    capturedAt: {
      format: "date-time",
      type: "string",
    },
    transactionDuration: {
      type: "number",
    },
    isActive: {
      type: "boolean",
    },
    result: {
      type: "string",
    },
    certainty: {
      type: "number",
    },
    inModel: {
      type: "boolean",
    },
    modelGroup: {
      type: "string",
    },
    modelFamily: {
      type: "string",
    },
  },
  required: ["id", "uuid", "createdAt"],
} as const;

export const $TransactionGroupDto = {
  type: "object",
  properties: {
    groupId: {
      type: "string",
      format: "uuid",
    },
    startTime: {
      format: "date-time",
      type: "string",
    },
    endTime: {
      format: "date-time",
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagReferencedDto",
      },
    },
    referencedTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagReferencedDto",
      },
    },
    transactions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionDto",
      },
    },
  },
  required: ["groupId", "transactions"],
} as const;

export const $SessionDeviceDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    site: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
  },
  required: ["name", "id"],
} as const;

export const $DeviceWithStateDto = {
  type: "object",
  properties: {
    state: {
      enum: ["deploying", "ready", "disconnected", "disabled", "down"],
      type: "string",
    },
    agentVersion: {
      type: "string",
      description:
        "Which device requests the agent understands. Only selected where a caller needs it.",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["state", "name", "id"],
} as const;

export const $SessionDto = {
  type: "object",
  properties: {
    nonScans: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            $ref: "#/components/schemas/TransactionGroupDto",
          },
        ],
      },
    },
    sessionVideoLink: {
      type: "string",
    },
    sessionVisualizationLink: {
      type: "string",
    },
    transactions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionDto",
      },
    },
    id: {
      type: "number",
    },
    sessionId: {
      type: "string",
    },
    state: {
      type: "string",
    },
    sampleCount: {
      type: "number",
    },
    nonScanCount: {
      type: "number",
    },
    nonMatchCount: {
      type: "number",
    },
    leftInCartCount: {
      type: "number",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagReferencedDto",
      },
    },
    storagePath: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    startTime: {
      format: "date-time",
      type: "string",
    },
    endTime: {
      format: "date-time",
      type: "string",
    },
    calculatedStartTime: {
      format: "date-time",
      type: "string",
    },
    calculatedEndTime: {
      format: "date-time",
      type: "string",
    },
    startCause: {
      type: "string",
    },
    stopCause: {
      type: "string",
    },
    size: {
      format: "int64",
      type: "integer",
    },
    codec: {
      type: "string",
    },
    width: {
      type: "number",
    },
    height: {
      type: "number",
    },
    fps: {
      type: "number",
    },
    device: {
      $ref: "#/components/schemas/SessionDeviceDto",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    storageDevice: {
      $ref: "#/components/schemas/DeviceWithStateDto",
    },
    assistantId: {
      type: "string",
    },
    shopperId: {
      type: "string",
    },
    sessionTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    assigneeName: {
      type: "string",
    },
    assigneeId: {
      type: "number",
    },
    headBlurred: {
      type: "boolean",
      description:
        "true when the session video had heads blurred on the device",
    },
    cameraType: {
      type: "string",
      description:
        "The camera model the session was recorded on, as it was tagged at the time (ID-6991).",
    },
    leftInCartMode: {
      type: "string",
      description:
        "Left-in-cart as it worked for the session - disabled, silent or active; absent when the agent did not say (ID-7293).",
    },
    referencedTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagReferencedDto",
      },
    },
  },
  required: [
    "nonScans",
    "transactions",
    "id",
    "sessionId",
    "sampleCount",
    "nonScanCount",
    "nonMatchCount",
    "leftInCartCount",
    "calculatedEndTime",
    "startCause",
    "stopCause",
    "sessionTags",
    "headBlurred",
  ],
} as const;

export const $ListSessionsOrderEnum = {
  type: "string",
  enum: ["createdAt", "session", "size"],
} as const;

export const $ListSessionsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ListSessionsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListSessionsDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storage: {
      enum: ["any", "backend", "cluster", "edge", "device", "recorded", "none"],
      type: "string",
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ListSessionsOrderEnumSortOption",
      },
    },
    timeField: {
      enum: ["createdAt", "session"],
      type: "string",
    },
    sessionIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionsTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    assigneeIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    assigneeMatch: {
      enum: ["any", "none"],
      type: "string",
    },
    alertType: {
      type: "array",
      items: {
        type: "string",
        enum: ["non-scan", "non-match", "left-in-cart"],
      },
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetId: {
      type: "number",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    onlyNonScans: {
      type: "boolean",
    },
    onlyStored: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    assistantId: {
      type: "string",
    },
    shopperId: {
      type: "string",
    },
  },
  required: ["limit", "page"],
} as const;

export const $SessionSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    sessionId: {
      type: "string",
    },
    state: {
      type: "string",
    },
    sampleCount: {
      type: "number",
    },
    nonScanCount: {
      type: "number",
    },
    nonMatchCount: {
      type: "number",
    },
    leftInCartCount: {
      type: "number",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagDto",
      },
    },
    storagePath: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    startTime: {
      format: "date-time",
      type: "string",
    },
    endTime: {
      format: "date-time",
      type: "string",
    },
    calculatedStartTime: {
      format: "date-time",
      type: "string",
    },
    calculatedEndTime: {
      format: "date-time",
      type: "string",
    },
    startCause: {
      type: "string",
    },
    stopCause: {
      type: "string",
    },
    size: {
      format: "int64",
      type: "integer",
    },
    codec: {
      type: "string",
    },
    width: {
      type: "number",
    },
    height: {
      type: "number",
    },
    fps: {
      type: "number",
    },
    device: {
      $ref: "#/components/schemas/SessionDeviceDto",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    storageDevice: {
      $ref: "#/components/schemas/DeviceWithStateDto",
    },
    assistantId: {
      type: "string",
    },
    shopperId: {
      type: "string",
    },
    sessionTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    assigneeName: {
      type: "string",
    },
    assigneeId: {
      type: "number",
    },
    headBlurred: {
      type: "boolean",
      description:
        "true when the session video had heads blurred on the device",
    },
    cameraType: {
      type: "string",
      description:
        "The camera model the session was recorded on, as it was tagged at the time (ID-6991).",
    },
    leftInCartMode: {
      type: "string",
      description:
        "Left-in-cart as it worked for the session - disabled, silent or active; absent when the agent did not say (ID-7293).",
    },
  },
  required: [
    "id",
    "sessionId",
    "sampleCount",
    "nonScanCount",
    "nonMatchCount",
    "leftInCartCount",
    "tags",
    "endTime",
    "calculatedEndTime",
    "startCause",
    "stopCause",
    "sessionTags",
    "headBlurred",
  ],
} as const;

export const $BulkSessionsQueryDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storage: {
      enum: ["any", "backend", "cluster", "edge", "device", "recorded", "none"],
      type: "string",
    },
    timeField: {
      enum: ["createdAt", "session"],
      type: "string",
    },
    sessionIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionsTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    assigneeIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    assigneeMatch: {
      enum: ["any", "none"],
      type: "string",
    },
    alertType: {
      type: "array",
      items: {
        type: "string",
        enum: ["non-scan", "non-match", "left-in-cart"],
      },
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetId: {
      type: "number",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    onlyNonScans: {
      type: "boolean",
    },
    onlyStored: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    assistantId: {
      type: "string",
    },
    shopperId: {
      type: "string",
    },
  },
} as const;

export const $UpdateSessionsTaggingBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkSessionsQueryDto",
    },
    assignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    unAssignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    all: {
      type: "boolean",
    },
  },
  required: ["query"],
} as const;

export const $UpdateSessionsAssigneeBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkSessionsQueryDto",
    },
    assigneeId: {
      type: "number",
      nullable: true,
      minimum: 1,
    },
  },
  required: ["query", "assigneeId"],
} as const;

export const $ExportClusterSummariesDto = {
  type: "object",
  properties: {
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ClusterSummariesOrderEnumSortOption",
      },
    },
    maxRows: {
      type: "number",
      minimum: 1,
      description:
        "Backend-only row cap override. Not exposed in the UI; omit to use the default.",
    },
    name: {
      type: "string",
    },
  },
} as const;

export const $DownloadClusterSummariesRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/ExportClusterSummariesDto",
    },
  },
  required: ["query"],
} as const;

export const $CreateClusterDto = {
  type: "object",
  properties: {
    architecture: {
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
    },
    name: {
      type: "string",
    },
    serverDeviceId: {
      type: "number",
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["architecture", "name", "deviceIds"],
} as const;

export const $ListClusterSummariesDto = {
  type: "object",
  properties: {
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ClusterSummariesOrderEnumSortOption",
      },
    },
    name: {
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $ClusterSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    lastPing: {
      format: "date-time",
      type: "string",
    },
    readyDevices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    offlineDevices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    collaborator: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    architecture: {
      type: "string",
      description:
        "Decides which of the cluster's devices run a deployed model, so the UI can say the same.",
      enum: ["distributed", "hybrid", "centralized"],
    },
    models: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    clusterModelDeployment: {
      type: "object",
      properties: {
        model: {
          $ref: "#/components/schemas/MinimalEntityDto",
        },
      },
      required: ["model"],
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
  required: [
    "id",
    "name",
    "lastPing",
    "readyDevices",
    "offlineDevices",
    "collaborator",
    "architecture",
    "models",
    "tags",
  ],
} as const;

export const $ClustersModelDeploymentBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkClustersQueryDto",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    includeCollaboratorDevices: {
      type: "boolean",
      description:
        "Also deploy to each selected cluster's in-site collaborator. Absent means false.",
      default: false,
    },
    modelId: {
      type: "number",
      minimum: 1,
    },
    role: {
      enum: [
        "predictor",
        "nonScanDetector",
        "objectDetector",
        "similarityFilter",
      ],
      type: "string",
    },
  },
  required: ["query", "modelId"],
} as const;

export const $ClustersConfigDeploymentBulkDto = {
  type: "object",
  properties: {
    deviceConfig: {
      $ref: "#/components/schemas/PartialDeviceConfigDto",
    },
    query: {
      $ref: "#/components/schemas/BulkClustersQueryDto",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    isPartial: {
      type: "boolean",
    },
    originalDeviceId: {
      type: "number",
      minimum: 1,
    },
    dontCleanDangerousConfigParams: {
      type: "boolean",
    },
  },
  required: ["deviceConfig", "query", "isPartial"],
} as const;

export const $UpdateClustersTaggingBulkDto = {
  type: "object",
  properties: {
    assignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    unAssignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    all: {
      type: "boolean",
    },
    query: {
      $ref: "#/components/schemas/BulkClustersQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $ClusterUploadPreviewRowDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    architecture: {
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
    },
    server: {
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        type: "string",
      },
    },
    status: {
      enum: ["new", "existing", "error"],
      type: "string",
    },
    warnings: {
      description: "Warning messages (e.g. server device not found)",
      type: "array",
      items: {
        type: "string",
      },
    },
    error: {
      type: "string",
      description: "Error message when status is error",
    },
  },
  required: ["name", "tags", "status", "warnings"],
} as const;

export const $ClusterUploadResponseDto = {
  type: "object",
  properties: {
    dryRun: {
      type: "boolean",
      description:
        "Whether this response is from a dry run (preview) or an actual apply",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ClusterUploadPreviewRowDto",
      },
    },
    totalNew: {
      type: "number",
    },
    totalExisting: {
      type: "number",
    },
    totalErrors: {
      type: "number",
    },
    fatalError: {
      type: "string",
      description:
        "Fatal error that prevents the entire upload from proceeding",
    },
  },
  required: ["dryRun", "results", "totalNew", "totalExisting", "totalErrors"],
} as const;

export const $UploadClustersFileDto = {
  type: "object",
  properties: {
    file: {
      type: "string",
      format: "binary",
    },
    dryRun: {
      type: "boolean",
      description:
        "If true, validate and return preview without applying changes",
      default: false,
    },
  },
  required: ["file", "dryRun"],
} as const;

export const $MinimalDeviceDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    state: {
      type: "string",
      enum: ["deploying", "ready", "disconnected", "disabled", "down"],
    },
  },
  required: ["name", "id"],
} as const;

export const $ClusterDeviceDto = {
  type: "object",
  properties: {
    labelsDistribution: {
      $ref: "#/components/schemas/LabelsDistributionDto",
    },
    state: {
      enum: ["deploying", "ready", "disconnected", "disabled", "down"],
      type: "string",
    },
    localIp: {
      type: "string",
    },
    webGrpcPort: {
      type: "string",
    },
    webServerPort: {
      type: "string",
    },
    httpPort: {
      type: "string",
    },
    httpsPort: {
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["name", "id"],
} as const;

export const $ClusterDetailsDto = {
  type: "object",
  properties: {
    serverDevice: {
      $ref: "#/components/schemas/MinimalDeviceDto",
    },
    architecture: {
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
    },
    devices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ClusterDeviceDto",
      },
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    labelWithLeastSamples: {
      type: "string",
    },
    totalSamples: {
      type: "number",
    },
    totalLabels: {
      type: "number",
    },
    clusterModelDeployment: {
      type: "object",
      properties: {
        model: {
          $ref: "#/components/schemas/MinimalEntityDto",
        },
        createdAt: {
          format: "date-time",
          type: "string",
        },
      },
      required: ["model", "createdAt"],
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
  required: [
    "serverDevice",
    "architecture",
    "devices",
    "id",
    "name",
    "labelWithLeastSamples",
    "totalSamples",
    "totalLabels",
    "createdAt",
    "updatedAt",
    "tags",
  ],
} as const;

export const $UpdateClusterDto = {
  type: "object",
  properties: {
    architecture: {
      enum: ["distributed", "hybrid", "centralized"],
      type: "string",
    },
    name: {
      type: "string",
    },
    serverDeviceId: {
      type: "number",
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    isVisible: {
      type: "boolean",
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
} as const;

export const $UpdateClusterDevicesBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $CreateDatasetDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["name", "deviceIds"],
} as const;

export const $ListDatasetSummariesDto = {
  type: "object",
  properties: {
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
    id: {
      type: "number",
      minimum: 1,
    },
    name: {
      type: "string",
    },
  },
  required: ["limit", "page"],
} as const;

export const $MinimalDatasetSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["id", "name", "createdAt", "updatedAt"],
} as const;

export const $DatasetDeviceDto = {
  type: "object",
  properties: {
    labelsDistribution: {
      $ref: "#/components/schemas/LabelsDistributionDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["labelsDistribution", "name", "id"],
} as const;

export const $DatasetDetailsDto = {
  type: "object",
  properties: {
    devices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DatasetDeviceDto",
      },
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["devices", "id", "name", "createdAt", "updatedAt"],
} as const;

export const $UpdateDatasetDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    isVisible: {
      type: "boolean",
    },
  },
} as const;

export const $StaticDatasetSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    uuid: {
      type: "string",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    storagePath: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    isVisible: {
      type: "boolean",
    },
    samplesCount: {
      type: "number",
      description: "Number of samples in this dataset",
    },
    sessionsCount: {
      type: "number",
      description: "Number of sessions in this dataset",
    },
    missingSamplesCount: {
      type: "number",
      description: "Number of missing samples in this dataset",
    },
    missingSessionsCount: {
      type: "number",
      description: "Number of missing sessions in this dataset",
    },
    isDeleting: {
      type: "boolean",
      description: "True when a delete job is in progress for this dataset",
    },
    hasActiveJob: {
      type: "boolean",
      description:
        "True while any job for this dataset (import, add, retry, recalculate, delete) is pending, running or cancelling",
    },
  },
  required: [
    "id",
    "uuid",
    "name",
    "storagePath",
    "createdAt",
    "updatedAt",
    "isVisible",
    "samplesCount",
    "sessionsCount",
    "missingSamplesCount",
    "missingSessionsCount",
    "isDeleting",
    "hasActiveJob",
  ],
} as const;

export const $DatasetMinimalDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    uuid: {
      type: "string",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "uuid", "name"],
} as const;

export const $UploadErrorDto = {
  type: "object",
  properties: {
    uuid: {
      type: "string",
    },
    message: {
      type: "string",
    },
  },
  required: ["uuid", "message"],
} as const;

export const $StaticDatasetUploadStatisticsDto = {
  type: "object",
  properties: {
    addedSamplesInCsv: {
      type: "number",
    },
    sessionsInCsv: {
      type: "number",
    },
    samplesInCsv: {
      type: "number",
    },
    addedSamplesCreated: {
      type: "number",
    },
    samplesTotal: {
      type: "number",
    },
    samplesMissing: {
      type: "number",
    },
    sessionsTotal: {
      type: "number",
    },
    sessionsMissing: {
      type: "number",
    },
    errors: {
      type: "array",
      items: {
        $ref: "#/components/schemas/UploadErrorDto",
      },
    },
  },
} as const;

export const $DatasetJobStatusDto = {
  type: "object",
  properties: {
    jobId: {
      type: "number",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "cancelling",
        "done",
        "failed",
        "cancelled",
        "suspended",
        "aborted",
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    transferred: {
      type: "number",
    },
    missing: {
      type: "number",
    },
    resumable: {
      type: "boolean",
    },
    startTime: {
      format: "date-time",
      type: "string",
    },
    endTime: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["jobId", "state"],
} as const;

export const $DatasetJobHistoryEntryDto = {
  type: "object",
  properties: {
    jobId: {
      type: "number",
    },
    state: {
      enum: [
        "pending",
        "running",
        "cancelling",
        "done",
        "failed",
        "cancelled",
        "suspended",
        "aborted",
      ],
      type: "string",
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    transferred: {
      type: "number",
    },
    missing: {
      type: "number",
    },
    resumable: {
      type: "boolean",
    },
    startTime: {
      format: "date-time",
      type: "string",
    },
    endTime: {
      format: "date-time",
      type: "string",
    },
    kind: {
      type: "string",
      enum: [
        "import",
        "importSessions",
        "importSamples",
        "addSamples",
        "addSessions",
        "retryMissingSamples",
        "retryMissingSessions",
        "recalculateAnalytics",
      ],
    },
  },
  required: ["jobId", "state", "kind"],
} as const;

export const $StaticDatasetDetailsDto = {
  type: "object",
  properties: {
    uploadStatistics: {
      $ref: "#/components/schemas/StaticDatasetUploadStatisticsDto",
    },
    jobStatus: {
      $ref: "#/components/schemas/DatasetJobStatusDto",
    },
    samplesJobStatus: {
      $ref: "#/components/schemas/DatasetJobStatusDto",
    },
    fromSamplesJobStatus: {
      $ref: "#/components/schemas/DatasetJobStatusDto",
    },
    retryJobStatus: {
      $ref: "#/components/schemas/DatasetJobStatusDto",
    },
    fromSessionsJobStatus: {
      $ref: "#/components/schemas/DatasetJobStatusDto",
    },
    retrySessionsJobStatus: {
      $ref: "#/components/schemas/DatasetJobStatusDto",
    },
    jobHistory: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DatasetJobHistoryEntryDto",
      },
    },
    analyticsJobStatus: {
      $ref: "#/components/schemas/DatasetJobStatusDto",
    },
    deleteJobStatus: {
      $ref: "#/components/schemas/DatasetJobStatusDto",
    },
    id: {
      type: "number",
    },
    uuid: {
      type: "string",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    storagePath: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    isVisible: {
      type: "boolean",
    },
    samplesCount: {
      type: "number",
    },
    sessionsCount: {
      type: "number",
    },
    missingSamplesCount: {
      type: "number",
    },
    missingSessionsCount: {
      type: "number",
    },
    uploadResultUrl: {
      type: "string",
    },
    storageUrl: {
      type: "string",
    },
    samplesStorageUrl: {
      type: "string",
    },
  },
  required: [
    "id",
    "uuid",
    "name",
    "storagePath",
    "createdAt",
    "updatedAt",
    "isVisible",
    "samplesCount",
    "sessionsCount",
    "missingSamplesCount",
    "missingSessionsCount",
  ],
} as const;

export const $AnalyzeDatasetDto = {
  type: "object",
  properties: {
    file: {
      type: "string",
      format: "binary",
    },
  },
  required: ["file"],
} as const;

export const $CreateDatasetFromTempDto = {
  type: "object",
  properties: {
    tempId: {
      type: "string",
      format: "uuid",
      description: "Temporary analysis session ID",
    },
    name: {
      type: "string",
      description: "Dataset name",
    },
    description: {
      type: "string",
      description: "Dataset description",
    },
  },
  required: ["tempId", "name"],
} as const;

export const $UploadStaticDatasetDto = {
  type: "object",
  properties: {
    file: {
      type: "string",
      format: "binary",
    },
    name: {
      type: "string",
      description: "Dataset name",
    },
    description: {
      type: "string",
      description: "Dataset description",
    },
  },
  required: ["file", "name"],
} as const;

export const $CreateEmptyDatasetDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
  required: ["name"],
} as const;

export const $AddSamplesFromFilterDto = {
  type: "object",
  properties: {
    sampleId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    sampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    region: {
      type: "string",
      deprecated: true,
      description:
        "Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.",
    },
    regionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this region (active regions only).",
    },
    subRegionId: {
      type: "number",
      minimum: 1,
      description:
        "Filter samples to sites assigned to this sub-region (active, under an active region).",
    },
    uxSource: {
      type: "string",
      description: "UX source filter (case-insensitive exact match)",
    },
    deviceIp: {
      type: "string",
      description:
        "Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)",
    },
    timeField: {
      enum: ["createdAt", "addedAt"],
      type: "string",
    },
    state: {
      enum: [
        "existing",
        "deleted",
        "overridden",
        "evicted",
        "reported_only",
        "missing",
      ],
      type: "string",
    },
    modelIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    result: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TransactionResultEnum",
      },
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    predictions: {
      type: "array",
      items: {
        type: "string",
      },
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    taggedByIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    dataType: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetId: {
      type: "number",
    },
    fromDate: {
      format: "date-time",
      type: "string",
    },
    toDate: {
      format: "date-time",
      type: "string",
    },
    onlyWithPrediction: {
      type: "boolean",
    },
    showNonScans: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    headsFound: {
      type: "boolean",
    },
    family: {
      type: "string",
    },
    fuzzy: {
      type: "boolean",
    },
    matchStrength: {
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    showOnlyWithImages: {
      type: "boolean",
    },
    copyTagging: {
      type: "boolean",
    },
    copyPredictions: {
      type: "boolean",
    },
    allowDuplicates: {
      type: "boolean",
    },
  },
} as const;

export const $AddSessionsFromFilterDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storageDeviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    storage: {
      enum: ["any", "backend", "cluster", "edge", "device", "recorded", "none"],
      type: "string",
    },
    timeField: {
      enum: ["createdAt", "session"],
      type: "string",
    },
    sessionIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sessionsTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    devicesTagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    devicesTagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    assigneeIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    assigneeMatch: {
      enum: ["any", "none"],
      type: "string",
    },
    alertType: {
      type: "array",
      items: {
        type: "string",
        enum: ["non-scan", "non-match", "left-in-cart"],
      },
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    datasetId: {
      type: "number",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    sessionId: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    onlyNonScans: {
      type: "boolean",
    },
    onlyStored: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    assistantId: {
      type: "string",
    },
    shopperId: {
      type: "string",
    },
    includeJsonSamples: {
      type: "boolean",
    },
    copyTagging: {
      type: "boolean",
    },
    copyPredictions: {
      type: "boolean",
    },
    allowDuplicates: {
      type: "boolean",
    },
  },
} as const;

export const $TrainingSummaryDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "starting",
        "running",
        "completed",
        "failed",
        "cancelled",
        "suspended",
      ],
      type: "string",
    },
    clusters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    reason: {
      type: "string",
    },
  },
  required: ["state", "clusters", "id", "name", "createdAt", "reason"],
} as const;

export const $TrainingState = {
  type: "string",
  enum: [
    "starting",
    "running",
    "completed",
    "failed",
    "cancelled",
    "suspended",
  ],
} as const;

export const $TrainingSummariesOrderEnum = {
  type: "string",
  enum: ["name", "createdAt", "state"],
} as const;

export const $TrainingSummariesOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/TrainingSummariesOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListTrainingSummariesDto = {
  type: "object",
  properties: {
    state: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TrainingState",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TrainingSummariesOrderEnumSortOption",
      },
    },
    name: {
      type: "string",
    },
    createdSince: {
      format: "date-time",
      type: "string",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    isVisible: {
      type: "boolean",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $CandidateImagesDto = {
  type: "object",
  properties: {
    clientImageUrl: {
      type: "string",
    },
    serverImageUrl: {
      type: "string",
    },
  },
} as const;

export const $TrainingDefaultCandidatesDto = {
  type: "object",
  properties: {
    accountDefault: {
      $ref: "#/components/schemas/CandidateImagesDto",
    },
    latestDeployed: {
      $ref: "#/components/schemas/CandidateImagesDto",
    },
    latestRelease: {
      description:
        "Newest published tag, whether or not any device runs it. Absent if the registry could not be read.",
      allOf: [
        {
          $ref: "#/components/schemas/CandidateImagesDto",
        },
      ],
    },
  },
} as const;

export const $TrainingDefaultsDto = {
  type: "object",
  properties: {
    clientImageUrl: {
      type: "string",
      description: "Worker container image URL to prefill.",
    },
    serverImageUrl: {
      type: "string",
      description: "Collaborator container image URL to prefill.",
    },
    config: {
      type: "string",
      description:
        "The account's default configuration YAML. Absent means start empty, i.e. the classifier defaults.",
    },
    autoDeploy: {
      type: "boolean",
    },
    sources: {
      type: "object",
      additionalProperties: {
        enum: ["accountDefault", "latestRelease", "latestDeployed", "none"],
      },
      description:
        "Per-field origin of the value above: `accountDefault` when it comes from the stored account defaults, `latestRelease` when it came from the newest published image, `latestDeployed` when the registry could not be reached and the newest version this account has deployed was used instead, `none` when there is nothing to prefill.",
    },
    candidates: {
      description: "Every container version the user could switch this job to.",
      allOf: [
        {
          $ref: "#/components/schemas/TrainingDefaultCandidatesDto",
        },
      ],
    },
    isSet: {
      type: "boolean",
      description: "Whether this account has stored training-job defaults.",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    updatedByName: {
      type: "string",
    },
  },
  required: ["sources", "candidates", "isSet"],
} as const;

export const $UpdateTrainingDefaultsDto = {
  type: "object",
  properties: {
    clientImageUrl: {
      type: "string",
      nullable: true,
      maxLength: 1000,
      description: "Worker container image URL.",
    },
    serverImageUrl: {
      type: "string",
      nullable: true,
      maxLength: 1000,
      description: "Collaborator container image URL.",
    },
    config: {
      type: "string",
      nullable: true,
      maxLength: 100000,
      description:
        "Default training configuration YAML. Unset means new jobs start with an empty configuration.",
    },
    autoDeploy: {
      type: "boolean",
      nullable: true,
    },
  },
} as const;

export const $TrainingDetailsDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "starting",
        "running",
        "completed",
        "failed",
        "cancelled",
        "suspended",
      ],
      type: "string",
    },
    clusters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    server: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    inputModel: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    description: {
      type: "string",
    },
    recurring: {
      type: "number",
    },
    autoDeploy: {
      type: "boolean",
    },
    clientImageUrl: {
      type: "string",
    },
    serverImageUrl: {
      type: "string",
    },
    config: {
      type: "string",
    },
    isTrainingWindow: {
      type: "boolean",
    },
    windowEnd: {
      format: "date-time",
      type: "string",
    },
    windowStart: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "state",
    "clusters",
    "inputModel",
    "id",
    "name",
    "createdAt",
    "updatedAt",
    "description",
    "recurring",
    "autoDeploy",
    "clientImageUrl",
    "serverImageUrl",
    "config",
  ],
} as const;

export const $EpochDetailsDto = {
  type: "object",
  properties: {
    trainingLoss: {
      type: "number",
    },
    validationLoss: {
      type: "number",
    },
    trainingAccuracy: {
      type: "number",
    },
    validationAccuracy: {
      type: "number",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "trainingLoss",
    "validationLoss",
    "trainingAccuracy",
    "validationAccuracy",
    "createdAt",
  ],
} as const;

export const $TrainingExecutionDetailsDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "starting",
        "running",
        "completed",
        "failed",
        "cancelled",
        "suspended",
      ],
      type: "string",
    },
    participatingClusters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    resultModel: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    epochMetrics: {
      type: "array",
      items: {
        $ref: "#/components/schemas/EpochDetailsDto",
      },
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    reason: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "participatingClusters",
    "resultModel",
    "epochMetrics",
    "id",
    "name",
    "description",
    "reason",
    "createdAt",
    "updatedAt",
  ],
} as const;

export const $TrainingDeviceParticipationDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "setup",
        "deploying",
        "pending",
        "running",
        "completed",
        "failed",
        "aborted",
        "cancelled",
        "suspended",
      ],
      type: "string",
    },
    deviceId: {
      type: "number",
    },
    deviceName: {
      type: "string",
    },
    token: {
      type: "string",
    },
    reason: {
      type: "string",
    },
  },
  required: ["state", "deviceId", "deviceName", "token", "reason"],
} as const;

export const $TrainingClusterParticipationDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "starting",
        "running",
        "completed",
        "failed",
        "cancelled",
        "aborted",
        "suspended",
      ],
      type: "string",
    },
    collaborator: {
      $ref: "#/components/schemas/TrainingDeviceParticipationDto",
    },
    workers: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TrainingDeviceParticipationDto",
      },
    },
    clusterId: {
      type: "number",
    },
    clusterName: {
      type: "string",
    },
    reason: {
      type: "string",
    },
  },
  required: [
    "state",
    "collaborator",
    "workers",
    "clusterId",
    "clusterName",
    "reason",
  ],
} as const;

export const $TrainingParticipationsDto = {
  type: "object",
  properties: {
    server: {
      $ref: "#/components/schemas/TrainingDeviceParticipationDto",
    },
    clusters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TrainingClusterParticipationDto",
      },
    },
  },
  required: ["server", "clusters"],
} as const;

export const $EpochMetricsMetricDto = {
  type: "object",
  properties: {
    data: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            type: "array",
            maxLength: 1,
            items: {
              type: "number",
            },
          },
        ],
      },
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    uuid: {
      type: "string",
      nullable: true,
    },
  },
  required: ["data", "createdAt"],
} as const;

export const $DataReportMetricDto = {
  type: "object",
  properties: {
    data: {
      type: "object",
      properties: {
        val: {
          type: "object",
          additionalProperties: {
            oneOf: [
              {
                type: "object",
                properties: {
                  0: {
                    type: "number",
                  },
                },
              },
            ],
          },
        },
        train: {
          type: "object",
          additionalProperties: {
            oneOf: [
              {
                type: "object",
                properties: {
                  0: {
                    type: "number",
                  },
                },
              },
            ],
          },
        },
      },
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    uuid: {
      type: "string",
      nullable: true,
    },
  },
  required: ["data", "createdAt"],
} as const;

export const $ConfusionMatrixMetricDto = {
  type: "object",
  properties: {
    data: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            type: "object",
            additionalProperties: {
              oneOf: [
                {
                  type: "number",
                },
              ],
            },
          },
        ],
      },
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    uuid: {
      type: "string",
      nullable: true,
    },
  },
  required: ["data", "createdAt"],
} as const;

export const $ConfidenceStatsMetricDto = {
  type: "object",
  properties: {
    data: {
      type: "object",
      properties: {
        per_class_stats_dict: {
          type: "object",
          additionalProperties: {
            oneOf: [
              {
                type: "object",
                properties: {
                  recall: {
                    type: "object",
                    properties: {
                      top_1: {
                        type: "number",
                      },
                      top_2: {
                        type: "number",
                      },
                      top_3: {
                        type: "number",
                      },
                    },
                  },
                  "n samples": {
                    type: "number",
                    required: false,
                  },
                  n_samples: {
                    type: "number",
                    required: false,
                  },
                  precision: {
                    type: "object",
                    properties: {
                      top_1: {
                        type: "number",
                      },
                      top_2: {
                        type: "number",
                      },
                      top_3: {
                        type: "number",
                      },
                    },
                  },
                  "class_prediction rate": {
                    type: "number",
                    required: false,
                  },
                  class_prediction_rate: {
                    type: "number",
                    required: false,
                  },
                },
              },
            ],
          },
        },
        filtering: {
          type: "object",
          properties: {
            final_message: {
              type: "string",
              required: false,
            },
            certain_rate: {
              type: "number",
            },
            certain_precision: {
              type: "number",
            },
            "top-1_recall": {
              type: "number",
            },
            "top-1_precision": {
              type: "number",
            },
            "top-1_pred_rate": {
              type: "number",
            },
            "top-2_recall": {
              type: "number",
            },
            "top-2_precision": {
              type: "number",
            },
            "top-2_pred_rate": {
              type: "number",
            },
            "top-3_recall": {
              type: "number",
            },
            "top-3_precision": {
              type: "number",
            },
            "top-3_pred_rate": {
              type: "number",
            },
          },
          patternProperties: {},
        },
      },
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    uuid: {
      type: "string",
      nullable: true,
    },
  },
  required: ["data", "createdAt"],
} as const;

export const $TrainingSampleStatsDto = {
  type: "object",
  properties: {
    epochMetrics: {
      type: "array",
      items: {
        $ref: "#/components/schemas/EpochMetricsMetricDto",
      },
    },
    dataReport: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DataReportMetricDto",
      },
    },
    confusionMatrix: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ConfusionMatrixMetricDto",
      },
    },
    confidenceStats: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ConfidenceStatsMetricDto",
      },
    },
  },
} as const;

export const $UpdateTrainingDto = {
  type: "object",
  properties: {
    autoDeploy: {
      type: "boolean",
      description: "Omit to use the account default, then false.",
    },
    clientImageUrl: {
      type: "string",
      maxLength: 1000,
      description:
        "Worker container image URL. Omit to use the account's default training-job settings, else the newest edgify-worker version this account has deployed -- resolved when the training is created rather than snapshotted here, so a schedule follows the fleet instead of freezing a version.",
    },
    serverImageUrl: {
      type: "string",
      maxLength: 1000,
      description:
        "Collaborator container image URL. Same defaulting as `clientImageUrl`.",
    },
    config: {
      type: "string",
      maxLength: 100000,
      description:
        "Training configuration YAML. Omit to use the account's default configuration, or send an empty string to run with the worker's built-in classifier defaults.",
    },
    name: {
      type: "string",
      maxLength: 1000,
    },
    description: {
      type: "string",
      maxLength: 1000,
    },
    clusterIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "number",
      },
    },
    serverDeviceId: {
      type: "number",
    },
    inputModelId: {
      type: "number",
    },
    isTrainingWindow: {
      type: "boolean",
    },
    windowEnd: {
      format: "date-time",
      type: "string",
    },
    windowStart: {
      format: "date-time",
      type: "string",
    },
    isVisible: {
      type: "boolean",
    },
  },
} as const;

export const $BulkTrainingsQueryDto = {
  type: "object",
  properties: {
    state: {
      type: "array",
      items: {
        $ref: "#/components/schemas/TrainingState",
      },
    },
    name: {
      type: "string",
    },
    createdSince: {
      format: "date-time",
      type: "string",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    isVisible: {
      type: "boolean",
    },
    trainingIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $BulkTrainingsDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkTrainingsQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $CreateTrainingDto = {
  type: "object",
  properties: {
    autoDeploy: {
      type: "boolean",
      description: "Omit to use the account default, then false.",
    },
    clientImageUrl: {
      type: "string",
      maxLength: 1000,
      description:
        "Worker container image URL. Omit to use the account's default training-job settings, else the newest edgify-worker version this account has deployed -- resolved when the training is created rather than snapshotted here, so a schedule follows the fleet instead of freezing a version.",
    },
    serverImageUrl: {
      type: "string",
      maxLength: 1000,
      description:
        "Collaborator container image URL. Same defaulting as `clientImageUrl`.",
    },
    config: {
      type: "string",
      maxLength: 100000,
      description:
        "Training configuration YAML. Omit to use the account's default configuration, or send an empty string to run with the worker's built-in classifier defaults.",
    },
    name: {
      type: "string",
      maxLength: 1000,
    },
    description: {
      type: "string",
      maxLength: 1000,
    },
    clusterIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "number",
      },
    },
    serverDeviceId: {
      type: "number",
    },
    inputModelId: {
      type: "number",
    },
    isTrainingWindow: {
      type: "boolean",
    },
    windowEnd: {
      format: "date-time",
      type: "string",
    },
    windowStart: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["name", "clusterIds"],
} as const;

export const $ModelType = {
  type: "string",
  enum: ["classifier", "objectDetector", "embeddingFilter"],
} as const;

export const $ModelSummariesOrderEnum = {
  type: "string",
  enum: ["name", "createdAt"],
} as const;

export const $ModelSummariesOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ModelSummariesOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListModelSummariesDto = {
  type: "object",
  properties: {
    type: {
      allOf: [
        {
          $ref: "#/components/schemas/ModelType",
        },
      ],
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ModelSummariesOrderEnumSortOption",
      },
    },
    search: {
      type: "string",
    },
    name: {
      type: "string",
    },
    role: {
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $ModelFormat = {
  type: "string",
  enum: ["onnx", "tflite", "pt", "zip"],
} as const;

export const $ModelSummaryDto = {
  type: "object",
  properties: {
    devices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    clusters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    format: {
      allOf: [
        {
          $ref: "#/components/schemas/ModelFormat",
        },
      ],
    },
    type: {
      allOf: [
        {
          $ref: "#/components/schemas/ModelType",
        },
      ],
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    classes: {
      type: "number",
    },
    trainSamples: {
      type: "number",
    },
    validationSamples: {
      type: "number",
    },
    accuracy: {
      type: "number",
    },
    role: {
      type: "string",
    },
  },
  required: [
    "devices",
    "clusters",
    "format",
    "type",
    "id",
    "name",
    "createdAt",
    "classes",
    "trainSamples",
    "validationSamples",
    "accuracy",
    "role",
  ],
} as const;

export const $MinimalModelOrderEnum = {
  type: "string",
  enum: ["name", "createdAt"],
} as const;

export const $MinimalModelOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/MinimalModelOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListMinimalModelDto = {
  type: "object",
  properties: {
    type: {
      allOf: [
        {
          $ref: "#/components/schemas/ModelType",
        },
      ],
    },
    orderBy: {
      enum: ["name", "createdAt"],
      type: "string",
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalModelOrderEnumSortOption",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
    search: {
      type: "string",
    },
    name: {
      type: "string",
    },
    role: {
      type: "string",
    },
  },
  required: ["limit", "page"],
} as const;

export const $ModelMinimalDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["name", "id"],
} as const;

export const $ModelTrainingDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    config: {
      type: "string",
    },
  },
  required: ["name", "id"],
} as const;

export const $ModelAssetsStatsItemDto = {
  type: "object",
  properties: {
    git_commit: {
      type: "string",
    },
    "mAP (accuracy of detector model)": {
      type: "number",
    },
    "[scan]Alerts": {
      type: "number",
    },
    "[scan]F1": {
      type: "number",
    },
    "[scan]FP": {
      type: "number",
    },
    "[scan]FPR": {
      type: "number",
    },
    "[scan]GT": {
      type: "number",
    },
    "[scan]Missed GT": {
      type: "number",
    },
    "[scan]Precision": {
      type: "number",
    },
    "[scan]Recall": {
      type: "number",
    },
    "[scan]Scans total": {
      type: "number",
    },
    "[scan]TP": {
      type: "number",
    },
    "[scan]TP per scan (%)": {
      type: "number",
    },
    "[scan]TP per session (%)": {
      type: "number",
    },
    "[session]F1": {
      type: "number",
    },
    "[session]FN": {
      type: "number",
    },
    "[session]FP": {
      type: "number",
    },
    "[session]FPR": {
      type: "number",
    },
    "[session]Precision": {
      type: "number",
    },
    "[session]Recall": {
      type: "number",
    },
    "[session]Sessions total": {
      type: "number",
    },
    "[session]TN": {
      type: "number",
    },
    "[session]TP": {
      type: "number",
    },
    "[session]TP per session (%)": {
      type: "number",
    },
    "[session]GT": {
      type: "number",
    },
  },
  required: [
    "git_commit",
    "mAP (accuracy of detector model)",
    "[scan]Alerts",
    "[scan]F1",
    "[scan]FP",
    "[scan]FPR",
    "[scan]GT",
    "[scan]Missed GT",
    "[scan]Precision",
    "[scan]Recall",
    "[scan]Scans total",
    "[scan]TP",
    "[scan]TP per scan (%)",
    "[scan]TP per session (%)",
    "[session]F1",
    "[session]FN",
    "[session]FP",
    "[session]FPR",
    "[session]Precision",
    "[session]Recall",
    "[session]Sessions total",
    "[session]TN",
    "[session]TP",
    "[session]TP per session (%)",
    "[session]GT",
  ],
} as const;

export const $ModelAssetsStatsDto = {
  type: "object",
  properties: {
    strict: {
      $ref: "#/components/schemas/ModelAssetsStatsItemDto",
    },
    normal: {
      $ref: "#/components/schemas/ModelAssetsStatsItemDto",
    },
    soft: {
      $ref: "#/components/schemas/ModelAssetsStatsItemDto",
    },
  },
  required: ["strict", "normal", "soft"],
} as const;

export const $ModelAssetsDto = {
  type: "object",
  properties: {
    "stats.json": {
      $ref: "#/components/schemas/ModelAssetsStatsDto",
    },
  },
} as const;

export const $ModelDetailsDto = {
  type: "object",
  properties: {
    type: {
      allOf: [
        {
          $ref: "#/components/schemas/ModelType",
        },
      ],
    },
    format: {
      allOf: [
        {
          $ref: "#/components/schemas/ModelFormat",
        },
      ],
    },
    devices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    trainingCreatedFrom: {
      $ref: "#/components/schemas/ModelTrainingDto",
    },
    state: {
      enum: ["setup", "building", "created", "failed"],
      type: "string",
    },
    confusionMatrix: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            type: "object",
            additionalProperties: {
              oneOf: [
                {
                  type: "number",
                },
              ],
            },
          },
        ],
      },
    },
    confidenceStats: {
      type: "object",
      properties: {
        per_class_stats_dict: {
          type: "object",
          additionalProperties: {
            oneOf: [
              {
                type: "object",
                properties: {
                  recall: {
                    type: "object",
                    properties: {
                      top_1: {
                        type: "number",
                      },
                      top_2: {
                        type: "number",
                      },
                      top_3: {
                        type: "number",
                      },
                    },
                  },
                  "n samples": {
                    type: "number",
                    required: false,
                  },
                  n_samples: {
                    type: "number",
                    required: false,
                  },
                  precision: {
                    type: "object",
                    properties: {
                      top_1: {
                        type: "number",
                      },
                      top_2: {
                        type: "number",
                      },
                      top_3: {
                        type: "number",
                      },
                    },
                  },
                  "class_prediction rate": {
                    type: "number",
                    required: false,
                  },
                  class_prediction_rate: {
                    type: "number",
                    required: false,
                  },
                },
              },
            ],
          },
        },
        filtering: {
          type: "object",
          properties: {
            final_message: {
              type: "string",
              required: false,
            },
            certain_rate: {
              type: "number",
            },
            certain_precision: {
              type: "number",
            },
            "top-1_recall": {
              type: "number",
            },
            "top-1_precision": {
              type: "number",
            },
            "top-1_pred_rate": {
              type: "number",
            },
            "top-2_recall": {
              type: "number",
            },
            "top-2_precision": {
              type: "number",
            },
            "top-2_pred_rate": {
              type: "number",
            },
            "top-3_recall": {
              type: "number",
            },
            "top-3_precision": {
              type: "number",
            },
            "top-3_pred_rate": {
              type: "number",
            },
          },
          patternProperties: {},
        },
      },
    },
    dataReport: {
      type: "object",
      properties: {
        val: {
          type: "object",
          additionalProperties: {
            oneOf: [
              {
                type: "object",
                properties: {
                  0: {
                    type: "number",
                  },
                },
              },
            ],
          },
        },
        train: {
          type: "object",
          additionalProperties: {
            oneOf: [
              {
                type: "object",
                properties: {
                  0: {
                    type: "number",
                  },
                },
              },
            ],
          },
        },
      },
    },
    epochMetrics: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            type: "array",
            maxLength: 1,
            items: {
              type: "number",
            },
          },
        ],
      },
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    role: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    description: {
      type: "string",
    },
    maxPredictions: {
      type: "number",
    },
    trainingAccuracy: {
      type: "number",
    },
    trainingSamples: {
      type: "number",
    },
    validationAccuracy: {
      type: "number",
    },
    validationSamples: {
      type: "number",
    },
    classes: {
      type: "number",
    },
    assets: {
      $ref: "#/components/schemas/ModelAssetsDto",
    },
  },
  required: [
    "type",
    "format",
    "devices",
    "trainingCreatedFrom",
    "state",
    "confusionMatrix",
    "confidenceStats",
    "dataReport",
    "epochMetrics",
    "id",
    "name",
    "role",
    "createdAt",
    "description",
    "assets",
  ],
} as const;

export const $UploadModelDto = {
  type: "object",
  properties: {
    description: {
      type: "string",
    },
    name: {
      type: "string",
    },
    file: {
      type: "string",
      format: "binary",
    },
  },
  required: ["name", "file"],
} as const;

export const $UpdateModelDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    isVisible: {
      type: "boolean",
    },
  },
} as const;

export const $ModelDeploymentDto = {
  type: "object",
  properties: {
    state: {
      enum: [
        "pending",
        "cancelled",
        "installing",
        "failed",
        "running",
        "stopped",
      ],
      type: "string",
    },
    device: {
      $ref: "#/components/schemas/DeviceWithStateDto",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    manuallyDeployedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["state", "device", "updatedAt", "createdAt", "manuallyDeployedAt"],
} as const;

export const $ModelDeploymentsOrderEnum = {
  type: "string",
  enum: ["name", "deviceState", "cluster", "state", "createdAt", "deployedOn"],
} as const;

export const $ModelDeploymentsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ModelDeploymentsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListModelDeploymentsDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    state: {
      enum: [
        "pending",
        "cancelled",
        "installing",
        "failed",
        "running",
        "stopped",
        "all",
      ],
      type: "string",
    },
    states: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "pending",
          "cancelled",
          "installing",
          "failed",
          "running",
          "stopped",
        ],
      },
    },
    deviceStates: {
      type: "array",
      items: {
        type: "string",
        enum: ["deploying", "ready", "disconnected", "disabled", "down"],
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ModelDeploymentsOrderEnumSortOption",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $ClusterModelDeploymentDto = {
  type: "object",
  properties: {
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    collaboratorTargeted: {
      type: "boolean",
      nullable: true,
      description: `Whether the cluster's in-site collaborator runs this model, which follows the cluster's
architecture and the collaborator choice the deployment recorded: a centralized cluster's
collaborator always does, a hybrid one's only when the deployment asked for it. Null when the
cluster has no collaborator at all, as every distributed cluster does.`,
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["cluster", "collaboratorTargeted", "updatedAt"],
} as const;

export const $ClusterModelDeploymentsOrderEnum = {
  type: "string",
  enum: ["name", "createdAt"],
} as const;

export const $ClusterModelDeploymentsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ClusterModelDeploymentsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListClusterModelDeploymentsDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ClusterModelDeploymentsOrderEnumSortOption",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $DeployModelDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    role: {
      type: "string",
    },
    includeCollaboratorDevices: {
      type: "boolean",
    },
  },
} as const;

export const $DeployModelResponseDto = {
  type: "object",
  properties: {
    successes: {
      type: "number",
    },
    failures: {
      type: "number",
    },
  },
  required: ["successes", "failures"],
} as const;

export const $ScheduledTrainingSummaryDto = {
  type: "object",
  properties: {
    status: {
      enum: [
        "starting",
        "running",
        "completed",
        "failed",
        "cancelled",
        "suspended",
      ],
      type: "string",
    },
    clusters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    recurringDays: {
      nullable: true,
      type: "array",
      items: {
        type: "string",
        enum: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
      },
      description:
        "Weekdays the training runs on, or null when it is not weekday-restricted",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    reason: {
      type: "string",
    },
    scheduledFor: {
      format: "date-time",
      type: "string",
    },
    recurring: {
      type: "number",
    },
  },
  required: [
    "status",
    "clusters",
    "recurringDays",
    "id",
    "name",
    "reason",
    "scheduledFor",
    "recurring",
  ],
} as const;

export const $ScheduledTrainingOrderEnum = {
  type: "string",
  enum: ["name", "createdAt", "state", "scheduledFor"],
} as const;

export const $ScheduledTrainingOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ScheduledTrainingOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ScheduledTrainingDetailsDto = {
  type: "object",
  properties: {
    recurringDays: {
      nullable: true,
      type: "array",
      items: {
        type: "string",
        enum: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
      },
      description:
        "Weekdays the training runs on, or null when it is not weekday-restricted",
    },
    clusters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    server: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    inputModel: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    clientImageUrl: {
      type: "string",
      nullable: true,
      description: "Null when the schedule defers to the account default.",
    },
    serverImageUrl: {
      type: "string",
      nullable: true,
      description: "Null when the schedule defers to the account default.",
    },
    config: {
      type: "string",
      description:
        "Empty when the schedule defers to the account default configuration.",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    scheduledFor: {
      format: "date-time",
      type: "string",
    },
    recurring: {
      type: "number",
    },
    autoDeploy: {
      type: "boolean",
    },
    isVisible: {
      type: "boolean",
    },
    isTrainingWindow: {
      type: "boolean",
    },
    windowEnd: {
      format: "date-time",
      type: "string",
    },
    windowStart: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "recurringDays",
    "clusters",
    "inputModel",
    "config",
    "id",
    "name",
    "description",
    "scheduledFor",
    "recurring",
    "autoDeploy",
    "isVisible",
  ],
} as const;

export const $UpdateScheduledTrainingDto = {
  type: "object",
  properties: {
    autoDeploy: {
      type: "boolean",
      description: "Omit to use the account default, then false.",
    },
    clientImageUrl: {
      type: "string",
      maxLength: 1000,
      description:
        "Worker container image URL. Omit to use the account's default training-job settings, else the newest edgify-worker version this account has deployed -- resolved when the training is created rather than snapshotted here, so a schedule follows the fleet instead of freezing a version.",
    },
    serverImageUrl: {
      type: "string",
      maxLength: 1000,
      description:
        "Collaborator container image URL. Same defaulting as `clientImageUrl`.",
    },
    config: {
      type: "string",
      maxLength: 100000,
      description:
        "Training configuration YAML. Omit to use the account's default configuration, or send an empty string to run with the worker's built-in classifier defaults.",
    },
    recurringDays: {
      nullable: true,
      uniqueItems: true,
      minItems: 1,
      maxItems: 7,
      type: "array",
      items: {
        type: "string",
        enum: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
      },
      description:
        "Weekdays the training runs on, evaluated in the account timezone. Null (or omitted) means no weekday restriction: the recurrence simply repeats every `recurring` days. A list must name between 1 and 7 days -- an empty list is rejected rather than silently read as unrestricted, since `null` is the one spelling of that.",
    },
    name: {
      type: "string",
      maxLength: 1000,
    },
    description: {
      type: "string",
      maxLength: 1000,
    },
    clusterIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "number",
      },
    },
    serverDeviceId: {
      type: "number",
    },
    inputModelId: {
      type: "number",
    },
    isTrainingWindow: {
      type: "boolean",
    },
    windowEnd: {
      format: "date-time",
      type: "string",
    },
    windowStart: {
      format: "date-time",
      type: "string",
    },
    recurring: {
      type: "number",
    },
    scheduledFor: {
      format: "date-time",
      type: "string",
    },
  },
} as const;

export const $CreateScheduledTrainingDto = {
  type: "object",
  properties: {
    autoDeploy: {
      type: "boolean",
      description: "Omit to use the account default, then false.",
    },
    clientImageUrl: {
      type: "string",
      maxLength: 1000,
      description:
        "Worker container image URL. Omit to use the account's default training-job settings, else the newest edgify-worker version this account has deployed -- resolved when the training is created rather than snapshotted here, so a schedule follows the fleet instead of freezing a version.",
    },
    serverImageUrl: {
      type: "string",
      maxLength: 1000,
      description:
        "Collaborator container image URL. Same defaulting as `clientImageUrl`.",
    },
    config: {
      type: "string",
      maxLength: 100000,
      description:
        "Training configuration YAML. Omit to use the account's default configuration, or send an empty string to run with the worker's built-in classifier defaults.",
    },
    recurringDays: {
      nullable: true,
      uniqueItems: true,
      minItems: 1,
      maxItems: 7,
      type: "array",
      items: {
        type: "string",
        enum: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
      },
      description:
        "Weekdays the training runs on, evaluated in the account timezone. Null (or omitted) means no weekday restriction: the recurrence simply repeats every `recurring` days. A list must name between 1 and 7 days -- an empty list is rejected rather than silently read as unrestricted, since `null` is the one spelling of that.",
    },
    recurring: {
      type: "number",
    },
    scheduledFor: {
      format: "date-time",
      type: "string",
    },
    name: {
      type: "string",
      maxLength: 1000,
    },
    description: {
      type: "string",
      maxLength: 1000,
    },
    clusterIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "number",
      },
    },
    serverDeviceId: {
      type: "number",
    },
    inputModelId: {
      type: "number",
    },
    isTrainingWindow: {
      type: "boolean",
    },
    windowEnd: {
      format: "date-time",
      type: "string",
    },
    windowStart: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["recurring", "name", "clusterIds"],
} as const;

export const $BulkScheduledTrainingsQueryDto = {
  type: "object",
  properties: {
    scheduledTrainingIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $BulkScheduledTrainingsDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkScheduledTrainingsQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $CameraCalibrationJobDataDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    predictorDeviceId: {
      type: "number",
    },
    family: {
      type: "string",
    },
  },
  required: ["predictorDeviceId"],
} as const;

export const $CameraCalibrationScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CameraCalibrationJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $PredictorInfoDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    model: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["name", "id"],
} as const;

export const $CameraCalibrationJobInfoDto = {
  type: "object",
  properties: {
    predictor: {
      $ref: "#/components/schemas/PredictorInfoDto",
    },
  },
} as const;

export const $CameraCalibrationScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CameraCalibrationJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    info: {
      $ref: "#/components/schemas/CameraCalibrationJobInfoDto",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $CameraCalibrationScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CameraCalibrationJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    info: {
      $ref: "#/components/schemas/CameraCalibrationJobInfoDto",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $CameraCalibrationUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CameraCalibrationJobDataDto",
    },
  },
} as const;

export const $CameraCalibrationJobResultDto = {
  type: "object",
  properties: {
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    devices: {
      type: "object",
      properties: {
        total: {
          type: "number",
          required: true,
        },
        stateCounts: {
          type: "object",
          properties: {
            capturing: {
              type: "number",
              required: false,
            },
            predicting: {
              type: "number",
              required: false,
            },
            storing: {
              type: "number",
              required: false,
            },
            done: {
              type: "number",
              required: false,
            },
            failed: {
              type: "number",
              required: false,
            },
          },
        },
        states: {
          type: "object",
          selfRequired: false,
          properties: {
            capturing: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            predicting: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            storing: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            done: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            failed: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
          },
        },
      },
    },
  },
} as const;

export const $CameraCalibrationJobDeviceStateDto = {
  type: "string",
  enum: ["capturing", "predicting", "storing", "done", "failed"],
} as const;

export const $CameraCalibrationStateEnum = {
  type: "string",
  enum: ["capturing", "predicting", "storing", "done", "failed"],
  description: "",
} as const;

export const $CameraCalibrationDeviceResultDto = {
  type: "object",
  properties: {
    result: {
      enum: ["calibrated", "uncalibrated", "unknown", "unrelated", "failure"],
      type: "string",
    },
    state: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/CameraCalibrationStateEnum",
        },
      ],
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    captureTime: {
      type: "string",
      format: "date-time",
    },
    updateTime: {
      type: "string",
      format: "date-time",
    },
    name: {
      type: "string",
    },
    prediction: {
      $ref: "#/components/schemas/PredictResponseDto",
    },
    sampleId: {
      type: "string",
    },
    total: {
      type: "number",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
  },
} as const;

export const $CameraCalibrationJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/CameraCalibrationJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/CameraCalibrationDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $CameraCalibrationJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/CameraCalibrationJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $CameraCalibrationJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/CameraCalibrationJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/CameraCalibrationJobDataDto",
    },
    info: {
      $ref: "#/components/schemas/CameraCalibrationJobInfoDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/CameraCalibrationJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $CameraCalibrationDataWithNameDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    predictorDeviceId: {
      type: "number",
    },
    family: {
      type: "string",
    },
  },
  required: ["predictorDeviceId"],
} as const;

export const $CameraCalibrationJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/CameraCalibrationJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/CameraCalibrationJobDataDto",
    },
    info: {
      $ref: "#/components/schemas/CameraCalibrationJobInfoDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $CameraCalibrationUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $CreateLookupTableDto = {
  type: "object",
  properties: {
    file: {
      type: "string",
      format: "binary",
    },
    name: {
      type: "string",
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["name"],
} as const;

export const $LookupTablesOrderEnum = {
  type: "string",
  enum: ["name"],
} as const;

export const $LookupTablesOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/LookupTablesOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListLookupTablesSummaryQueryDto = {
  type: "object",
  properties: {
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LookupTablesOrderEnumSortOption",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $LookupTablesSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    sitesCount: {
      type: "number",
    },
    hasData: {
      type: "boolean",
    },
  },
  required: ["id", "name", "updatedAt", "sitesCount", "hasData"],
} as const;

export const $UpdateLookupTableDto = {
  type: "object",
  properties: {
    file: {
      type: "string",
      format: "binary",
    },
    name: {
      type: "string",
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $site = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "name"],
} as const;

export const $LookupTableDetailsDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    sites: {
      type: "array",
      items: {
        $ref: "#/components/schemas/site",
      },
    },
  },
  required: ["name", "sites"],
} as const;

export const $StorageUriDto = {
  type: "object",
  properties: {
    uri: {
      type: "string",
    },
  },
  required: ["uri"],
} as const;

export const $DeviceRoleEnum = {
  type: "string",
  enum: ["edge", "cluster"],
  description: "",
} as const;

export const $UploadVideosJobDataDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    architecture: {
      type: "array",
      items: {
        type: "string",
        enum: ["distributed", "hybrid", "centralized"],
      },
    },
    query: {
      $ref: "#/components/schemas/GetSessionsRequestDto",
    },
    target: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    targetEdge: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    targetCluster: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    devicesRole: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/DeviceRoleEnum",
        },
      ],
    },
    maxUploadSpeed: {
      type: "number",
      minimum: 0,
    },
    delete: {
      type: "boolean",
    },
    deleteEdge: {
      type: "boolean",
    },
    deleteCluster: {
      type: "boolean",
    },
    force: {
      type: "boolean",
    },
    forceEdge: {
      type: "boolean",
    },
    forceCluster: {
      type: "boolean",
    },
    timeout: {
      type: "number",
    },
    onlyHeadBlurred: {
      type: "boolean",
      description:
        "Upload only already-blurred videos - forces query.head_blurred=true on the agent. Requires ^1.58.0 || ^2.34.0",
    },
    waitForBlur: {
      type: "boolean",
      description:
        "Blur a session before uploading it when it is not blurred yet; a blur failure fails the session. Requires ^1.58.0 || ^2.34.0",
    },
  },
} as const;

export const $UploadVideosScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/UploadVideosJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $UploadVideosScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/UploadVideosJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $UploadVideosScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/UploadVideosJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $UploadVideosUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/UploadVideosJobDataDto",
    },
  },
} as const;

export const $UploadVideosJobResultDto = {
  type: "object",
  properties: {
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    devices: {
      type: "object",
      properties: {
        total: {
          type: "number",
          required: true,
        },
        stateCounts: {
          type: "object",
          properties: {
            pending: {
              type: "number",
              required: false,
            },
            running: {
              type: "number",
              required: false,
            },
            done: {
              type: "number",
              required: false,
            },
            failed: {
              type: "number",
              required: false,
            },
            cancelled: {
              type: "number",
              required: false,
            },
            aborted: {
              type: "number",
              required: false,
            },
            stopped: {
              type: "number",
              required: false,
            },
          },
        },
        states: {
          type: "object",
          selfRequired: false,
          properties: {
            pending: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            running: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            done: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            failed: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            cancelled: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            aborted: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            stopped: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
          },
        },
      },
    },
  },
} as const;

export const $UploadVideosJobDeviceStateDto = {
  type: "string",
  enum: [
    "pending",
    "running",
    "done",
    "failed",
    "cancelled",
    "aborted",
    "stopped",
  ],
} as const;

export const $UploadVideosDeviceResultDto = {
  type: "object",
  properties: {
    lastStart: {
      type: "string",
      format: "date-time",
    },
    lastProgress: {
      type: "string",
      format: "date-time",
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    retries: {
      type: "number",
    },
    wasRunning: {
      type: "boolean",
    },
    remaining: {
      type: "number",
    },
    _meta: {
      $ref: "#/components/schemas/VideoUploadProgressDto",
    },
  },
} as const;

export const $UploadVideosJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/UploadVideosJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/UploadVideosDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $UploadVideosJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/UploadVideosJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $UploadVideosJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/UploadVideosJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/UploadVideosJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/UploadVideosJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $UploadVideosDataWithNameDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    architecture: {
      type: "array",
      items: {
        type: "string",
        enum: ["distributed", "hybrid", "centralized"],
      },
    },
    query: {
      $ref: "#/components/schemas/GetSessionsRequestDto",
    },
    target: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    targetEdge: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    targetCluster: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    devicesRole: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/DeviceRoleEnum",
        },
      ],
    },
    maxUploadSpeed: {
      type: "number",
      minimum: 0,
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    delete: {
      type: "boolean",
    },
    deleteEdge: {
      type: "boolean",
    },
    deleteCluster: {
      type: "boolean",
    },
    force: {
      type: "boolean",
    },
    forceEdge: {
      type: "boolean",
    },
    forceCluster: {
      type: "boolean",
    },
    timeout: {
      type: "number",
    },
    onlyHeadBlurred: {
      type: "boolean",
      description:
        "Upload only already-blurred videos - forces query.head_blurred=true on the agent. Requires ^1.58.0 || ^2.34.0",
    },
    waitForBlur: {
      type: "boolean",
      description:
        "Blur a session before uploading it when it is not blurred yet; a blur failure fails the session. Requires ^1.58.0 || ^2.34.0",
    },
  },
} as const;

export const $UploadVideosJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/UploadVideosJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/UploadVideosJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $UploadVideosUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $HeadBlurVideosJobDataDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    architecture: {
      type: "array",
      items: {
        type: "string",
        enum: ["distributed", "hybrid", "centralized"],
      },
    },
    query: {
      $ref: "#/components/schemas/GetSessionsRequestDto",
    },
    force: {
      type: "boolean",
      description: "re-blur even if the target is already marked headBlurred",
    },
  },
} as const;

export const $HeadBlurVideosScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurVideosJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $HeadBlurVideosScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurVideosJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $HeadBlurVideosScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurVideosJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $HeadBlurVideosUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurVideosJobDataDto",
    },
  },
} as const;

export const $HeadBlurVideosJobResultDto = {
  type: "object",
  properties: {
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    devices: {
      type: "object",
      properties: {
        total: {
          type: "number",
          required: true,
        },
        stateCounts: {
          type: "object",
          properties: {
            pending: {
              type: "number",
              required: false,
            },
            running: {
              type: "number",
              required: false,
            },
            done: {
              type: "number",
              required: false,
            },
            failed: {
              type: "number",
              required: false,
            },
            cancelled: {
              type: "number",
              required: false,
            },
            aborted: {
              type: "number",
              required: false,
            },
            stopped: {
              type: "number",
              required: false,
            },
          },
        },
        states: {
          type: "object",
          selfRequired: false,
          properties: {
            pending: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            running: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            done: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            failed: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            cancelled: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            aborted: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            stopped: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
          },
        },
      },
    },
  },
} as const;

export const $HeadBlurVideosJobDeviceStateDto = {
  type: "string",
  enum: [
    "pending",
    "running",
    "done",
    "failed",
    "cancelled",
    "aborted",
    "stopped",
  ],
} as const;

export const $HeadBlurVideosDeviceResultDto = {
  type: "object",
  properties: {
    lastStart: {
      type: "string",
      format: "date-time",
    },
    lastProgress: {
      type: "string",
      format: "date-time",
    },
    _meta: {
      $ref: "#/components/schemas/HeadBlurVideosStateDto",
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    retries: {
      type: "number",
    },
    wasRunning: {
      type: "boolean",
    },
    remaining: {
      type: "number",
    },
  },
} as const;

export const $HeadBlurVideosJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/HeadBlurVideosJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/HeadBlurVideosDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $HeadBlurVideosJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/HeadBlurVideosJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $HeadBlurVideosJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/HeadBlurVideosJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurVideosJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/HeadBlurVideosJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $HeadBlurVideosDataWithNameDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    architecture: {
      type: "array",
      items: {
        type: "string",
        enum: ["distributed", "hybrid", "centralized"],
      },
    },
    query: {
      $ref: "#/components/schemas/GetSessionsRequestDto",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    force: {
      type: "boolean",
      description: "re-blur even if the target is already marked headBlurred",
    },
  },
} as const;

export const $HeadBlurVideosJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/HeadBlurVideosJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurVideosJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $HeadBlurVideosUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $HeadBlurImagesJobDataDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    architecture: {
      type: "array",
      items: {
        type: "string",
        enum: ["distributed", "hybrid", "centralized"],
      },
    },
    query: {
      $ref: "#/components/schemas/GetSamplesQueryRequestDto",
    },
    force: {
      type: "boolean",
      description: "re-blur even if the target is already marked headBlurred",
    },
  },
} as const;

export const $HeadBlurImagesScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurImagesJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $HeadBlurImagesScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurImagesJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $HeadBlurImagesScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurImagesJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $HeadBlurImagesUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurImagesJobDataDto",
    },
  },
} as const;

export const $HeadBlurImagesJobResultDto = {
  type: "object",
  properties: {
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    devices: {
      type: "object",
      properties: {
        total: {
          type: "number",
          required: true,
        },
        stateCounts: {
          type: "object",
          properties: {
            pending: {
              type: "number",
              required: false,
            },
            running: {
              type: "number",
              required: false,
            },
            done: {
              type: "number",
              required: false,
            },
            failed: {
              type: "number",
              required: false,
            },
            cancelled: {
              type: "number",
              required: false,
            },
            aborted: {
              type: "number",
              required: false,
            },
            stopped: {
              type: "number",
              required: false,
            },
          },
        },
        states: {
          type: "object",
          selfRequired: false,
          properties: {
            pending: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            running: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            done: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            failed: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            cancelled: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            aborted: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
            stopped: {
              type: "array",
              required: false,
              items: {
                type: "number",
              },
            },
          },
        },
      },
    },
  },
} as const;

export const $HeadBlurImagesJobDeviceStateDto = {
  type: "string",
  enum: [
    "pending",
    "running",
    "done",
    "failed",
    "cancelled",
    "aborted",
    "stopped",
  ],
} as const;

export const $HeadBlurImagesDeviceResultDto = {
  type: "object",
  properties: {
    lastStart: {
      type: "string",
      format: "date-time",
    },
    lastProgress: {
      type: "string",
      format: "date-time",
    },
    _meta: {
      $ref: "#/components/schemas/HeadBlurImagesStateDto",
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    retries: {
      type: "number",
    },
    wasRunning: {
      type: "boolean",
    },
    remaining: {
      type: "number",
    },
  },
} as const;

export const $HeadBlurImagesJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/HeadBlurImagesJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/HeadBlurImagesDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $HeadBlurImagesJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/HeadBlurImagesJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $HeadBlurImagesJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/HeadBlurImagesJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurImagesJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/HeadBlurImagesJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $HeadBlurImagesDataWithNameDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    architecture: {
      type: "array",
      items: {
        type: "string",
        enum: ["distributed", "hybrid", "centralized"],
      },
    },
    query: {
      $ref: "#/components/schemas/GetSamplesQueryRequestDto",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    force: {
      type: "boolean",
      description: "re-blur even if the target is already marked headBlurred",
    },
  },
} as const;

export const $HeadBlurImagesJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/HeadBlurImagesJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/HeadBlurImagesJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $HeadBlurImagesUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $LegacyUploadModeEnum = {
  type: "string",
  enum: ["default", "agent", "backend", "disable"],
} as const;

export const $UploadSamplesJobDataDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    architecture: {
      type: "array",
      items: {
        type: "string",
        enum: ["distributed", "hybrid", "centralized"],
      },
    },
    query: {
      $ref: "#/components/schemas/GetSamplesQueryRequestDto",
    },
    target: {
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    targetEdge: {
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    targetCluster: {
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    maxUploadSpeed: {
      type: "number",
      minimum: 0,
    },
    legacyUpload: {
      allOf: [
        {
          $ref: "#/components/schemas/LegacyUploadModeEnum",
        },
      ],
    },
    pageSize: {
      type: "number",
      minimum: 1,
    },
    delete: {
      type: "boolean",
    },
    deleteEdge: {
      type: "boolean",
    },
    deleteCluster: {
      type: "boolean",
    },
    force: {
      type: "boolean",
    },
    forceEdge: {
      type: "boolean",
    },
    forceCluster: {
      type: "boolean",
    },
    timeout: {
      type: "number",
    },
    onlyHeadBlurred: {
      type: "boolean",
      description:
        "Upload only already-blurred samples - forces query.head_blurred=true on the agent. Requires ^1.58.0 || ^2.34.0",
    },
    waitForBlur: {
      type: "boolean",
      description:
        "Blur a sample before uploading it when it is not blurred yet; a blur failure fails the sample. Requires ^1.58.0 || ^2.34.0",
    },
  },
} as const;

export const $UploadSamplesScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/UploadSamplesJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $UploadSamplesScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/UploadSamplesJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $UploadSamplesScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/UploadSamplesJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $UploadSamplesUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/UploadSamplesJobDataDto",
    },
  },
} as const;

export const $UploadSamplesDeviceResultDto = {
  type: "object",
  properties: {
    lastStart: {
      type: "string",
      format: "date-time",
    },
    lastProgress: {
      type: "string",
      format: "date-time",
    },
    legacyMode: {
      type: "string",
      enum: ["agent", "backend"],
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    retries: {
      type: "number",
    },
    wasRunning: {
      type: "boolean",
    },
    remaining: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    done: {
      type: "number",
    },
    skipped: {
      type: "number",
    },
    total: {
      type: "number",
    },
    _meta: {
      $ref: "#/components/schemas/SampleUploadProgressDto",
    },
  },
} as const;

export const $UploadSamplesJobDetailsDto = {
  type: "object",
  properties: {
    total: {
      type: "number",
    },
    done: {
      type: "number",
    },
    remaining: {
      type: "number",
    },
    legacyDevices: {
      type: "object",
      additionalProperties: {
        type: "array",
        items: {
          type: "number",
        },
      },
    },
  },
} as const;

export const $UploadSamplesJobDeviceStateDto = {
  type: "string",
  enum: [
    "pending",
    "running",
    "done",
    "failed",
    "cancelled",
    "aborted",
    "stopped",
  ],
} as const;

export const $UploadSamplesJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/UploadSamplesJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/UploadSamplesDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $UploadSamplesJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/UploadSamplesJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $UploadSamplesJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/UploadSamplesJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/UploadSamplesJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/UploadSamplesJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $UploadSamplesDataWithNameDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    architecture: {
      type: "array",
      items: {
        type: "string",
        enum: ["distributed", "hybrid", "centralized"],
      },
    },
    query: {
      $ref: "#/components/schemas/GetSamplesQueryRequestDto",
    },
    target: {
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    targetEdge: {
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    targetCluster: {
      allOf: [
        {
          $ref: "#/components/schemas/VideoUploadTargetEnum",
        },
      ],
    },
    maxUploadSpeed: {
      type: "number",
      minimum: 0,
    },
    legacyUpload: {
      allOf: [
        {
          $ref: "#/components/schemas/LegacyUploadModeEnum",
        },
      ],
    },
    pageSize: {
      type: "number",
      minimum: 1,
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    delete: {
      type: "boolean",
    },
    deleteEdge: {
      type: "boolean",
    },
    deleteCluster: {
      type: "boolean",
    },
    force: {
      type: "boolean",
    },
    forceEdge: {
      type: "boolean",
    },
    forceCluster: {
      type: "boolean",
    },
    timeout: {
      type: "number",
    },
    onlyHeadBlurred: {
      type: "boolean",
      description:
        "Upload only already-blurred samples - forces query.head_blurred=true on the agent. Requires ^1.58.0 || ^2.34.0",
    },
    waitForBlur: {
      type: "boolean",
      description:
        "Blur a sample before uploading it when it is not blurred yet; a blur failure fails the sample. Requires ^1.58.0 || ^2.34.0",
    },
  },
} as const;

export const $UploadSamplesJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/UploadSamplesJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/UploadSamplesJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $UploadSamplesUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $DeleteSamplesJobDataDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    query: {
      $ref: "#/components/schemas/GetSamplesQueryRequestDto",
    },
  },
} as const;

export const $DeleteSamplesScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeleteSamplesJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $DeleteSamplesScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeleteSamplesJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $DeleteSamplesScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeleteSamplesJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $DeleteSamplesUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeleteSamplesJobDataDto",
    },
  },
} as const;

export const $DeleteSamplesDeviceStateEnum = {
  type: "string",
  enum: ["running", "done", "failed"],
  description: "",
} as const;

export const $SkippedForDatasetsDto = {
  type: "object",
  properties: {
    uuid: {
      type: "string",
    },
    datasets: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["uuid", "datasets"],
} as const;

export const $DeleteSamplesDeviceResultDto = {
  type: "object",
  properties: {
    state: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/DeleteSamplesDeviceStateEnum",
        },
      ],
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    updateTime: {
      type: "string",
      format: "date-time",
    },
    remaining: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    skipped: {
      type: "number",
    },
    skippedItems: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SkippedForDatasetsDto",
      },
    },
  },
} as const;

export const $DeleteSamplesJobDetailsDto = {
  type: "object",
  properties: {
    total: {
      type: "number",
    },
    done: {
      type: "number",
    },
    remaining: {
      type: "number",
    },
  },
} as const;

export const $DeleteSamplesJobDeviceStateDto = {
  type: "string",
  enum: ["running", "done", "failed"],
} as const;

export const $DeleteSamplesJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/DeleteSamplesJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/DeleteSamplesDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $DeleteSamplesJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/DeleteSamplesJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $DeleteSamplesJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeleteSamplesJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/DeleteSamplesJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/DeleteSamplesJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $DeleteSamplesDataWithNameDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    query: {
      $ref: "#/components/schemas/GetSamplesQueryRequestDto",
    },
  },
} as const;

export const $DeleteSamplesJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeleteSamplesJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/DeleteSamplesJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $DeleteSamplesUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $DeleteVideosJobDataDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    query: {
      $ref: "#/components/schemas/GetSessionsRequestDto",
    },
  },
} as const;

export const $DeleteVideosScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeleteVideosJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $DeleteVideosScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeleteVideosJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $DeleteVideosScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeleteVideosJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $DeleteVideosUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/DeleteVideosJobDataDto",
    },
  },
} as const;

export const $DeleteVideosDeviceStateEnum = {
  type: "string",
  enum: ["running", "done", "failed"],
  description: "",
} as const;

export const $DeleteVideosDeviceResultDto = {
  type: "object",
  properties: {
    state: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/DeleteVideosDeviceStateEnum",
        },
      ],
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    updateTime: {
      type: "string",
      format: "date-time",
    },
    remaining: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
    skipped: {
      type: "number",
    },
    skippedItems: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SkippedForDatasetsDto",
      },
    },
  },
} as const;

export const $DeleteVideosJobDetailsDto = {
  type: "object",
  properties: {
    total: {
      type: "number",
    },
    done: {
      type: "number",
    },
    remaining: {
      type: "number",
    },
  },
} as const;

export const $DeleteVideosJobDeviceStateDto = {
  type: "string",
  enum: ["running", "done", "failed"],
} as const;

export const $DeleteVideosJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/DeleteVideosJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/DeleteVideosDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $DeleteVideosJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/DeleteVideosJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $DeleteVideosJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeleteVideosJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/DeleteVideosJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/DeleteVideosJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $DeleteVideosDataWithNameDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    query: {
      $ref: "#/components/schemas/GetSessionsRequestDto",
    },
  },
} as const;

export const $DeleteVideosJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/DeleteVideosJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/DeleteVideosJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $DeleteVideosUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $SyncGroundTruthsJobDataDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["deviceIds"],
} as const;

export const $SyncGroundTruthsScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/SyncGroundTruthsJobDataDto",
    },
  },
  required: ["name", "data"],
} as const;

export const $SyncGroundTruthsScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/SyncGroundTruthsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $SyncGroundTruthsScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/SyncGroundTruthsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $SyncGroundTruthsUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/SyncGroundTruthsJobDataDto",
    },
  },
} as const;

export const $SyncGroundTruthsDeviceStateEnum = {
  type: "string",
  enum: ["running", "done", "failed"],
  description: "",
} as const;

export const $SyncGroundTruthsDeviceResultDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    updateTime: {
      type: "string",
      format: "date-time",
    },
    total: {
      type: "number",
    },
    created: {
      type: "number",
    },
    updated: {
      type: "number",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    markedEvicted: {
      type: "number",
    },
    invalid: {
      type: "number",
    },
    state: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/SyncGroundTruthsDeviceStateEnum",
        },
      ],
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
  },
} as const;

export const $SyncGroundTruthsJobDetailsDto = {
  type: "object",
  properties: {
    devices: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            $ref: "#/components/schemas/SyncGroundTruthsDeviceResultDto",
          },
        ],
      },
    },
  },
  required: ["devices"],
} as const;

export const $SyncGroundTruthsJobDeviceStateDto = {
  type: "string",
  enum: ["running", "done", "failed"],
} as const;

export const $SyncGroundTruthsJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/SyncGroundTruthsJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/SyncGroundTruthsDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $SyncGroundTruthsJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/SyncGroundTruthsJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $SyncGroundTruthsJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/SyncGroundTruthsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/SyncGroundTruthsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/SyncGroundTruthsJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $SyncGroundTruthsDataWithNameDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
  required: ["deviceIds"],
} as const;

export const $SyncGroundTruthsJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/SyncGroundTruthsJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/SyncGroundTruthsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $SyncGroundTruthsUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $WorkerJobTypesEnum = {
  type: "string",
  enum: ["no_scan_find_candidates"],
} as const;

export const $WorkerJobDataDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    jobType: {
      type: "string",
      enum: ["no_scan_find_candidates"],
    },
    version: {
      type: "string",
    },
    keepContainer: {
      type: "boolean",
    },
    jobInput: {
      type: "object",
    },
  },
  required: ["deviceIds", "jobType"],
} as const;

export const $WorkerJobScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/WorkerJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $WorkerJobScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/WorkerJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $WorkerJobScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/WorkerJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $WorkerJobUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/WorkerJobDataDto",
    },
  },
} as const;

export const $WorkerJobDeviceStateEnum = {
  type: "string",
  enum: ["running", "done", "failed"],
  description: "",
} as const;

export const $WorkerJobDeviceDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    updateTime: {
      type: "string",
      format: "date-time",
    },
    total: {
      type: "number",
    },
    created: {
      type: "number",
    },
    updated: {
      type: "number",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    markedDeleted: {
      type: "number",
    },
    invalid: {
      type: "number",
    },
    state: {
      description: "",
      allOf: [
        {
          $ref: "#/components/schemas/WorkerJobDeviceStateEnum",
        },
      ],
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
  },
} as const;

export const $WorkerJobDetailsDto = {
  type: "object",
  properties: {
    devices: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            $ref: "#/components/schemas/WorkerJobDeviceDto",
          },
        ],
      },
    },
  },
  required: ["devices"],
} as const;

export const $WorkerJobJobDeviceStateDto = {
  type: "string",
  enum: ["running", "done", "failed"],
} as const;

export const $WorkerJobDeviceResultDto = {
  type: "object",
  properties: {
    total: {
      type: "number",
    },
    created: {
      type: "number",
    },
    updated: {
      type: "number",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    markedDeleted: {
      type: "number",
    },
    invalid: {
      type: "number",
    },
    startTime: {
      format: "date-time",
      type: "string",
    },
    updateTime: {
      format: "date-time",
      type: "string",
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
  },
} as const;

export const $WorkerJobJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/WorkerJobJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/WorkerJobDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $WorkerJobJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/WorkerJobJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $WorkerJobJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/WorkerJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/WorkerJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/WorkerJobJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $WorkerJobDataWithNameDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    jobType: {
      type: "string",
      enum: ["no_scan_find_candidates"],
    },
    version: {
      type: "string",
    },
    keepContainer: {
      type: "boolean",
    },
    jobInput: {
      type: "object",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
  required: ["deviceIds", "jobType"],
} as const;

export const $WorkerJobJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/WorkerJobDetailsDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/WorkerJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $WorkerJobUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $QueueItemSummaryDto = {
  type: "object",
  properties: {
    count: {
      type: "number",
    },
    size: {
      type: "number",
    },
  },
  required: ["count", "size"],
} as const;

export const $QueueSummaryDto = {
  type: "object",
  properties: {
    pending: {
      $ref: "#/components/schemas/QueueItemSummaryDto",
    },
    failures: {
      $ref: "#/components/schemas/QueueItemSummaryDto",
    },
  },
  required: ["pending", "failures"],
} as const;

export const $QueuesSummaryDto = {
  type: "object",
  properties: {
    "ground-truths": {
      $ref: "#/components/schemas/QueueSummaryDto",
    },
    predictions: {
      $ref: "#/components/schemas/QueueSummaryDto",
    },
    events: {
      $ref: "#/components/schemas/QueueSummaryDto",
    },
    sessions: {
      $ref: "#/components/schemas/QueueSummaryDto",
    },
    "session-tagging": {
      $ref: "#/components/schemas/QueueSummaryDto",
    },
    "sample-group-tagging": {
      $ref: "#/components/schemas/QueueSummaryDto",
    },
    "sample-event-tagging": {
      $ref: "#/components/schemas/QueueSummaryDto",
    },
    "agent-logs": {
      $ref: "#/components/schemas/QueueSummaryDto",
    },
  },
  required: [
    "ground-truths",
    "predictions",
    "events",
    "sessions",
    "session-tagging",
    "sample-group-tagging",
    "sample-event-tagging",
    "agent-logs",
  ],
} as const;

export const $QueueFailureDto = {
  type: "object",
  properties: {
    data: {
      type: "object",
      additionalProperties: true,
    },
    error: {
      type: "object",
      properties: {
        name: {
          type: "string",
          required: false,
        },
        message: {
          type: "string",
          required: false,
        },
      },
    },
  },
  required: ["data"],
} as const;

export const $QueueDefinitionEndpoint = {
  type: "string",
  enum: [
    "ground-truths",
    "predictions",
    "events",
    "sessions",
    "session-tagging",
    "sample-group-tagging",
    "sample-event-tagging",
    "agent-logs",
  ],
} as const;

export const $QueueBulkDto = {
  type: "object",
  properties: {
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $QueuePendingDto = {
  type: "object",
  properties: {
    data: {
      type: "object",
      additionalProperties: true,
    },
  },
  required: ["data"],
} as const;

export const $JiraAuthOrAccountDto = {
  type: "object",
  properties: {
    username: {
      type: "string",
    },
    password: {
      type: "string",
    },
    url: {
      type: "string",
    },
    alertChannelId: {
      type: "number",
    },
  },
} as const;

export const $ProjectIssueTypesDto = {
  type: "object",
  properties: {
    username: {
      type: "string",
    },
    password: {
      type: "string",
    },
    url: {
      type: "string",
    },
    alertChannelId: {
      type: "number",
    },
    project: {
      type: "string",
    },
  },
  required: ["project"],
} as const;

export const $StateInputFlexibleDto = {
  type: "object",
  properties: {
    project: {
      type: "string",
    },
    issueType: {
      type: "string",
    },
    username: {
      type: "string",
    },
    password: {
      type: "string",
    },
    url: {
      type: "string",
    },
    alertChannelId: {
      type: "number",
    },
  },
  required: ["project", "issueType"],
} as const;

export const $JiraState = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    stateId: {
      type: "string",
    },
    transitionId: {
      type: "string",
    },
  },
  required: ["stateId", "transitionId"],
} as const;

export const $CreateSlackAlertChannelDto = {
  type: "object",
  properties: {
    channelId: {
      type: "string",
    },
    alertChannelId: {
      type: "number",
    },
    name: {
      type: "string",
      maxLength: 100,
    },
    editsViaPatch: {
      type: "boolean",
    },
  },
  required: ["channelId"],
} as const;

export const $TestRecurrenceNotificationDto = {
  type: "object",
  properties: {
    alertChannelId: {
      type: "number",
    },
    messageTs: {
      type: "string",
    },
    timestamp: {
      type: "string",
    },
    message: {
      type: "string",
    },
    numAlerts: {
      type: "number",
    },
    numResolves: {
      type: "number",
    },
  },
  required: ["alertChannelId", "messageTs", "timestamp", "numAlerts"],
} as const;

export const $TestPartialResolveNotificationDto = {
  type: "object",
  properties: {
    alertChannelId: {
      type: "number",
    },
    messageTs: {
      type: "string",
    },
    timestamp: {
      type: "string",
    },
    message: {
      type: "string",
    },
    numAlerts: {
      type: "number",
    },
    numResolves: {
      type: "number",
    },
  },
  required: [
    "alertChannelId",
    "messageTs",
    "timestamp",
    "message",
    "numAlerts",
    "numResolves",
  ],
} as const;

export const $TestCreateAlertDto = {
  type: "object",
  properties: {
    alertChannelId: {
      type: "number",
    },
    title: {
      type: "string",
    },
    message: {
      type: "string",
    },
    timestamp: {
      type: "string",
    },
    handling: {
      type: "string",
    },
    accountId: {
      type: "number",
    },
    accountName: {
      type: "string",
    },
    device: {
      type: "string",
    },
    env: {
      type: "string",
    },
  },
  required: [
    "alertChannelId",
    "title",
    "message",
    "timestamp",
    "handling",
    "accountId",
    "accountName",
    "env",
  ],
} as const;

export const $TestResolveAlertDto = {
  type: "object",
  properties: {
    alertChannelId: {
      type: "number",
    },
    messageTs: {
      type: "string",
    },
    timestamp: {
      type: "string",
    },
    message: {
      type: "string",
    },
    numAlerts: {
      type: "number",
    },
    numResolves: {
      type: "number",
    },
  },
  required: ["alertChannelId", "messageTs", "timestamp"],
} as const;

export const $TestServiceHealthCheckDto = {
  type: "object",
  properties: {
    endpoint: {
      type: "string",
      format: "uri",
    },
    method: {
      enum: ["GET", "POST"],
      type: "string",
      default: "GET",
    },
    expectedStatus: {
      type: "number",
      default: 200,
    },
    expectedBodyContains: {
      type: "string",
    },
    timeoutMs: {
      type: "number",
      default: 5000,
    },
  },
  required: ["endpoint"],
} as const;

export const $ServiceHealthCheckTestResultDto = {
  type: "object",
  properties: {
    healthy: {
      type: "boolean",
    },
    status: {
      type: "number",
      nullable: true,
    },
    checkedAt: {
      type: "string",
    },
    reason: {
      type: "string",
      description: "Explains why the check was unhealthy",
    },
    endpoint: {
      type: "string",
    },
    method: {
      type: "string",
    },
    responseHeaders: {
      type: "object",
      additionalProperties: true,
    },
    responseBody: {
      type: "object",
    },
    error: {
      type: "string",
    },
  },
  required: ["healthy", "status", "checkedAt", "endpoint", "method"],
} as const;

export const $ServiceHealthCheckJobDataDto = {
  type: "object",
  properties: {
    serviceName: {
      type: "string",
    },
    endpoint: {
      type: "string",
      format: "uri",
    },
    method: {
      enum: ["GET", "POST"],
      type: "string",
      default: "GET",
    },
    expectedStatus: {
      type: "number",
      default: 200,
    },
    expectedBodyContains: {
      type: "string",
    },
    timeoutMs: {
      type: "number",
      default: 5000,
    },
  },
  required: ["serviceName", "endpoint"],
} as const;

export const $ServiceHealthChecksScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ServiceHealthCheckJobDataDto",
    },
  },
  required: ["name", "data"],
} as const;

export const $ServiceHealthChecksScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ServiceHealthCheckJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $ServiceHealthChecksScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ServiceHealthCheckJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $ServiceHealthChecksUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/ServiceHealthCheckJobDataDto",
    },
  },
} as const;

export const $ServiceHealthCheckJobResultDto = {
  type: "object",
  properties: {
    check: {
      $ref: "#/components/schemas/ServiceHealthCheckTestResultDto",
    },
    total: {
      type: "number",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
  },
  required: ["check", "total", "done", "failures"],
} as const;

export const $JobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      type: "string",
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      type: "object",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $JobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/JobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $ServiceHealthChecksJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/ServiceHealthCheckJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/ServiceHealthCheckJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/JobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $ServiceHealthChecksDataWithNameDto = {
  type: "object",
  properties: {
    serviceName: {
      type: "string",
    },
    endpoint: {
      type: "string",
      format: "uri",
    },
    method: {
      enum: ["GET", "POST"],
      type: "string",
      default: "GET",
    },
    expectedStatus: {
      type: "number",
      default: 200,
    },
    expectedBodyContains: {
      type: "string",
    },
    timeoutMs: {
      type: "number",
      default: 5000,
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
  required: ["serviceName", "endpoint"],
} as const;

export const $ServiceHealthChecksJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/ServiceHealthCheckJobResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/ServiceHealthCheckJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $ServiceHealthChecksUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $CapacityTaggingPreCheckRequestDto = {
  type: "object",
  properties: {
    fromDate: {
      type: "string",
      format: "date-time",
    },
    toDate: {
      type: "string",
      format: "date-time",
    },
    lookbackDays: {
      type: "number",
      minimum: 1,
      maximum: 31,
    },
    completenessThresholdEnabled: {
      type: "boolean",
      default: true,
    },
    completenessThresholdPercent: {
      type: "number",
      minimum: 0,
      maximum: 100,
    },
  },
} as const;

export const $CapacityTaggingStoreCompletenessDto = {
  type: "object",
  properties: {
    siteId: {
      type: "object",
      nullable: true,
    },
    siteName: {
      type: "object",
      nullable: true,
    },
    alerted: {
      type: "number",
      description: "Alerted sessions in the window for this store",
    },
    withVideo: {
      type: "number",
      description: "Alerted sessions with video uploaded",
    },
    percent: {
      type: "number",
      description: "withVideo / alerted, percent (0-100)",
    },
  },
  required: ["alerted", "withVideo", "percent"],
} as const;

export const $CapacityTaggingCompletenessDto = {
  type: "object",
  properties: {
    alertedSessions: {
      type: "number",
    },
    withVideo: {
      type: "number",
    },
    percent: {
      type: "number",
      description: "Overall completeness percent (0-100)",
    },
    thresholdPercent: {
      type: "object",
      nullable: true,
      description:
        "Threshold percent the run was gated on (null when the gate is disabled)",
    },
    passesThreshold: {
      type: "boolean",
      description: "Whether the window passed the completeness gate",
    },
    perStore: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CapacityTaggingStoreCompletenessDto",
      },
    },
  },
  required: [
    "alertedSessions",
    "withVideo",
    "percent",
    "thresholdPercent",
    "passesThreshold",
    "perStore",
  ],
} as const;

export const $CapacityTaggingPreCheckResponseDto = {
  type: "object",
  properties: {
    windowFrom: {
      type: "string",
      format: "date-time",
      description: "Resolved window start",
    },
    windowTo: {
      type: "string",
      format: "date-time",
      description: "Resolved window end",
    },
    alertedSessions: {
      type: "number",
      description: "Alerted sessions in the window",
    },
    wouldProcess: {
      type: "number",
      description:
        "Eligible sessions the run would process (video uploaded, not already dispatched)",
    },
    completeness: {
      $ref: "#/components/schemas/CapacityTaggingCompletenessDto",
    },
  },
  required: [
    "windowFrom",
    "windowTo",
    "alertedSessions",
    "wouldProcess",
    "completeness",
  ],
} as const;

export const $CapacityTaggingJobDataDto = {
  type: "object",
  properties: {
    fromDate: {
      type: "string",
      format: "date-time",
      description: "Explicit window start (manual runs)",
    },
    toDate: {
      type: "string",
      format: "date-time",
      description: "Explicit window end (manual runs)",
    },
    lookbackDays: {
      type: "number",
      minimum: 1,
      maximum: 31,
      description:
        "Relative look-back window in days, resolved at run time (recurring/interval runs)",
    },
    completenessThresholdEnabled: {
      type: "boolean",
      default: true,
      description: "Enable the data-completeness threshold gate",
    },
    completenessThresholdPercent: {
      type: "number",
      minimum: 0,
      maximum: 100,
      default: 80,
      description:
        "Minimum percent of the window's alerted sessions that must have video uploaded; below it the run alerts instead of dispatching",
    },
    capacity: {
      type: "number",
      minimum: 1,
      description:
        "Daily review capacity (sessions/day) handed to the component as its review budget; defaults to the account's nonScanDailyCapacityThreshold setting, then 600",
    },
    tagName: {
      type: "string",
      minLength: 1,
      maxLength: 1000,
      default: "Sampled for tagging",
      deprecated: true,
      description:
        "Superseded by tags; still honored for schedules persisted before multi-tag support",
    },
    tags: {
      default: ["Sampled for tagging"],
      description:
        "Session tags applied to the selected sessions (missing tags are auto-created). Takes precedence over the deprecated tagName.",
      type: "array",
      items: {
        type: "string",
        minLength: 1,
      },
    },
    sessionsPerBatch: {
      type: "number",
      minimum: 1,
      default: 1000,
      description:
        "Target sessions per Cloud Run task shard of the scoring execution (default 1k)",
    },
  },
} as const;

export const $CapacityTaggingScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CapacityTaggingJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $CapacityTaggingScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CapacityTaggingJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $CapacityTaggingScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CapacityTaggingJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $CapacityTaggingUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CapacityTaggingJobDataDto",
    },
  },
} as const;

export const $CapacityTaggingPrepareCacheProgressDto = {
  type: "object",
  properties: {
    batchesTotal: {
      type: "number",
      description: "Cloud Run task count of the scoring execution",
    },
    batchesRunning: {
      type: "number",
      description: "Tasks not yet terminal",
    },
    batchesDone: {
      type: "number",
      description: "Tasks succeeded",
    },
    batchesFailed: {
      type: "number",
      description: "Tasks failed or cancelled",
    },
    sessionsProcessed: {
      type: "number",
      description:
        "Sessions processed (task-proportional estimate while running)",
    },
    sessionsTotal: {
      type: "number",
      description: "Sessions in the scoring input CSV",
    },
  },
  required: [
    "batchesTotal",
    "batchesRunning",
    "batchesDone",
    "batchesFailed",
    "sessionsProcessed",
    "sessionsTotal",
  ],
} as const;

export const $CapacityTaggingSampleDateDto = {
  type: "object",
  properties: {
    date: {
      type: "string",
      description:
        "Business date the sample run decided (YYYY-MM-DD, store-local)",
    },
    selectedCount: {
      type: "number",
      description:
        "Sessions selected for review on this date (union of the date’s selection files)",
    },
    cellsDecided: {
      type: "number",
      description: "Cells (stores) decided for this date",
    },
    cellsWaiting: {
      type: "number",
      description: "Cells left waiting (coverage below the component’s gate)",
    },
    waitingStores: {
      description: "Store ids of the waiting cells",
      type: "array",
      items: {
        type: "string",
      },
    },
    skippedNoPredictions: {
      type: "boolean",
      description:
        "True when the sample run was skipped: scoring produced no predictions for this date",
    },
  },
  required: ["date", "selectedCount"],
} as const;

export const $CapacityTaggingScoreDateSummaryDto = {
  type: "object",
  properties: {
    date: {
      type: "string",
      description: "Business date (YYYY-MM-DD, store-local)",
    },
    summaryFound: {
      type: "boolean",
      description:
        "Whether a score run summary was found in the date’s handoff dir",
    },
    sessionsScored: {
      type: "number",
    },
    sessionsFailed: {
      type: "number",
    },
  },
  required: ["date", "summaryFound"],
} as const;

export const $CapacityTaggingAlertDto = {
  type: "object",
  properties: {
    accountId: {
      type: "number",
    },
    windowFrom: {
      type: "string",
      format: "date-time",
    },
    windowTo: {
      type: "string",
      format: "date-time",
    },
    thresholdPercent: {
      type: "number",
    },
    actualPercent: {
      type: "number",
    },
    completeness: {
      $ref: "#/components/schemas/CapacityTaggingCompletenessDto",
    },
  },
  required: [
    "accountId",
    "windowFrom",
    "windowTo",
    "thresholdPercent",
    "actualPercent",
    "completeness",
  ],
} as const;

export const $CapacityTaggingResultDto = {
  type: "object",
  properties: {
    done: {
      type: "number",
      description: "Sessions processed (drives the jobs-list progress bar)",
    },
    total: {
      type: "number",
      description: "Sessions to process (eligible sessions collected)",
    },
    failures: {
      type: "number",
      description:
        "Always 0 on success — a failed scoring execution fails the whole run",
    },
    sessionsCollected: {
      type: "number",
      description:
        "Alerted sessions eligible for processing (video uploaded, not already dispatched)",
    },
    sessionsProcessed: {
      type: "number",
    },
    completeness: {
      $ref: "#/components/schemas/CapacityTaggingCompletenessDto",
    },
    csvFiles: {
      description: "GCS path of the uploaded input CSV (single file per run)",
      type: "array",
      items: {
        type: "string",
      },
    },
    prepareCache: {
      $ref: "#/components/schemas/CapacityTaggingPrepareCacheProgressDto",
    },
    sampledSessionCount: {
      type: "number",
      description: "Sessions selected by the sample step",
    },
    capacityApplied: {
      type: "number",
      description:
        "Daily review capacity handed to the component for this run (sessions/day): the job's capacity, else the account's nonScanDailyCapacityThreshold, else 600",
    },
    sampleConfigPath: {
      type: "string",
      description:
        "GCS path of the per-run component config carrying that capacity as the review budget (passed to sample --config)",
    },
    sessionsSkippedNoSite: {
      type: "number",
      description:
        "Sessions excluded because no site resolves for them (blank Site ID is a hard input error for the component)",
    },
    sampleDates: {
      description: "Per-business-date sample outcomes",
      type: "array",
      items: {
        $ref: "#/components/schemas/CapacityTaggingSampleDateDto",
      },
    },
    scoreSummaries: {
      description:
        "Per-date score run-summary counts read from the component’s handoff dirs (best effort)",
      type: "array",
      items: {
        $ref: "#/components/schemas/CapacityTaggingScoreDateSummaryDto",
      },
    },
    sessionsTagged: {
      type: "number",
      description: "Sessions actually tagged with the run tags",
    },
    tags: {
      description: "Session tags applied to the selected sessions",
      type: "array",
      items: {
        type: "string",
      },
    },
    tagName: {
      type: "string",
      deprecated: true,
      description: "Superseded by tags; mirrors tags[0]",
    },
    dispatchTag: {
      type: "string",
      description: "Dedup marker tag applied on dispatch",
    },
    skippedByThreshold: {
      type: "boolean",
      description:
        "True when the run was skipped by the data-completeness threshold gate",
    },
    alert: {
      description: "Alert recorded when the completeness gate failed",
      allOf: [
        {
          $ref: "#/components/schemas/CapacityTaggingAlertDto",
        },
      ],
    },
    windowFrom: {
      type: "string",
      format: "date-time",
      description: "Resolved window start",
    },
    windowTo: {
      type: "string",
      format: "date-time",
      description: "Resolved window end",
    },
  },
} as const;

export const $CapacityTaggingJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/CapacityTaggingResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/CapacityTaggingJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/JobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $CapacityTaggingDataWithNameDto = {
  type: "object",
  properties: {
    fromDate: {
      type: "string",
      format: "date-time",
      description: "Explicit window start (manual runs)",
    },
    toDate: {
      type: "string",
      format: "date-time",
      description: "Explicit window end (manual runs)",
    },
    lookbackDays: {
      type: "number",
      minimum: 1,
      maximum: 31,
      description:
        "Relative look-back window in days, resolved at run time (recurring/interval runs)",
    },
    completenessThresholdEnabled: {
      type: "boolean",
      default: true,
      description: "Enable the data-completeness threshold gate",
    },
    completenessThresholdPercent: {
      type: "number",
      minimum: 0,
      maximum: 100,
      default: 80,
      description:
        "Minimum percent of the window's alerted sessions that must have video uploaded; below it the run alerts instead of dispatching",
    },
    capacity: {
      type: "number",
      minimum: 1,
      description:
        "Daily review capacity (sessions/day) handed to the component as its review budget; defaults to the account's nonScanDailyCapacityThreshold setting, then 600",
    },
    tagName: {
      type: "string",
      minLength: 1,
      maxLength: 1000,
      default: "Sampled for tagging",
      deprecated: true,
      description:
        "Superseded by tags; still honored for schedules persisted before multi-tag support",
    },
    tags: {
      default: ["Sampled for tagging"],
      description:
        "Session tags applied to the selected sessions (missing tags are auto-created). Takes precedence over the deprecated tagName.",
      type: "array",
      items: {
        type: "string",
        minLength: 1,
      },
    },
    sessionsPerBatch: {
      type: "number",
      minimum: 1,
      default: 1000,
      description:
        "Target sessions per Cloud Run task shard of the scoring execution (default 1k)",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $CapacityTaggingJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/CapacityTaggingResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/CapacityTaggingJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $CapacityTaggingUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $RecoveryEstimatesModeEnum = {
  type: "string",
  enum: ["weekly", "monthly"],
  description:
    "weekly = estimate --week-ending <weekEnding>; monthly = estimate-monthly --month <month>",
} as const;

export const $RecoveryEstimatesPreCheckRequestDto = {
  type: "object",
  properties: {
    mode: {
      description:
        "weekly = estimate --week-ending <weekEnding>; monthly = estimate-monthly --month <month>",
      allOf: [
        {
          $ref: "#/components/schemas/RecoveryEstimatesModeEnum",
        },
      ],
    },
    weekEnding: {
      type: "string",
      pattern: "^\\d{4}-\\d{2}-\\d{2}$",
      example: "2026-04-05",
      description:
        "Weekly runs: the store-local week-end date (YYYY-MM-DD) being finalized. Must be the last day of a reporting week (the day before calendar.week_start in the component config); the component refuses any other date.",
    },
    month: {
      type: "string",
      pattern: "^\\d{4}-\\d{2}$",
      example: "2026-04",
      description:
        "Monthly runs: the calendar month (YYYY-MM) to finalize, after the weekly run that folds its last week.",
    },
  },
  required: ["mode"],
} as const;

export const $RecoveryEstimatesReviewsStatsDto = {
  type: "object",
  properties: {
    sessionsInWeek: {
      type: "number",
      description:
        "Dispatched (sent-for-scoring) sessions whose store-local business date falls in the week",
    },
    reviewedSessions: {
      type: "number",
      description:
        "Sessions with at least one reviewed (verdict-tagged) alert — the sessions the CSV covers",
    },
    reviewedAlerts: {
      type: "number",
      description: "Alerts with a verdict — the rows written",
    },
    conflictingAlerts: {
      type: "number",
      description:
        "Alerts tagged both confirmed-non-scan and system-mistake — excluded from the CSV",
    },
    unreviewedAlerts: {
      type: "number",
      description:
        "Non-scan alerts of those sessions with no verdict yet (non-response for the component)",
    },
    alertsWithoutGroupId: {
      type: "number",
      description:
        "Non-scan alert rows without a group id — cannot be keyed for the component, excluded",
    },
    sessionsSkippedNoTimezone: {
      type: "number",
      description:
        "Sessions excluded because no timezone resolves for their site/account",
    },
    recoveredAlerts: {
      type: "number",
      description:
        "Confirmed alerts tagged product recovered whose recovered sample resolved — written recovered=True with its total_price",
    },
    failedAlerts: {
      type: "number",
      description:
        "Confirmed alerts tagged failed to recover — written recovered=False",
    },
    noOutcomeAlerts: {
      type: "number",
      description:
        "Confirmed alerts with neither outcome tag — written recovered=False by decision (provisional), so this count is the downward bias on the recovery rate",
    },
    conflictingOutcomes: {
      type: "number",
      description:
        "Confirmed alerts tagged both product recovered and failed to recover — written recovered=False",
    },
    unresolvedPairs: {
      type: "number",
      description:
        "Alerts tagged product recovered whose referenced sample is not present or has no total_price — written recovered=False",
    },
  },
  required: [
    "sessionsInWeek",
    "reviewedSessions",
    "reviewedAlerts",
    "conflictingAlerts",
    "unreviewedAlerts",
    "alertsWithoutGroupId",
    "sessionsSkippedNoTimezone",
    "recoveredAlerts",
    "failedAlerts",
    "noOutcomeAlerts",
    "conflictingOutcomes",
    "unresolvedPairs",
  ],
} as const;

export const $RecoveryEstimatesPreCheckResponseDto = {
  type: "object",
  properties: {
    mode: {
      allOf: [
        {
          $ref: "#/components/schemas/RecoveryEstimatesModeEnum",
        },
      ],
    },
    weekStart: {
      type: "string",
      description:
        "calendar.week_start from the component config (monday … sunday)",
    },
    weekEnding: {
      type: "string",
    },
    weekEndingValid: {
      type: "boolean",
      description: "Whether weekEnding is the last day of a reporting week",
    },
    previousWeekEnding: {
      type: "string",
      description: "Nearest valid week-ending on or before weekEnding",
    },
    nextWeekEnding: {
      type: "string",
      description: "Nearest valid week-ending on or after weekEnding",
    },
    weekFrom: {
      type: "string",
      description: "First store-local date of the week (weekEnding − 6 days)",
    },
    reviews: {
      description: "What the reviews CSV would carry (valid weekly runs only)",
      allOf: [
        {
          $ref: "#/components/schemas/RecoveryEstimatesReviewsStatsDto",
        },
      ],
    },
    month: {
      type: "string",
    },
    weeksExpected: {
      type: "array",
      items: {
        type: "string",
      },
    },
    weeksFolded: {
      type: "array",
      items: {
        type: "string",
      },
    },
    weeksMissing: {
      type: "array",
      items: {
        type: "string",
      },
    },
    monthAlreadyFolded: {
      type: "boolean",
      description:
        "Whether an estimates_monthly_<month>.csv already exists (a re-run overwrites it)",
    },
  },
  required: ["mode", "weekStart"],
} as const;

export const $RecoveryEstimatesJobDataDto = {
  type: "object",
  properties: {
    mode: {
      description:
        "weekly = estimate --week-ending <weekEnding>; monthly = estimate-monthly --month <month>",
      allOf: [
        {
          $ref: "#/components/schemas/RecoveryEstimatesModeEnum",
        },
      ],
    },
    weekEnding: {
      type: "string",
      pattern: "^\\d{4}-\\d{2}-\\d{2}$",
      example: "2026-04-05",
      description:
        "Weekly runs: the store-local week-end date (YYYY-MM-DD) being finalized. Must be the last day of a reporting week (the day before calendar.week_start in the component config); the component refuses any other date.",
    },
    month: {
      type: "string",
      pattern: "^\\d{4}-\\d{2}$",
      example: "2026-04",
      description:
        "Monthly runs: the calendar month (YYYY-MM) to finalize, after the weekly run that folds its last week.",
    },
  },
  required: ["mode"],
} as const;

export const $RecoveryEstimatesScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/RecoveryEstimatesJobDataDto",
    },
  },
  required: ["name"],
} as const;

export const $RecoveryEstimatesScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/RecoveryEstimatesJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $RecoveryEstimatesScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/RecoveryEstimatesJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "id", "createdAt", "updatedAt"],
} as const;

export const $RecoveryEstimatesUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/RecoveryEstimatesJobDataDto",
    },
  },
} as const;

export const $RecoveryEstimatesGlobalRowDto = {
  type: "object",
  properties: {
    estimand: {
      type: "string",
      description: "week | trailing | month_to_date | month_final",
    },
    periodLabel: {
      type: "string",
      description:
        "Week-start date(s) or month the row covers, as labelled by the component",
    },
    metric: {
      type: "string",
      description: "One of the ten §4.3 metrics",
    },
    estimator: {
      type: "string",
      description: "greg | two_margin — the estimator that produced the row",
    },
    estimate: {
      type: "number",
      nullable: true,
      description: "Point estimate for the whole fleet",
    },
    moe: {
      type: "number",
      nullable: true,
      description: "95% margin of error; the interval is estimate ± moe",
    },
    reliabilityFlag: {
      type: "string",
      nullable: true,
      description: "ok | directional | partial",
    },
    nReviews: {
      type: "number",
      nullable: true,
      description: "Reviewed sessions backing the row",
    },
    auditedCount: {
      type: "number",
      nullable: true,
      description:
        "Directly observed count — a hard lower bound on estimate (blank for rates)",
    },
    storesPending: {
      type: "number",
      nullable: true,
      description: "Stores with a never-decided cell in this domain",
    },
    pendingSessionShare: {
      type: "number",
      nullable: true,
      description: "Those cells' share of the domain's expected sessions",
    },
  },
  required: [
    "estimand",
    "periodLabel",
    "metric",
    "estimator",
    "estimate",
    "moe",
    "reliabilityFlag",
    "nReviews",
    "auditedCount",
    "storesPending",
    "pendingSessionShare",
  ],
} as const;

export const $RecoveryEstimatesVerificationDto = {
  type: "object",
  properties: {
    passed: {
      type: "boolean",
      description:
        "True when no defect was found (warnings do not fail verification)",
    },
    rowCount: {
      type: "number",
    },
    storeCount: {
      type: "number",
      description: "Distinct store_id values, GLOBAL excluded",
    },
    estimands: {
      description: "Distinct estimand values present",
      type: "array",
      items: {
        type: "string",
      },
    },
    defects: {
      description:
        "Contract violations — a defect in the run, not a wide interval",
      type: "array",
      items: {
        type: "string",
      },
    },
    warnings: {
      description:
        "Non-fatal observations (directional rows, partial totals, pending stores, …)",
      type: "array",
      items: {
        type: "string",
      },
    },
    global: {
      description:
        "The fleet rows — the headline numbers, one per (estimand, metric)",
      type: "array",
      items: {
        $ref: "#/components/schemas/RecoveryEstimatesGlobalRowDto",
      },
    },
  },
  required: [
    "passed",
    "rowCount",
    "storeCount",
    "estimands",
    "defects",
    "warnings",
    "global",
  ],
} as const;

export const $RecoveryEstimatesPersistedDto = {
  type: "object",
  properties: {
    runId: {
      type: "number",
      description:
        "recovery_estimate_runs.id — the join key for every persisted row of this fold",
    },
    runAsOf: {
      type: "string",
      description:
        "The data cutoff the rows were keyed on (from the CSV, else the dispatched period end)",
    },
    estimateRows: {
      type: "number",
      description: "Rows written to recovery_estimates",
    },
    periodTotalRows: {
      type: "number",
      description:
        "Rows written to recovery_period_totals (one per period and store, GLOBAL included)",
    },
    kpiRows: {
      type: "number",
      description: "Rows written to recovery_kpis",
    },
    skippedRows: {
      type: "number",
      description:
        "CSV rows not persisted because they could not be keyed or parsed (each is also a verification defect)",
    },
    unknownStores: {
      description:
        "store_id values that are not a site of the account — persisted with site_id NULL",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: [
    "runId",
    "runAsOf",
    "estimateRows",
    "periodTotalRows",
    "kpiRows",
    "skippedRows",
    "unknownStores",
  ],
} as const;

export const $RecoveryEstimatesResultDto = {
  type: "object",
  properties: {
    done: {
      type: "number",
      description:
        "Executions completed (0 or 1) — drives the jobs-list progress bar",
    },
    total: {
      type: "number",
      description: "Always 1: one Cloud Run execution per run",
    },
    failures: {
      type: "number",
      description: "Verification defects found (0 when verification passed)",
    },
    mode: {
      allOf: [
        {
          $ref: "#/components/schemas/RecoveryEstimatesModeEnum",
        },
      ],
    },
    weekEnding: {
      type: "string",
    },
    month: {
      type: "string",
    },
    weekStart: {
      type: "string",
      description:
        "calendar.week_start from the component config (monday … sunday)",
    },
    reviewsCsvPath: {
      type: "string",
      description:
        "Bucket-relative path of the reviews CSV handed to estimate --reviews-csv",
    },
    reviewsValuesSource: {
      enum: ["postgres", "none"],
      type: "string",
      description:
        "Where recovered / recovered_value in the reviews CSV came from: postgres — the product recovered / failed to recover tags and the recovered sample’s total_price; none — a run that folded on verdicts alone",
    },
    reviews: {
      $ref: "#/components/schemas/RecoveryEstimatesReviewsStatsDto",
    },
    weeksExpected: {
      description: "Monthly: week-ending dates whose weeks overlap the month",
      type: "array",
      items: {
        type: "string",
      },
    },
    weeksFolded: {
      description:
        "Monthly: those weeks with an estimates CSV in the state dir (already folded)",
      type: "array",
      items: {
        type: "string",
      },
    },
    weeksMissing: {
      description:
        "Monthly: expected weeks not yet folded when the run started",
      type: "array",
      items: {
        type: "string",
      },
    },
    estimatesCsvPath: {
      type: "string",
      description:
        "Bucket-relative path of the estimates CSV the component wrote",
    },
    summaryPath: {
      type: "string",
      description: "Bucket-relative path of the run summary JSON",
    },
    summary: {
      type: "object",
      additionalProperties: true,
      nullable: true,
      description: "The run summary JSON as written by the component",
    },
    verification: {
      $ref: "#/components/schemas/RecoveryEstimatesVerificationDto",
    },
    runId: {
      type: "number",
      description: "recovery_estimate_runs.id of the persisted fold",
    },
    persisted: {
      $ref: "#/components/schemas/RecoveryEstimatesPersistedDto",
    },
  },
  required: ["mode"],
} as const;

export const $RecoveryEstimatesJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/RecoveryEstimatesResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/RecoveryEstimatesJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/JobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $RecoveryEstimatesDataWithNameDto = {
  type: "object",
  properties: {
    mode: {
      description:
        "weekly = estimate --week-ending <weekEnding>; monthly = estimate-monthly --month <month>",
      allOf: [
        {
          $ref: "#/components/schemas/RecoveryEstimatesModeEnum",
        },
      ],
    },
    weekEnding: {
      type: "string",
      pattern: "^\\d{4}-\\d{2}-\\d{2}$",
      example: "2026-04-05",
      description:
        "Weekly runs: the store-local week-end date (YYYY-MM-DD) being finalized. Must be the last day of a reporting week (the day before calendar.week_start in the component config); the component refuses any other date.",
    },
    month: {
      type: "string",
      pattern: "^\\d{4}-\\d{2}$",
      example: "2026-04",
      description:
        "Monthly runs: the calendar month (YYYY-MM) to finalize, after the weekly run that folds its last week.",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
  required: ["mode"],
} as const;

export const $RecoveryEstimatesJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    result: {
      $ref: "#/components/schemas/RecoveryEstimatesResultDto",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/RecoveryEstimatesJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "result", "createdAt", "updatedAt", "state"],
} as const;

export const $RecoveryEstimatesUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $ListCatalogDto = {
  type: "object",
  properties: {
    siteId: {
      type: "number",
    },
    plu: {
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $ListCatalogMinimalDto = {
  type: "object",
  properties: {
    search: {
      type: "string",
    },
    page: {
      type: "number",
      default: 1,
      minimum: 1,
    },
    limit: {
      type: "number",
      default: 25,
      minimum: 1,
    },
    notInGroup: {
      type: "number",
      description:
        "Site group ID to exclude items that already have labels in this group",
    },
  },
} as const;

export const $CatalogMinimalItemDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    plu: {
      type: "string",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "plu", "name"],
} as const;

export const $ListFamiliesOrderEnum = {
  type: "string",
  enum: ["name", "createdAt"],
} as const;

export const $ListFamiliesOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ListFamiliesOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $CatalogItemsSummaryOrderEnum = {
  type: "string",
  enum: ["name", "englishName", "plu", "family"],
} as const;

export const $CatalogItemsSummaryOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/CatalogItemsSummaryOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListCatalogItemsSummaryQueryDto = {
  type: "object",
  properties: {
    plus: {
      type: "array",
      items: {
        type: "string",
      },
    },
    itemIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    priceBy: {
      enum: ["weight", "quantity"],
      type: "string",
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CatalogItemsSummaryOrderEnumSortOption",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    siteId: {
      type: "number",
    },
    groupId: {
      type: "number",
    },
    search: {
      type: "string",
    },
    exact: {
      type: "boolean",
    },
    plu: {
      type: "string",
    },
    name: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    outOfScope: {
      type: "boolean",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $SiteGroupLabel = {
  type: "object",
  properties: {
    siteGroupId: {
      type: "number",
    },
    siteGroupName: {
      type: "string",
    },
    labelInGroup: {
      type: "string",
    },
  },
  required: ["siteGroupId", "siteGroupName", "labelInGroup"],
} as const;

export const $CatalogItemDetailsDto = {
  type: "object",
  properties: {
    priceBy: {
      enum: ["weight", "quantity"],
      type: "string",
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    siteGroupLabels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SiteGroupLabel",
      },
    },
    id: {
      type: "number",
    },
    plu: {
      type: "string",
    },
    name: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    family: {
      type: "string",
    },
    outOfScope: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    updatedBy: {
      type: "string",
    },
    repImgUrl: {
      type: "string",
    },
  },
  required: ["tags"],
} as const;

export const $ExportCatalogItemsQueryDto = {
  type: "object",
  properties: {
    plus: {
      type: "array",
      items: {
        type: "string",
      },
    },
    itemIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    priceBy: {
      enum: ["weight", "quantity"],
      type: "string",
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CatalogItemsSummaryOrderEnumSortOption",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    siteId: {
      type: "number",
    },
    groupId: {
      type: "number",
    },
    maxRows: {
      type: "number",
      minimum: 1,
      description:
        "Backend-only row cap override. Not exposed in the UI; omit to use the default.",
    },
    search: {
      type: "string",
    },
    exact: {
      type: "boolean",
    },
    name: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    outOfScope: {
      type: "boolean",
    },
  },
} as const;

export const $DownloadCatalogItemsRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/ExportCatalogItemsQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $LookupTableDataDto = {
  type: "object",
  properties: {
    translated_name: {
      type: "string",
    },
    human_readable_name: {
      type: "string",
    },
    comment: {
      type: "string",
    },
  },
  required: ["translated_name", "human_readable_name", "comment"],
} as const;

export const $LookupTableDto = {
  type: "object",
  properties: {
    data: {
      type: "object",
      additionalProperties: {
        oneOf: [
          {
            $ref: "#/components/schemas/LookupTableDataDto",
          },
        ],
      },
    },
    name: {
      type: "string",
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["data", "name", "siteIds"],
} as const;

export const $BulkCatalogItemsQueryDto = {
  type: "object",
  properties: {
    plus: {
      type: "array",
      items: {
        type: "string",
      },
    },
    itemIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    priceBy: {
      enum: ["weight", "quantity"],
      type: "string",
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CatalogItemsSummaryOrderEnumSortOption",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    siteId: {
      type: "number",
    },
    groupId: {
      type: "number",
    },
    search: {
      type: "string",
    },
    exact: {
      type: "boolean",
    },
    name: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    outOfScope: {
      type: "boolean",
    },
  },
} as const;

export const $UpdateCatalogItemsTaggingBulkDto = {
  type: "object",
  properties: {
    assignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    unAssignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    all: {
      type: "boolean",
    },
    query: {
      $ref: "#/components/schemas/BulkCatalogItemsQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $UpdateCatalogItemsOutOfScopeBulkDto = {
  type: "object",
  properties: {
    outOfScope: {
      type: "boolean",
    },
    query: {
      $ref: "#/components/schemas/BulkCatalogItemsQueryDto",
    },
  },
  required: ["outOfScope", "query"],
} as const;

export const $CatalogLabelQueryDto = {
  type: "object",
  properties: {
    siteId: {
      type: "number",
    },
    groupId: {
      type: "number",
    },
  },
} as const;

export const $SitePriceDto = {
  type: "object",
  properties: {
    priceInSite: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    siteId: {
      type: "number",
    },
    id: {
      type: "number",
    },
  },
  required: ["siteId"],
} as const;

export const $CatalogItemSitePricesDto = {
  type: "object",
  properties: {
    basePrice: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    priceBy: {
      enum: ["weight", "quantity"],
      type: "string",
    },
    sitePrices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SitePriceDto",
      },
    },
    plu: {
      type: "string",
    },
  },
  required: ["sitePrices", "plu"],
} as const;

export const $SiteGroupLabelDto = {
  type: "object",
  properties: {
    siteGroupId: {
      type: "number",
    },
    siteGroupName: {
      type: "string",
    },
    labelInGroup: {
      type: "string",
    },
  },
  required: ["siteGroupId", "siteGroupName", "labelInGroup"],
} as const;

export const $CatalogItemLabelsDto = {
  type: "object",
  properties: {
    baseLabel: {
      type: "string",
    },
    name: {
      type: "string",
    },
    siteGroupLabels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SiteGroupLabelDto",
      },
    },
  },
  required: ["baseLabel", "name", "siteGroupLabels"],
} as const;

export const $CreateCatalogItemDto = {
  type: "object",
  properties: {
    priceBy: {
      enum: ["weight", "quantity"],
      type: "string",
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    name: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    family: {
      type: "string",
    },
    outOfScope: {
      type: "boolean",
    },
    tags: {
      description: `Tags to add. A new item starts with exactly these; an item brought back keeps the tags it had and gains these.
No tag is removed.`,
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
} as const;

export const $CreatedCatalogItemDto = {
  type: "object",
  properties: {
    priceBy: {
      enum: ["weight", "quantity"],
      type: "string",
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    siteGroupLabels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SiteGroupLabel",
      },
    },
    id: {
      type: "number",
    },
    plu: {
      type: "string",
    },
    name: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    family: {
      type: "string",
    },
    outOfScope: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    updatedBy: {
      type: "string",
    },
    repImgUrl: {
      type: "string",
    },
    restored: {
      type: "boolean",
      description:
        "Whether the label belonged to a removed item, which this brought back instead of creating a new one.",
    },
    previous: {
      description: `What the removed item had before it was brought back: the values the fields left out kept, and the tags it already
had. Only on a restore.`,
      allOf: [
        {
          $ref: "#/components/schemas/CatalogItemDetailsDto",
        },
      ],
    },
  },
  required: ["tags", "restored"],
} as const;

export const $UpdateCatalogItemDto = {
  type: "object",
  properties: {
    priceBy: {
      enum: ["weight", "quantity"],
      type: "string",
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
      allOf: [
        {
          $ref: "#/components/schemas/Decimal2",
        },
      ],
    },
    name: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    family: {
      type: "string",
    },
    outOfScope: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    assignTags: {
      description: `Tags to add to the item. Unlike \`tags\`, which replaces the item's tags, every tag the item already has stays.
Send either \`tags\` or \`assignTags\`, not both.`,
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
} as const;

export const $UpdatedCatalogItemDto = {
  type: "object",
  properties: {
    priceBy: {
      enum: ["weight", "quantity"],
      type: "string",
    },
    price: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "number",
        },
      ],
    },
    siteGroupLabels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SiteGroupLabel",
      },
    },
    id: {
      type: "number",
    },
    plu: {
      type: "string",
    },
    name: {
      type: "string",
    },
    englishName: {
      type: "string",
    },
    family: {
      type: "string",
    },
    outOfScope: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    updatedBy: {
      type: "string",
    },
    repImgUrl: {
      type: "string",
    },
  },
  required: ["tags"],
} as const;

export const $UploadFileDto = {
  type: "object",
  properties: {
    file: {
      type: "string",
      format: "binary",
    },
    siteIds: {
      description: "Site ID(s) for site-specific catalog upload",
      type: "array",
      items: {
        type: "number",
      },
    },
    groupIds: {
      description:
        "Group ID(s) for group-specific catalog upload (applies to all sites in each group)",
      type: "array",
      items: {
        type: "number",
      },
    },
    uploadMode: {
      enum: ["full", "partial"],
      type: "string",
      default: "full",
      description:
        'Upload mode for site-group uploads: "full" replaces all label translations in the group, "partial" adds/updates only the labels in the file',
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    name: {
      type: "string",
      description: "Custom job name. Overrides the auto-generated name.",
    },
    immediateApply: {
      type: "boolean",
      description: "Whether to apply the upload immediately",
      default: false,
    },
  },
  required: ["file"],
} as const;

export const $JobDevicesOrderBy = {
  type: "string",
  enum: ["name", "state"],
} as const;

export const $JobDevicesOrderBySortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/JobDevicesOrderBy",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $LabelUpdate = {
  type: "object",
  properties: {
    catalogItemId: {
      type: "number",
    },
    labelInGroup: {
      type: "string",
    },
    plu: {
      type: "string",
      description: "Populated when reading job details; ignored on write.",
    },
    catalogItemName: {
      type: "string",
      description: "Populated when reading job details; ignored on write.",
    },
  },
  required: ["catalogItemId", "labelInGroup"],
} as const;

export const $CatalogUploadJobDataDto = {
  type: "object",
  properties: {
    gcsFilePath: {
      type: "string",
      description: "CSV upload jobs only",
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    groupIds: {
      description:
        "For CSV uploads: the target site groups. For label jobs: the single site group being updated.",
      type: "array",
      items: {
        type: "number",
      },
    },
    siteNames: {
      type: "array",
      items: {
        type: "string",
      },
    },
    siteGroupNames: {
      type: "array",
      items: {
        type: "string",
      },
    },
    uploadMode: {
      enum: ["full", "partial"],
      type: "string",
      description: "CSV upload jobs only",
    },
    labels: {
      description:
        "Site group label bulk-update jobs only. Presence of this field is the job-kind discriminator.",
      type: "array",
      items: {
        $ref: "#/components/schemas/LabelUpdate",
      },
    },
    immediateApply: {
      type: "boolean",
      description:
        "True when the DB was updated immediately (Paths A/B); false when the full job runs on schedule (Path C).",
    },
  },
} as const;

export const $CatalogUploadScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CatalogUploadJobDataDto",
    },
  },
  required: ["name", "data"],
} as const;

export const $CatalogUploadScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CatalogUploadJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $ListCatalogUploadScheduledJobsDto = {
  type: "object",
  properties: {
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ScheduledJobOrderEnumSortOption",
      },
    },
    siteGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $CatalogUploadUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CatalogUploadJobDataDto",
    },
  },
} as const;

export const $CatalogUploadScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/CatalogUploadJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $CatalogUploadJobDeviceStateDto = {
  type: "string",
  enum: ["running", "done", "failed", "pending", "cancelled"],
} as const;

export const $CatalogUploadDeviceStateEnum = {
  type: "string",
  enum: ["running", "done", "failed", "pending", "cancelled"],
} as const;

export const $CatalogUploadDeviceResultDto = {
  type: "object",
  properties: {
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/CatalogUploadDeviceStateEnum",
        },
      ],
    },
    done: {
      type: "boolean",
    },
    failed: {
      type: "boolean",
    },
    pending: {
      type: "boolean",
    },
    cancelled: {
      type: "boolean",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    updateTime: {
      type: "string",
      format: "date-time",
    },
    failure: {
      $ref: "#/components/schemas/ErrorDto",
    },
  },
} as const;

export const $CatalogUploadJobDeviceParticipationDto = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    state: {
      allOf: [
        {
          $ref: "#/components/schemas/CatalogUploadJobDeviceStateDto",
        },
      ],
    },
    done: {
      type: "number",
    },
    total: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    result: {
      $ref: "#/components/schemas/CatalogUploadDeviceResultDto",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
  },
  required: ["createdAt", "updatedAt", "state", "result"],
} as const;

export const $CatalogUploadJobDeviceDto = {
  type: "object",
  properties: {
    participation: {
      $ref: "#/components/schemas/CatalogUploadJobDeviceParticipationDto",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["participation", "name", "id"],
} as const;

export const $CatalogUploadJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/CatalogUploadJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/CatalogUploadJobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $CatalogUploadDataWithNameDto = {
  type: "object",
  properties: {
    gcsFilePath: {
      type: "string",
      description: "CSV upload jobs only",
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    groupIds: {
      description:
        "For CSV uploads: the target site groups. For label jobs: the single site group being updated.",
      type: "array",
      items: {
        type: "number",
      },
    },
    siteNames: {
      type: "array",
      items: {
        type: "string",
      },
    },
    siteGroupNames: {
      type: "array",
      items: {
        type: "string",
      },
    },
    uploadMode: {
      enum: ["full", "partial"],
      type: "string",
      description: "CSV upload jobs only",
    },
    labels: {
      description:
        "Site group label bulk-update jobs only. Presence of this field is the job-kind discriminator.",
      type: "array",
      items: {
        $ref: "#/components/schemas/LabelUpdate",
      },
    },
    immediateApply: {
      type: "boolean",
      description:
        "True when the DB was updated immediately (Paths A/B); false when the full job runs on schedule (Path C).",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $CatalogUploadJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/CatalogUploadJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $CatalogUploadUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $SitesServiceVersionDeploymentBulkDto = {
  type: "object",
  properties: {
    serviceName: {
      enum: [
        "edgify-non-scan-detector",
        "edgify-worker",
        "edgify-on-screen-app",
        "edgify-zebra-adapter",
        "edgify-agent",
        "edgify-model",
      ],
      type: "string",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    query: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    version: {
      type: "string",
    },
    type: {
      type: "string",
    },
  },
  required: ["serviceName", "query", "version"],
} as const;

export const $ExportSiteSummariesDto = {
  type: "object",
  properties: {
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    groupId: {
      type: "number",
    },
    excludeGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    maxRows: {
      type: "number",
      minimum: 1,
      description:
        "Backend-only row cap override. Not exposed in the UI; omit to use the default.",
    },
    name: {
      type: "string",
    },
  },
} as const;

export const $DownloadSiteSummariesRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/ExportSiteSummariesDto",
    },
  },
  required: ["query"],
} as const;

export const $CreateSiteDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["name", "deviceIds"],
} as const;

export const $SiteOrderEnum = {
  type: "string",
  enum: ["name"],
} as const;

export const $SiteOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/SiteOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListSiteSummariesDto = {
  type: "object",
  properties: {
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      description:
        "Sorting by one or more fields, each with an optional direction.",
      type: "array",
      items: {
        $ref: "#/components/schemas/SiteOrderEnumSortOption",
      },
    },
    groupId: {
      type: "number",
    },
    excludeGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    tagsMatch: {
      enum: ["any", "exact", "all", "none"],
      type: "string",
    },
    name: {
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $SiteSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    lastPing: {
      format: "date-time",
      type: "string",
    },
    readyDevices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    offlineDevices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    hasOperationalHours: {
      type: "boolean",
    },
    siteGroup: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: [
    "id",
    "name",
    "lastPing",
    "readyDevices",
    "offlineDevices",
    "tags",
    "hasOperationalHours",
  ],
} as const;

export const $ListRegionOptionsDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
      description: "Case-insensitive substring match on the name",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $ListSubRegionOptionsDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
      description: "Case-insensitive substring match on the name",
    },
    regionId: {
      type: "number",
      description: "Limit to sub-regions of this region",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $SubRegionOptionDto = {
  type: "object",
  properties: {
    regionId: {
      type: "number",
      description:
        "Parent region, so the UI can cascade one dropdown off the other.",
    },
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
  },
  required: ["regionId", "name", "id"],
} as const;

export const $UpdateSitesTaggingsBulkDto = {
  type: "object",
  properties: {
    assignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    unAssignTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    all: {
      type: "boolean",
    },
    query: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $SitesModelDeploymentBulkDto = {
  type: "object",
  properties: {
    modelId: {
      type: "number",
    },
    query: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    role: {
      enum: [
        "predictor",
        "nonScanDetector",
        "objectDetector",
        "similarityFilter",
      ],
      type: "string",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
  },
  required: ["modelId", "query"],
} as const;

export const $UpdateSitesRegionsDto = {
  type: "object",
  properties: {
    regionId: {
      type: "number",
      nullable: true,
      minimum: 1,
      description:
        "Region id from the regions tables. null clears the region and its sub-region.",
    },
    subRegionId: {
      type: "number",
      nullable: true,
      minimum: 1,
      description:
        "Sub-region id from the regions tables; sets its region as well. null clears only the sub-region.",
    },
    query: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $UpdateSitesActivationTimeDto = {
  type: "object",
  properties: {
    activationTime: {
      format: "date-time",
      type: "string",
    },
    query: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
  },
  required: ["activationTime", "query"],
} as const;

export const $UpdateSitesGroupBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    groupId: {
      type: "number",
    },
  },
  required: ["query", "groupId"],
} as const;

export const $SitesConfigDeploymentBulkDto = {
  type: "object",
  properties: {
    deviceConfig: {
      $ref: "#/components/schemas/PartialDeviceConfigDto",
    },
    query: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    isPartial: {
      type: "boolean",
    },
    originalDeviceId: {
      type: "number",
      minimum: 1,
    },
    dontCleanDangerousConfigParams: {
      type: "boolean",
    },
  },
  required: ["deviceConfig", "query", "isPartial"],
} as const;

export const $BulkUpsertSitesOperationalHoursDto = {
  type: "object",
  properties: {
    schedule: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CreateOperationalHoursEntryDto",
      },
    },
    query: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
    enabled: {
      type: "boolean",
    },
    timezone: {
      type: "string",
    },
  },
  required: ["schedule", "query", "enabled", "timezone"],
} as const;

export const $SiteUploadPreviewRowDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    region: {
      type: "string",
    },
    subRegion: {
      type: "string",
    },
    group: {
      type: "string",
      description: "Site group name; created if it does not exist yet",
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        type: "string",
      },
    },
    status: {
      enum: ["new", "existing", "error"],
      type: "string",
    },
    error: {
      type: "string",
      description: "Error message when status is error",
    },
    warnings: {
      description:
        "Non-blocking notices for this row, e.g. a region that will be created. Empty when there are none.",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "tags", "status", "warnings"],
} as const;

export const $SiteUploadResponseDto = {
  type: "object",
  properties: {
    dryRun: {
      type: "boolean",
      description:
        "Whether this response is from a dry run (preview) or an actual apply",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SiteUploadPreviewRowDto",
      },
    },
    totalNew: {
      type: "number",
    },
    totalExisting: {
      type: "number",
    },
    totalErrors: {
      type: "number",
    },
    totalWarnings: {
      type: "number",
      description: "Rows carrying at least one warning (rows, not warnings)",
    },
  },
  required: [
    "dryRun",
    "results",
    "totalNew",
    "totalExisting",
    "totalErrors",
    "totalWarnings",
  ],
} as const;

export const $UploadSitesFileDto = {
  type: "object",
  properties: {
    file: {
      type: "string",
      format: "binary",
    },
    dryRun: {
      type: "boolean",
      description:
        "If true, validate and return preview without applying changes",
      default: false,
    },
  },
  required: ["file", "dryRun"],
} as const;

export const $SiteDetailsDto = {
  type: "object",
  properties: {
    devices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ClusterDeviceDto",
      },
    },
    regionId: {
      type: "number",
      nullable: true,
    },
    subRegionId: {
      type: "number",
      nullable: true,
    },
    operationalHours: {
      $ref: "#/components/schemas/OperationalHoursResponseDto",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    labelWithLeastSamples: {
      type: "string",
    },
    totalSamples: {
      type: "number",
    },
    totalLabels: {
      type: "number",
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
    region: {
      type: "string",
    },
    subRegion: {
      type: "string",
    },
    latitude: {
      type: "number",
    },
    longitude: {
      type: "number",
    },
    formattedAddress: {
      type: "string",
    },
    lookupTableId: {
      type: "number",
    },
    lookupTableName: {
      type: "string",
    },
    siteGroupId: {
      type: "number",
    },
    siteGroupName: {
      type: "string",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
  required: [
    "devices",
    "id",
    "name",
    "createdAt",
    "updatedAt",
    "labelWithLeastSamples",
    "totalSamples",
    "totalLabels",
    "tags",
  ],
} as const;

export const $UpdateSiteDto = {
  type: "object",
  properties: {
    regionId: {
      type: "number",
      nullable: true,
      minimum: 1,
      description:
        "Region id from the regions tables. null clears the region and its sub-region.",
    },
    subRegionId: {
      type: "number",
      nullable: true,
      minimum: 1,
      description:
        "Sub-region id from the regions tables; sets its region as well. null clears only the sub-region.",
    },
    isVisible: {
      type: "boolean",
    },
    activationTime: {
      format: "date-time",
      type: "string",
    },
    latitude: {
      type: "number",
    },
    longitude: {
      type: "number",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
    name: {
      type: "string",
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $SiteAgentDeploymentDto = {
  type: "object",
  properties: {
    agentVersion: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["agentVersion", "createdAt", "updatedAt"],
} as const;

export const $SiteServiceDeploymentsDto = {
  type: "object",
  properties: {
    serviceName: {
      type: "string",
    },
    version: {
      type: "string",
    },
    error: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    type: {
      type: "string",
    },
    runningStartTime: {
      format: "date-time",
      type: "string",
    },
    runningEndTime: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["serviceName", "version", "createdAt", "updatedAt"],
} as const;

export const $UpdateSiteDevicesBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkDevicesQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $DeleteSiteDeviceDto = {
  type: "object",
  properties: {
    deviceId: {
      type: "number",
    },
  },
  required: ["deviceId"],
} as const;

export const $BulkRegionRowsQueryDto = {
  type: "object",
  properties: {
    region: {
      type: "string",
      description: "Case-insensitive substring match on the region name",
    },
    subRegion: {
      type: "string",
      description: "Case-insensitive substring match on the sub-region name",
    },
    regionIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    subRegionIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    showInactive: {
      type: "boolean",
      description:
        "When true, list INACTIVE rows instead of active ones. Omitted or false = active only.",
    },
  },
} as const;

export const $RegionRowDto = {
  type: "object",
  properties: {
    subRegionId: {
      type: "number",
      nullable: true,
    },
    subRegion: {
      type: "string",
      nullable: true,
    },
    subRegionIsVisible: {
      type: "boolean",
      nullable: true,
    },
    siteCount: {
      type: "number",
      description:
        "Live sites assigned to this row. Reads 0 until ID-7058 backfills sites.region_id / sites.sub_region_id.",
    },
    deviceCount: {
      type: "number",
      description:
        "Devices at those same sites -- the two counts describe one set, so a row cannot report devices it has no sites for. Reads 0 until ID-7058 backfills.",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    regionId: {
      type: "number",
    },
    region: {
      type: "string",
    },
    regionIsVisible: {
      type: "boolean",
    },
  },
  required: [
    "subRegionId",
    "subRegion",
    "subRegionIsVisible",
    "siteCount",
    "deviceCount",
    "updatedAt",
    "regionId",
    "region",
    "regionIsVisible",
  ],
} as const;

export const $RegionRowOrderEnum = {
  type: "string",
  enum: ["region", "subRegion", "siteCount", "deviceCount", "updatedAt"],
} as const;

export const $RegionRowOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/RegionRowOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListRegionSummariesDto = {
  type: "object",
  properties: {
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/RegionRowOrderEnumSortOption",
      },
    },
    region: {
      type: "string",
      description: "Case-insensitive substring match on the region name",
    },
    subRegion: {
      type: "string",
      description: "Case-insensitive substring match on the sub-region name",
    },
    regionIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    subRegionIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    showInactive: {
      type: "boolean",
      description:
        "When true, list INACTIVE rows instead of active ones. Omitted or false = active only.",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $CreateRegionDto = {
  type: "object",
  properties: {
    regionId: {
      type: "number",
      description:
        "Attach to this existing region. Mutually exclusive with regionName.",
    },
    regionName: {
      type: "string",
      maxLength: 120,
      description:
        "Create (or reactivate) a region with this name. Mutually exclusive with regionId.",
    },
    subRegionName: {
      type: "string",
      maxLength: 120,
      description: "Optionally create a sub-region under the region above.",
    },
  },
} as const;

export const $CreateRegionResponseDto = {
  type: "object",
  properties: {
    region: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    subRegion: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/MinimalEntityDto",
        },
      ],
    },
  },
  required: ["region"],
} as const;

export const $MoveSubRegionsBulkDto = {
  type: "object",
  properties: {
    regionId: {
      type: "number",
      description: "The region the selected sub-regions are moved under.",
    },
    dryRun: {
      type: "boolean",
      description:
        "If true, validate the whole batch and report what WOULD happen without committing anything. The UI runs this first and only enables the real move once the preview comes back clean. REQUIRED -- unlike the inactivate verb this has no default, and an omitted flag is rejected rather than assumed. A move that silently previewed would look like a move that silently did nothing, and one that silently applied is the outcome all-or-nothing exists to prevent.",
    },
    query: {
      $ref: "#/components/schemas/BulkRegionRowsQueryDto",
    },
  },
  required: ["regionId", "dryRun", "query"],
} as const;

export const $MoveSubRegionConflictDto = {
  type: "object",
  properties: {
    subRegionId: {
      type: "number",
    },
    name: {
      type: "string",
    },
    reason: {
      type: "string",
    },
  },
  required: ["subRegionId", "name", "reason"],
} as const;

export const $MoveSubRegionsResultDto = {
  type: "object",
  properties: {
    dryRun: {
      type: "boolean",
      description:
        "Whether this was a preview (nothing committed) or a real move.",
    },
    applied: {
      type: "boolean",
      description:
        "True only when rows actually moved. False for a preview, and false when conflicts blocked the batch.",
    },
    eligible: {
      type: "number",
      description:
        "Sub-regions that would move. Non-zero even on a preview, and even when conflicts blocked the batch.",
    },
    moved: {
      type: "number",
      description:
        "Sub-regions re-parented. A dry run reports the REAL count it would move -- that is the point of previewing through the applying code path -- so read `applied` to tell a preview from a commit.",
    },
    sitesRealigned: {
      type: "number",
      description:
        "Sites whose region_id was realigned to the target because their sub_region_id moved. As with `moved`, a dry run reports the real count and rolls it back. Reads 0 until ID-7058 backfills those columns.",
    },
    conflicts: {
      description:
        "Names the target region already holds. ANY entry here means NOTHING was moved.",
      type: "array",
      items: {
        $ref: "#/components/schemas/MoveSubRegionConflictDto",
      },
    },
  },
  required: [
    "dryRun",
    "applied",
    "eligible",
    "moved",
    "sitesRealigned",
    "conflicts",
  ],
} as const;

export const $UpdateSubRegionDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
      maxLength: 120,
    },
    isVisible: {
      type: "boolean",
      description:
        "Set true to reactivate an inactivated sub-region. Inactivate through PATCH /regions/inactivateBulk.",
    },
  },
} as const;

export const $InactivateRowsBulkDto = {
  type: "object",
  properties: {
    dryRun: {
      type: "boolean",
      default: true,
      description:
        "Defaults to TRUE. A preview reports exactly what would be inactivated and commits nothing.",
    },
    query: {
      $ref: "#/components/schemas/BulkRegionRowsQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $AffectedEntityDto = {
  type: "object",
  properties: {
    region: {
      type: "string",
      nullable: true,
      description:
        "Parent region name, on a sub-region entry. Null on a region entry.",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "name"],
} as const;

export const $AffectedSiteDto = {
  type: "object",
  properties: {
    region: {
      type: "string",
      nullable: true,
      description: "Region the site is assigned to, by name.",
    },
    subRegion: {
      type: "string",
      nullable: true,
      description: "Sub-region the site is assigned to, by name.",
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
  },
  required: ["id", "name"],
} as const;

export const $InactivateRowsResultDto = {
  type: "object",
  properties: {
    dryRun: {
      type: "boolean",
      description:
        "Whether this was a preview (nothing committed) or a real inactivation.",
    },
    applied: {
      type: "boolean",
      description:
        "True only when rows were actually inactivated. Always false for a preview.",
    },
    regionsInactivated: {
      type: "number",
      description:
        "Regions inactivated, or that would be -- the region-only rows of the selection.",
    },
    subRegionsInactivated: {
      type: "number",
      description:
        "Sub-regions inactivated, or that would be: the selected paired rows, PLUS every sub-region cascading from a selected region-only row.",
    },
    sitesAffected: {
      type: "number",
      description:
        "How many sites are assigned to any of the above. They are NOT modified -- their assignment simply ends up pointing at something inactive, which is why the user is shown it before committing. The `sites` list is capped; this is the true total. Reads 0 until ID-7058 backfills the site columns.",
    },
    regions: {
      description: "The regions themselves, by name.",
      type: "array",
      items: {
        $ref: "#/components/schemas/AffectedEntityDto",
      },
    },
    subRegions: {
      description: "Every sub-region that goes with them, by name.",
      type: "array",
      items: {
        $ref: "#/components/schemas/AffectedEntityDto",
      },
    },
    sites: {
      description:
        "The affected sites, by name, capped at SITES_PREVIEW_LIMIT. EMPTY when nothing is assigned -- the normal answer until ID-7058 backfills. Compare against sitesAffected to tell a short list from a truncated one.",
      type: "array",
      items: {
        $ref: "#/components/schemas/AffectedSiteDto",
      },
    },
  },
  required: [
    "dryRun",
    "applied",
    "regionsInactivated",
    "subRegionsInactivated",
    "sitesAffected",
    "regions",
    "subRegions",
    "sites",
  ],
} as const;

export const $UpdateRegionDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
      maxLength: 120,
    },
    isVisible: {
      type: "boolean",
      description:
        "Set true to reactivate an inactivated region. Inactivate through PATCH /regions/inactivateBulk.",
    },
  },
} as const;

export const $RegionUploadRowDto = {
  type: "object",
  properties: {
    row: {
      type: "number",
      description:
        "1-based row number in the uploaded file, excluding the header",
    },
    region: {
      type: "string",
    },
    subRegion: {
      type: "string",
      nullable: true,
    },
    status: {
      enum: ["new", "unchanged", "reactivated", "error"],
      type: "string",
    },
    message: {
      type: "string",
      description: "Present when status is error",
    },
  },
  required: ["row", "region", "status"],
} as const;

export const $RegionsUploadResponseDto = {
  type: "object",
  properties: {
    dryRun: {
      type: "boolean",
      description:
        "Whether this was a preview (nothing committed) or a real apply",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/RegionUploadRowDto",
      },
    },
    totalNew: {
      type: "number",
    },
    totalUnchanged: {
      type: "number",
    },
    totalReactivated: {
      type: "number",
    },
    totalErrors: {
      type: "number",
    },
  },
  required: [
    "dryRun",
    "results",
    "totalNew",
    "totalUnchanged",
    "totalReactivated",
    "totalErrors",
  ],
} as const;

export const $UploadRegionsFileDto = {
  type: "object",
  properties: {
    file: {
      type: "string",
      format: "binary",
    },
    dryRun: {
      type: "boolean",
      description:
        "If true, validate and return a preview without applying anything",
      default: false,
    },
  },
  required: ["file", "dryRun"],
} as const;

export const $DownloadRegionsRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkRegionRowsQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $SiteGroupSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    sitesCount: {
      type: "number",
    },
    translatedLabelsCount: {
      type: "number",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    hasOperationalHours: {
      type: "boolean",
    },
  },
  required: [
    "id",
    "name",
    "sitesCount",
    "translatedLabelsCount",
    "createdAt",
    "updatedAt",
    "hasOperationalHours",
  ],
} as const;

export const $SiteGroupDetailsDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    sites: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    operationalHours: {
      $ref: "#/components/schemas/OperationalHoursResponseDto",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["id", "name", "sites", "createdAt", "updatedAt"],
} as const;

export const $SiteGroupOrderEnum = {
  type: "string",
  enum: ["name", "updatedAt"],
} as const;

export const $SiteGroupOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/SiteGroupOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListSiteGroupsSummaryDto = {
  type: "object",
  properties: {
    siteGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SiteGroupOrderEnumSortOption",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $BulkSiteGroupsQueryDto = {
  type: "object",
  properties: {
    siteGroupIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
  },
} as const;

export const $BulkUpsertSiteGroupsOperationalHoursDto = {
  type: "object",
  properties: {
    schedule: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CreateOperationalHoursEntryDto",
      },
    },
    query: {
      $ref: "#/components/schemas/BulkSiteGroupsQueryDto",
    },
    enabled: {
      type: "boolean",
    },
    timezone: {
      type: "string",
    },
  },
  required: ["schedule", "query", "enabled", "timezone"],
} as const;

export const $CreateSiteGroupDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["name"],
} as const;

export const $UpdateSiteGroupDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $UpdateSiteGroupSitesBulkDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/BulkSitesQueryDto",
    },
  },
  required: ["query"],
} as const;

export const $CatalogItemLabelDto = {
  type: "object",
  properties: {
    catalogItemId: {
      type: "number",
    },
    plu: {
      type: "string",
    },
    catalogItemName: {
      type: "string",
    },
    labelInGroup: {
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    updatedBy: {
      type: "string",
    },
  },
  required: [
    "catalogItemId",
    "plu",
    "catalogItemName",
    "labelInGroup",
    "updatedAt",
  ],
} as const;

export const $SiteGroupLabelsResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CatalogItemLabelDto",
      },
    },
    total: {
      type: "number",
    },
    page: {
      type: "number",
    },
    limit: {
      type: "number",
    },
  },
  required: ["results", "total", "page", "limit"],
} as const;

export const $ListSiteGroupLabelsDto = {
  type: "object",
  properties: {
    page: {
      type: "number",
      default: 1,
      minimum: 1,
    },
    limit: {
      type: "number",
      default: 50,
      minimum: 1,
    },
    search: {
      type: "string",
    },
  },
  required: ["page", "limit"],
} as const;

export const $BulkUpdateSiteGroupLabelsDto = {
  type: "object",
  properties: {
    labels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LabelUpdate",
      },
    },
    schedule: {
      $ref: "#/components/schemas/ScheduleJobScheduleDto",
    },
    name: {
      type: "string",
      description: "Custom job name. Overrides the auto-generated name.",
    },
    immediateApply: {
      type: "boolean",
      description:
        "Only meaningful when `schedule` is set: apply labels to the DB immediately and only defer device notification.",
      default: false,
    },
  },
  required: ["labels"],
} as const;

export const $CheckDuplicateLabelResponseDto = {
  type: "object",
  properties: {
    isDuplicate: {
      type: "boolean",
      description: "Whether a duplicate label exists in the site group",
      example: true,
    },
  },
  required: ["isDuplicate"],
} as const;

export const $EmailReportsScheduleJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/EmailReportsJobDataDto",
    },
  },
  required: ["name", "data"],
} as const;

export const $EmailReportsScheduledJobSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/EmailReportsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $ReportSubscriptionAudienceDto = {
  type: "object",
  properties: {
    external: {
      type: "number",
    },
    internal: {
      type: "number",
    },
    externalEmails: {
      type: "array",
      items: {
        type: "string",
      },
    },
    internalEmails: {
      type: "array",
      items: {
        type: "string",
      },
    },
    approverEmails: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: [
    "external",
    "internal",
    "externalEmails",
    "internalEmails",
    "approverEmails",
  ],
} as const;

export const $ReportSubscriptionSummaryDto = {
  type: "object",
  properties: {
    subscriptionId: {
      type: "number",
    },
    scheduledJobId: {
      type: "number",
    },
    isCustomReport: {
      type: "boolean",
    },
    isPending: {
      type: "boolean",
    },
    subscriptionName: {
      type: "string",
    },
    cron: {
      type: "string",
    },
    timezone: {
      type: "string",
    },
    lastSent: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    nextSend: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    audience: {
      $ref: "#/components/schemas/ReportSubscriptionAudienceDto",
    },
    createdBy: {
      $ref: "#/components/schemas/UserMinimalDto",
    },
  },
  required: [
    "subscriptionId",
    "scheduledJobId",
    "isCustomReport",
    "isPending",
    "subscriptionName",
    "cron",
    "timezone",
    "lastSent",
    "nextSend",
    "audience",
  ],
} as const;

export const $ReportSubscriptionDetailDto = {
  type: "object",
  properties: {
    subscriptionId: {
      type: "number",
    },
    jobId: {
      type: "number",
    },
    subscriptionName: {
      type: "string",
    },
    cron: {
      type: "string",
    },
    timezone: {
      type: "string",
    },
    lastSent: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    nextSend: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    isPending: {
      type: "boolean",
    },
    generatedDate: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    pendingSummaryText: {
      type: "string",
      nullable: true,
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    reportName: {
      type: "string",
    },
    accountName: {
      type: "string",
    },
    audience: {
      $ref: "#/components/schemas/ReportSubscriptionAudienceDto",
    },
    createdBy: {
      $ref: "#/components/schemas/UserMinimalDto",
    },
    data: {
      $ref: "#/components/schemas/EmailReportsJobDataDto",
    },
  },
  required: [
    "subscriptionId",
    "jobId",
    "subscriptionName",
    "cron",
    "timezone",
    "lastSent",
    "nextSend",
    "isPending",
    "generatedDate",
    "pendingSummaryText",
    "createdAt",
    "reportName",
    "accountName",
    "audience",
    "data",
  ],
} as const;

export const $FailedRecipientDto = {
  type: "object",
  properties: {
    address: {
      type: "string",
    },
    reason: {
      type: "string",
    },
  },
  required: ["address", "reason"],
} as const;

export const $SubscriptionSendHistoryEntryDto = {
  type: "object",
  properties: {
    jobId: {
      type: "number",
    },
    sentAt: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    state: {
      type: "string",
    },
    audience: {
      $ref: "#/components/schemas/ReportSubscriptionAudienceDto",
    },
    approvedBy: {
      type: "string",
      nullable: true,
    },
    approvalOutcome: {
      type: "string",
      nullable: true,
    },
    approvedAt: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    sendRecorded: {
      type: "boolean",
    },
    rejectedBy: {
      type: "string",
      nullable: true,
    },
    rejectedAt: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    rejectionNote: {
      type: "string",
      nullable: true,
    },
    hasSentCopy: {
      type: "boolean",
    },
    sentSubject: {
      type: "string",
      nullable: true,
    },
    sentTo: {
      nullable: true,
      type: "array",
      items: {
        type: "string",
      },
    },
    failedRecipients: {
      nullable: true,
      type: "array",
      items: {
        $ref: "#/components/schemas/FailedRecipientDto",
      },
    },
  },
  required: [
    "jobId",
    "sentAt",
    "state",
    "audience",
    "approvedBy",
    "approvalOutcome",
    "approvedAt",
    "sendRecorded",
    "rejectedBy",
    "rejectedAt",
    "rejectionNote",
    "hasSentCopy",
    "sentSubject",
    "sentTo",
    "failedRecipients",
  ],
} as const;

export const $RecentSendStateDto = {
  type: "object",
  properties: {
    state: {
      type: "string",
    },
    approvalOutcome: {
      type: "string",
      nullable: true,
    },
    sendRecorded: {
      type: "boolean",
    },
    hasFailedRecipients: {
      type: "boolean",
    },
  },
  required: ["state", "approvalOutcome", "sendRecorded", "hasFailedRecipients"],
} as const;

export const $SubscriptionSendHistorySummaryDto = {
  type: "object",
  properties: {
    windowSize: {
      type: "number",
    },
    sent: {
      type: "number",
    },
    failed: {
      type: "number",
    },
    rejected: {
      type: "number",
    },
    lapsed: {
      type: "number",
    },
    rate: {
      type: "number",
    },
    recentStates: {
      type: "array",
      items: {
        $ref: "#/components/schemas/RecentSendStateDto",
      },
    },
    availableOutcomeBuckets: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "rejected",
          "failed",
          "sent",
          "waitingApproval",
          "approvalExpired",
          "notSent",
          "inProgress",
        ],
      },
    },
  },
  required: [
    "windowSize",
    "sent",
    "failed",
    "rejected",
    "lapsed",
    "rate",
    "recentStates",
    "availableOutcomeBuckets",
  ],
} as const;

export const $SubscriptionSendHistoryResponseDto = {
  type: "object",
  properties: {
    results: {
      type: "array",
    },
    count: {
      type: "number",
    },
    countIsEstimate: {
      type: "boolean",
    },
    lastPage: {
      type: "number",
    },
    perPage: {
      type: "number",
    },
    total: {
      type: "number",
    },
    totalIsEstimate: {
      type: "boolean",
    },
    limit: {
      type: "number",
    },
    page: {
      type: "number",
    },
    summary: {
      $ref: "#/components/schemas/SubscriptionSendHistorySummaryDto",
    },
  },
  required: ["results", "total", "limit", "page", "summary"],
} as const;

export const $ExportSubscriptionSendHistoryDto = {
  type: "object",
  properties: {
    subscriptionId: {
      type: "number",
    },
    maxRows: {
      type: "number",
    },
    since: {
      format: "date-time",
      type: "string",
    },
    until: {
      format: "date-time",
      type: "string",
    },
    outcomes: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "rejected",
          "failed",
          "sent",
          "waitingApproval",
          "approvalExpired",
          "notSent",
          "inProgress",
        ],
      },
    },
  },
  required: ["subscriptionId"],
} as const;

export const $DownloadSubscriptionSendHistoryRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/ExportSubscriptionSendHistoryDto",
    },
  },
  required: ["query"],
} as const;

export const $ReportSendLogAttentionItemDto = {
  type: "object",
  properties: {
    subscriptionId: {
      type: "number",
    },
    subscriptionName: {
      type: "string",
    },
    since: {
      format: "date-time",
      type: "string",
    },
    reason: {
      type: "string",
    },
    isCustomReport: {
      type: "boolean",
    },
  },
  required: [
    "subscriptionId",
    "subscriptionName",
    "since",
    "reason",
    "isCustomReport",
  ],
} as const;

export const $ReportSendLogUpcomingItemDto = {
  type: "object",
  properties: {
    subscriptionId: {
      type: "number",
    },
    subscriptionName: {
      type: "string",
    },
    nextSend: {
      format: "date-time",
      type: "string",
    },
    audience: {
      $ref: "#/components/schemas/ReportSubscriptionAudienceDto",
    },
    requiresApproval: {
      type: "boolean",
    },
    isCustomReport: {
      type: "boolean",
    },
  },
  required: [
    "subscriptionId",
    "subscriptionName",
    "nextSend",
    "audience",
    "requiresApproval",
    "isCustomReport",
  ],
} as const;

export const $ReportSendLogRecentItemDto = {
  type: "object",
  properties: {
    jobId: {
      type: "number",
    },
    subscriptionId: {
      type: "number",
    },
    subscriptionName: {
      type: "string",
    },
    sentAt: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    state: {
      type: "string",
    },
    approvalOutcome: {
      type: "string",
      nullable: true,
    },
    approvedAt: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    sendRecorded: {
      type: "boolean",
    },
    approvedBy: {
      type: "string",
      nullable: true,
    },
    audience: {
      $ref: "#/components/schemas/ReportSubscriptionAudienceDto",
    },
    hasSentCopy: {
      type: "boolean",
    },
    sentSubject: {
      type: "string",
      nullable: true,
    },
    sentTo: {
      nullable: true,
      type: "array",
      items: {
        type: "string",
      },
    },
    failedRecipients: {
      nullable: true,
      type: "array",
      items: {
        $ref: "#/components/schemas/FailedRecipientDto",
      },
    },
    isCustomReport: {
      type: "boolean",
    },
  },
  required: [
    "jobId",
    "subscriptionId",
    "subscriptionName",
    "sentAt",
    "state",
    "approvalOutcome",
    "approvedAt",
    "sendRecorded",
    "approvedBy",
    "audience",
    "hasSentCopy",
    "sentSubject",
    "sentTo",
    "failedRecipients",
    "isCustomReport",
  ],
} as const;

export const $ReportSendLogResponseDto = {
  type: "object",
  properties: {
    summary: {
      $ref: "#/components/schemas/SubscriptionSendHistorySummaryDto",
    },
    needsAttention: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ReportSendLogAttentionItemDto",
      },
    },
    upcoming: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ReportSendLogUpcomingItemDto",
      },
    },
    recent: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ReportSendLogRecentItemDto",
      },
    },
  },
  required: ["summary", "needsAttention", "upcoming", "recent"],
} as const;

export const $EmailReportsUpdateScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/EmailReportsJobDataDto",
    },
  },
} as const;

export const $EmailReportsScheduledJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    every: {
      type: "number",
      description: "in milliseconds",
    },
    duration: {
      type: "number",
      description: "in milliseconds",
    },
    timezone: {
      type: "string",
    },
    cronStart: {
      type: "string",
    },
    cronEnd: {
      type: "string",
    },
    startDate: {
      type: "string",
      format: "date-time",
    },
    endDate: {
      type: "string",
      format: "date-time",
    },
    runOnce: {
      type: "boolean",
    },
    data: {
      $ref: "#/components/schemas/EmailReportsJobDataDto",
    },
    id: {
      type: "number",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    scheduled: {
      type: "boolean",
    },
    shouldBeScheduled: {
      type: "boolean",
    },
    scheduleError: {
      type: "string",
    },
    latestJobId: {
      type: "number",
    },
    warnings: {
      description: "Scheduling warnings intended for UI display",
      type: "array",
      items: {
        type: "string",
      },
    },
    description: {
      type: "string",
    },
  },
  required: ["name", "data", "id", "createdAt", "updatedAt"],
} as const;

export const $SendPendingReportDto = {
  type: "object",
  properties: {
    jobId: {
      type: "number",
    },
  },
  required: ["jobId"],
} as const;

export const $SendPendingReportResponseDto = {
  type: "object",
  properties: {
    failedRecipients: {
      type: "array",
      items: {
        type: "string",
      },
    },
    success: {
      type: "boolean",
    },
    totalEmails: {
      type: "number",
    },
    successfulSends: {
      type: "number",
    },
    failedSends: {
      type: "number",
    },
  },
  required: [
    "failedRecipients",
    "success",
    "totalEmails",
    "successfulSends",
    "failedSends",
  ],
} as const;

export const $RejectPendingReportDto = {
  type: "object",
  properties: {
    jobId: {
      type: "number",
    },
    note: {
      type: "string",
      maxLength: 2000,
    },
  },
  required: ["jobId"],
} as const;

export const $PreviewTemplateDto = {
  type: "object",
  properties: {
    subscriptionId: {
      type: "number",
    },
    summaryText: {
      type: "string",
    },
    customReportQuestions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetabaseQuestion",
      },
    },
    summaryTable: {
      $ref: "#/components/schemas/MetabaseQuestion",
    },
  },
  required: ["subscriptionId"],
} as const;

export const $UpdateSummaryTextDto = {
  type: "object",
  properties: {
    subscriptionId: {
      type: "number",
    },
    summaryText: {
      type: "string",
    },
  },
  required: ["subscriptionId", "summaryText"],
} as const;

export const $EmailReportsDataWithNameDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    mailingList: {
      minItems: 1,
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    internalMailingList: {
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    approvers: {
      type: "array",
      items: {
        type: "string",
        format: "email",
      },
    },
    reportUrl: {
      type: "string",
    },
    reportName: {
      type: "string",
    },
    reportId: {
      type: "number",
    },
    addAttachments: {
      type: "boolean",
    },
    fileType: {
      type: "string",
    },
    selectedQuestions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetabaseQuestion",
      },
    },
    customReportQuestions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetabaseQuestion",
      },
    },
    summaryTable: {
      $ref: "#/components/schemas/MetabaseQuestion",
    },
    summaryText: {
      type: "string",
    },
    subject: {
      type: "string",
    },
    isCustomReport: {
      type: "boolean",
    },
  },
  required: ["mailingList", "reportUrl", "reportName"],
} as const;

export const $EmailReportsJobDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/EmailReportsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      items: {
        $ref: "#/components/schemas/JobDeviceDto",
      },
      type: "array",
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    description: {
      type: "string",
    },
  },
  required: ["id", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $EmailReportsJobSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    createdAt: {
      type: "string",
      format: "date-time",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    data: {
      $ref: "#/components/schemas/EmailReportsJobDataDto",
    },
    done: {
      type: "number",
    },
    failures: {
      type: "number",
    },
    pending: {
      type: "number",
    },
    cancelled: {
      type: "number",
    },
    expired: {
      type: "number",
    },
    total: {
      type: "number",
    },
    durationMs: {
      type: "number",
      description: "in milliseconds",
    },
    state: {
      type: "string",
      enum: [
        "pending",
        "running",
        "done",
        "failed",
        "cancelled",
        "cancelling",
        "suspended",
        "aborted",
      ],
    },
    devices: {
      type: "array",
      items: {
        type: "#/components/schemas/MinimalEntityDto",
      },
    },
    scheduledJob: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["id", "createdAt", "updatedAt", "data", "state"],
} as const;

export const $EmailReportsUpdateJobDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
  },
} as const;

export const $PendingActionEnum = {
  type: "string",
  enum: ["upload", "delete", "relabel", "family"],
} as const;

export const $PendingOrderEnum = {
  type: "string",
  enum: ["lastAttempted", "actionTime"],
} as const;

export const $PendingOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/PendingOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListPendingSamplesSummaryQueryDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    operationIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    actions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PendingActionEnum",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PendingOrderEnumSortOption",
      },
    },
    uuid: {
      type: "string",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    ownedByMe: {
      type: "boolean",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $PendingSampleDetailsDto = {
  type: "object",
  properties: {
    toDelete: {
      type: "boolean",
      nullable: true,
    },
    toUpload: {
      type: "boolean",
      nullable: true,
    },
    deleteAfterUpload: {
      type: "boolean",
      nullable: true,
    },
    uploadOperationId: {
      type: "number",
      nullable: true,
    },
    uploadStartedAt: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    uploadCancelRequestedAt: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    label: {
      type: "string",
      nullable: true,
    },
    family: {
      type: "string",
      nullable: true,
    },
    lastErrorMessage: {
      type: "string",
      nullable: true,
    },
    id: {
      type: "number",
    },
    uuid: {
      type: "string",
    },
    deviceId: {
      type: "number",
    },
    deviceName: {
      type: "string",
    },
    agentVersion: {
      type: "string",
    },
    uploadOwnedByCurrentUser: {
      type: "boolean",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "id",
    "uuid",
    "deviceId",
    "deviceName",
    "agentVersion",
    "uploadOwnedByCurrentUser",
    "createdAt",
    "updatedAt",
  ],
} as const;

export const $UploadOperationOrderEnum = {
  type: "string",
  enum: ["createdAt"],
} as const;

export const $UploadOperationOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/UploadOperationOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListUploadOperationsQueryDto = {
  type: "object",
  properties: {
    operationIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/UploadOperationOrderEnumSortOption",
      },
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
    ownedByMe: {
      type: "boolean",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $PendingUploadOperationDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    deleteAfterUpload: {
      type: "boolean",
    },
    remaining: {
      type: "number",
    },
    cancellationRequested: {
      type: "number",
    },
    ownedByCurrentUser: {
      type: "boolean",
    },
  },
  required: [
    "id",
    "createdAt",
    "deleteAfterUpload",
    "remaining",
    "cancellationRequested",
    "ownedByCurrentUser",
  ],
} as const;

export const $UploadOperationCancellationResultDto = {
  type: "object",
  properties: {
    operationId: {
      type: "number",
    },
    cancelledBeforeStart: {
      type: "number",
    },
    alreadyStarted: {
      type: "number",
    },
    notOwnedOrNotCancellable: {
      type: "number",
    },
  },
  required: [
    "operationId",
    "cancelledBeforeStart",
    "alreadyStarted",
    "notOwnedOrNotCancellable",
  ],
} as const;

export const $CancelPendingUploadsDto = {
  type: "object",
  properties: {
    allFiltered: {
      type: "boolean",
      description:
        "Set to true to cancel all rows matching the supplied pending-row filters (and optional exclusions)",
    },
    uuid: {
      type: "string",
      format: "uuid",
      description: "Pending-row UUID filter for all-filtered cancellation",
    },
    ids: {
      description: "Explicit pending row IDs to cancel",
      type: "array",
      items: {
        type: "number",
      },
    },
    uuids: {
      description: "Explicit pending sample UUIDs to cancel",
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    excludedIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    excludedUuids: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    operationIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    actions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/PendingActionEnum",
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    ownedByMe: {
      type: "boolean",
    },
    from: {
      format: "date-time",
      type: "string",
    },
    to: {
      format: "date-time",
      type: "string",
    },
  },
} as const;

export const $UploadCancellationResultDto = {
  type: "object",
  properties: {
    cancelledBeforeStart: {
      type: "number",
    },
    alreadyStarted: {
      type: "number",
    },
    notOwnedOrNotCancellable: {
      type: "number",
    },
  },
  required: [
    "cancelledBeforeStart",
    "alreadyStarted",
    "notOwnedOrNotCancellable",
  ],
} as const;

export const $CreateDashboardAlertDto = {
  type: "object",
  properties: {
    errorMessages: {
      type: "string",
    },
    stackTrace: {
      type: "string",
    },
    fullStoryUrl: {
      type: "string",
    },
  },
  required: ["errorMessages", "stackTrace"],
} as const;

export const $AlertType = {
  type: "string",
  enum: [
    "DeviceDown",
    "ServerDown",
    "CameraDown",
    "HighResourceUsage",
    "LookupTableDisabled",
    "DeployedModelFailure",
    "RegisterDisabledDeviceAttempt",
    "RegisterDuplicateDeviceAttempt",
    "TrainingFailed",
    "NonScanDetectorDown",
    "OnScreenAppDown",
    "ZebraAdapterDown",
    "AgentPortClash",
    "LockedSamplesAboveThreshold",
    "FailedToStoreSampleLackOfStorage",
    "BlackScreenImageDetected",
    "LocalStorageAlmostFull",
    "AgentDoesNotReachEdgibox",
    "VideoUploadError",
    "ImageUploadError",
    "PredictorDisabled",
    "NonScanDetectorRepeatedFpsDrops",
    "ModelBelowKpiThreshold",
    "TrainingWarnings",
    "LookupTableMismatch",
    "MetricThresholdBreach",
    "ServiceDown",
    "DataCompletenessBelowThreshold",
    "DeviceDownEscalated",
    "ServerDownEscalated",
    "CameraDownEscalated",
    "HighResourceUsageEscalated",
    "LookupTableDisabledEscalated",
    "DeployedModelFailureEscalated",
    "NonScanDetectorDownEscalated",
    "OnScreenAppDownEscalated",
    "ZebraAdapterDownEscalated",
    "AgentPortClashEscalated",
    "LockedSamplesAboveThresholdEscalated",
    "FailedToStoreSampleLackOfStorageEscalated",
    "BlackScreenImageDetectedEscalated",
    "LocalStorageAlmostFullEscalated",
    "AgentDoesNotReachEdgiboxEscalated",
    "VideoUploadErrorEscalated",
    "ImageUploadErrorEscalated",
    "PredictorDisabledEscalated",
    "NonScanDetectorRepeatedFpsDropsEscalated",
  ],
} as const;

export const $EmitTestAlertDto = {
  type: "object",
  properties: {
    alertType: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertType",
        },
      ],
    },
    deviceId: {
      type: "number",
      minimum: 1,
      description:
        "Optional device id to use for test-alert context enrichment",
    },
    alertAction: {
      enum: ["Alert", "Resolve"],
      type: "string",
    },
  },
  required: ["alertType", "alertAction"],
} as const;

export const $UpdateAccountAlertDto = {
  type: "object",
  properties: {
    isEnabled: {
      type: "boolean",
    },
  },
  required: ["isEnabled"],
} as const;

export const $ConfiguredAlertChannelDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    channelType: {
      type: "string",
      enum: ["email", "JIRA", "slack", "webhook"],
    },
    name: {
      type: "string",
      nullable: true,
    },
    username: {
      type: "string",
    },
    url: {
      type: "string",
    },
    configurationInfo: {
      type: "object",
    },
    isGlobal: {
      type: "boolean",
    },
  },
  required: [
    "id",
    "channelType",
    "name",
    "username",
    "url",
    "configurationInfo",
    "isGlobal",
  ],
} as const;

export const $AlertChannelsResponseDto = {
  type: "object",
  properties: {
    alertsEnabled: {
      type: "boolean",
    },
    configuredAlertChannels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ConfiguredAlertChannelDto",
      },
    },
  },
  required: ["alertsEnabled", "configuredAlertChannels"],
} as const;

export const $ListAlertDeliveriesRequestDto = {
  type: "object",
  properties: {
    limit: {
      type: "number",
      maximum: 100,
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $AlertDeliveryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    eventId: {
      type: "string",
    },
    alertType: {
      type: "string",
      enum: [
        "DeviceDown",
        "ServerDown",
        "CameraDown",
        "HighResourceUsage",
        "LookupTableDisabled",
        "DeployedModelFailure",
        "RegisterDisabledDeviceAttempt",
        "RegisterDuplicateDeviceAttempt",
        "TrainingFailed",
        "NonScanDetectorDown",
        "OnScreenAppDown",
        "ZebraAdapterDown",
        "AgentPortClash",
        "LockedSamplesAboveThreshold",
        "FailedToStoreSampleLackOfStorage",
        "BlackScreenImageDetected",
        "LocalStorageAlmostFull",
        "AgentDoesNotReachEdgibox",
        "VideoUploadError",
        "ImageUploadError",
        "PredictorDisabled",
        "NonScanDetectorRepeatedFpsDrops",
        "ModelBelowKpiThreshold",
        "TrainingWarnings",
        "LookupTableMismatch",
        "MetricThresholdBreach",
        "ServiceDown",
        "DataCompletenessBelowThreshold",
        "DeviceDownEscalated",
        "ServerDownEscalated",
        "CameraDownEscalated",
        "HighResourceUsageEscalated",
        "LookupTableDisabledEscalated",
        "DeployedModelFailureEscalated",
        "NonScanDetectorDownEscalated",
        "OnScreenAppDownEscalated",
        "ZebraAdapterDownEscalated",
        "AgentPortClashEscalated",
        "LockedSamplesAboveThresholdEscalated",
        "FailedToStoreSampleLackOfStorageEscalated",
        "BlackScreenImageDetectedEscalated",
        "LocalStorageAlmostFullEscalated",
        "AgentDoesNotReachEdgiboxEscalated",
        "VideoUploadErrorEscalated",
        "ImageUploadErrorEscalated",
        "PredictorDisabledEscalated",
        "NonScanDetectorRepeatedFpsDropsEscalated",
      ],
    },
    status: {
      type: "string",
      enum: ["Open", "Closed"],
    },
    attempt: {
      type: "number",
    },
    success: {
      type: "boolean",
    },
    httpStatus: {
      type: "number",
      nullable: true,
    },
    error: {
      type: "string",
      nullable: true,
    },
    requestPayload: {
      type: "object",
    },
    responseBody: {
      type: "object",
    },
    deviceId: {
      type: "number",
      nullable: true,
    },
    deviceName: {
      type: "string",
      nullable: true,
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "id",
    "eventId",
    "alertType",
    "status",
    "attempt",
    "success",
    "httpStatus",
    "error",
    "requestPayload",
    "responseBody",
    "deviceId",
    "deviceName",
    "createdAt",
  ],
} as const;

export const $AuthenticationFieldsDto = {
  type: "object",
  properties: {
    username: {
      type: "string",
    },
    password: {
      type: "string",
    },
    token: {
      type: "string",
    },
    url: {
      type: "string",
    },
  },
} as const;

export const $CreateAlertChannelDto = {
  type: "object",
  properties: {
    channelType: {
      enum: ["email", "JIRA", "slack", "webhook"],
      type: "string",
    },
    name: {
      type: "string",
      maxLength: 100,
    },
    editsViaPatch: {
      type: "boolean",
    },
    authenticationInfo: {
      $ref: "#/components/schemas/AuthenticationFieldsDto",
    },
    configurationInfo: {
      type: "object",
    },
  },
  required: ["channelType", "authenticationInfo"],
} as const;

export const $UpdateAlertChannelDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
      nullable: true,
      maxLength: 100,
    },
    authenticationInfo: {
      $ref: "#/components/schemas/AuthenticationFieldsDto",
    },
    configurationInfo: {
      type: "object",
    },
  },
} as const;

export const $AlertPriority = {
  type: "string",
  enum: ["Minor", "Normal", "Urgent", "Blocker"],
} as const;

export const $AlertSeverity = {
  type: "string",
  enum: ["Low", "Medium", "High"],
} as const;

export const $ManagedAlertsOrderEnum = {
  type: "string",
  enum: ["createdAt", "updatedAt", "name", "priority", "severity"],
} as const;

export const $ManagedAlertsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ManagedAlertsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListManagedAlertsRequestDto = {
  type: "object",
  properties: {
    priority: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertPriority",
      },
    },
    severity: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertSeverity",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ManagedAlertsOrderEnumSortOption",
      },
    },
    eventIds: {
      type: "array",
      items: {
        type: "string",
      },
    },
    status: {
      type: "array",
      items: {
        type: "string",
        enum: ["Open", "Closed"],
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    alertTypes: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "DeviceDown",
          "ServerDown",
          "CameraDown",
          "HighResourceUsage",
          "LookupTableDisabled",
          "DeployedModelFailure",
          "RegisterDisabledDeviceAttempt",
          "RegisterDuplicateDeviceAttempt",
          "TrainingFailed",
          "NonScanDetectorDown",
          "OnScreenAppDown",
          "ZebraAdapterDown",
          "AgentPortClash",
          "LockedSamplesAboveThreshold",
          "FailedToStoreSampleLackOfStorage",
          "BlackScreenImageDetected",
          "LocalStorageAlmostFull",
          "AgentDoesNotReachEdgibox",
          "VideoUploadError",
          "ImageUploadError",
          "PredictorDisabled",
          "NonScanDetectorRepeatedFpsDrops",
          "ModelBelowKpiThreshold",
          "TrainingWarnings",
          "LookupTableMismatch",
          "MetricThresholdBreach",
          "ServiceDown",
          "DataCompletenessBelowThreshold",
          "DeviceDownEscalated",
          "ServerDownEscalated",
          "CameraDownEscalated",
          "HighResourceUsageEscalated",
          "LookupTableDisabledEscalated",
          "DeployedModelFailureEscalated",
          "NonScanDetectorDownEscalated",
          "OnScreenAppDownEscalated",
          "ZebraAdapterDownEscalated",
          "AgentPortClashEscalated",
          "LockedSamplesAboveThresholdEscalated",
          "FailedToStoreSampleLackOfStorageEscalated",
          "BlackScreenImageDetectedEscalated",
          "LocalStorageAlmostFullEscalated",
          "AgentDoesNotReachEdgiboxEscalated",
          "VideoUploadErrorEscalated",
          "ImageUploadErrorEscalated",
          "PredictorDisabledEscalated",
          "NonScanDetectorRepeatedFpsDropsEscalated",
        ],
      },
    },
    name: {
      type: "string",
    },
    alertKey: {
      type: "string",
    },
    escalated: {
      type: "boolean",
    },
    fromDate: {
      format: "date-time",
      type: "string",
    },
    toDate: {
      format: "date-time",
      type: "string",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $ManagedAlertListItemAlertDto = {
  type: "object",
  properties: {
    alertType: {
      type: "string",
      enum: [
        "DeviceDown",
        "ServerDown",
        "CameraDown",
        "HighResourceUsage",
        "LookupTableDisabled",
        "DeployedModelFailure",
        "RegisterDisabledDeviceAttempt",
        "RegisterDuplicateDeviceAttempt",
        "TrainingFailed",
        "NonScanDetectorDown",
        "OnScreenAppDown",
        "ZebraAdapterDown",
        "AgentPortClash",
        "LockedSamplesAboveThreshold",
        "FailedToStoreSampleLackOfStorage",
        "BlackScreenImageDetected",
        "LocalStorageAlmostFull",
        "AgentDoesNotReachEdgibox",
        "VideoUploadError",
        "ImageUploadError",
        "PredictorDisabled",
        "NonScanDetectorRepeatedFpsDrops",
        "ModelBelowKpiThreshold",
        "TrainingWarnings",
        "LookupTableMismatch",
        "MetricThresholdBreach",
        "ServiceDown",
        "DataCompletenessBelowThreshold",
        "DeviceDownEscalated",
        "ServerDownEscalated",
        "CameraDownEscalated",
        "HighResourceUsageEscalated",
        "LookupTableDisabledEscalated",
        "DeployedModelFailureEscalated",
        "NonScanDetectorDownEscalated",
        "OnScreenAppDownEscalated",
        "ZebraAdapterDownEscalated",
        "AgentPortClashEscalated",
        "LockedSamplesAboveThresholdEscalated",
        "FailedToStoreSampleLackOfStorageEscalated",
        "BlackScreenImageDetectedEscalated",
        "LocalStorageAlmostFullEscalated",
        "AgentDoesNotReachEdgiboxEscalated",
        "VideoUploadErrorEscalated",
        "ImageUploadErrorEscalated",
        "PredictorDisabledEscalated",
        "NonScanDetectorRepeatedFpsDropsEscalated",
      ],
    },
    id: {
      type: "number",
    },
    parentSpecId: {
      type: "number",
      nullable: true,
    },
  },
  required: ["alertType", "id", "parentSpecId"],
} as const;

export const $AlertChannelType = {
  type: "string",
  enum: ["JIRA", "email", "slack", "webhook"],
} as const;

export const $ManagedAlertChannelDto = {
  type: "object",
  properties: {
    alertChannelType: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertChannelType",
        },
      ],
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
      nullable: true,
    },
    url: {
      type: "string",
      nullable: true,
    },
    configurationInfo: {
      type: "object",
    },
    isGlobal: {
      type: "boolean",
    },
  },
  required: ["alertChannelType", "id", "name", "isGlobal"],
} as const;

export const $ManagedAlertListItemDto = {
  type: "object",
  properties: {
    priority: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    severity: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/AlertSeverity",
        },
      ],
    },
    deviceId: {
      type: "number",
      nullable: true,
    },
    accountId: {
      type: "number",
    },
    id: {
      type: "number",
    },
    alertSubscriptionId: {
      type: "number",
    },
    channelName: {
      type: "string",
    },
    alertSpecId: {
      type: "number",
    },
    status: {
      type: "string",
      enum: ["Open", "Closed"],
    },
    title: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    managedAlertKey: {
      type: "string",
      nullable: true,
    },
    alertSpec: {
      $ref: "#/components/schemas/ManagedAlertListItemAlertDto",
    },
    alertChannel: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/ManagedAlertChannelDto",
        },
      ],
    },
  },
  required: [
    "priority",
    "severity",
    "deviceId",
    "accountId",
    "id",
    "alertSubscriptionId",
    "channelName",
    "alertSpecId",
    "status",
    "title",
    "createdAt",
    "updatedAt",
    "managedAlertKey",
    "alertSpec",
    "alertChannel",
  ],
} as const;

export const $ExportManagedAlertsDto = {
  type: "object",
  properties: {
    priority: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertPriority",
      },
    },
    severity: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertSeverity",
      },
    },
    maxRows: {
      type: "number",
      minimum: 1,
      description:
        "Backend-only row cap override. Not exposed in the UI; omit to use the default.",
    },
    eventIds: {
      type: "array",
      items: {
        type: "string",
      },
    },
    status: {
      type: "array",
      items: {
        type: "string",
        enum: ["Open", "Closed"],
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    alertTypes: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "DeviceDown",
          "ServerDown",
          "CameraDown",
          "HighResourceUsage",
          "LookupTableDisabled",
          "DeployedModelFailure",
          "RegisterDisabledDeviceAttempt",
          "RegisterDuplicateDeviceAttempt",
          "TrainingFailed",
          "NonScanDetectorDown",
          "OnScreenAppDown",
          "ZebraAdapterDown",
          "AgentPortClash",
          "LockedSamplesAboveThreshold",
          "FailedToStoreSampleLackOfStorage",
          "BlackScreenImageDetected",
          "LocalStorageAlmostFull",
          "AgentDoesNotReachEdgibox",
          "VideoUploadError",
          "ImageUploadError",
          "PredictorDisabled",
          "NonScanDetectorRepeatedFpsDrops",
          "ModelBelowKpiThreshold",
          "TrainingWarnings",
          "LookupTableMismatch",
          "MetricThresholdBreach",
          "ServiceDown",
          "DataCompletenessBelowThreshold",
          "DeviceDownEscalated",
          "ServerDownEscalated",
          "CameraDownEscalated",
          "HighResourceUsageEscalated",
          "LookupTableDisabledEscalated",
          "DeployedModelFailureEscalated",
          "NonScanDetectorDownEscalated",
          "OnScreenAppDownEscalated",
          "ZebraAdapterDownEscalated",
          "AgentPortClashEscalated",
          "LockedSamplesAboveThresholdEscalated",
          "FailedToStoreSampleLackOfStorageEscalated",
          "BlackScreenImageDetectedEscalated",
          "LocalStorageAlmostFullEscalated",
          "AgentDoesNotReachEdgiboxEscalated",
          "VideoUploadErrorEscalated",
          "ImageUploadErrorEscalated",
          "PredictorDisabledEscalated",
          "NonScanDetectorRepeatedFpsDropsEscalated",
        ],
      },
    },
    name: {
      type: "string",
    },
    alertKey: {
      type: "string",
    },
    escalated: {
      type: "boolean",
    },
    fromDate: {
      format: "date-time",
      type: "string",
    },
    toDate: {
      format: "date-time",
      type: "string",
    },
  },
} as const;

export const $DownloadManagedAlertsRequestDto = {
  type: "object",
  properties: {
    query: {
      $ref: "#/components/schemas/ExportManagedAlertsDto",
    },
  },
  required: ["query"],
} as const;

export const $GroupedManagedAlertDto = {
  type: "object",
  properties: {
    priority: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    severity: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/AlertSeverity",
        },
      ],
    },
    eventId: {
      type: "string",
    },
    status: {
      type: "string",
      enum: ["Open", "Closed"],
    },
    title: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    alertCount: {
      type: "number",
    },
    relatedAlerts: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ManagedAlertListItemDto",
      },
    },
  },
  required: [
    "priority",
    "severity",
    "eventId",
    "status",
    "title",
    "createdAt",
    "updatedAt",
    "alertCount",
    "relatedAlerts",
  ],
} as const;

export const $AlertAction = {
  type: "string",
  enum: ["Alert", "Resolve"],
} as const;

export const $UpdateManagedAlertStatusDto = {
  type: "object",
  properties: {
    alertAction: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertAction",
        },
      ],
    },
  },
  required: ["alertAction"],
} as const;

export const $BulkAlertAction = {
  type: "string",
  enum: ["Resolve"],
} as const;

export const $BulkManagedAlertsQueryDto = {
  type: "object",
  properties: {
    priority: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertPriority",
      },
    },
    severity: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertSeverity",
      },
    },
    eventIds: {
      type: "array",
      items: {
        type: "string",
      },
    },
    status: {
      type: "array",
      items: {
        type: "string",
        enum: ["Open", "Closed"],
      },
    },
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    alertTypes: {
      type: "array",
      items: {
        type: "string",
        enum: [
          "DeviceDown",
          "ServerDown",
          "CameraDown",
          "HighResourceUsage",
          "LookupTableDisabled",
          "DeployedModelFailure",
          "RegisterDisabledDeviceAttempt",
          "RegisterDuplicateDeviceAttempt",
          "TrainingFailed",
          "NonScanDetectorDown",
          "OnScreenAppDown",
          "ZebraAdapterDown",
          "AgentPortClash",
          "LockedSamplesAboveThreshold",
          "FailedToStoreSampleLackOfStorage",
          "BlackScreenImageDetected",
          "LocalStorageAlmostFull",
          "AgentDoesNotReachEdgibox",
          "VideoUploadError",
          "ImageUploadError",
          "PredictorDisabled",
          "NonScanDetectorRepeatedFpsDrops",
          "ModelBelowKpiThreshold",
          "TrainingWarnings",
          "LookupTableMismatch",
          "MetricThresholdBreach",
          "ServiceDown",
          "DataCompletenessBelowThreshold",
          "DeviceDownEscalated",
          "ServerDownEscalated",
          "CameraDownEscalated",
          "HighResourceUsageEscalated",
          "LookupTableDisabledEscalated",
          "DeployedModelFailureEscalated",
          "NonScanDetectorDownEscalated",
          "OnScreenAppDownEscalated",
          "ZebraAdapterDownEscalated",
          "AgentPortClashEscalated",
          "LockedSamplesAboveThresholdEscalated",
          "FailedToStoreSampleLackOfStorageEscalated",
          "BlackScreenImageDetectedEscalated",
          "LocalStorageAlmostFullEscalated",
          "AgentDoesNotReachEdgiboxEscalated",
          "VideoUploadErrorEscalated",
          "ImageUploadErrorEscalated",
          "PredictorDisabledEscalated",
          "NonScanDetectorRepeatedFpsDropsEscalated",
        ],
      },
    },
    name: {
      type: "string",
    },
    alertKey: {
      type: "string",
    },
    escalated: {
      type: "boolean",
    },
    fromDate: {
      format: "date-time",
      type: "string",
    },
    toDate: {
      format: "date-time",
      type: "string",
    },
  },
} as const;

export const $UpdateManagedAlertStatusBulkDto = {
  type: "object",
  properties: {
    alertAction: {
      allOf: [
        {
          $ref: "#/components/schemas/BulkAlertAction",
        },
      ],
    },
    query: {
      $ref: "#/components/schemas/BulkManagedAlertsQueryDto",
    },
  },
  required: ["alertAction", "query"],
} as const;

export const $AlertSpecsOrderEnum = {
  type: "string",
  enum: ["alertType", "priority", "severity"],
} as const;

export const $AlertSpecsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertSpecsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListAlertsRequestDto = {
  type: "object",
  properties: {
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertSpecsOrderEnumSortOption",
      },
    },
    priority: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertPriority",
      },
    },
    severity: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertSeverity",
      },
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    enabled: {
      type: "boolean",
    },
    includeEscalated: {
      type: "boolean",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $AlertSubscriptionItemDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
      nullable: true,
    },
    alertChannelId: {
      type: "number",
    },
    channelName: {
      type: "string",
    },
    name: {
      type: "string",
      nullable: true,
    },
    channelType: {
      type: "string",
      enum: ["email", "JIRA", "slack", "webhook"],
    },
    isEnabled: {
      type: "boolean",
    },
    isGlobal: {
      type: "boolean",
    },
  },
  required: [
    "id",
    "alertChannelId",
    "channelName",
    "name",
    "channelType",
    "isEnabled",
    "isGlobal",
  ],
} as const;

export const $AlertEscalationScope = {
  type: "string",
  enum: ["Site", "Account"],
} as const;

export const $AlertEscalationThresholdType = {
  type: "string",
  enum: ["Count", "Percent"],
} as const;

export const $AlertEscalationRuleDto = {
  type: "object",
  properties: {
    scope: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertEscalationScope",
        },
      ],
    },
    thresholdType: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertEscalationThresholdType",
        },
      ],
    },
    thresholdValue: {
      type: "number",
    },
    timeWindowSec: {
      type: "number",
    },
    isEnabled: {
      type: "boolean",
    },
  },
  required: [
    "scope",
    "thresholdType",
    "thresholdValue",
    "timeWindowSec",
    "isEnabled",
  ],
} as const;

export const $AlertEscalationChannelDto = {
  type: "object",
  properties: {
    channelType: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertChannelType",
        },
      ],
    },
    alertChannelId: {
      type: "number",
    },
    channelName: {
      type: "string",
    },
    isGlobal: {
      type: "boolean",
    },
  },
  required: ["channelType", "alertChannelId", "channelName", "isGlobal"],
} as const;

export const $AlertEscalationSummaryDto = {
  type: "object",
  properties: {
    priority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    rules: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertEscalationRuleDto",
      },
    },
    enabled: {
      type: "boolean",
    },
    channels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertEscalationChannelDto",
      },
    },
    channelCount: {
      type: "number",
    },
  },
  required: ["priority", "rules", "enabled", "channels", "channelCount"],
} as const;

export const $ListAlertsResponseDto = {
  type: "object",
  properties: {
    priority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    severity: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertSeverity",
        },
      ],
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    description: {
      type: "string",
    },
    enabled: {
      type: "boolean",
    },
    autoResolve: {
      type: "boolean",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    subscriptions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertSubscriptionItemDto",
      },
    },
    updatedBy: {
      type: "string",
    },
    escalation: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/AlertEscalationSummaryDto",
        },
      ],
    },
  },
  required: [
    "priority",
    "severity",
    "id",
    "name",
    "description",
    "enabled",
    "autoResolve",
    "updatedAt",
    "subscriptions",
    "escalation",
  ],
} as const;

export const $AlertChannelDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    alertChannelType: {
      type: "string",
    },
    name: {
      type: "string",
      nullable: true,
    },
    isGlobal: {
      type: "boolean",
    },
    url: {
      type: "string",
    },
    configurationInfo: {
      type: "object",
      additionalProperties: true,
    },
  },
  required: [
    "id",
    "alertChannelType",
    "name",
    "isGlobal",
    "url",
    "configurationInfo",
  ],
} as const;

export const $DisabledDeviceDto = {
  type: "object",
  properties: {
    deviceId: {
      type: "number",
    },
    deviceName: {
      type: "string",
    },
    suppressedUntil: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
  },
  required: ["deviceId", "deviceName", "suppressedUntil"],
} as const;

export const $AlertDetailsDto = {
  type: "object",
  properties: {
    alertType: {
      enum: [
        "DeviceDown",
        "ServerDown",
        "CameraDown",
        "HighResourceUsage",
        "LookupTableDisabled",
        "DeployedModelFailure",
        "RegisterDisabledDeviceAttempt",
        "RegisterDuplicateDeviceAttempt",
        "TrainingFailed",
        "NonScanDetectorDown",
        "OnScreenAppDown",
        "ZebraAdapterDown",
        "AgentPortClash",
        "LockedSamplesAboveThreshold",
        "FailedToStoreSampleLackOfStorage",
        "BlackScreenImageDetected",
        "LocalStorageAlmostFull",
        "AgentDoesNotReachEdgibox",
        "VideoUploadError",
        "ImageUploadError",
        "PredictorDisabled",
        "NonScanDetectorRepeatedFpsDrops",
        "ModelBelowKpiThreshold",
        "TrainingWarnings",
        "LookupTableMismatch",
        "MetricThresholdBreach",
        "ServiceDown",
        "DataCompletenessBelowThreshold",
        "DeviceDownEscalated",
        "ServerDownEscalated",
        "CameraDownEscalated",
        "HighResourceUsageEscalated",
        "LookupTableDisabledEscalated",
        "DeployedModelFailureEscalated",
        "NonScanDetectorDownEscalated",
        "OnScreenAppDownEscalated",
        "ZebraAdapterDownEscalated",
        "AgentPortClashEscalated",
        "LockedSamplesAboveThresholdEscalated",
        "FailedToStoreSampleLackOfStorageEscalated",
        "BlackScreenImageDetectedEscalated",
        "LocalStorageAlmostFullEscalated",
        "AgentDoesNotReachEdgiboxEscalated",
        "VideoUploadErrorEscalated",
        "ImageUploadErrorEscalated",
        "PredictorDisabledEscalated",
        "NonScanDetectorRepeatedFpsDropsEscalated",
      ],
      type: "string",
    },
    handling: {
      type: "string",
    },
    alertIntervalUnits: {
      enum: ["minutes", "hours"],
      type: "string",
    },
    enabled: {
      type: "boolean",
    },
    priority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    severity: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertSeverity",
        },
      ],
    },
    id: {
      type: "number",
    },
    title: {
      type: "string",
    },
    description: {
      type: "string",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    allowThreshold: {
      type: "boolean",
    },
    allowOperationalHours: {
      type: "boolean",
    },
    allowInterval: {
      type: "boolean",
    },
    escalatedSpecId: {
      type: "number",
      nullable: true,
    },
    parentSpecId: {
      type: "number",
      nullable: true,
    },
    escalation: {
      nullable: true,
      type: "object",
      allOf: [
        {
          $ref: "#/components/schemas/AlertEscalationSummaryDto",
        },
      ],
    },
    occurrenceThreshold: {
      type: "number",
    },
    timeWindowSec: {
      type: "number",
    },
    alertInterval: {
      type: "number",
    },
    useOperationalHours: {
      type: "boolean",
    },
    subscriptions: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertSubscriptionItemDto",
      },
    },
    availableChannels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertChannelDto",
      },
    },
    disabledDevices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/DisabledDeviceDto",
      },
    },
  },
  required: [
    "alertType",
    "handling",
    "alertIntervalUnits",
    "enabled",
    "priority",
    "severity",
    "id",
    "title",
    "description",
    "createdAt",
    "updatedAt",
    "allowThreshold",
    "allowOperationalHours",
    "allowInterval",
    "escalatedSpecId",
    "parentSpecId",
    "escalation",
    "subscriptions",
    "availableChannels",
    "disabledDevices",
  ],
} as const;

export const $UpdateAlertDto = {
  type: "object",
  properties: {
    priority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    severity: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertSeverity",
        },
      ],
    },
    description: {
      type: "string",
    },
    handling: {
      type: "string",
    },
    alertInterval: {
      type: "number",
    },
    timeWindowSec: {
      type: "number",
    },
    occurrenceThreshold: {
      type: "number",
    },
    useOperationalHours: {
      type: "boolean",
    },
  },
} as const;

export const $UpdateAlertSubscriptionsDto = {
  type: "object",
  properties: {
    subscriptions: {
      type: "object",
      additionalProperties: {
        type: "boolean",
      },
    },
  },
  required: ["subscriptions"],
} as const;

export const $AlertEscalationChannelOptionDto = {
  type: "object",
  properties: {
    channelType: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertChannelType",
        },
      ],
    },
    alertChannelId: {
      type: "number",
    },
    channelName: {
      type: "string",
    },
    isGlobal: {
      type: "boolean",
    },
    isSubscribed: {
      type: "boolean",
    },
  },
  required: [
    "channelType",
    "alertChannelId",
    "channelName",
    "isGlobal",
    "isSubscribed",
  ],
} as const;

export const $AlertEscalationResponseDto = {
  type: "object",
  properties: {
    escalatedAlertType: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertType",
        },
      ],
    },
    activeScope: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/AlertEscalationScope",
        },
      ],
    },
    priority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    parentPriority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    allowedPriorities: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertPriority",
      },
    },
    escalatedSpecId: {
      type: "number",
    },
    rules: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertEscalationRuleDto",
      },
    },
    useOperationalHours: {
      type: "boolean",
    },
    channels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AlertEscalationChannelOptionDto",
      },
    },
  },
  required: [
    "escalatedAlertType",
    "activeScope",
    "priority",
    "parentPriority",
    "allowedPriorities",
    "escalatedSpecId",
    "rules",
    "useOperationalHours",
    "channels",
  ],
} as const;

export const $SaveAlertEscalationDto = {
  type: "object",
  properties: {
    scope: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertEscalationScope",
        },
      ],
    },
    thresholdType: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertEscalationThresholdType",
        },
      ],
    },
    priority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    thresholdValue: {
      type: "number",
    },
    timeWindowSec: {
      type: "number",
    },
    useOperationalHours: {
      type: "boolean",
    },
    channelIds: {
      uniqueItems: true,
      maxItems: 100,
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: [
    "scope",
    "thresholdType",
    "priority",
    "thresholdValue",
    "timeWindowSec",
    "useOperationalHours",
    "channelIds",
  ],
} as const;

export const $LabelDistributionDeviceDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    cluster: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
    site: {
      $ref: "#/components/schemas/MinimalEntityDto",
    },
  },
  required: ["name", "id"],
} as const;

export const $LabelDistributionDto = {
  type: "object",
  properties: {
    label: {
      type: "string",
    },
    quantity: {
      type: "number",
    },
    opened: {
      type: "number",
    },
    closed: {
      type: "number",
    },
    englishName: {
      type: "string",
    },
    name: {
      type: "string",
    },
    family: {
      type: "string",
    },
    devicesCount: {
      type: "number",
    },
    clustersCount: {
      type: "number",
    },
    sitesCount: {
      type: "number",
    },
    devices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LabelDistributionDeviceDto",
      },
    },
    clusters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
    sites: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MinimalEntityDto",
      },
    },
  },
  required: ["label", "quantity"],
} as const;

export const $LabelDistributionOrderEnum = {
  type: "string",
  enum: ["label", "quantity"],
} as const;

export const $LabelDistributionOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/LabelDistributionOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListLabelDistributionDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LabelDistributionOrderEnumSortOption",
      },
    },
    label: {
      type: "string",
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    family: {
      type: "string",
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    quantity: {
      type: "array",
      items: {
        $ref: "#/components/schemas/NumberConditionDto",
      },
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $ListLabelDistributionCountDto = {
  type: "object",
  properties: {
    deviceIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    clusterIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    siteIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LabelDistributionOrderEnumSortOption",
      },
    },
    label: {
      type: "string",
    },
    labels: {
      type: "array",
      items: {
        type: "string",
      },
    },
    family: {
      type: "string",
    },
    families: {
      type: "array",
      items: {
        type: "string",
      },
    },
    quantity: {
      type: "array",
      items: {
        $ref: "#/components/schemas/NumberConditionDto",
      },
    },
  },
} as const;

export const $CreateFeedbackDto = {
  type: "object",
  properties: {
    attachments: {
      type: "array",
      items: {
        type: "string",
        format: "binary",
      },
    },
    category: {
      type: "string",
    },
    description: {
      type: "string",
    },
    importance: {
      type: "string",
    },
    attachmentUrls: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["category", "description", "importance"],
} as const;

export const $EligibilityResponseDto = {
  type: "object",
  properties: {
    ready: {
      type: "boolean",
      description:
        "True when the account has a ready, environment-matched tenant.",
    },
    reason: {
      enum: [
        "not_entitled",
        "not_ready",
        "incomplete_provisioning",
        "env_mismatch",
        "missing_llm_key",
      ],
      type: "string",
      description:
        "Present only when `ready` is false. `missing_llm_key` is a deployment-wide misconfiguration (REPORTS_COMPANION_LLM_API_KEY unset); the other reasons match the chat endpoint's per-account refusal taxonomy.",
    },
    message: {
      type: "string",
      description:
        "Backend-authored English fallback explanation. The frontend prefers a per-reason translation when it recognises `reason`; this is what the panel renders when it does not (e.g. a reason the backend added after the deployed frontend was built). Safe to render as-is.",
    },
    status: {
      type: "string",
      description:
        'Only set when `reason === "not_ready"`: the current provisioning status from `account_bigquery_provisioning`. Interpolated into the `not_ready` translation on the frontend so the user can see how far along setup is (e.g. "awaitingPropagation").',
    },
    advancedControlsEnabled: {
      type: "boolean",
      description:
        "True when the caller holds `mcp.advancedUse` (SuperAdmin auto). Frontend uses this to gate the model + reasoning-level controls in the chat header; regular MCP users never see them.",
    },
  },
  required: ["ready", "advancedControlsEnabled"],
} as const;

export const $ChatMessageDto = {
  type: "object",
  properties: {
    role: {
      enum: ["user", "assistant"],
      type: "string",
    },
    content: {
      type: "string",
    },
  },
  required: ["role", "content"],
} as const;

export const $ChatRequestDto = {
  type: "object",
  properties: {
    sessionId: {
      type: "string",
      format: "uuid",
      description:
        "Optional per-conversation UUID, generated by the client and reused for every turn of one conversation. Groups the turns into one conversation in the chat log; a fresh one is generated server-side when omitted.",
    },
    messages: {
      minItems: 1,
      type: "array",
      items: {
        $ref: "#/components/schemas/ChatMessageDto",
      },
    },
    model: {
      enum: ["claude-sonnet-4-6", "claude-sonnet-5", "claude-haiku-4-5"],
      type: "string",
      description:
        "Model override for this chat. Requires the caller to hold `mcp.advancedUse`; silently ignored for callers who don't. Defaults to Sonnet 4.6.",
    },
    reasoning: {
      enum: ["off", "low", "medium", "high"],
      type: "string",
      description:
        "Extended-thinking / effort rung for this chat. Requires the caller to hold `mcp.advancedUse`; silently ignored otherwise. Defaults to Off.",
    },
  },
  required: ["messages"],
} as const;

export const $ReportsCompanionChatOutcome = {
  type: "string",
  enum: ["answered", "refused", "error", "aborted", "max_iterations"],
} as const;

export const $ChatTurnResponseDto = {
  type: "object",
  properties: {
    outcome: {
      allOf: [
        {
          $ref: "#/components/schemas/ReportsCompanionChatOutcome",
        },
      ],
    },
    id: {
      type: "number",
    },
    sessionId: {
      type: "string",
    },
    accountId: {
      type: "number",
    },
    accountName: {
      type: "string",
    },
    userId: {
      type: "number",
      nullable: true,
    },
    userName: {
      type: "string",
      description: "Snapshot taken when the turn ran.",
    },
    userRole: {
      type: "string",
      description: "Snapshot taken when the turn ran.",
    },
    question: {
      type: "string",
    },
    answer: {
      type: "string",
      nullable: true,
    },
    executedSql: {
      type: "array",
      items: {
        type: "string",
      },
    },
    refusalReason: {
      type: "string",
      nullable: true,
    },
    errorMessage: {
      type: "string",
      nullable: true,
    },
    model: {
      type: "string",
    },
    reasoning: {
      type: "string",
    },
    inputTokens: {
      type: "number",
    },
    outputTokens: {
      type: "number",
    },
    iterations: {
      type: "number",
    },
    latencyMs: {
      type: "number",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "outcome",
    "id",
    "sessionId",
    "accountId",
    "accountName",
    "userId",
    "userName",
    "userRole",
    "question",
    "answer",
    "executedSql",
    "refusalReason",
    "errorMessage",
    "model",
    "reasoning",
    "inputTokens",
    "outputTokens",
    "iterations",
    "latencyMs",
    "createdAt",
  ],
} as const;

export const $ChatTurnOrderEnum = {
  type: "string",
  enum: ["createdAt", "latencyMs"],
} as const;

export const $ChatTurnOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/ChatTurnOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $NotificationResponseDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
      description: "Unique notification ID",
    },
    title: {
      type: "string",
      description: "Short title shown in the banner header",
    },
    message: {
      type: "string",
      description: "Full body text of the notification banner",
    },
    type: {
      enum: [
        "ScheduledMaintenance",
        "IncidentOutage",
        "IssueResolved",
        "GeneralInformation",
      ],
      type: "string",
      description:
        "Category of the notification (affects banner color and icon)",
    },
    status: {
      enum: ["Draft", "Scheduled", "Active", "Archived", "Canceled"],
      type: "string",
      description: "Current lifecycle state of the notification",
    },
    targetAccountIds: {
      description:
        "Account IDs this banner is scoped to. Empty array means global (all accounts).",
      type: "array",
      items: {
        type: "number",
      },
    },
    startsAt: {
      type: "object",
      nullable: true,
      description: "When the event starts (e.g. start of maintenance window)",
    },
    endsAt: {
      type: "object",
      nullable: true,
      description:
        "When the event ends. Banner is auto-archived after this time.",
    },
    notifyBeforeHours: {
      type: "number",
      nullable: true,
      description:
        "Hours before startsAt at which the banner becomes active. Null means activate at startsAt.",
    },
    isActive: {
      type: "boolean",
      description: "False indicates the notification has been soft-deleted",
    },
    createdById: {
      type: "number",
      description: "ID of the SuperAdmin user who created this notification",
    },
    updatedById: {
      type: "object",
      nullable: true,
      description:
        "ID of the SuperAdmin user who last updated this notification",
    },
    staticPageFileName: {
      type: "string",
      nullable: true,
      description:
        'File name of the generated standalone maintenance page, e.g. "scheduled-db-upgrade-12.html". Null until a page has been generated.',
    },
    staticPageUrl: {
      type: "string",
      nullable: true,
      description:
        "Permanent public URL of the generated standalone maintenance page. DevOps redirects traffic here during the downtime this notification announces. Null until a page has been generated.",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "id",
    "title",
    "message",
    "type",
    "status",
    "targetAccountIds",
    "startsAt",
    "endsAt",
    "notifyBeforeHours",
    "isActive",
    "createdById",
    "updatedById",
    "staticPageFileName",
    "staticPageUrl",
    "createdAt",
    "updatedAt",
  ],
} as const;

export const $PublicNotificationResponseDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
      description: "Unique notification ID",
    },
    title: {
      type: "string",
      description: "Short title shown in the banner header",
    },
    message: {
      type: "string",
      description: "Full body text of the notification banner",
    },
    type: {
      enum: [
        "ScheduledMaintenance",
        "IncidentOutage",
        "IssueResolved",
        "GeneralInformation",
      ],
      type: "string",
      description:
        "Category of the notification (affects banner color and icon)",
    },
    startsAt: {
      type: "object",
      nullable: true,
      description: "When the event starts (e.g. start of maintenance window)",
    },
    endsAt: {
      type: "object",
      nullable: true,
      description:
        "When the event ends. Banner is auto-archived after this time.",
    },
  },
  required: ["id", "title", "message", "type", "startsAt", "endsAt"],
} as const;

export const $NotificationSummaryDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
      description: "Unique notification ID",
    },
    title: {
      type: "string",
      description: "Short title shown in the banner header",
    },
    type: {
      enum: [
        "ScheduledMaintenance",
        "IncidentOutage",
        "IssueResolved",
        "GeneralInformation",
      ],
      type: "string",
      description: "Category of the notification",
    },
    status: {
      enum: ["Draft", "Scheduled", "Active", "Archived", "Canceled"],
      type: "string",
      description: "Current lifecycle state of the notification",
    },
    isActive: {
      type: "boolean",
      description: "False indicates the notification has been soft-deleted",
    },
    startsAt: {
      type: "object",
      nullable: true,
      description: "When the event starts",
    },
    endsAt: {
      type: "object",
      nullable: true,
      description:
        "When the event ends. Banner is auto-archived after this time.",
    },
    notifyBeforeHours: {
      type: "number",
      nullable: true,
      description: "Hours before startsAt at which the banner becomes active.",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
  },
  required: [
    "id",
    "title",
    "type",
    "status",
    "isActive",
    "startsAt",
    "endsAt",
    "notifyBeforeHours",
    "createdAt",
  ],
} as const;

export const $NotificationsOrderEnum = {
  type: "string",
  enum: ["type", "startsAt", "endsAt", "createdAt", "updatedAt"],
} as const;

export const $NotificationsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/NotificationsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $CreateNotificationDto = {
  type: "object",
  properties: {
    title: {
      type: "string",
      description: "Short title shown in the banner header",
    },
    message: {
      type: "string",
      description: "Full body text of the notification banner",
    },
    type: {
      enum: [
        "ScheduledMaintenance",
        "IncidentOutage",
        "IssueResolved",
        "GeneralInformation",
      ],
      type: "string",
      description:
        "Category of the notification (affects banner color and icon)",
    },
    startsAt: {
      format: "date-time",
      type: "string",
      description:
        "When the event starts (e.g. start of maintenance window). Providing this sets status to Scheduled.",
    },
    endsAt: {
      format: "date-time",
      type: "string",
      description:
        "When the event ends. The banner is automatically archived after this time.",
    },
    notifyBeforeHours: {
      type: "number",
      minimum: 0,
      description:
        "How many hours before startsAt to make the notification active (start showing it). 0 means activate exactly at startsAt.",
    },
    targetAccountIds: {
      description:
        "Account IDs that should see this banner. Omit or pass an empty array to show to all accounts.",
      type: "array",
      items: {
        type: "number",
        minimum: 1,
      },
    },
    saveAsDraft: {
      type: "boolean",
      description:
        "Save as Draft instead of publishing. When false (default): no startsAt → Active immediately, startsAt set → Scheduled.",
    },
  },
  required: ["title", "message", "type"],
} as const;

export const $UpdateNotificationDto = {
  type: "object",
  properties: {
    title: {
      type: "string",
      description: "Short title shown in the banner header",
    },
    message: {
      type: "string",
      description: "Full body text of the notification banner",
    },
    type: {
      enum: [
        "ScheduledMaintenance",
        "IncidentOutage",
        "IssueResolved",
        "GeneralInformation",
      ],
      type: "string",
      description:
        "Category of the notification (affects banner color and icon)",
    },
    status: {
      enum: ["Draft", "Scheduled", "Active", "Archived", "Canceled"],
      type: "string",
      description: "Lifecycle state of the notification",
    },
    startsAt: {
      format: "date-time",
      type: "string",
      description: "When the event starts (e.g. start of maintenance window)",
    },
    endsAt: {
      format: "date-time",
      type: "string",
      description:
        "When the event ends. The banner is automatically archived after this time.",
    },
    notifyBeforeHours: {
      type: "number",
      minimum: 0,
      description:
        "How many hours before startsAt to make the notification active. 0 means activate exactly at startsAt.",
    },
    targetAccountIds: {
      description:
        "Account IDs that should see this banner. Pass an empty array to make it global.",
      type: "array",
      items: {
        type: "number",
        minimum: 1,
      },
    },
  },
} as const;

export const $CreateMetricAlertDto = {
  type: "object",
  properties: {
    priority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    severity: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertSeverity",
        },
      ],
    },
    name: {
      type: "string",
    },
    reportId: {
      type: "number",
    },
    questionId: {
      type: "number",
    },
    dashcardId: {
      type: "number",
    },
    questionName: {
      type: "string",
    },
    filterScope: {
      type: "string",
    },
    operator: {
      type: "string",
      enum: ["BelowThreshold", "AboveThreshold"],
    },
    thresholdValue: {
      type: "number",
    },
    schedule: {
      type: "string",
    },
    timezone: {
      type: "string",
    },
    channelIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: [
    "name",
    "reportId",
    "questionId",
    "dashcardId",
    "questionName",
    "filterScope",
    "operator",
    "thresholdValue",
    "schedule",
    "channelIds",
  ],
} as const;

export const $MetricAlertChannelDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    alertChannelType: {
      type: "string",
      enum: ["email", "JIRA", "slack", "webhook"],
    },
    name: {
      type: "string",
      nullable: true,
    },
  },
  required: ["id", "alertChannelType", "name"],
} as const;

export const $MetricAlertRunDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    startTime: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    endTime: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    state: {
      type: "string",
      nullable: true,
    },
    value: {
      type: "number",
      nullable: true,
    },
    breached: {
      type: "boolean",
      nullable: true,
    },
  },
  required: [
    "id",
    "createdAt",
    "startTime",
    "endTime",
    "state",
    "value",
    "breached",
  ],
} as const;

export const $MetricAlertResponseDto = {
  type: "object",
  properties: {
    priority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    severity: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertSeverity",
        },
      ],
    },
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    reportId: {
      type: "number",
    },
    reportName: {
      type: "string",
    },
    questionId: {
      type: "number",
    },
    dashcardId: {
      type: "number",
    },
    questionName: {
      type: "string",
    },
    filterScope: {
      type: "string",
    },
    operator: {
      enum: ["BelowThreshold", "AboveThreshold"],
      type: "string",
    },
    thresholdValue: {
      type: "number",
    },
    schedule: {
      type: "string",
      nullable: true,
    },
    timezone: {
      type: "string",
      nullable: true,
    },
    isEnabled: {
      type: "boolean",
    },
    lastEvaluatedAt: {
      format: "date-time",
      type: "string",
      nullable: true,
    },
    lastEvaluatedValue: {
      type: "number",
      nullable: true,
    },
    channels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetricAlertChannelDto",
      },
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    updatedAt: {
      format: "date-time",
      type: "string",
    },
    updatedBy: {
      type: "string",
    },
    runs: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MetricAlertRunDto",
      },
    },
  },
  required: [
    "priority",
    "severity",
    "id",
    "name",
    "reportId",
    "reportName",
    "questionId",
    "dashcardId",
    "questionName",
    "filterScope",
    "operator",
    "thresholdValue",
    "schedule",
    "timezone",
    "isEnabled",
    "lastEvaluatedAt",
    "lastEvaluatedValue",
    "channels",
    "createdAt",
    "updatedAt",
  ],
} as const;

export const $MetricAlertsOrderEnum = {
  type: "string",
  enum: ["name", "createdAt", "updatedAt", "priority", "severity"],
} as const;

export const $MetricAlertsOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/MetricAlertsOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $UpdateMetricAlertDto = {
  type: "object",
  properties: {
    priority: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertPriority",
        },
      ],
    },
    severity: {
      allOf: [
        {
          $ref: "#/components/schemas/AlertSeverity",
        },
      ],
    },
    channelIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    name: {
      type: "string",
    },
    reportId: {
      type: "number",
    },
    questionId: {
      type: "number",
    },
    dashcardId: {
      type: "number",
    },
    questionName: {
      type: "string",
    },
    filterScope: {
      type: "string",
    },
    operator: {
      enum: ["BelowThreshold", "AboveThreshold"],
      type: "string",
    },
    thresholdValue: {
      type: "number",
    },
    schedule: {
      type: "string",
    },
    timezone: {
      type: "string",
    },
  },
} as const;

export const $PreviewMetricAlertDto = {
  type: "object",
  properties: {
    reportId: {
      type: "number",
    },
    questionId: {
      type: "number",
    },
    dashcardId: {
      type: "number",
    },
    filterScope: {
      type: "string",
    },
  },
  required: ["reportId", "questionId", "dashcardId", "filterScope"],
} as const;

export const $PreviewMetricAlertResponseDto = {
  type: "object",
  properties: {
    value: {
      type: "number",
      nullable: true,
    },
  },
  required: ["value"],
} as const;

export const $TestMetricAlertDto = {
  type: "object",
  properties: {
    alertAction: {
      type: "string",
      enum: ["Alert", "Resolve"],
    },
  },
  required: ["alertAction"],
} as const;

export const $TestMetricAlertResponseDto = {
  type: "object",
  properties: {
    value: {
      type: "number",
      nullable: true,
    },
    breached: {
      type: "boolean",
    },
  },
  required: ["value", "breached"],
} as const;

export const $OidcParamsDto = {
  type: "object",
  properties: {
    authorizationEndpoint: {
      type: "string",
      maxLength: 2048,
      format: "uri",
    },
    tokenEndpoint: {
      type: "string",
      maxLength: 2048,
      format: "uri",
    },
    userInfoEndpoint: {
      type: "string",
      maxLength: 2048,
      format: "uri",
    },
    clientId: {
      type: "string",
      maxLength: 256,
    },
    clientSecret: {
      type: "string",
      maxLength: 2048,
    },
    scope: {
      type: "string",
      maxLength: 256,
    },
    issuer: {
      type: "string",
      maxLength: 2048,
    },
  },
  required: [
    "authorizationEndpoint",
    "tokenEndpoint",
    "userInfoEndpoint",
    "clientId",
    "clientSecret",
    "scope",
    "issuer",
  ],
} as const;

export const $CreateDomainAuthSettingDto = {
  type: "object",
  properties: {
    domain: {
      type: "string",
      maxLength: 253,
    },
    strategy: {
      type: "string",
      enum: ["magicLink", "oidc"],
    },
    defaultAccountId: {
      type: "number",
    },
    company: {
      type: "string",
      maxLength: 256,
    },
    params: {
      $ref: "#/components/schemas/OidcParamsDto",
    },
  },
  required: ["domain", "strategy", "defaultAccountId", "company"],
} as const;

export const $DomainAuthSettingResponseDto = {
  type: "object",
  properties: {
    domain: {
      type: "string",
    },
    strategy: {
      enum: ["magicLink", "oidc"],
      type: "string",
    },
    defaultAccountId: {
      type: "number",
    },
    company: {
      type: "string",
    },
  },
  required: ["domain", "strategy", "defaultAccountId", "company"],
} as const;

export const $UpdateOidcParamsDto = {
  type: "object",
  properties: {
    authorizationEndpoint: {
      type: "string",
      maxLength: 2048,
      format: "uri",
    },
    tokenEndpoint: {
      type: "string",
      maxLength: 2048,
      format: "uri",
    },
    userInfoEndpoint: {
      type: "string",
      maxLength: 2048,
      format: "uri",
    },
    clientId: {
      type: "string",
      maxLength: 256,
    },
    clientSecret: {
      type: "string",
      maxLength: 2048,
    },
    scope: {
      type: "string",
      maxLength: 256,
    },
    issuer: {
      type: "string",
      maxLength: 2048,
    },
  },
} as const;

export const $UpdateDomainAuthSettingDto = {
  type: "object",
  properties: {
    defaultAccountId: {
      type: "number",
    },
    company: {
      type: "string",
      maxLength: 256,
    },
    params: {
      $ref: "#/components/schemas/UpdateOidcParamsDto",
    },
  },
} as const;

export const $UpdateStateDto = {
  type: "object",
  properties: {
    state: {
      type: "string",
      enum: [
        "failed",
        "deploying",
        "pending",
        "cancelled",
        "running",
        "completed",
        "suspended",
        "aborted",
        "setup",
      ],
    },
    deviceId: {
      type: "number",
    },
    role: {
      type: "string",
      enum: ["server", "worker", "collaborator", "mediator"],
    },
    errorMsg: {
      type: "string",
    },
  },
  required: ["state", "deviceId", "role"],
} as const;

export const $CreateCheckpointDto = {
  type: "object",
  properties: {
    checkpoint: {
      type: "string",
    },
    index: {
      type: "string",
    },
  },
  required: ["checkpoint", "index"],
} as const;

export const $ClusterServerDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    port: {
      type: "string",
    },
    reverse_proxy_port: {
      type: "string",
    },
    http_port: {
      type: "string",
    },
    https_port: {
      type: "string",
    },
    ip: {
      type: "string",
    },
    local_ip: {
      type: "string",
    },
  },
  required: [
    "id",
    "name",
    "port",
    "reverse_proxy_port",
    "http_port",
    "https_port",
    "ip",
    "local_ip",
  ],
} as const;

export const $ClusterInfoDto = {
  type: "object",
  properties: {
    id: {
      type: "number",
    },
    name: {
      type: "string",
    },
    architecture: {
      type: "string",
      enum: ["distributed", "hybrid", "centralized"],
    },
    server: {
      $ref: "#/components/schemas/ClusterServerDto",
    },
  },
  required: ["id", "name", "architecture"],
} as const;

export const $UploadedVideoDto = {
  type: "object",
  properties: {
    start_time: {
      type: "string",
      format: "date-time",
    },
    startTime: {
      type: "string",
      format: "date-time",
    },
    end_time: {
      type: "string",
      format: "date-time",
    },
    endTime: {
      type: "string",
      format: "date-time",
    },
    size: {
      type: "number",
    },
    width: {
      type: "number",
    },
    height: {
      type: "number",
    },
    fps: {
      type: "number",
    },
    deviceId: {
      type: "number",
    },
    bitrate: {
      type: "number",
    },
    visualizationSize: {
      type: "number",
    },
    artifactsSize: {
      type: "number",
    },
    headDetectionsSize: {
      type: "number",
    },
    nonScanModelId: {
      type: "number",
    },
    predictorModelId: {
      type: "number",
    },
    file: {
      type: "string",
    },
    visualization: {
      type: "string",
    },
    artifacts: {
      type: "string",
    },
    headDetections: {
      type: "string",
    },
    session_id: {
      type: "string",
    },
    sessionId: {
      type: "string",
    },
    path: {
      type: "string",
    },
    codec: {
      type: "string",
    },
    startCause: {
      type: "string",
    },
    stopCause: {
      type: "string",
    },
    metadata: {
      type: "object",
    },
    nonScanPrecisionLevel: {
      type: "string",
    },
    agentAlertMode: {
      type: "string",
    },
    clientAppMode: {
      type: "string",
    },
    head_blurred: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
  },
  required: ["file"],
} as const;

export const $UploadedSampleDto = {
  type: "object",
  properties: {
    uuid: {
      type: "string",
    },
    sampleId: {
      type: "string",
    },
    group_id: {
      type: "string",
      format: "uuid",
    },
    groupId: {
      type: "string",
      format: "uuid",
    },
    label: {
      type: "string",
    },
    ux_source: {
      type: "string",
    },
    uxSource: {
      type: "string",
    },
    labelTrigger: {
      type: "string",
    },
    capture_trigger: {
      type: "string",
    },
    captureTrigger: {
      type: "string",
    },
    added_at: {
      format: "date-time",
      type: "string",
    },
    addedAt: {
      format: "date-time",
      type: "string",
    },
    predicted_at: {
      format: "date-time",
      type: "string",
    },
    predictedAt: {
      format: "date-time",
      type: "string",
    },
    family: {
      type: "string",
    },
    img_source: {
      type: "string",
    },
    imgSource: {
      type: "string",
    },
    category: {
      type: "string",
    },
    session_id: {
      type: "string",
      format: "uuid",
    },
    sessionId: {
      type: "string",
      format: "uuid",
    },
    match_strength: {
      type: "string",
    },
    matchStrength: {
      type: "string",
    },
    barcode: {
      type: "string",
    },
    price: {
      type: "string",
    },
    weight: {
      type: "string",
    },
    count: {
      type: "number",
    },
    total_price: {
      type: "string",
    },
    totalPrice: {
      type: "string",
    },
    name: {
      type: "string",
    },
    device_id: {
      type: "number",
    },
    deviceId: {
      type: "number",
    },
    captured_at: {
      format: "date-time",
      type: "string",
    },
    capturedAt: {
      format: "date-time",
      type: "string",
    },
    data_type: {
      type: "string",
    },
    dataType: {
      type: "string",
    },
    head_blurred: {
      type: "boolean",
    },
    headBlurred: {
      type: "boolean",
    },
    heads_found: {
      type: "boolean",
    },
    headsFound: {
      type: "boolean",
    },
  },
  required: ["uuid", "sampleId"],
} as const;

export const $RegisterDeviceDto = {
  type: "object",
  properties: {
    host: {
      type: "string",
    },
    localIp: {
      type: "string",
    },
  },
  required: ["host"],
} as const;

export const $DeviceJobStatusUpdateDto = {
  type: "object",
  properties: {},
} as const;

export const $SampleTagOrderEnum = {
  type: "string",
  enum: ["createdAt", "name"],
} as const;

export const $SampleTagOrderEnumSortOption = {
  type: "object",
  properties: {
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/SampleTagOrderEnum",
        },
      ],
    },
    dir: {
      type: "string",
      enum: ["asc", "desc"],
    },
  },
  required: ["field"],
} as const;

export const $ListSampleTagsDto = {
  type: "object",
  properties: {
    sortBy: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagOrderEnumSortOption",
      },
    },
    name: {
      type: "string",
    },
    isVisible: {
      type: "boolean",
    },
    limit: {
      type: "number",
      minimum: 1,
    },
    page: {
      type: "number",
      minimum: 1,
    },
  },
  required: ["limit", "page"],
} as const;

export const $SampleTagSummaryDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    createdAt: {
      format: "date-time",
      type: "string",
    },
    isLocked: {
      type: "boolean",
    },
  },
  required: ["name", "id", "createdAt"],
} as const;

export const $CreateSampleTagDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
  },
  required: ["name"],
} as const;

export const $SampleTagAssignDto = {
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    id: {
      type: "number",
    },
    isNew: {
      type: "boolean",
    },
    referencedSampleUuid: {
      type: "string",
      format: "uuid",
    },
  },
  required: ["name"],
} as const;

export const $SetSampleTagsDto = {
  type: "object",
  properties: {
    taggedId: {
      type: "number",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagAssignDto",
      },
    },
  },
  required: ["taggedId", "tags"],
} as const;

export const $AssignSampleTagsDto = {
  type: "object",
  properties: {
    taggedIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "number",
      },
    },
    sampleUuids: {
      minItems: 1,
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    referencedSampleUuid: {
      type: "string",
      format: "uuid",
    },
    tags: {
      minItems: 1,
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagAssignDto",
      },
    },
  },
  required: ["tags"],
} as const;

export const $AssignSampleTagsResponseDto = {
  type: "object",
  properties: {
    taggedIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    missingSampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    missingSampleUuids: {
      type: "array",
      items: {
        type: "string",
      },
    },
    createdTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagDto",
      },
    },
  },
  required: ["taggedIds"],
} as const;

export const $SetGroupSampleTagsDto = {
  type: "object",
  properties: {
    sampleUuid: {
      type: "string",
      format: "uuid",
    },
    groupId: {
      type: "string",
      format: "uuid",
    },
    sessionId: {
      type: "string",
      format: "uuid",
    },
    referencedSampleUuid: {
      type: "string",
      nullable: true,
      format: "uuid",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagAssignDto",
      },
    },
  },
  required: ["tags"],
} as const;

export const $SetGroupSampleTagsResponseDto = {
  type: "object",
  properties: {
    sampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    createdTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagDto",
      },
    },
    removedTags: {
      type: "object",
      additionalProperties: true,
    },
  },
  required: ["sampleIds"],
} as const;

export const $UpdateGroupSampleTagsDto = {
  type: "object",
  properties: {
    sampleUuid: {
      type: "string",
      format: "uuid",
    },
    groupId: {
      type: "string",
      format: "uuid",
    },
    sessionId: {
      type: "string",
      format: "uuid",
    },
    referencedSampleUuid: {
      type: "string",
      nullable: true,
      format: "uuid",
    },
    assign: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagAssignDto",
      },
    },
    unassign: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $AssignGroupSampleTagsDto = {
  type: "object",
  properties: {
    sampleUuid: {
      type: "string",
      format: "uuid",
    },
    groupId: {
      type: "string",
      format: "uuid",
    },
    sessionId: {
      type: "string",
      format: "uuid",
    },
    referencedSampleUuid: {
      type: "string",
      format: "uuid",
    },
    tags: {
      minItems: 1,
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagAssignDto",
      },
    },
  },
  required: ["tags"],
} as const;

export const $AssignGroupSampleTagsResponseDto = {
  type: "object",
  properties: {
    sampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    createdTags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SampleTagDto",
      },
    },
  },
  required: ["sampleIds"],
} as const;

export const $UnassignGroupSampleTagsDto = {
  type: "object",
  properties: {
    sampleUuid: {
      type: "string",
      format: "uuid",
    },
    groupId: {
      type: "string",
      format: "uuid",
    },
    sessionId: {
      type: "string",
      format: "uuid",
    },
    all: {
      type: "boolean",
    },
    tagIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $UnassignGroupSampleTagsResponseDto = {
  type: "object",
  properties: {
    sampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
  },
  required: ["sampleIds"],
} as const;

export const $UnassignSampleTagsDto = {
  type: "object",
  properties: {
    all: {
      type: "boolean",
    },
    sampleIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "number",
      },
    },
    sampleUuids: {
      minItems: 1,
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    tagIds: {
      minItems: 1,
      type: "array",
      items: {
        type: "number",
      },
    },
  },
} as const;

export const $UnassignSampleTagsResponseDto = {
  type: "object",
  properties: {
    taggedIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    missingSampleIds: {
      type: "array",
      items: {
        type: "number",
      },
    },
    missingSampleUuids: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["taggedIds"],
} as const;
